
export default [
    {
        "id": 1,
        "shikenId": 1,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナー（以下「FP」という）の顧客に対する行為に関する次の記述のうち、職業倫理や関連法規に照らし、最も適切なものはどれか。(2023.01)",
        "choice1": "顧客から住宅ローンについて相談を受けたFPのAさんは、顧客から預かった給与所得の源泉徴収票のコピーを、顧客に紹介する予定の不動産会社の担当者に顧客の同意を得ないまま渡した。",
        "choice2": "顧客から外貨預金での資金運用について相談を受けたFPのBさんは、円安ドル高がこの先ずっと続くため、円預金の大半をドル預金に移すべきだとアドバイスをした。",
        "choice3": "顧客から老後に受け取ることができる年金について相談を受けたFPのCさんは、社会保険労務士の資格を有していないものの、顧客の「ねんきん定期便」に記載されている年金見込額を用いて、繰り下げた場合の年金受給額を試算した。",
        "choice4": "顧客から所得税の確定申告について相談を受けたFPのDさんは、税理士の資格を有していないものの、顧客の要望に応じて確定申告書の作成を代行した。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "FPと関連法規",
        "important": ""
    },
    {
        "id": 2,
        "shikenId": 1,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "ライフプランニングにおける各種係数を用いた必要額の算出に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、算出に当たっては下記＜資料＞の係数を乗算で使用し、手数料や税金等については考慮しないものとする。(2024.01)<br> <br> ・Aさんが60歳から65歳になるまでの5年間、年率2％で複利運用しながら、毎年200万円を受け取る場合、60歳時点の元金として（ア）が必要となる。<br> ・Bさんが45歳から毎年一定額を積み立てながら年率2％で複利運用し、15年後の60歳時に1,000万円を準備する場合、毎年の積立金額は（イ）となる。<br><img src='/img/1_2.jpg'/>",
        "choice1": "（ア）9,057,000円　（イ）578,000円",
        "choice2": "（ア）9,057,000円　（イ）778,000円",
        "choice3": "（ア）9,427,000円　（イ）578,000円",
        "choice4": "（ア）9,427,000円　（イ）778,000円",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "各種係数",
        "important": ""
    },
    {
        "id": 3,
        "shikenId": 1,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "公的医療保険に関する次の記述のうち、最も適切なものはどれか。(2024.09)",
        "choice1": "退職により健康保険の被保険者資格を喪失した者が、その資格を喪失した際に傷病手当金の支給を受けている場合、資格喪失日の前日まで継続して2ヵ月以上の被保険者期間があれば、傷病手当金の支給期間を限度として、退職後も引き続きその支給を受けることができる。",
        "choice2": "健康保険の任意継続被保険者に係る保険料は、その全額を任意継続被保険者が負担する。",
        "choice3": "健康保険や国民健康保険の被保険者が70歳に達すると、原則として、その被保険者資格を喪失し、後期高齢者医療制度の被保険者となる。",
        "choice4": "後期高齢者医療制度の被保険者が保険医療機関等の窓口で支払う一部負担金（自己負担額）の割合は、当該被保険者の所得金額の多寡にかかわらず、1割とされている。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的医療保険",
        "important": ""
    },
    {
        "id": 4,
        "shikenId": 1,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "雇用保険の育児休業給付および介護休業給付に関する次の記述のうち、最も不適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。(2023.05)",
        "choice1": "育児休業給付金は、子が1歳に達した日後の期間について休業することが特に必要と認められる場合、最長で子が1歳2ヵ月に達する日の前日まで支給される。",
        "choice2": "育児休業給付金に係る支給単位期間において支払われた賃金額が、休業開始時賃金日額に支給日数を乗じて得た額の80％相当額以上である場合、当該支給単位期間について育児休業給付金は支給されない。",
        "choice3": "被保険者が、一定の状態にある家族を介護するための休業をした場合、同一の対象家族について、通算3回かつ93日の介護休業を限度として、介護休業給付金が支給される。",
        "choice4": "複数の被保険者が、同一の対象家族について同時に介護休業を取得した場合、それぞれの被保険者に介護休業給付金が支給される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "雇用保険",
        "important": ""
    },
    {
        "id": 5,
        "shikenId": 1,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "公的年金に関する次の記述のうち、最も適切なものはどれか。(2022.05)",
        "choice1": "国民年金の第1号被保険者は、日本国内に住所を有する20歳以上60歳未満の自営業者や学生などのうち、日本国籍を有する者のみが該当する。",
        "choice2": "老齢厚生年金の受給権者が老齢厚生年金の繰下げ支給の申出をする場合、老齢基礎年金の繰下げ支給の申出を同時に行わなければならない。",
        "choice3": "老齢厚生年金の額に加給年金額が加算されるためには、原則として、厚生年金保険の被保険者期間が10年以上であり、かつ、その受給権者によって生計を維持されている一定の要件を満たす配偶者または子がいる必要がある。",
        "choice4": "産前産後休業を取得している厚生年金保険の被保険者の厚生年金保険料は、所定の手続きにより、被保険者負担分と事業主負担分がいずれも免除される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的年金に関する記述",
        "important": ""
    },
    {
        "id": 6,
        "shikenId": 1,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "国民年金基金、小規模企業共済および中小企業退職金共済に関する次の記述のうち、最も適切なものはどれか。(2023.05)",
        "choice1": "国民年金基金の加入員が死亡以外の事由で加入員資格を喪失した場合、それまでの加入期間に応じた解約返戻金が支払われる。",
        "choice2": "小規模企業共済の掛金月額は、5,000円から10万円までの範囲内で、500円単位で選択することができる。",
        "choice3": "中小企業退職金共済の掛金は、事業主と被共済者の合意に基づき、事業主と被共済者が折半して負担することができる。",
        "choice4": "中小企業退職金共済の被共済者が退職後3年以内に、中小企業退職金共済の退職金を請求せずに再就職して再び被共済者となった場合、所定の要件を満たせば、前の企業での掛金納付月数を再就職した企業での掛金納付月数と通算することができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "国民年金基金等",
        "important": ""
    },
    {
        "id": 7,
        "shikenId": 1,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "遺族厚生年金に関する次の記述のうち、最も不適切なものはどれか。(2022.05)",
        "choice1": "厚生年金保険の被保険者が死亡したことにより支給される遺族厚生年金の額は、死亡した者の厚生年金保険の被保険者期間が300月未満の場合、300月とみなして計算する。",
        "choice2": "遺族厚生年金の額（中高齢寡婦加算額および経過的寡婦加算額を除く）は、原則として、死亡した者の厚生年金保険の被保険者記録を基に計算された老齢厚生年金の報酬比例部分の3分の2相当額である。",
        "choice3": "厚生年金保険の被保険者である夫が死亡し、夫の死亡当時に子のいない40歳以上65歳未満の妻が遺族厚生年金の受給権を取得した場合、妻が65歳に達するまでの間、妻に支給される遺族厚生年金には中高齢寡婦加算額が加算される。",
        "choice4": "配偶者が死亡したことにより遺族厚生年金の受給権を取得した65歳以上の受給権者について、その受給権者が受給することができる老齢厚生年金の額が当該遺族厚生年金の額を上回る場合、当該遺族厚生年金の全部が支給停止される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "遺族厚生年金",
        "important": ""
    },
    {
        "id": 8,
        "shikenId": 1,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "リタイアメントプランニング等に関する次の記述のうち、最も不適切なものはどれか。(2023.09)",
        "choice1": "金融機関のリバースモーゲージには、一般に、利用者が死亡し、担保物件の売却代金により借入金を返済した後も債務が残った場合に、利用者の相続人がその返済義務を負う「リコース型」と、返済義務を負わない「ノンリコース型」がある。",
        "choice2": "高齢者の居住の安定確保に関する法律に定める「サービス付き高齢者向け住宅」に入居した者は、「状況把握サービス」や「生活相談サービス」を受けることができる。",
        "choice3": "将来、本人の判断能力が不十分になった場合に備えて、あらかじめ本人が選任した者と締結する任意後見契約は、公正証書によらない場合であっても有効である。",
        "choice4": "確定拠出年金の加入者が、老齢給付金を60歳から受給するためには、通算加入者等期間が10年以上なければならない。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "リタイアメントプランニング",
        "important": ""
    },
    {
        "id": 9,
        "shikenId": 1,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "住宅ローンの一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。(2024.05)",
        "choice1": "固定金利選択型の住宅ローンでは、一般に、固定金利期間終了後に適用される金利について、変動金利または固定金利のいずれかを選択することができる。",
        "choice2": "住宅ローンの返済方式では、借入額や返済期間等の他の条件が同一であれば、元金均等返済方式よりも元利均等返済方式の方が総返済額は多い。",
        "choice3": "住宅ローンの一部繰上げ返済では、繰上げ返済額や金利等の他の条件が同一であれば、毎回の返済額を変えずに返済期間を短縮する返済期間短縮型よりも返済期間を変えずに毎回の返済額を少なくする返済額軽減型の方が支払利息の軽減効果は大きい。",
        "choice4": "住宅ローンの借換えに際して、現在借入れをしている金融機関の抵当権を抹消し、借換先の金融機関の抵当権を新たに設定する場合、登録免許税等の諸費用が必要となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "住宅ローンの一般的な特徴",
        "important": ""
    },
    {
        "id": 10,
        "shikenId": 1,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "中小企業の資金調達の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。(2023.09)",
        "choice1": "日本政策金融公庫の中小企業事業における融資では、事業用資金だけでなく、投資を目的とする有価証券等の資産の取得資金についても融資対象となる。",
        "choice2": "信用保証協会保証付融資（マル保融資）は、中小企業者が金融機関から融資を受ける際に信用保証協会が保証するものであり、利用するためには、業種に応じて定められた資本金の額（出資の総額）または常時使用する従業員数の要件を満たす必要がある。",
        "choice3": "ABL（動産・債権担保融資）は、企業が保有する売掛債権や在庫・機械設備等の資産を担保として資金を調達する方法である。",
        "choice4": "クラウドファンディングは、インターネット等を介して不特定多数の者に資金の提供を呼びかけて資金を調達する方法であり、「購入型」「寄付型」等に分類される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "中小企業の資金調達",
        "important": ""
    },
    {
        "id": 11,
        "shikenId": 1,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "少額短期保険に関する次の記述のうち、最も適切なものはどれか。(2023.01)",
        "choice1": "少額短期保険は、低発生率保険および経過措置を適用している少額短期保険業者が引き受ける保険契約を除き、被保険者1人につき加入できる保険金額の合計額は1,000万円が上限である。",
        "choice2": "少額短期保険の保険期間は、生命保険、傷害疾病保険および損害保険のいずれも1年が上限である。",
        "choice3": "少額短期保険では、保険期間の満了時に満期返戻金を受け取ることができる。",
        "choice4": "少額短期保険業者が取り扱う保険契約は、保障内容に応じて、生命保険契約者保護機構または損害保険契約者保護機構のいずれかの保護の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "少額短期保険",
        "important": ""
    },
    {
        "id": 12,
        "shikenId": 1,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、特約については考慮しないものとする。(2024.01)",
        "choice1": "外貨建て終身保険では、死亡保険金を円貨で受け取る場合、受け取る金額は為替相場によって変動する。",
        "choice2": "変額保険（終身型）では、資産の運用実績に応じて死亡保険金額が変動するが、契約時に定めた保険金額（基本保険金額）は保証される。",
        "choice3": "こども保険（学資保険）では、契約者（＝保険料負担者）が死亡した場合であっても、保険契約は継続し、被保険者である子の成長に合わせて祝金（学資金）等を受け取ることができる。",
        "choice4": "低解約返戻金型終身保険では、他の契約条件が同一であれば、低解約返戻金型ではない終身保険と比較して、保険料払込期間満了後も解約返戻金額が低く設定されている。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 13,
        "shikenId": 1,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "2012年1月1日以後に締結した生命保険契約の保険料に係る生命保険料控除に関する次の記述のうち、最も適切なものはどれか。(2022.09)",
        "choice1": "終身保険の月払保険料について、保険料の支払いがなかったため自動振替貸付により保険料の払込みに充当された金額は、生命保険料控除の対象となる。",
        "choice2": "一般の生命保険料控除、個人年金保険料控除および介護医療保険料控除の控除限度額は、所得税では各3万円である。",
        "choice3": "勤労者財産形成貯蓄積立保険（一般財形）の保険料は、一般の生命保険料控除の対象となる。",
        "choice4": "特定（三大）疾病保障定期保険の保険料は、介護医療保険料控除の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険料控除",
        "important": ""
    },
    {
        "id": 14,
        "shikenId": 1,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "生命保険の税金に関する次の記述のうち、最も不適切なものはどれか。なお、いずれも契約者（＝保険料負担者）および保険金受取人は個人であるものとする。(2023.09)",
        "choice1": "契約者と被保険者が同一人である養老保険において、被保険者の相続人ではない者が受け取った死亡保険金は、相続税の課税対象となる。",
        "choice2": "契約者と被保険者が同一人である終身保険において、被保険者がリビング・ニーズ特約に基づいて受け取る特約保険金は、非課税となる。",
        "choice3": "契約者と年金受取人が同一人である個人年金保険において、年金受取人が毎年受け取る年金は、所得税における公的年金等控除の対象となる。",
        "choice4": "契約から10年を経過した一時払養老保険を解約して契約者が受け取る解約返戻金は、所得税において総合課税の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の税金",
        "important": ""
    },
    {
        "id": 15,
        "shikenId": 1,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "法人を契約者（＝保険料負担者）とする生命保険等に係る保険料の経理処理に関する次の記述のうち、最も不適切なものはどれか。なお、いずれの保険契約も保険料は年払いかつ全期払いで、2023年10月に締結したものとする。(2023.05)",
        "choice1": "被保険者が役員・従業員全員、死亡保険金受取人および満期保険金受取人が法人である養老保険の支払保険料は、その全額を資産に計上する。",
        "choice2": "被保険者が役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を損金の額に算入することができる。",
        "choice3": "被保険者が役員、給付金受取人が法人である解約返戻金のない医療保険の支払保険料は、その全額を損金の額に算入することができる。",
        "choice4": "被保険者が役員、死亡保険金受取人が法人で、最高解約返戻率が60％である定期保険（保険期間30年、年払保険料100万円）の支払保険料は、保険期間の前半4割相当期間においては、その40％相当額を資産に計上し、残額を損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "法人の生命保険の経理処理",
        "important": ""
    },
    {
        "id": 16,
        "shikenId": 1,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。(2024.05)",
        "choice1": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って車庫入れを誘導していた記名被保険者の配偶者に接触してケガをさせた場合、対人賠償保険の補償の対象となる。",
        "choice2": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って通行人が連れていたペットの犬に接触してケガをさせ、法律上の損害賠償責任を負った場合、対物賠償保険の補償の対象となる。",
        "choice3": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って衣料品販売店の店舗に衝突した場合、店舗の復旧期間中の休業損害は、対物賠償保険の補償の対象となる。",
        "choice4": "豪雨による洪水で被保険自動車が水没して被った損害は、一般条件の車両保険の補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "自動車保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 17,
        "shikenId": 1,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "住宅用建物および家財を保険の対象とする火災保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、特約については考慮しないものとする。(2022.09)",
        "choice1": "火災保険の保険料は、対象となる住宅用建物の構造により、M構造、T構造、H構造の3つに区分されて算定される。",
        "choice2": "保険金額が2,000万円（保険価額と同額）の火災保険に加入した後、火災により住宅用建物が損害を被り、損害保険金1,000万円が支払われた場合、保険契約は継続するが、保険期間満了日までの保険金額が1,000万円に減額される。",
        "choice3": "火災保険では、隣家の火災の消火活動により住宅用建物に収容されている家財が損壊した場合、補償の対象となる。",
        "choice4": "火災保険では、雪災により住宅用建物の屋根が損壊して100万円の損害が発生した場合、補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "火災保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 18,
        "shikenId": 1,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "傷害保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、特約および記載のない事項については考慮しないものとする。(2024.09)",
        "choice1": "普通傷害保険では、被保険者が自動車を運転中に他の自動車と衝突してケガをした場合、被保険者の過失割合にかかわらず補償の対象となる。",
        "choice2": "普通傷害保険では、海外旅行中に地震により倒壊した建物の下敷きになりケガをした場合、補償の対象となる。",
        "choice3": "交通事故傷害保険では、デパートのエスカレーターに搭乗中の事故によりケガをした場合、補償の対象となる。",
        "choice4": "国内旅行傷害保険では、被保険者が旅行中の飲食により細菌性食中毒を発症した場合、補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "傷害保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 19,
        "shikenId": 1,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "第三分野の保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、記載のない特約については考慮しないものとする。(2024.01)",
        "choice1": "所得補償保険では、勤務先企業の倒産によって失業した場合、保険金は支払われない。",
        "choice2": "更新型の医療保険では、保険期間中に入院給付金を受け取った場合、保険契約を更新することができない。",
        "choice3": "先進医療特約では、契約時点において先進医療に該当していた治療であれば、療養を受けた時点において先進医療に該当しない場合であっても、保険金の支払対象となる。",
        "choice4": "がん保険では、通常、180日間または6ヵ月間の免責期間が設けられている。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "第三分野の保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 20,
        "shikenId": 1,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "損害保険を利用した事業活動のリスク管理に関する次の記述のうち、最も不適切なものはどれか。(2023.01)",
        "choice1": "製造業を営む事業者が、従業員が就業中や通勤途上でケガをする場合に備えて、すべての従業員を被保険者として普通傷害保険に就業中のみの危険補償特約を付帯して契約した。",
        "choice2": "貸しビル業を営む事業者が、所有するビル内に設置した機械が火災により損害を被る場合に備えて、機械保険を契約した。",
        "choice3": "レストランを営む事業者が、フロア担当従業員が誤って来店客の衣服を汚損する場合に備えて、施設所有（管理）者賠償責任保険を契約した。",
        "choice4": "小型家電製品を製造する事業者が、製造した製品の欠陥が原因で顧客がケガをする場合に備えて、生産物賠償責任保険（PL保険）を契約した。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "損害保険を利用した事業活動のリスク管理",
        "important": ""
    },
    {
        "id": 21,
        "shikenId": 1,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "為替相場や金利の変動要因等に関する次の記述のうち、最も不適切なものはどれか。(2023.05)",
        "choice1": "日本の物価が米国と比較して相対的に上昇することは、一般に円高米ドル安の要因となる。",
        "choice2": "米国が政策金利を引き上げ、日本と米国との金利差が拡大することは、一般に円安米ドル高の要因となる。",
        "choice3": "日本の対米貿易赤字が拡大することは、一般に円安米ドル高の要因となる。",
        "choice4": "日本銀行が、国債買入オペによって長期国債（利付国債）を買い入れ、金融市場に資金を供給することは、一般に市中金利の低下要因となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "為替相場や金利の変動要因等",
        "important": ""
    },
    {
        "id": 22,
        "shikenId": 1,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "上場投資信託（ETF）の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。(2024.09)",
        "choice1": "ETFを市場で売却する際には、信託財産留保額はかからない。",
        "choice2": "ETFを証券取引所の立会時間中に売買する場合、成行注文や指値注文が可能である。",
        "choice3": "インバース型ETFは、日経平均株価などの指標の日々の変動率に一定の正の倍数を乗じて算出される指数に連動した運用成果を目指して運用されるETFである。",
        "choice4": "東京証券取引所には、指標連動型ETFの銘柄だけでなく、アクティブ運用型ETFの銘柄も上場されている。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "上場投資信託(ETF)の特徴",
        "important": ""
    },
    {
        "id": 23,
        "shikenId": 1,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "公募株式投資信託の費用に関する次の記述のうち、最も不適切なものはどれか。(2024.01)",
        "choice1": "購入時手数料がかからない投資信託は、一般に、ノーロード型（ノーロードファンド）と呼ばれる。",
        "choice2": "運用管理費用（信託報酬）は投資信託の銘柄ごとに定められており、一般に、インデックス型投資信託よりもアクティブ型投資信託の方が高い傾向がある。",
        "choice3": "会計監査に必要な費用（監査報酬）や組入有価証券に係る売買委託手数料は、信託財産から支出されるため、受益者（投資家）の負担となる。",
        "choice4": "信託財産留保額は、長期に投資信託を保有する投資家との公平性を確保するための費用であり、すべての投資信託に設定されている。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "公募株式投資信託の費用",
        "important": ""
    },
    {
        "id": 24,
        "shikenId": 1,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "固定利付債券の利回り（単利・年率）と価格との関係に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、手数料、経過利子、税金等については考慮しないものとし、計算結果は表示単位の小数点以下第3位を四捨五入するものとする。<br><br>表面利率が1.00％で、償還までの残存期間が5年の固定利付債券を、額面100円当たり102円で購入した投資家が、2年後に、額面100円当たり101円で売却した。この場合の所有期間利回りは（ア）であり、償還期限まで5年間保有した場合の最終利回りよりも（イ）。(2022.09)",
        "choice1": "（ア）0.49％　（イ）高い",
        "choice2": "（ア）0.49％　（イ）低い",
        "choice3": "（ア）0.59％　（イ）高い",
        "choice4": "（ア）0.59％　（イ）低い",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "固定利付債券の利回りと価格との関係",
        "important": ""
    },
    {
        "id": 25,
        "shikenId": 1,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "東京証券取引所の市場区分等に関する次の記述のうち、最も適切なものはどれか。(2023.09)",
        "choice1": "スタンダード市場は、「多くの機関投資家の投資対象になりうる規模の時価総額（流動性）を持ち、より高いガバナンス水準を備え、投資者との建設的な対話を中心に据えて持続的な成長と中長期的な企業価値の向上にコミットする企業向けの市場」である。",
        "choice2": "プライム市場は、「高い成長可能性を実現するための事業計画及びその進捗の適時・適切な開示が行われ一定の市場評価が得られる一方、事業実績の観点から相対的にリスクが高い企業向けの市場｣である。",
        "choice3": "スタンダード市場の上場会社がプライム市場へ市場区分の変更をするためには、プライム市場の新規上場基準と同様の基準に基づく審査を受ける必要がある。",
        "choice4": "東証株価指数（TOPIX）は、プライム市場、スタンダード市場およびグロース市場の全銘柄を対象として算出されている。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "東京証券取引所の市場区分",
        "important": ""
    },
    {
        "id": 26,
        "shikenId": 1,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "外貨建ての金融商品の一般的な特徴等に関する次の記述のうち、最も不適切なものはどれか。(2024.05)",
        "choice1": "外貨預金の払戻し時において、預金者が外貨を円貨に換える場合に適用される為替レートは、預入金融機関が提示する対顧客直物電信買相場（TTB）である。",
        "choice2": "外貨預金は、その金額の多寡にかかわらず、預金保険制度による保護の対象とならない。",
        "choice3": "為替予約を締結していない外貨定期預金を満期時に円貨で払い戻した結果生じた為替差益は、一時所得として所得税の課税対象となる。",
        "choice4": "外貨建てMMFは、主に外国の格付けの高い公社債やコマーシャル・ペーパー（CP）などの短期金融商品を投資対象として運用される外貨建ての投資信託である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨建ての金融商品の一般的な特徴",
        "important": ""
    },
    {
        "id": 27,
        "shikenId": 1,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "先物取引やオプション取引に関する次の記述のうち、最も不適切なものはどれか。(2022.09)",
        "choice1": "現在保有している現物資産が将来値下がりすることに備えるため、先物を売り建てた。",
        "choice2": "将来保有しようとする現物資産が将来値上がりすることに備えるため、先物を買い建てた。",
        "choice3": "現在保有している現物資産が将来値下がりすることに備えるため、プット・オプションを売った。",
        "choice4": "将来保有しようとする現物資産が将来値上がりすることに備えるため、コール・オプションを買った。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "先物取引やオプション取引に関する記述",
        "important": ""
    },
    {
        "id": 28,
        "shikenId": 1,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "下記＜資料＞に基づくファンドAとファンドBの過去5年間の運用パフォーマンスの比較評価に関する次の記述の空欄（ア）、（イ）にあてはまる語句または数値の組み合わせとして、最も適切なものはどれか。(2024.05)<br> <br><img src='/img/1_28.jpg'/><br><br> ファンドの運用パフォーマンスに係る評価指標の一つとして、シャープレシオがある。無リスク金利を全期間にわたり1.0％とし、＜資料＞の数値により、ファンドAのシャープレシオの値を算出すると、（ア）となる。同様にファンドBのシャープレシオの値を算出したうえで、両ファンドの運用パフォーマンスを比較すると、過去5年間は（イ）の方が効率的な運用であったと判断される。",
        "choice1": "（ア）2.0　（イ）ファンドA",
        "choice2": "（ア）2.0　（イ）ファンドB",
        "choice3": "（ア）2.5　（イ）ファンドA",
        "choice4": "（ア）2.5　（イ）ファンドB",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "運用パフォーマンスの比較評価",
        "important": ""
    },
    {
        "id": 29,
        "shikenId": 1,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "上場株式等の譲渡および配当等（一定の大口株主等が受けるものを除く）に係る税金に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、NISA（少額投資非課税制度）により投資収益が非課税となる口座をNISA口座という。(2024.01)",
        "choice1": "上場株式の配当に係る配当所得の金額について、総合課税を選択して所得税の確定申告をした場合、特定口座内で生じた上場株式等に係る譲渡損失の金額と損益通算することができる。",
        "choice2": "NISA口座で保有する上場株式の配当金を非課税扱いにするためには、配当金の受取方法として株式数比例配分方式を選択しなければならない。",
        "choice3": "上場株式等に係る配当所得等の金額と損益通算してもなお控除しきれない上場株式等に係る譲渡損失の金額は、所得税の確定申告をすることにより、翌年以後3年間にわたって繰り越すことができる。",
        "choice4": "NISA口座で取得した上場株式等を売却したことにより生じた損失の金額については、特定口座内で保有する上場株式等の配当等に係る配当所得の金額と損益通算することができない。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "上場株式等の譲渡および配当等に係る税金",
        "important": ""
    },
    {
        "id": 30,
        "shikenId": 1,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "金融商品の取引等に係る各種法令に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、「金融サービスの提供に関する法律」を金融サービス提供法、「犯罪による収益の移転防止に関する法律」を犯罪収益移転防止法という。(2023.01)",
        "choice1": "金融商品取引法では、金融商品取引契約を締結しようとする金融商品取引業者等は、あらかじめ顧客（特定投資家を除く）に契約締結前交付書面を交付しなければならないとされているが、顧客から交付を要しない旨の意思表示があった場合、その交付義務は免除される。",
        "choice2": "金融サービス提供法では、金融サービス仲介業の登録を受けた事業者は、銀行、証券、保険、貸金業の分野のサービスを仲介することができるが、特定の金融機関に所属し、その指導および監督を受けなければならないとされている。",
        "choice3": "消費者契約法では、事業者の不適切な行為によって、消費者が誤認や困惑をし、それによって消費者契約の申込みまたはその承諾の意思表示をした場合、消費者は、当該契約によって生じた損害について賠償を請求することができるとされている。",
        "choice4": "犯罪収益移転防止法では、金融機関等の特定事業者が顧客と特定業務に係る取引を行った場合、特定事業者は、原則として、直ちに当該取引に関する記録を作成し、当該取引の行われた日から7年間保存しなければならないとされている。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金融商品の取引等に係る各種法令",
        "important": ""
    },
    {
        "id": 31,
        "shikenId": 1,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税の基本的な仕組みに関する次の記述のうち、最も不適切なものはどれか。(2023.09)",
        "choice1": "所得税では、原則として、納税者本人の申告により納付すべき税額が確定し、この確定した税額を納付する申告納税制度が採用されている。",
        "choice2": "所得税の納税義務を負うのは居住者のみであり、非居住者が所得税の納税義務を負うことはない。",
        "choice3": "所得税では、課税対象となる所得を10種類に区分し、それぞれの所得の種類ごとに定められた計算方法により所得の金額を計算する。",
        "choice4": "所得税額の計算において課税総所得金額に乗じる税率は、課税総所得金額が大きくなるにつれて段階的に税率が高くなる超過累進税率が採用されている。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の基本的な仕組み",
        "important": ""
    },
    {
        "id": 32,
        "shikenId": 1,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税における各種所得の金額の計算方法に関する次の記述のうち、最も不適切なものはどれか。(2023.05)",
        "choice1": "利子所得の金額は、「利子等の収入金額－元本を取得するために要した負債の利子の額」の算式により計算される。",
        "choice2": "不動産所得の金額は、原則として、「不動産所得に係る総収入金額－必要経費」の算式により計算される。",
        "choice3": "一時所得の金額は、「一時所得に係る総収入金額－その収入を得るために支出した金額－特別控除額」の算式により計算される。",
        "choice4": "退職所得の金額は、特定役員退職手当等および短期退職手当等に係るものを除き、「（退職手当等の収入金額－退職所得控除額）×1／2」の算式により計算される。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税における各種所得の金額の計算方法",
        "important": ""
    },
    {
        "id": 33,
        "shikenId": 1,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税の損益通算に関する次の記述のうち、最も適切なものはどれか。(2024.01)",
        "choice1": "先物取引に係る雑所得の金額の計算上生じた損失の金額は、不動産所得の金額と損益通算することができる。",
        "choice2": "業務用車両を譲渡したことによる譲渡所得の金額の計算上生じた損失の金額は、事業所得の金額と損益通算することができる。",
        "choice3": "不動産所得の金額の計算上生じた損失の金額のうち、不動産所得を生ずべき土地の取得に要した負債の利子の額に相当する部分の金額は、事業所得の金額と損益通算することができる。",
        "choice4": "生命保険の解約返戻金を受け取ったことによる一時所得の金額の計算上生じた損失の金額は、不動産所得の金額と損益通算することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の損益通算",
        "important": ""
    },

    {
        "id": 34,
        "shikenId": 1,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "所得税における住宅借入金等特別控除（以下「住宅ローン控除」という）に関する次の記述のうち、最も不適切なものはどれか。なお、2023年10月に住宅ローンを利用して住宅を取得したものとする。(2024.05)",
        "choice1": "住宅ローン控除の適用を受けるためには、原則として、その対象となる家屋を取得等した日から6ヵ月以内に自己の居住の用に供さなければならない。",
        "choice2": "住宅ローン控除の対象となる家屋は、床面積の2分の1以上に相当する部分がもっぱら自己の居住の用に供されるものに限られる。",
        "choice3": "住宅ローン控除の対象となる借入金は、契約による償還期間が10年以上のものに限られる。",
        "choice4": "住宅ローン控除は、納税者が給与所得者である場合、住宅を取得して居住の用に供した年分から年末調整により適用を受けることができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 35,
        "shikenId": 1,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "法人税の仕組みに関する次の記述のうち、最も適切なものはどれか。(2022.09)",
        "choice1": "法人税の納税地は、原則として、その法人の代表者の住所または居所の所在地である。",
        "choice2": "法人税の各事業年度の所得の金額は、その事業年度の益金の額からその事業年度の損金の額を控除した金額である。",
        "choice3": "期末資本金の額等が1億円以下の一定の中小法人に対する法人税の税率は、所得金額のうち年1,000万円以下の部分について軽減税率が適用される。",
        "choice4": "法人税の確定申告書は、原則として、各事業年度終了の日の翌日から1ヵ月以内に、納税地の所轄税務署長に提出しなければならない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人税の仕組み",
        "important": ""
    },
    {
        "id": 36,
        "shikenId": 1,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "法人税の損金に関する次の記述のうち、最も不適切なものはどれか。(2022.05)",
        "choice1": "法人が法人税および法人住民税を納付した場合、その全額を損金の額に算入することができる。",
        "choice2": "法人が会議に関連して、茶菓、弁当その他これらに類する飲食物を供与するために通常要する費用を支出した場合、その全額を損金の額に算入することができる。",
        "choice3": "法人が役員に対して定期同額給与を支給した場合、不相当に高額な部分の金額など一定のものを除き、その全額を損金の額に算入することができる。",
        "choice4": "法人が減価償却費として損金経理した金額のうち、償却限度額に達するまでの金額は、その全額を損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人税の損金",
        "important": ""
    },
    {
        "id": 37,
        "shikenId": 1,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "消費税に関する次の記述のうち、最も不適切なものはどれか。(2023.01)",
        "choice1": "基準期間における課税売上高が1,000万円を超える法人は、消費税の免税事業者となることができない。",
        "choice2": "特定期間における給与等支払額の合計額および課税売上高がいずれも1,000万円を超える法人は、消費税の免税事業者となることができない。",
        "choice3": "基準期間における課税売上高が5,000万円を超える課税事業者は、簡易課税制度の適用を受けることができない。",
        "choice4": "消費税の免税事業者が「消費税課税事業者選択届出書」を提出して消費税の課税事業者となったときは、事業を廃止した場合を除き、原則として3年間は消費税の免税事業者に戻ることができない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "消費税",
        "important": ""
    },
    {
        "id": 38,
        "shikenId": 1,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。(2023.09)",
        "choice1": "会社が役員に対して無利息で金銭の貸付けを行った場合、原則として、通常収受すべき利息に相当する金額が、その会社の所得金額の計算上、益金の額に算入される。",
        "choice2": "会社が役員からの借入金について債務免除を受けた場合、その債務免除を受けた金額が、その会社の所得金額の計算上、益金の額に算入される。",
        "choice3": "役員が所有する土地を適正な時価の2分の1未満の価額で会社に譲渡した場合、その役員は、適正な時価の2分の1に相当する金額により当該土地を譲渡したものとして譲渡所得の計算を行う。",
        "choice4": "役員が会社の所有する社宅に無償で居住している場合、原則として、通常の賃貸料相当額が、その役員の給与所得の収入金額に算入される。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "会社と役員間の取引",
        "important": ""
    },
    {
        "id": 39,
        "shikenId": 1,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "決算書の見方に関する次の記述のうち、最も不適切なものはどれか。(2023.09)",
        "choice1": "損益計算書の営業利益の額は、売上総利益の額から販売費及び一般管理費の額を差し引いた額である。",
        "choice2": "損益計算書の税引前当期純利益の額は、経常利益の額に営業外損益の額を加算・減算した額である。",
        "choice3": "流動比率（％）は、「流動資産÷流動負債×100」の算式で計算される。",
        "choice4": "自己資本比率（％）は、「自己資本÷総資産×100」の算式で計算される。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "決算書の見方",
        "important": ""
    },
    {
        "id": 40,
        "shikenId": 1,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "消費税の適格請求書等保存方式（インボイス制度）に関する次の記述のうち、最も不適切なものはどれか。(2024.09)",
        "choice1": "消費税の免税事業者が適格請求書発行事業者の登録を受けると、消費税の課税事業者となる。",
        "choice2": "適格請求書発行事業者の登録に係る効力は、事業者が登録の通知を受けた日にかかわらず、適格請求書発行事業者登録簿に登載された日から生じる。",
        "choice3": "適格請求書発行事業者が、適格請求書に代えて適格簡易請求書を交付するためには、消費税の簡易課税制度の適用を受ける必要がある。",
        "choice4": "適格請求書には、適格請求書発行事業者の氏名または名称および登録番号や税率ごとに区分した消費税額等の記載が必要とされる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "適格請求書等保存方式（インボイス制度）",
        "important": ""
    },
    {
        "id": 41,
        "shikenId": 1,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "不動産鑑定評価基準における不動産の鑑定評価に関する次の記述のうち、最も不適切なものはどれか。(2022.09)",
        "choice1": "不動産の価格を求める鑑定評価の基本的な手法は、原価法、取引事例比較法および収益還元法に大別され、鑑定評価に当たっては、対象不動産に係る市場の特性等を考慮し、これらのうち最も適した1つの手法に限定して適用することとされている。",
        "choice2": "最有効使用の原則は、不動産の効用が最高度に発揮される可能性に最も富む使用を前提として把握される価格を標準として不動産の価格が形成されるとする原則である。",
        "choice3": "原価法は、価格時点における対象不動産の再調達原価を求め、この再調達原価について減価修正を行って対象不動産の価格を求める手法である。",
        "choice4": "収益還元法は、対象不動産が賃貸用不動産である場合だけでなく、自用の不動産であっても、賃貸を想定することにより適用されるものであるとされている。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産鑑定評価",
        "important": ""
    },
    {
        "id": 42,
        "shikenId": 1,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "不動産売買の契約に係る民法の規定に関する次の記述のうち、最も不適切なものはどれか。なお、特約については考慮しないものとする。(2024.05)",
        "choice1": "売買契約の締結後、買主の責めに帰すことのできない事由により、当該契約の目的物の引渡債務の全部が履行不能となった場合、買主は、履行の催告をすることなく、直ちに契約の解除をすることができる。",
        "choice2": "売主が種類または品質に関して契約の内容に適合しない目的物を買主に引き渡した場合において、買主がその不適合を知った時から1年以内にその旨を売主に通知しないときは、売主が引渡しの時にその不適合を知っていたとしても、買主は、その不適合を理由として契約の解除をすることができない。",
        "choice3": "売買の目的物である建物が、その売買契約の締結から当該建物の引渡しまでの間に、地震により全壊した場合、買主は、売主に対して建物代金の支払いを拒むことができる。",
        "choice4": "買主が売主に解約手付を交付した場合、売主は、買主が契約の履行に着手する前であれば、受領した手付の倍額を買主に対して現実に提供することにより、契約の解除をすることができる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産売買の契約に係る民法の規定",
        "important": ""
    },
    {
        "id": 43,
        "shikenId": 1,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、同法第38条による定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。また、記載された特約以外のものについては考慮しないものとする。(2022.09)",
        "choice1": "普通借家契約において存続期間を1年未満に定めた場合、その存続期間は1年とみなされる。",
        "choice2": "期間の定めがある普通借家契約において、賃借人は、正当の事由がなければ、賃貸人に対し、更新しない旨の通知をすることができない。",
        "choice3": "定期借家契約は、もっぱら居住の用に供する建物に限られ、事業の用に供する建物については締結することができない。",
        "choice4": "定期借家契約において、その賃料が、近傍同種の建物の賃料に比較して不相当となっても、賃貸借期間中は増減額させないこととする特約をした場合、その特約は有効である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "借地借家法（借家）",
        "important": ""
    },
    {
        "id": 44,
        "shikenId": 1,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、同法第22条の借地権を一般定期借地権といい、第22条から第24条の定期借地権等以外の借地権を普通借地権という。(2023.09)",
        "choice1": "普通借地権の設定契約において、期間の定めがないときは、存続期間は30年とされる。",
        "choice2": "普通借地権の存続期間が満了した時点で借地上に建物が存在しない場合は、借地権者が契約の更新を請求しても、従前の契約と同一の条件で契約が更新されたものとはみなされない。",
        "choice3": "一般定期借地権の設定契約において、存続期間は30年とすることができる。",
        "choice4": "一般定期借地権の設定契約は、公正証書による等書面（電磁的記録による場合を含む）によってしなければならない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "借地借家法（借地）",
        "important": ""
    },
    {
        "id": 45,
        "shikenId": 1,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。(2024.01)",
        "choice1": "すべての都市計画区域について、都市計画に市街化区域と市街化調整区域の区域区分を定めなければならない。",
        "choice2": "都市計画区域のうち、市街化調整区域は、おおむね10年以内に優先的かつ計画的に市街化を図るべき区域である。",
        "choice3": "開発許可を受けた開発区域内の土地においては、開発工事完了の公告があるまでの間は、原則として、建築物を建築することができない。",
        "choice4": "市街化調整区域内において、農業を営む者の居住の用に供する建築物の建築を目的として行う開発行為は、開発許可を受ける必要がある。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "都市計画法",
        "important": ""
    },
    {
        "id": 46,
        "shikenId": 1,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も適切なものはどれか。(2024.09)",
        "choice1": "建築基準法第42条第2項により道路境界線とみなされる線と道路との間の敷地の部分（セットバック部分）は、建築物を建築することができないが、建蔽率および容積率を算定する際の敷地面積に算入することができる。",
        "choice2": "準防火地域内に準耐火建築物を建築する場合、建蔽率の制限について緩和措置の適用を受けることができる。",
        "choice3": "建築物の敷地が2つの異なる用途地域にわたる場合、その建築物の全部について、敷地の過半の属する用途地域の建蔽率の制限が適用される。",
        "choice4": "敷地の前面道路の幅員が12ｍ未満である建築物の建蔽率は、原則として、「都市計画で定められた建蔽率」と「前面道路の幅員に一定の数値を乗じて得たもの」とのいずれか低い方が上限となる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築基準法の規定",
        "important": ""
    },
    {
        "id": 47,
        "shikenId": 1,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。(2023.01)",
        "choice1": "区分所有者は、敷地利用権が数人で有する所有権その他の権利である場合、規約に別段の定めがない限り、敷地利用権を専有部分と分離して処分することができる。",
        "choice2": "区分所有者は、規約に別段の定めがない限り、集会の議決によって管理者を選任し、または解任することができる。",
        "choice3": "集会においては、区分所有者および議決権の各5分の4以上の多数により建替え決議をすることができる。",
        "choice4": "共用部分に対する区分所有者の共有持分は、規約に別段の定めがない限り、各共有者が有する専有部分の床面積の割合による。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "区分所有法",
        "important": ""
    },
    {
        "id": 48,
        "shikenId": 1,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "不動産の取得に係る税金に関する次の記述のうち、最も適切なものはどれか。(2023.01)",
        "choice1": "不動産取得税は、相続により不動産を取得した場合は課されるが、贈与により不動産を取得した場合は課されない。",
        "choice2": "一定の要件を満たす戸建て住宅（認定長期優良住宅を除く）を新築した場合、不動産取得税の課税標準の算定に当たっては、1戸につき最高1,200万円を価格から控除することができる。",
        "choice3": "登録免許税は、贈与により不動産を取得した場合の所有権移転登記では課されない。",
        "choice4": "登録免許税は、建物を新築した場合の建物表題登記であっても課される。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の取得に係る税金",
        "important": ""
    },
    {
        "id": 49,
        "shikenId": 1,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人が土地を譲渡した場合の譲渡所得に関する次の記述のうち、最も不適切なものはどれか。(2024.01)",
        "choice1": "土地の譲渡に係る所得については、その土地を譲渡した日の属する年の1月1日における所有期間が10年以下の場合、短期譲渡所得に区分される。",
        "choice2": "譲渡所得の金額の計算上、譲渡した土地の取得費が不明な場合には、譲渡収入金額の5％相当額を取得費とすることができる。",
        "choice3": "相続（限定承認に係るものを除く）により取得した土地を譲渡した場合、その土地の所有期間を判定する際の取得の時期は、被相続人の取得の時期が引き継がれる。",
        "choice4": "土地を譲渡する際に支出した仲介手数料は、譲渡所得の金額の計算上、譲渡費用に含まれる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "個人が土地を譲渡した場合の譲渡所得",
        "important": ""
    },
    {
        "id": 50,
        "shikenId": 1,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "不動産の投資判断の手法等に関する次の記述のうち、最も不適切なものはどれか。(2023.05)",
        "choice1": "レバレッジ効果とは、投資に対する収益率が借入金の金利を上回っている場合に、借入金の利用により自己資金に対する利回りが上昇する効果をいう。",
        "choice2": "DCF法は、連続する複数の期間に発生する純収益および復帰価格を、その発生時期に応じて現在価値に割り引いて、それぞれを合計して対象不動産の収益価格を求める手法である。",
        "choice3": "NPV法（正味現在価値法）による投資判断においては、対象不動産から得られる収益の現在価値の合計額が投資額を上回っている場合、その投資は有利であると判定することができる。",
        "choice4": "IRR法（内部収益率法）による投資判断においては、対象不動産に対する投資家の期待収益率が対象不動産の内部収益率を上回っている場合、その投資は有利であると判定することができる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の投資判断の手法",
        "important": ""
    },
    {
        "id": 51,
        "shikenId": 1,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "民法上の贈与に関する次の記述のうち、最も適切なものはどれか。(2023.01)",
        "choice1": "書面によらない贈与は、その履行の終わった部分についても、各当事者が解除をすることができる。",
        "choice2": "定期贈与とは、贈与者が受贈者に対して定期的に財産を給付することを目的とする贈与をいい、贈与者または受贈者のいずれか一方が生存している限り、その効力を失うことはない。",
        "choice3": "負担付贈与では、受贈者がその負担である義務を履行しない場合において、贈与者が相当の期間を定めてその履行の催告をし、その期間内に履行がない場合、原則として、贈与者は、当該贈与の契約の解除をすることができる。",
        "choice4": "死因贈与では、民法の遺贈に関する規定が準用され、贈与者のみの意思表示により成立し、贈与者の死亡によって効力が生じる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "民法上の贈与",
        "important": ""
    },
    {
        "id": 52,
        "shikenId": 1,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "相続時精算課税制度（以下「本制度」という）に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。(2024.09)",
        "choice1": "父からの財産の贈与について本制度を選択した子は、その選択をした年分以後、所定の手続きにより、その父から受ける財産の贈与について暦年課税に変更することができる。",
        "choice2": "父からの財産の贈与について本制度を選択した子は、同一年中に母から受けた財産の贈与についても本制度が適用され、母からの贈与について暦年課税により贈与税額を計算することはできない。",
        "choice3": "父からの財産の贈与について子が本制度を選択しようとする場合、贈与者の年齢に係る要件はあるが、受贈者の年齢に係る要件はない。",
        "choice4": "父からの財産の贈与について子が本制度を選択しようとする場合、その適用の対象となる贈与財産の種類や贈与回数について制限はない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続時精算課税制度",
        "important": ""
    },
    {
        "id": 53,
        "shikenId": 1,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "民法上の遺言に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。(2024.05)",
        "choice1": "公正証書遺言の作成において、遺言者の配偶者は証人として立ち会うことができない。",
        "choice2": "自筆証書遺言の作成に当たって、自筆証書にこれと一体のものとして添付する財産目録をパソコンで作成する場合、その財産目録への署名および押印は不要である。",
        "choice3": "同一の遺言者による公正証書遺言と自筆証書遺言について、それぞれの内容が異なっている場合、その異なっている部分については、作成日付の新しい遺言の内容が効力を有する。",
        "choice4": "自筆証書遺言書保管制度により法務局（遺言書保管所）に保管されている自筆証書遺言は、遺言者の相続開始後、家庭裁判所の検認が不要である。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "民法上の遺言",
        "important": ""
    },
    {
        "id": 54,
        "shikenId": 1,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "遺産の分割に関する次の記述のうち、最も不適切なものはどれか。(2023.05)",
        "choice1": "共同相続人は、一定の場合を除き、遺産の全部ではなく一部の分割内容のみを定めた遺産分割協議書を作成することができる。",
        "choice2": "換価分割は、共同相続人が相続により取得した財産の全部または一部を金銭に換価し、その換価代金を共同相続人の間で分割する方法である。",
        "choice3": "代償分割は、現物分割を困難とする事由がある場合に、共同相続人が家庭裁判所に申し立て、その審判を受けることにより認められる分割方法である。",
        "choice4": "相続人が代償分割により他の相続人から交付を受けた代償財産は、相続税の課税対象となる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺産の分割",
        "important": ""
    },
    {
        "id": 55,
        "shikenId": 1,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "次の費用等のうち、相続税の課税価格の計算上、相続財産の価額から債務控除することができるものはどれか。なお、相続人は債務控除の適用要件を満たしているものとする。(2022.09)",
        "choice1": "被相続人が生前に購入した墓碑の購入代金で、相続開始時点で未払いのもの",
        "choice2": "遺言執行者に支払った被相続人の相続に係る遺言執行費用",
        "choice3": "被相続人に係る初七日および四十九日の法要に要した費用のうち、社会通念上相当と認められるもの",
        "choice4": "被相続人が所有していた不動産に係る固定資産税のうち、相続開始時点で納税義務は生じているが、納付期限が到来していない未払いのもの",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "債務控除できるもの",
        "important": ""
    },
    {
        "id": 56,
        "shikenId": 1,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "相続税の納税に関する次の記述のうち、最も不適切なものはどれか。(2023.01)",
        "choice1": "相続により土地を取得した者がその相続に係る相続税について延納を申請する場合、一定の要件を満たせば、その相続により取得した土地以外の土地を延納の担保として提供することができる。",
        "choice2": "相続税は金銭による一括納付が原則であるが、一括納付や延納による金銭の納付が困難な場合、納税義務者は、その納付を困難とする金額を限度に物納を申請することができる。",
        "choice3": "物納に充てることができる財産の種類には順位があり、不動産と上場株式はいずれも第1順位に分類されている。",
        "choice4": "「小規模宅地等についての相続税の課税価格の計算の特例」の適用を受けた宅地等を物納する場合の収納価額は、特例適用前の価額である。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の納税",
        "important": ""
    },
    {
        "id": 57,
        "shikenId": 1,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "下記＜親族関係図＞において、Aさんの相続が開始した場合の相続税額の計算における遺産に係る基礎控除額として、最も適切なものはどれか。なお、Cさんは相続の放棄をしている。また、Eさんは、Aさんの普通養子（特別養子縁組以外の縁組による養子）である。(2023.05)<br><img src='/img/1_57.jpg'/>",
        "choice1": "4,200万円",
        "choice2": "4,800万円",
        "choice3": "5,400万円",
        "choice4": "6,000万円",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺産に係る基礎控除額",
        "important": ""
    },
    {
        "id": 58,
        "shikenId": 1,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "宅地の相続税評価額の算定方法等に関する次の記述のうち、最も適切なものはどれか。(2024.01)",
        "choice1": "宅地の評価方法には、路線価方式と倍率方式があり、どちらの方式を採用するかについては、納税者が任意に選択することができる。",
        "choice2": "倍率方式は、固定資産税評価額に国税局長が一定の地域ごとに定める倍率を乗じて計算した金額によって評価する方式である。",
        "choice3": "正面と側方に路線がある宅地（角地）を路線価方式によって評価する場合、原則として、それぞれの路線価に奥行価格補正率を乗じた価額を比較し、低い方の路線価が正面路線価となる。",
        "choice4": "路線価は、路線に面する標準的な宅地の1坪当たりの価額であり、千円単位で表示される。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "宅地の相続税評価額の算定方法",
        "important": ""
    },
    {
        "id": 59,
        "shikenId": 1,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "Aさんの相続が開始した場合の相続税額の計算における下記＜資料＞の甲宅地の評価に関する次の記述のうち、最も適切なものはどれか。なお、記載のない事項については考慮しないものとする。(2023.09)<br><img src='/img/1_59.jpg'/>",
        "choice1": "長男が相続により甲宅地を取得した場合、貸宅地として評価する。",
        "choice2": "長男が相続により甲宅地を取得した場合、自用地として評価する。",
        "choice3": "妻が相続により甲宅地を取得した場合、貸宅地として評価する。",
        "choice4": "妻が相続により甲宅地を取得した場合、貸家建付地として評価する。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続財産の評価（不動産）",
        "important": ""
    },
    {
        "id": 60,
        "shikenId": 1,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "中小企業における経営の承継の円滑化に関する法律による「遺留分に関する民法の特例」（以下「本特例」という）に関する次の記述のうち、最も不適切なものはどれか。(2024.05)",
        "choice1": "会社事業後継者が本特例の適用を受けるためには、遺留分を有する旧代表者の推定相続人および会社事業後継者全員の書面による合意が必要である。",
        "choice2": "本特例の適用を受けることにより、会社事業後継者が旧代表者から贈与により取得した自社株式について、その価額を、遺留分を算定するための財産の価額に算入しないことができる。",
        "choice3": "本特例の適用を受けることにより、会社事業後継者が旧代表者から贈与により取得した自社株式について、遺留分を算定するための財産の価額に算入すべき価額を、本特例の適用に係る合意をした時点の価額とすることができる。",
        "choice4": "本特例の対象となる会社事業後継者は、旧代表者の親族に限られる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺留分に関する民法の特例",
        "important": ""
    },
    {
        "id": 61,
        "shikenId": 3,
        "no": 1,
        "answerType": 4,
        "groupId": 0,
        "answer": "781451,1109776,50869,1160645",
        "score": "1,1,1,1",
        "question1": "<img src='/img/1_1.png'/>",
        "question2": "Ａさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生 年金の年金額（2025年度価額）を計算した次の〈計算の手順〉の空欄①～④に入る 最も適切な数値を解答欄に入力しなさい。なお、計算にあたっては、《設例》の〈Ａさ ん夫妻に関する資料〉および下記の〈資料〉に基づくこと。また、問題の性質上、 明らかにできない部分は「□□□」で示してある。<br><img src='/img/1_2.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "2024.05(改）",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金・老齢厚生年金の年金額",
        "important": ""
    },
    {
        "id": 62,
        "shikenId": 3,
        "no": 2,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "<img src='/img/1_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、公的年金制度の老齢給付について説明した。Ｍさんが 説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を 解答欄に入力しなさい。",
        "choice1": "「Ａさんが老齢厚生年金の繰上げ支給を請求する場合、老齢基礎年金の繰上げ支給 の請求も同時に行わなければなりません」",
        "choice2": "「Ａさんが75歳０カ月で老齢基礎年金および老齢厚生年金の繰下げ支給の申出をす る場合、それぞれの年金額の増額率は70％となります」",
        "choice3": "「Ａさんおよび妻Ｂさんは、1961年４月２日以降生まれであるため、いずれも報酬 比例部分のみの特別支給の老齢厚生年金を受給することはできません」",
        "choice4": "",
        "choice5": "2024.05(改）",
        "categoryName": "ライフ",
        "rontenName": "公的年金制度の老齢給付",
        "important": ""
    },
    {
        "id": 63,
        "shikenId": 3,
        "no": 3,
        "answerType": 6,
        "groupId": 0,
        "answer": "チ,ホ,ロ",
        "score": "1,1,1",
        "question1": "<img src='/img/1_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、社会保険の各種取扱いについて説明した。Ｍさんが説 明した以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかか ら選び、その記号を解答欄に入力しなさい。<br><img src='/img/3_1.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.05(改）",
        "categoryName": "ライフ",
        "rontenName": "社会保険の各種取扱い",
        "important": ""
    },
    {
        "id": 64,
        "shikenId": 3,
        "no": 4,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,1",
        "score": "1,1,1",
        "question1": "<img src='/img/3_64.png'/>",
        "question2": "Ｍさんは、Ａさんと長女Ｃさんに対して、株式取引のルール等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「国内株式市場における代表的な株価指標である日経平均株価は、東京証券取引所のスタンダード市場に上場している銘柄のうち、代表的な225銘柄を対象とした修正平均型の株価指標です」",
        "choice2": "「上場株式の注文方法のうち、指値注文では、高い値段の買い注文が低い値段の買い注文に優先して売買が成立し、同じ値段の買い注文については、寄付や引けなどを除き、先に出された注文が後に出された注文に優先して売買が成立します」",
        "choice3": "「Ｘ社株式の次回の配当を受け取るためには、普通取引の場合、権利確定日の２営業日前である本年６月28日（水）までに買付けを行い、権利確定日に株主として株主名簿に記載される必要があります」",
        "choice4": "",
        "choice5": "2023.05（改）",
        "categoryName": "金融",
        "rontenName": "株式取引のルール等",
        "important": ""
    },
    {
        "id": 65,
        "shikenId": 3,
        "no": 5,
        "answerType": 4,
        "groupId": 0,
        "answer": "10.83,2.23",
        "score": "2,2",
        "question1": "<img src='/img/3_64.png'/>",
        "question2": "《設例》のデータに基づいて算出される次の①、②を求め、解答欄に入力しなさい（計算過程の記載は不要）。〈答〉は表示単位の小数点以下第３位を四捨五入し、小数点以下第２位までを解答すること。<br>①Ｘ社株式のＰＥＲ<br>②Ｙ社株式のＰＢＲ",
        "choice1": "倍",
        "choice2": "倍",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.05(改）",
        "categoryName": "金融",
        "rontenName": "PERとPBRの計算",
        "important": ""
    },
    {
        "id": 66,
        "shikenId": 3,
        "no": 6,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "<img src='/img/3_64.png'/>",
        "question2": "Ｍさんは、Ａさんと長女Ｃさんに対して、《設例》のデータに基づいて、株式の投資指標等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「一般に、ＲＯＥの数値が高いほうが経営の効率性が高いと判断されます。ＲＯＥは、Ｙ社のほうがⅩ社よりも高くなっています」",
        "choice2": "「株主への利益還元の大きさに着目した指標として、配当性向があります。配当性向は、Ⅹ社のほうがＹ社よりも高くなっています」",
        "choice3": "「株式投資において、ＰＥＲやＰＢＲ等が低い銘柄など、企業の業績や財務内容等からみて株価が割安と判断される銘柄に投資する手法は、一般に、グロース投資と呼ばれます」",
        "choice4": "",
        "choice5": "2023.05(改）",
        "categoryName": "金融",
        "rontenName": "株式の投資指標等",
        "important": ""
    },
    {
        "id": 67,
        "shikenId": 3,
        "no": 7,
        "answerType": 6,
        "groupId": 0,
        "answer": "ヘ,ル,イ,ホ",
        "score": "1,1,1,1",
        "question1": "<img src='/img/3_67.png'/>",
        "question2": "所得税における医療費控除に関する以下の文章の空欄①～④に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を解答欄に入力しなさい。<br><img src='/img/3_67_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル|ヲ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.01",
        "categoryName": "タックス",
        "rontenName": "医療費控除に関する数値",
        "important": ""
    },
    {
        "id": 68,
        "shikenId": 3,
        "no": 8,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "<img src='/img/3_67.png'/>",
        "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「Ａさんは、配偶者控除の適用を受けることはできませんが、配偶者特別控除の適用を受けることができます」",
        "choice2": "「Ａさんが適用を受けることができる扶養控除の控除額は、101万円です」",
        "choice3": "「Ａさんが医療費控除の適用を受けるためには、所得税の確定申告が必要です。年末調整では医療費控除の適用を受けることができません」",
        "choice4": "",
        "choice5": "2023.01（改）",
        "categoryName": "タックス",
        "rontenName": "所得税の課税",
        "important": ""
    },
    {
        "id": 69,
        "shikenId": 3,
        "no": 9,
        "answerType": 4,
        "groupId": 0,
        "answer": "700,640",
        "score": "1,2",
        "question1": "<img src='/img/3_67.png'/>",
        "question2": "Ａさんの本年分の所得金額について、次の①、②を求め、解答欄に入力しなさい（計算過程の記載は不要）。なお、①の計算上、Ａさんが所得金額調整控除の適用対象者に該当している場合、所得金額調整控除額を控除すること。また、〈答〉は万円単位とすること。<br>①総所得金額に算入される給与所得の金額<br>②総所得金額<br><img src='/img/3_69.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.01（改）",
        "categoryName": "タックス",
        "rontenName": "所得金額の計算",
        "important": ""
    },
    {
        "id": 70,
        "shikenId": 3,
        "no": 10,
        "answerType": 4,
        "groupId": 0,
        "answer": "600,1800",
        "score": "2,2",
        "question1": "<img src='/img/3_70.png'/>",
        "question2": "甲土地上に耐火建築物を建築する場合における次の①、②を求め、解答欄に入力しなさい（計算過程の記載は不要）。<br>①建蔽率の上限となる建築面積<br>②容積率の上限となる延べ面積",
        "choice1": "㎡",
        "choice2": "㎡",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "不動産",
        "rontenName": "建築面積と延べ面積の上限",
        "important": ""
    },
    {
        "id": 71,
        "shikenId": 3,
        "no": 11,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,1",
        "score": "1,1,1",
        "question1": "<img src='/img/3_70.png'/>",
        "question2": "定期借地権方式による甲土地の有効活用に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に記入しなさい。",
        "choice1": "「定期借地権方式は、事業者等に対して甲土地を一定期間賃貸する手法です。仮に、Ａさんが甲土地に事業用定期借地権を設定する場合、その契約は公正証書によってしなければなりません」",
        "choice2": "「事業用定期借地権は、ドラッグストアやコンビニ等の店舗だけでなく、賃貸マンションや老人ホーム等の居住用の施設を有する建物を建築する場合にも設定することができます」",
        "choice3": "「甲土地に建物譲渡特約付借地権を設定した場合、その設定後30年以上を経過した日に、Ａさんが甲土地上の建物を借地権者から買い取ったときは、借地契約が終了します。買い取った建物は賃貸することで家賃収入を得ることができますが、建物の維持管理の状態などによっては、十分な収益が見込めない可能性があります」",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "不動産",
        "rontenName": "定期借地権方式による土地の有効活用",
        "important": ""
    },
    {
        "id": 72,
        "shikenId": 3,
        "no": 12,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "<img src='/img/3_70.png'/>",
        "question2": "定期借地権方式により甲土地を有効活用する場合の課税等に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「Ａさんが甲土地に定期借地権を設定した場合、甲土地上の建物については借地権者が、甲土地については借地権割合に基づきＡさんと借地権者が、それぞれ固定資産税の納税義務者となります」",
        "choice2": "「Ａさんが甲土地に事業用定期借地権を設定し、その存続期間中にＡさんの相続が開始した場合、相続税額の計算上、甲土地は貸家建付地として評価されます」",
        "choice3": "「Ａさんが甲土地に事業用定期借地権を設定した場合、当該借地契約は、借地権者から申出があっても更新することはできませんが、Ａさんと借地権者の合意のもと、借地借家法で定められた事業用定期借地権の存続期間内で存続期間を延長することや、存続期間満了時において再契約することは可能です」",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "不動産",
        "rontenName": "土地を有効活用する場合の課税等",
        "important": ""
    },
    {
        "id": 73,
        "shikenId": 3,
        "no": 13,
        "answerType": 6,
        "groupId": 0,
        "answer": "ホ,チ,ヌ,ロ",
        "score": "1,1,1,1",
        "question1": "<img src='/img/3_73.png'/>",
        "question2": "Ａさんの相続に関する以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を解答用紙に記入しなさい。<br><img src='/img/3_73_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.09（改）",
        "categoryName": "相続",
        "rontenName": "相続等に関する語句または数値",
        "important": ""
    },
    {
        "id": 74,
        "shikenId": 3,
        "no": 14,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "<img src='/img/3_73.png'/>",
        "question2": "「直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税」 （以下、 「本制度」という）に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答用紙に記入しなさい。",
        "choice1": "「本制度の適用を受けるためには、取得等した住宅用家屋の床面積が50㎡以上200㎡以下でなければならず、また、その家屋の床面積の２分の１以上に相当する部分が受贈者の居住の用に供されるものである必要があります」",
        "choice2": "「長女Ｄさんが、Ａさんおよび妻Ｂさんのそれぞれから住宅取得等資金の贈与を受けてマンションを購入し、本制度の適用を受ける場合、当該マンションが一定の省エネ等住宅に該当するときは、Ａさんおよび妻Ｂさんから贈与を受けた資金について、それぞれ1,000万円を限度として贈与税が非課税となります」",
        "choice3": "「長女Ｄさんが、Ａさんから贈与を受けた住宅取得等資金について本制度の適用を受け、その後、Ａさんの相続が開始した場合、本制度の適用を受けたことにより贈与税が非課税とされた金額を相続税の課税価格に加算する必要はありません」",
        "choice4": "",
        "choice5": "2024.09（改）",
        "categoryName": "相続",
        "rontenName": "住宅取得等資金の贈与の非課税",
        "important": ""
    },
    {
        "id": 75,
        "shikenId": 3,
        "no": 15,
        "answerType": 4,
        "groupId": 0,
        "answer": "4800,800,3900",
        "score": "1,1,1",
        "question1": "<img src='/img/3_73.png'/>",
        "question2": "現時点（本年９月８日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、課税遺産総額（相続税の課税価格の合計額－遺産に係る基礎控除額）は２億円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src='/img/3_75_2.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "2024.09（改）",
        "categoryName": "相続",
        "rontenName": "相続税の総額",
        "important": ""
    },
    {
        "id": 76,
        "shikenId": 4,
        "no": 1,
        "answerType": 4,
        "groupId": 0,
        "answer": "783184,1149765,49136,1614801",
        "score": "1,1,1,1",
        "question1": "<img src='/img/4_76.png'/>",
        "question2": "Ａさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（2025年度価額）を計算した次の＜計算の手順＞の空欄①～④に入る最も適切な数値を解答欄に入力しなさい。計算にあたっては、《設例》の＜Ａさん夫妻に関する資料＞および下記の＜資料＞に基づくこと。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src='/img/4_76_2.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "2023.05（改）",
        "categoryName": "ライフ",
        "rontenName": "年金額の計算",
        "important": ""
    },
    {
        "id": 77,
        "shikenId": 4,
        "no": 2,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "<img src='/img/4_76.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、Ａさん夫妻が受給することができる公的年金制度からの老齢給付について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「Ａさんは特別支給の老齢厚生年金を受給することができませんが、妻Ｂさんは64歳から報酬比例部分のみの特別支給の老齢厚生年金を受給することができます」",
        "choice2": "「仮に、Ａさんが60歳０カ月で老齢基礎年金および老齢厚生年金の繰上げ支給を請求した場合の減額率は24％となります。繰上げ支給を請求した場合は、一生涯減額された年金額を受け取ることになります」",
        "choice3": "「Ａさんが希望すれば、66歳以後、老齢基礎年金および老齢厚生年金の繰下げ支給の申出をすることができます。Ａさんの場合、繰下げの上限年齢は70歳です」",
        "choice4": "",
        "choice5": "2023.05（改）",
        "categoryName": "ライフ",
        "rontenName": "公的年金制度からの老齢給付",
        "important": ""
    },
    {
        "id": 78,
        "shikenId": 4,
        "no": 3,
        "answerType": 6,
        "groupId": 0,
        "answer": "ニ,イ,チ",
        "score": "1,1,1",
        "question1": "<img src='/img/4_76.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、雇用保険の高年齢雇用継続基本給付金および在職老齢年金について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を解答欄に入力しなさい。<br><br>Ⅰ　「ＡさんがＸ社の継続雇用制度を利用して、60歳以後も引き続きＸ社に勤務し、かつ、60歳以後の各月（支給対象月）に支払われた賃金額（みなし賃金を含む）が60歳到達時の賃金月額の（　①　）％未満となる場合、Ａさんは、所定の手続により、原則として、高年齢雇用継続基本給付金を受給することができます。高年齢雇用継続基本給付金の額は、支給対象月ごとに、その月に支払われた賃金額の低下率に応じて、一定の方法により算定されますが、賃金額が60歳到達時の賃金月額の61％未満となる場合、原則として、当該金額は賃金額の（　②　）％に相当する額になります」<br><br>Ⅱ　「Ａさんが、65歳以後も引き続き厚生年金保険の被保険者としてＸ社に勤務し、かつ、65歳から老齢厚生年金を受給する場合、Ａさんの老齢厚生年金の報酬比例部分の額に基づく基本月額と総報酬月額相当額との合計額が（　③　）支給停止調整額、（2025年度価額）以下のときは調整が行われず、老齢厚生年金は全額支給されます」<br><img src='/img/4_78.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.05（改）",
        "categoryName": "ライフ",
        "rontenName": "高年齢雇用継続基本給付金",
        "important": ""
    },
    {
        "id": 79,
        "shikenId": 4,
        "no": 4,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "<img src='/img/4_79.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、公的年金制度からの給付および公的介護保険からの保険給付について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。なお、各記述において、ほかに必要とされる要件等は満たしていることとする。",
        "choice1": "「Ａさんが死亡した場合、妻Ｂさんに対して、遺族厚生年金が支給されます。遺族厚生年金の額は、原則として、Ａさんの厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の３分の２相当額になります」",
        "choice2": "「Ａさんが病気やケガで重度の障害状態となり、その障害の程度が障害等級１級と認定された場合、Ａさんは障害厚生年金を受給することができますが、Ａさんには子どもがいないため、障害基礎年金を受給することはできません」",
        "choice3": "「Ａさんのような公的介護保険の第２号被保険者は、要介護状態または要支援状態となった原因が特定疾病によって生じたものでなければ、公的介護保険からの保険給付は受けられません。特定疾病の具体例として、末期がん、脳血管疾患、初老期における認知症などが挙げられます」",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "保険（個人）",
        "rontenName": "公的年金制度・公的介護保険",
        "important": ""
    },
    {
        "id": 80,
        "shikenId": 4,
        "no": 5,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,1,2",
        "score": "1,1,1,1",
        "question1": "<img src='/img/4_79.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の内容等について説明した。Ｍさんが説明した次の記述①～④について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「Ａさんが死亡した場合、妻Ｂさんに支払われる死亡保険金額は、600万円となります。Ａさんが死亡した場合の必要保障額を算出し、準備すべき死亡保障の額を確認したうえで、死亡保険金額をご検討ください」",
        "choice2": "「Ａさんが病気やケガで重度の障害状態となって働けなくなった場合、Ａさんの収入が減るだけでなく、妻Ｂさんの仕事にも影響がでることが想定されます。現在提案を受けている生活介護収入保障特約など、重い障害や介護に備えることができる保障を準備することは検討に値します」",
        "choice3": "「がん等の重度疾病については、再発のリスクがあり、治療期間も長期にわたるケースがあります。そのため、重度疾病の保障を準備する際には、再発時の保障の有無や、保険金等が支払われる疾病の種類および状態を確認する必要があります」",
        "choice4": "「Ａさんが厚生労働大臣により定められた先進医療による療養を受けたとき、その先進医療の技術に係る費用と同額を先進医療給付金として受け取ることができます。ただし、先進医療特約の対象は入院を伴った治療のみであり、外来での治療は対象外となります」",
        "choice5": "2024.01",
        "categoryName": "保険（個人）",
        "rontenName": "生命保険の内容等",
        "important": ""
    },
    {
        "id": 81,
        "shikenId": 4,
        "no": 6,
        "answerType": 6,
        "groupId": 0,
        "answer": "ニ,ロ,リ",
        "score": "1,1,1",
        "question1": "<img src='/img/4_79.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の課税関係について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を解答欄に入力しなさい。<br><br>Ⅰ　「支払保険料のうち、終身保険特約および定期保険特約に係る保険料は一般の生命保険料控除の対象となります。他方、生活介護収入保障特約、重度疾病保障特約および総合医療特約等に係る保険料は介護医療保険料控除の対象となります。それぞれの適用限度額は、所得税で（　①　）円、住民税で（　②　）円です」<br><br>Ⅱ　「被保険者であるＡさんが入院給付金などを請求することができない特別な事情がある場合には、指定代理請求人である妻ＢさんがＡさんに代わって請求することができます。妻Ｂさんが指定代理請求人として受け取る入院給付金は、（　③　）となります」<br><img src='/img/4_81.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "保険（個人）",
        "rontenName": "生命保険の課税関係",
        "important": ""
    },
    {
        "id": 82,
        "shikenId": 4,
        "no": 7,
        "answerType": 4,
        "groupId": 0,
        "answer": "1500,1750",
        "score": "1,2",
        "question1": "<img src='/img/4_80.png'/>",
        "question2": "仮に、将来Ｘ社がＡさんに役員退職金5,000万円を支給した場合、Ａさんが受け取る役員退職金について、次の①、②を求め、解答欄に入力しなさい（計算過程の記載は不要）。〈答〉は万円単位とすること。なお、Ａさんの役員在任期間（勤続年数）を29年６カ月とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。<br>①退職所得控除額<br>②退職所得の金額",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "保険（法人）",
        "rontenName": "退職所得の金額",
        "important": ""
    },
    {
        "id": 83,
        "shikenId": 4,
        "no": 8,
        "answerType": 6,
        "groupId": 0,
        "answer": "イ,ニ,チ,ル",
        "score": "1,1,1,1",
        "question1": "<img src='/img/4_80.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、中小企業退職金共済制度（以下、「中退共」という）について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句を、下記の〈語句群〉のなかから選び、その記号を解答欄に入力しなさい。<br><br>　「中退共は、中小企業の事業主が勤労者退職金共済機構と雇用者（従業員）を被共済者とする退職金共済契約を締結して、退職金を社外に積み立てる共済制度です。<br>　掛金は、被共済者１人につき、月額5,000円から３万円までの範囲内から選択し、（　①　）負担します。なお、短時間労働者（パートタイマー等）は、月額2,000円から加入することができ、役員は原則として加入することができません。<br>　また、中退共に新たに加入する事業主に対して、原則として、掛金月額の（　②　）（被共済者１人ごとに5,000円が上限）を加入後４カ月目から（　③　）、国が助成する制度があります。<br>被共済者が中途（生存）退職したときの退職金は、勤労者退職金共済機構から（　④　）支給されます」<br><img src='/img/4_83.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "保険（法人）",
        "rontenName": "中小企業退職金共済制度",
        "important": ""
    },
    {
        "id": 84,
        "shikenId": 4,
        "no": 9,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,1",
        "score": "1,1,1",
        "question1": "<img src='/img/4_80.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、〈資料〉の養老保険（福利厚生プラン）について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「福利厚生プランの保険料は、その全額を福利厚生費として損金の額に算入します」",
        "choice2": "「福利厚生プランは、原則として、役員・従業員全員を被保険者とする等の普遍的加入でなければなりませんので、制度導入後に入社した従業員について加入漏れがないように注意してください」",
        "choice3": "「死亡保険金が被保険者の遺族に支払われた場合、Ｘ社は当該保険契約に係る資産計上額を取り崩し、当該金額を雑損失として損金の額に算入します」",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "保険（法人）",
        "rontenName": "養老保険（福利厚生プラン）",
        "important": ""
    },
    {
        "id": 85,
        "shikenId": 4,
        "no": 10,
        "answerType": 6,
        "groupId": 0,
        "answer": "ヘ,イ,ホ",
        "score": "1,1,1",
        "question1": "<img src='/img/4_85.png'/>",
        "question2": "所得税における医療費控除に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を解答用紙に記入しなさい。<br><img src='/img/4_85_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.09（改）",
        "categoryName": "タックス",
        "rontenName": "医療費控除に関する数値",
        "important": ""
    },
    {
        "id": 86,
        "shikenId": 4,
        "no": 11,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,1",
        "score": "1,1,1",
        "question1": "<img src='/img/4_85.png'/>",
        "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答用紙に記入しなさい。",
        "choice1": "「一時払養老保険は金融類似商品に該当するため、Ａさんが受け取った満期保険金に係る保険差益は源泉分離課税の対象となります」",
        "choice2": "「Ａさんが通常の医療費控除の適用を受けた場合、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）の適用を受けることはできません」",
        "choice3": "「Ａさんが適用を受けることができる配偶者控除の控除額は、38万円です」",
        "choice4": "",
        "choice5": "2024.09（改）",
        "categoryName": "タックス",
        "rontenName": "所得税の課税に関する記述",
        "important": ""
    },
    {
        "id": 87,
        "shikenId": 4,
        "no": 12,
        "answerType": 4,
        "groupId": 0,
        "answer": "6720000,630000,580000,352500",
        "score": "1,1,1,1",
        "question1": "<img src='/img/4_85.png'/>",
        "question2": "Ａさん本年分の所得税の算出税額を計算した下記の表の空欄①～④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src='/img/4_87_1.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "2024.09（改）",
        "categoryName": "タックス",
        "rontenName": "所得税の算出税額",
        "important": ""
    },
    {
        "id": 88,
        "shikenId": 4,
        "no": 13,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,1",
        "score": "1,1,1",
        "question1": "<img src='/img/4_88.png'/>",
        "question2": "遺言に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「自筆証書遺言は、その遺言の全文および財産目録をパソコンで作成し、日付および氏名を自書して押印することで作成することができます」",
        "choice2": "「自筆証書遺言は、所定の手続により、法務局（遺言書保管所）に保管することができます。法務局に保管された自筆証書遺言は、遺言者の相続開始時に、家庭裁判所の検認が不要となります」",
        "choice3": "「公正証書遺言は、証人２人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人がこれを筆記して作成しますが、推定相続人が証人になることはできません」",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "相続",
        "rontenName": "遺言に関する記述",
        "important": ""
    },
    {
        "id": 89,
        "shikenId": 4,
        "no": 14,
        "answerType": 6,
        "groupId": 0,
        "answer": "チ,ホ,ル,ロ",
        "score": "1,1,1,1",
        "question1": "<img src='/img/4_88.png'/>",
        "question2": "Ａさんの相続に関する以下の文章の空欄①～④に入る最も適切な語句を、下記の〈語句群〉のなかから選び、その記号を解答欄に入力しなさい。<br><br>Ⅰ　「遺言により、自宅および現預金等を妻Ｂさん、Ｘ社関連の資産を長男Ｃさんに相続させた場合、二男Ｄさんの遺留分を侵害するおそれがあります。仮に、遺留分を算定するための財産の価額が６億円の場合、二男Ｄさんの遺留分の金額は、（　①　）となります」<br><br>Ⅱ　「長男ＣさんがＸ社本社敷地を相続により取得し、当該敷地について、特定同族会社事業用宅地等として『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、当該敷地（相続税評価額8,000万円）について、相続税の課税価格に算入すべき価額を（　②　）とすることができます。なお、自宅敷地とＸ社本社敷地について、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けようとする場合、（　③　）」<br><br>Ⅲ　「Ａさんが加入している一時払終身保険の死亡保険金は、みなし相続財産として相続税の課税対象となります。Ａさんの相続開始後、妻Ｂさんが受け取る死亡保険金2,000万円のうち、相続税の課税価格に算入される金額は、（　④　）となります」<br><img src='/img/4_89.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "相続",
        "rontenName": "相続に関する語句",
        "important": ""
    },
    {
        "id": 90,
        "shikenId": 4,
        "no": 15,
        "answerType": 4,
        "groupId": 0,
        "answer": "4800,2820,13110",
        "score": "1,1,1",
        "question1": "<img src='/img/4_88.png'/>",
        "question2": "現時点（本年９月10日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は５億円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src='/img/4_90_1.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "2023.09（改）",
        "categoryName": "相続",
        "rontenName": "相続税の総額",
        "important": ""
    },
    {
        "id": 91,
        "shikenId": 2,
        "no": 1,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,2,1",
        "score": "1,1,1,1",
        "question1": "ファイナンシャル・プランナー（以下「ＦＰ」という）が、ファイナンシャル・プランニング業務を行ううえで関連業法等を順守することが重要である。ＦＰの行為に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を入力しなさい。",
        "question2": "",
        "choice1": "社会保険労務士資格を有していないＦＰが、顧客が持参した「ねんきん定期便」を基に、有償で公的年金の受給見込み額を計算した。",
        "choice2": "弁護士資格を有していないＦＰが、報酬を得て顧客の離婚問題における交渉代理人となり、ＦＰ業務の一環として法律的な判断に基づいて相手方との交渉を代行した。",
        "choice3": "投資助言・代理業の登録を受けていないＦＰが、独自の景気見通しを基に、有償で具体的な投資時期等を判断し、助言を行った。",
        "choice4": "税理士資格を有していないＦＰが、相続対策を検討している顧客に対し、有料の相談業務におい て、仮定の事例に基づく一般的な解説を行った。",
        "choice5": "2022.09",
        "categoryName": "ライフ",
        "rontenName": "FPと関連業法",
        "important": ""
    },
    {
        "id": 92,
        "shikenId": 2,
        "no": 2,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "「消費者契約法」に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "消費者が、商品を購入せずに退去したい旨を申し出たが、認められずに困惑して契約した場合で、購入場所が事業者の店舗であるときは、当該契約は取り消すことができる。",
        "choice2": "「販売した商品は、いかなる理由があっても、後から返品・キャンセルはできません」とした契約条項は無効である。",
        "choice3": "消費者契約法では、個人および法人を保護の対象としている。",
        "choice4": "消費者の努力義務として、契約に際して事業者から提供された情報を活用し、契約内容を理解することが求められている。",
        "choice5": "2022.09",
        "categoryName": "ライフ",
        "rontenName": "消費者契約法",
        "important": ""
    },
    {
        "id": 93,
        "shikenId": 2,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "下記＜証券口座の概要＞に関する次の記述のうち、最も適切なものはどれか。<br><img src='/img/2_93.png'/>",
        "question2": "",
        "choice1": "金融商品取引業者等は、（ａ）のみを選択している個人投資家に対して、その口座内での１年間の取引をまとめて取引報告書を交付しなければならない。",
        "choice2": "年初の売却で（ｂ）を選択した場合、同年中の２度目以降の売却の際に（ｃ）に変更できない。",
        "choice3": "（ｃ）を選択した場合、ほかの金融商品取引業者等に開設している特定口座における損益と通算することはできない。",
        "choice4": "（ｄ）の非課税投資枠を超えた取引は、（ａ）で取引しなければならない。",
        "choice5": "2023.09",
        "categoryName": "金融",
        "rontenName": "証券口座の種類",
        "important": ""
    },
    {
        "id": 94,
        "shikenId": 2,
        "no": 4,
        "answerType": 8,
        "groupId": 1,
        "answer": "1,10,6,2",
        "score": "1,1,1,1",
        "question1": "個人向け国債（変動１０年）に関する下表の空欄（ア）～（エ）にあてはまる適切な語句または数値を語群の中から選び、その番号のみを解答欄に入力しなさい。なお、同じ番号を何度選んでもよいこととする。<br><img src='/img/2_94.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9|10",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "金融",
        "rontenName": "個人向け国債",
        "important": ""
    },
    {
        "id": 95,
        "shikenId": 2,
        "no": 5,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "馬場さんは、特定口座で保有しているＨＧ投資信託（追加型国内公募株式投資信託）の収益分配金を本年６月に受け取った。ＨＧ投資信託の運用状況が下記＜資料＞のとおりである場合、次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。 <br><img src='/img/2_95.png'/>",
        "question2": "",
        "choice1": "（ア）１３,６００円 （イ）される",
        "choice2": "（ア）１４,１００円 （イ）される",
        "choice3": "（ア）１３,６００円 （イ）されない",
        "choice4": "（ア）１４,１００円 （イ）されない",
        "choice5": "2023.09（改）",
        "categoryName": "金融",
        "rontenName": "収益分配金の課税関係",
        "important": ""
    },
    {
        "id": 96,
        "shikenId": 2,
        "no": 6,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "藤原さんは、勤務先に企業年金がないため、ＨＴ社を運営管理機関とする個人型確定拠出年金（以下「ｉＤｅＣｏ」という）に加入することを検討しており、下記＜資料＞を示してＦＰの小山さんに質問をした。小山さんの説明のうち、最も不適切なものはどれか。<br><img src='/img/2_96.png'/>",
        "question2": "",
        "choice1": "「ＨＴ社が扱う商品の中から１つだけを運用商品として、選択することはできません。」 ",
        "choice2": "「選択した運用商品は、ｉＤｅＣｏ加入中、原則として、いつでも変更することができます。」 ",
        "choice3": "「運用商品のうち投資信託には、国内株式型や国内債券型など投資対象となる資産によって分類されるものもありますが、バランス型のように複数資産を組み合わせたものもあります。」",
        "choice4": "「運用商品には、保険商品や定期預金等の元本確保型商品があり、所定の利息が上乗せされますが、金利情勢によっては利息額を手数料が上回る場合もあります。」",
        "choice5": "2023.09",
        "categoryName": "金融",
        "rontenName": "個人型確定拠出年金",
        "important": ""
    },
    {
        "id": 97,
        "shikenId": 2,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "建築基準法に従い、下記＜資料＞の土地に耐火建築物を建てる場合、建築面積の最高限度（ア）と延べ面積（床面積の合計）の最高限度（イ）の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない条件は一切考慮しないこと。<br><img src='/img/2_97.png'/>",
        "question2": "",
        "choice1": "（ア）１６２㎡（イ）１０８０㎡",
        "choice2": "（ア）１８９㎡（イ） ８６４㎡",
        "choice3": "（ア）１６２㎡ （イ） ８６４㎡",
        "choice4": "（ア）１８９㎡ （イ）１０８０㎡",
        "choice5": "2022.09",
        "categoryName": "不動産",
        "rontenName": "建築面積と延べ面積の最高限度",
        "important": ""
    },
    {
        "id": 98,
        "shikenId": 2,
        "no": 8,
        "answerType": 8,
        "groupId": 1,
        "answer": "1,2,4,5",
        "score": "1,1,1,1",
        "question1": "羽田さんは、所有しているアパートを貸すに当たり、ＦＰの近藤さんに借家契約の説明を受けた。借地借家法に基づく借家契約に関する下表の空欄（ア）～（エ）に入る最も適切な語句を語群の中から選び、その番号のみを解答欄に入力しなさい。なお、同じ語句を何度選んでもよいこととする。<br><img src='/img/2_98.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2022.09",
        "categoryName": "不動産",
        "rontenName": "借家契約",
        "important": ""
    },
    {
        "id": 99,
        "shikenId": 2,
        "no": 9,
        "answerType": 8,
        "groupId": 1,
        "answer": "4,2,7",
        "score": "1,1,1",
        "question1": "飯田さんは、１００㎡ほどの土地付き中古一戸建て住宅の購入を検討しており、ＦＰで税理士でもある浅見さんに不動産にかかる税金について質問をした。下記の空欄（ア）～（ウ）に入る適切な語句を語群の中から選び、その番号のみを解答欄に入力しなさい。<br><img src='/img/2_99.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2022.09",
        "categoryName": "不動産",
        "rontenName": "不動産にかかる税金",
        "important": ""
    },
    {
        "id": 100,
        "shikenId": 2,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "下記＜資料＞は、天野さんが購入を検討している投資用マンションの概要である。この物件の表面利回り（年利）と実質利回り（年利）の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない事項については一切考慮しないこととし、計算結果については小数点以下第３位を四捨五入すること。<br><img src='/img/2_100.png'/>",
        "question2": "",
        "choice1": "表面利回り（年利）：５.２０％ 実質利回り（年利）：３.８８％",
        "choice2": "表面利回り（年利）：５.２０％ 実質利回り（年利）：０.４０％",
        "choice3": "表面利回り（年利）：４.２０％ 実質利回り（年利）：３.８８％",
        "choice4": "表面利回り（年利）：４.２０％ 実質利回り（年利）：０.４０％",
        "choice5": "2022.09",
        "categoryName": "不動産",
        "rontenName": "表面利回りと実質利回り",
        "important": ""
    },
    {
        "id": 101,
        "shikenId": 2,
        "no": 11,
        "answerType": 9,
        "groupId": 1,
        "answer": "22,72,30",
        "score": "1,1,1",
        "question1": "井上隆也さん（３８歳）が加入の提案を受けた生命保険の保障内容は下記＜資料＞のとおりである。この生命保険に加入した場合、次の記述の空欄（ア）～（ウ）にあてはまる数値を解答欄に入力しなさい。なお、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><img src='/img/2_101.png'/><br><img src='/img/2_101_2.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "2024.01（改）",
        "categoryName": "リスク",
        "rontenName": "生命保険の補償内容",
        "important": ""
    },
    {
        "id": 102,
        "shikenId": 2,
        "no": 12,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "少額短期保険に関する次の記述の空欄（ア）～（エ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src='/img/2_102.png'/>",
        "question2": "",
        "choice1": "（ア）３００万円       （イ）１年       （ウ）２年       （エ）ならない",
        "choice2": "（ア）５００万円       （イ）１年       （ウ）１年       （エ）なる",
        "choice3": "（ア）３００万円       （イ）２年       （ウ）１年       （エ）ならない",
        "choice4": "（ア）５００万円       （イ）２年       （ウ）２年       （エ）なる",
        "choice5": "2024.01",
        "categoryName": "リスク",
        "rontenName": "少額短期保険",
        "important": ""
    },
    {
        "id": 103,
        "shikenId": 2,
        "no": 13,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,1,1,2",
        "score": "1,1,1,1",
        "question1": "加瀬さん（４５歳）は、下記＜資料＞の自動車保険に加入している。下記＜資料＞に基づく次の（ア）～（エ）の記述のうち、適切なものには○、不適切なものには×を解答欄に入力しなさい。なお、＜資料＞に記載のない特約については考慮しないものとする。<br><img src='/img/2_103.png'/>",
        "question2": "",
        "choice1": "加瀬さんの友人（５０歳）が被保険自動車を運転中、他人にケガをさせ法律上の損害賠償責任を負った場合、補償の対象となる。",
        "choice2": "加瀬さんが被保険自動車を運転中、飛び石により窓ガラスが破損し、車両保険金のみが支払われた場合、当該事故はノンフリート等級別料率制度における「１等級ダウン事故」に該当する。",
        "choice3": "加瀬さんが被保険自動車を運転中、他人が運転する自動車と衝突し、加瀬さんがケガをした場合、過失割合にかかわらず治療費用の補償を受けることができる。",
        "choice4": "加瀬さんが所有する原動機付自転車を加瀬さんの妻（４０歳）が運転中、他人にケガをさせ法律上の損害賠償責任を負った場合、補償の対象とならない。",
        "choice5": "2024.01（改）",
        "categoryName": "リスク",
        "rontenName": "自動車保険",
        "important": ""
    },
    {
        "id": 104,
        "shikenId": 2,
        "no": 14,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "羽田涼介さんが本年中に支払った終身保険と終身医療保険の保険料は下記＜資料＞のとおりである。涼介さんの本年分の所得税の計算における生命保険料控除額として、正しいものはどれか。なお、下記＜資料＞の保険について、これまでに契約内容の変更はないものとする。また、本年分の生命保険料控除額が最も多くなるように計算すること。<br><img src='/img/2_104.png'/>",
        "question2": "",
        "choice1": "７８,７８０円",
        "choice2": "８３,７８０円",
        "choice3": "８８,７８０円",
        "choice4": "９３,７８０円",
        "choice5": "2024.01（改）",
        "categoryName": "リスク",
        "rontenName": "生命保険料控除額",
        "important": ""
    },
    {
        "id": 105,
        "shikenId": 2,
        "no": 15,
        "answerType": 9,
        "groupId": 0,
        "answer": 540,
        "score": 2,
        "question1": "会社員の小田さんは、本年１２月末で３５年４ヵ月勤め続けてきた株式会社ＹＺを退職し、退職一時金３,０００万円を受け取った。この退職一時金に係る退職所得の金額はいくらになるか。なお、小田さんは、勤務先の役員であったことはなく、退職は障害者になったことに基因するものではない。また、解答に当たっては、解答欄に記載されている単位に従うこと。",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.01（改）",
        "categoryName": "タックス",
        "rontenName": "退職所得の金額",
        "important": ""
    },
    {
        "id": 106,
        "shikenId": 2,
        "no": 16,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "公的年金等に係る所得税の取扱いに関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "小規模企業共済の共済金や確定拠出年金の老齢給付金は、年金形式で受け取る場合、公的年金等に係る雑所得の収入金額となる。",
        "choice2": "公的年金等に係る雑所得の金額の計算は、「公的年金等の収入金額－公的年金等控除額」により計算するが、公的年金等控除額は、受給者の年齢が７０歳以上か７０歳未満かにより、控除額が異なる。",
        "choice3": "公的年金等以外の総合課税となる雑所得の金額に、赤字が生じた場合、その赤字の金額と公的年金等に係る雑所得の金額を通算し、雑所得の金額を計算することができる。",
        "choice4": "公的年金等の収入金額が４００万円以下であり、かつ、その公的年金等の全部が源泉徴収の対象となる場合において、公的年金等に係る雑所得以外の所得金額の合計が２０万円以下であるときは、確定申告は不要である。",
        "choice5": "2023.01",
        "categoryName": "タックス",
        "rontenName": "公的年金等に係る所得税の取り扱い",
        "important": ""
    },
    {
        "id": 107,
        "shikenId": 2,
        "no": 17,
        "answerType": 9,
        "groupId": 1,
        "answer": "55,65,10",
        "score": "1,1,1",
        "question1": "所得税の青色申告特別控除制度に関する次の記述の空欄（ア）～（ウ）に入る適切な数値を解答欄に入力しなさい。<br><img src='/img/2_107.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "2023.01",
        "categoryName": "タックス",
        "rontenName": "青色申告特別控除制度",
        "important": ""
    },
    {
        "id": 108,
        "shikenId": 2,
        "no": 18,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "会社員の山岸さんの本年分の所得等が下記＜資料＞のとおりである場合、山岸さんが本年分の所得税の確定申告を行う際に、給与所得と損益通算できる損失に関する次の記述のうち、最も適切なものはどれか。なお、▲が付された所得金額は、その所得に損失が発生していることを意味する。<br><img src='/img/2_108.png'/>",
        "question2": "",
        "choice1": "不動産所得▲１００万円と損益通算できる。",
        "choice2": "副業の雑所得▲１０万円と損益通算できる。",
        "choice3": "上場株式の譲渡所得▲１５０万円と損益通算できる。",
        "choice4": "損益通算できる損失はない。",
        "choice5": "2023.01（改）",
        "categoryName": "タックス",
        "rontenName": "損益通算できる損失",
        "important": ""
    },
    {
        "id": 109,
        "shikenId": 2,
        "no": 19,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "下記の相続事例（本年７月３０日相続開始）における相続税の課税価格の合計額として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><img src='/img/2_109.png'/>",
        "question2": "",
        "choice1": "５,３００万円",
        "choice2": "５,５００万円",
        "choice3": "６,８００万円",
        "choice4": "８,５００万円",
        "choice5": "2024.09（改）",
        "categoryName": "相続",
        "rontenName": "相続税の課税価格の合計額",
        "important": ""
    },
    {
        "id": 110,
        "shikenId": 2,
        "no": 20,
        "answerType": 8,
        "groupId": 1,
        "answer": "4,3,2,8",
        "score": "1,1,1,1",
        "question1": "木内さんは、父の相続開始後の手続き等について、ＦＰで税理士でもある高倉さんに質問をした。下記の空欄（ア）～（エ）にあてはまる適切な語句を語群の中から選び、その番号のみを解答欄に記入しなさい。なお、同じ番号を何度選んでもよいものとする。<br><img src='/img/2_110.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.09",
        "categoryName": "相続",
        "rontenName": "相続開始後の手続き等",
        "important": ""
    },
    {
        "id": 111,
        "shikenId": 2,
        "no": 21,
        "answerType": 8,
        "groupId": 1,
        "answer": "5,9,2",
        "score": "1,1,1",
        "question1": "下記＜親族関係図＞の場合において、民法の規定に基づく法定相続分および遺留分に関する次の記述の空欄（ア）～（ウ）にあてはまる適切な語句または数値を語群の中から選び、その番号のみを解答欄に記入しなさい。なお、同じ番号を何度選んでもよいものとする。<br><img src='/img/2_111.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.09",
        "categoryName": "相続",
        "rontenName": "法定相続分および遺留分",
        "important": ""
    },
    {
        "id": 112,
        "shikenId": 2,
        "no": 22,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "下記＜資料＞の宅地（貸家建付地）に係る路線価方式による相続税評価額の計算式として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><img src='/img/2_112.png'/>",
        "question2": "",
        "choice1": "３５０,０００円×１.００×３００㎡",
        "choice2": "３５０,０００円×１.００×３００㎡×７０％",
        "choice3": "３５０,０００円×１.００×３００㎡×（１－７０％）",
        "choice4": "３５０,０００円×１.００×３００㎡×（１－７０％×３０％×１００％）",
        "choice5": "2024.09",
        "categoryName": "相続",
        "rontenName": "貸家建付地の相続税評価額",
        "important": ""
    },
    {
        "id": 113,
        "shikenId": 2,
        "no": 23,
        "answerType": 9,
        "groupId": 0,
        "answer": 518,
        "score": 2,
        "question1": "福岡家のキャッシュフロー表の空欄（ア）は洋司さんの可処分所得である。下表のデータに基づいて、空欄（ア）にあてはまる数値を計算しなさい。なお、本年における洋司さんの収入は給与収入のみである。<br><img src='/img/2_113_2.png'/><br><br><img src='/img/2_113.png'/><br>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.09（改）",
        "categoryName": "ライフ",
        "rontenName": "CF表",
        "important": ""
    },
    {
        "id": 114,
        "shikenId": 2,
        "no": 24,
        "answerType": 9,
        "groupId": 0,
        "answer": 396,
        "score": 2,
        "question1": "福岡家のキャッシュフロー表の空欄（イ）にあてはまる数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用し、計算結果については万円未満を四捨五入すること。<br><img src='/img/2_113.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "ライフ",
        "rontenName": "CF表",
        "important": ""
    },
    {
        "id": 115,
        "shikenId": 2,
        "no": 25,
        "answerType": 9,
        "groupId": 0,
        "answer": 1136,
        "score": 2,
        "question1": "福岡家のキャッシュフロー表の空欄（ウ）にあてはまる数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用し、計算結果については万円未満を四捨五入すること。<br><img src='/img/2_113.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "ライフ",
        "rontenName": "CF表",
        "important": ""
    },
    {
        "id": 116,
        "shikenId": 2,
        "no": 26,
        "answerType": 9,
        "groupId": 0,
        "answer": 4525000,
        "score": 2,
        "question1": "皆川さんは、自宅のリフォーム費用として、１０年後に５００万円を準備したいと考えている。年利１.０％で１０年間複利運用する場合、現在いくらの資金があればよいか。<br>下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないこととし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/2_116.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.05",
        "categoryName": "ライフ",
        "rontenName": "6つの係数",
        "important": ""
    },
    {
        "id": 117,
        "shikenId": 2,
        "no": 27,
        "answerType": 9,
        "groupId": 0,
        "answer": 975000,
        "score": 2,
        "question1": "山根さんは、退職金の２,５００万円を今後３０年間、年利１.０％で複利運用しながら毎年１回、年末に均等に生活資金として取り崩していきたいと考えている。毎年取り崩すことができる最大金額はいくらになるか。<br>下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないこととし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/2_116.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.05",
        "categoryName": "ライフ",
        "rontenName": "6つの係数",
        "important": ""
    },
    {
        "id": 118,
        "shikenId": 2,
        "no": 28,
        "answerType": 9,
        "groupId": 0,
        "answer": 930000,
        "score": 2,
        "question1": "安藤さんは、子どもの留学資金として、１５年後に１,５００万円を準備したいと考えている。年利１.０％で複利運用しながら毎年年末に一定額を積み立てる場合、毎年いくらずつ積み立てればよいか。<br>下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないこととし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/2_116.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.05",
        "categoryName": "ライフ",
        "rontenName": "6つの係数",
        "important": ""
    },
    {
        "id": 119,
        "shikenId": 2,
        "no": 29,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "大久保和雄さんは、現在居住している自宅の住宅ローンの繰上げ返済を検討しており、ＦＰの岡さんに質問をした。和雄さんが住宅ローンを１２０回返済後に、１００万円以内で期間短縮型の繰上げ返済をする場合、この繰上げ返済により短縮される返済期間として、正しいものはどれか。なお、計算に当たっては、下記＜資料＞を使用し、繰上げ返済額は１００万円を超えない範囲での最大額とすること。また、繰上げ返済に伴う手数料等は考慮しないものとする。<br><br><img src='/img/2_119_2.png'/>",
        "question2": "",
        "choice1": "１年８ヵ月",
        "choice2": "１年７ヵ月",
        "choice3": "１年６ヵ月",
        "choice4": "１０ヵ月",
        "choice5": "2023.01（改）",
        "categoryName": "ライフ",
        "rontenName": "繰上げ返済により短縮される返済期間",
        "important": ""
    },
    {
        "id": 120,
        "shikenId": 2,
        "no": 30,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "和雄さんは、翔太さんの高校の授業料負担についてＦＰの岡さんに質問をした。「高等学校等就学支援金制度」に係る下記＜資料＞に関する岡さんの説明のうち、最も不適切なものはどれか。<br><br><img src='/img/2_119.png'/><br><br><img src='/img/2_120.png'/>",
        "question2": "",
        "choice1": "「所得判定基準が３０４,２００円未満の場合、国公立高校の授業料負担は実質０円になります。」",
        "choice2": "「高校入学時に高等学校等就学支援金の受給資格に該当しない場合、その後在学中に申請はできません。」",
        "choice3": "「高等学校等就学支援金は、学校設置者が生徒本人に代わって受け取り授業料に充てるしくみのため、生徒や保護者が直接お金を受け取るものではありません。」",
        "choice4": "「高等学校等就学支援金制度を利用するためには申請が必要で、原則として、保護者等の収入状況を登録する必要があります。」",
        "choice5": "2023.01 ",
        "categoryName": "ライフ",
        "rontenName": "高等学校等就学支援金制度",
        "important": ""
    },
    {
        "id": 121,
        "shikenId": 2,
        "no": 31,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,1,2,2",
        "score": "1,1,1,1",
        "question1": "大久保家が契約している保険の保険金等が支払われた場合の課税に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を解答欄に入力しなさい。<br><br><img src='/img/2_119.png'/><br><br><img src='/img/2_119_3.png'/>",
        "question2": "",
        "choice1": "和雄さんが余命６ヵ月以内と診断され、定期保険Ａからリビング・ニーズ特約の生前給付金を受け取った後、和雄さんが死亡した場合、相続開始時点における残額は、相続税の課税対象となる。",
        "choice2": "和雄さんが死亡したことにより、留美子さんが受け取る定期保険Ａの死亡保険金は、相続税の課税対象となる。",
        "choice3": "自宅が火災で全焼となり、和雄さんが受け取る火災保険Ｂの損害保険金は、所得税（一時所得）の課税対象となる。",
        "choice4": "留美子さんが、がんに罹患して陽子線治療を受けたことによって、留美子さんが受け取る医療保険Ｃからの先進医療給付金は、所得税（一時所得）の課税対象となる。",
        "choice5": "2023.01（改） ",
        "categoryName": "タックス",
        "rontenName": "保険金等に対する課税",
        "important": ""
    },
    {
        "id": 122,
        "shikenId": 2,
        "no": 32,
        "answerType": 8,
        "groupId": 1,
        "answer": "2,3,6",
        "score": "1,1,1",
        "question1": "和雄さんは、現在勤めている会社を自己都合退職した場合に受給できる雇用保険の基本手当についてＦＰの岡さんに質問をした。雇用保険の基本手当に関する次の記述の空欄（ア）～（ウ）にあてはまる適切な語句を語群の中から選び、その番号のみを解答欄に入力しなさい。なお、和雄さんは本年１月に自己都合退職するものと仮定し、現在の会社に２２歳から勤務し、継続して雇用保険に加入しており、雇用保険の基本手当の受給要件はすべて満たしているものとする。また、和雄さんには、この他に雇用保険の加入期間はなく、障害者等の就職困難者には該当しないものとし、延長給付については考慮しないものとする。<br><br><img src='/img/2_119.png'/><br><img src='/img/2_122.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.01 （改）",
        "categoryName": "ライフ",
        "rontenName": "雇用保険の基本手当",
        "important": ""
    },
    {
        "id": 123,
        "shikenId": 2,
        "no": 33,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,1,1,1",
        "score": "1,1,1,1",
        "question1": "和雄さんの妹の枝里子さんは、民間企業に勤務する会社員であり、現在妊娠中である。和雄さんは、枝里子さんが出産のために仕事を休んだ場合に支給される出産手当金や、産前産後休業中の社会保険料の取扱いについて、ＦＰの岡さんに質問をした。出産手当金および産前産後休業中の社会保険料に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を解答欄に入力しなさい。なお、枝里子さんは、全国健康保険協会管掌健康保険（協会けんぽ）の被保険者であり、かつ厚生年金の被保険者であるものとする。<br><img src='/img/2_123.png'/>",
        "question2": "",
        "choice1": "空欄（ ａ ）にあてはまる語句は「４２日」である。",
        "choice2": "空欄（ ｂ ）にあてはまる語句は「３分の２」である。",
        "choice3": "空欄（ ｃ ）にあてはまる語句は「本人負担分および事業主負担分」である。",
        "choice4": "空欄（ ｄ ）にあてはまる語句は「保険料を納めた期間」である。",
        "choice5": "2023.01",
        "categoryName": "ライフ",
        "rontenName": "産前産後期間の社会保険",
        "important": ""
    },
    {
        "id": 124,
        "shikenId": 2,
        "no": 34,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,2,1,2",
        "score": "1,1,1,1",
        "question1": "和雄さんは、労働者災害補償保険（以下「労災保険」という）について、ＦＰの岡さんに質問をした。労災保険の概要に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を解答欄に入力しなさい。",
        "question2": "",
        "choice1": "労災保険は、在宅勤務をする労働者を給付対象としない。",
        "choice2": "労災保険における保険料率は、業種にかかわらず一律である。",
        "choice3": "労災保険の保険料は、その全額を事業主が負担する。",
        "choice4": "労働者が業務上の災害により労災指定病院等において療養を受けた場合は、その費用の１割を労働者が負担し、残る部分が療養補償給付となる。",
        "choice5": "2023.01",
        "categoryName": "ライフ",
        "rontenName": "労働者災害補償保険",
        "important": ""
    },
    {
        "id": 125,
        "shikenId": 2,
        "no": 35,
        "answerType": 9,
        "groupId": 1,
        "answer": 14020,
        "score": 2,
        "question1": "ＦＰの飯田さんは、まず本年４月１日現在における安藤家（雅之さんと裕子さん）のバランスシート分析を行うこととした。＜資料＞に記載のあるデータに基づいて下表の空欄（ア）にあてはまる数値を計算しなさい。<br><img src='/img/2_125.png'/><br><br>＜資料：本年4月1日現在＞<br><img src='/img/2_124_1.png'/><br><img src='/img/2_124_2.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.05（改）",
        "categoryName": "ライフ",
        "rontenName": "バランスシート",
        "important": ""
    },
    {
        "id": 126,
        "shikenId": 2,
        "no": 36,
        "answerType": 8,
        "groupId": 1,
        "answer": "2,4,7",
        "score": "1,1,1",
        "question1": "下記＜資料＞は、雅之さんの前年分の「給与所得の源泉徴収票（一部省略）」であり、雅之さんは、所得控除の額について、ＦＰで税理士でもある飯田さんに質問をした。下記＜資料＞に基づく雅之さんの前年分の所得控除の額に関する次の記述の空欄（ア）～（ウ）にあてはまる適切な数値を語群の中から選び、その番号のみを解答欄に入力しなさい。なお、雅之さんには、前年中において給与所得以外に申告すべき所得はなく、年末調整の対象となった所得控除以外に適用を受けることのできる所得控除はない。また、記載のない事項については一切考慮しないものとする。<br><br><img src='/img/2_124_6.png'/><br><img src='/img/2_126.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.05（改）",
        "categoryName": "タックス",
        "rontenName": "源泉徴収票の見方",
        "important": ""
    },
    {
        "id": 127,
        "shikenId": 2,
        "no": 37,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "安藤雅之さんの父の三郎さんは老人ホームへの入居を検討しているため、ＦＰで税理士でもある飯田さんに所有する自宅の売却について相談をした。下記＜資料＞に基づく三郎さんの自宅の売却に係る所得税および住民税に関する次の記述の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、「居住用財産を譲渡した場合の３,０００万円の特別控除」および「居住用財産を譲渡した場合の長期譲渡所得の軽減税率の特例」の適用要件は満たしており、これらの適用を受けるものとする。また、所得控除その他記載のない事項については一切考慮しないものとする。<br><img src='/img/2_127.png'/>",
        "question2": "",
        "choice1": "（ア）２００万円 （イ）１０％ （ウ）４％",
        "choice2": "（ア）２００万円 （イ）１５％ （ウ）５％",
        "choice3": "（ア）６００万円 （イ）１０％ （ウ）５％",
        "choice4": "（ア）６００万円 （イ）１５％ （ウ）４％",
        "choice5": "2024.05（改）",
        "categoryName": "不動産",
        "rontenName": "譲渡所得の特例",
        "important": ""
    },
    {
        "id": 128,
        "shikenId": 2,
        "no": 38,
        "answerType": 9,
        "groupId": 1,
        "answer": 1494948,
        "score": 2,
        "question1": "安藤雅之さんが取引をしている国内の証券会社から送付された本年分の特定口座年間取引報告書（抜粋）が下記＜資料＞のとおりである場合、翌年に繰り越すことのできる上場株式等の譲渡損失の金額（上限）を計算しなさい。なお、雅之さんはこの他に有価証券取引は行っておらず、前年以前から繰り越された上場株式等の譲渡損失はないものとする。また、解答に当たっては、解答用欄に記載されている単位に従うこと。<br><br><img src='/img/2_128.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.05（改）",
        "categoryName": "金融",
        "rontenName": "特定口座年間取引報告書",
        "important": ""
    },
    {
        "id": 129,
        "shikenId": 2,
        "no": 39,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "安藤裕子さんは、老齢年金の繰上げ受給を検討しており、ＦＰの飯田さんに質問をした。裕子さんの老齢基礎年金の繰上げ受給に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "「老齢基礎年金の繰上げ請求を行った場合の年金額は、０.４％に繰上げ請求月から５歳に達する月の前月までの月数を乗じた率に基づき減額されます。」",
        "choice2": "「老齢厚生年金の繰上げ請求を行うことができる人が老齢基礎年金の繰上げ請求をする場合、老齢厚生年金も同時に繰上げ請求しなければなりません。」",
        "choice3": "「老齢基礎年金と併せて付加年金を受給できる人が老齢基礎年金の繰上げ請求をした場合、付加年金も減額されて繰上げ支給されます。」",
        "choice4": "「２０歳から６０歳になるまでの間に保険料を納めていなかった期間がある人については、老齢基礎年金の繰上げ請求をした後であっても、国民年金に任意加入することができます。」",
        "choice5": "2024.05 ",
        "categoryName": "ライフ",
        "rontenName": "老齢年金の繰上げ受給",
        "important": ""
    },
    {
        "id": 130,
        "shikenId": 2,
        "no": 40,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "佐々木洋子さんは、本年２月中に病気（私傷病）療養のため休業した日がある。ＦＰの飯田さんが下記＜資料＞に基づいて計算した洋子さんに支給される傷病手当金の額として、正しいものはどれか。なお、洋子さんは全国健康保険協会管掌健康保険（協会けんぽ）の被保険者であるものとする。また、記載のない事項については一切考慮しないものとする。<br><img src='/img/2_130.png'/>",
        "question2": "",
        "choice1": "１７,５６０円",
        "choice2": "２６,３４０円",
        "choice3": "４３,９００円",
        "choice4": "７０,２４０円",
        "choice5": "2024.05（改）",
        "categoryName": "ライフ",
        "rontenName": "傷病手当金",
        "important": ""
    },
    {
        "id": 201,
        "shikenId": 5,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナー（以下「ＦＰ」という）の顧客に対する行為に関する次の記述のうち、関連法規に照らし、最も適切なものはどれか。(2025.01改)",
        "choice1": "社会保険労務士の登録を受けていないＦＰのＡさんは、年金について相談に来た顧客の求めに応じ、公的年金の老齢給付を繰り上げた場合と繰り下げた場合の受給額について、それぞれの見込額を試算して説明した。",
        "choice2": "税理士の登録を受けていないＦＰのＢさんは、ふるさと納税について相談に来た顧客の求めに応じ、顧客の年間収入や家族構成をもとに寄附金控除の額を計算し、確定申告書の作成を代行した。",
        "choice3": "金融商品取引業者の登録を受けていないＦＰのＣさんは、株式投資について相談に来た顧客の求めに応じ、顧客の選んだ銘柄の株価チャートを示しながら投資のタイミングを有償で助言した。",
        "choice4": "弁護士の登録を受けていないＦＰのＤさんは、相続について相談に来た顧客の求めに応じ、顧客と代理人契約を締結し、顧客の代理人として、有償で他の相続人との遺産分割協議を行った。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "関連法規とコンプライアンス",
        "important": ""
    },
    {
        "id": 202,
        "shikenId": 5,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "ライフプランの作成の際に活用される下記<資料>の各種係数に関する次の記述のうち、最も不適切なものはどれか。(2022.05)<br><br><img src='/img/set1/1_2.png'/>",
        "choice1": "元本１００万円を１０年間にわたり、年率２％で複利運用した場合の元利合計額は、「１００万円×１. ２１９０」で求められる。",
        "choice2": "年率２％で複利運用しながら１０年後に１００万円を得るために必要な毎年の積立額は、「１００万円×０. ０９１３」で求められる。",
        "choice3": "１０年間にわたり、年率２％で複利運用しながら、毎年１００万円を受け取るために必要な元本は、「１００万円×１０. ９４９７」で求められる。",
        "choice4": "年率２％で複利運用しながら１０年後に１００万円を得るために必要な元本は、「１００万円×０. ８２０３」で求められる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数の計算",
        "important": ""
    },
    {
        "id": 203,
        "shikenId": 5,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "労働者災害補償保険（以下「労災保険」という）に関する次の記述のうち、最も適切なものはどれか。(2021.09)",
        "choice1": "労災保険の適用を受ける労働者には、雇用形態がアルバイトやパートタイマーである者は含まれない。",
        "choice2": "業務上の負傷または疾病が治癒したときに身体に一定の障害が残り、その障害の程度が労働者災害補償保険法に規定する障害等級に該当する場合、障害補償給付が受けられる。",
        "choice3": "労災保険の適用事業所の事業主は、その営む事業において使用する労働者数の多寡にかかわらず、労災保険の特別加入の対象となる。",
        "choice4": "労災保険の保険料を計算する際に用いる保険料率は、適用事業所の事業の種類による差異はない。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "労働者災害補償保険",
        "important": ""
    },
    {
        "id": 204,
        "shikenId": 5,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "雇用保険の失業等給付に関する次の記述のうち、最も不適切なものはどれか。(2023.09)",
        "choice1": "雇用保険の一般被保険者が失業した場合、基本手当を受給するためには、原則として、離職の日以前２年間に被保険者期間が通算して１２ヵ月以上あること等の要件を満たす必要がある。",
        "choice2": "正当な理由がなく自己都合により退職し、基本手当の受給を申請した場合、７日間の待期期間経過後、４ヵ月間は給付制限期間として基本手当を受給することができない。",
        "choice3": "基本手当の受給期間内に、出産、疾病等の理由で引き続き３０日以上職業に就くことができない場合、所定の申出により、受給期間を離職日の翌日から最長４年まで延長することができる。",
        "choice4": "雇用保険の高年齢被保険者が失業した場合、高年齢求職者給付金を受給するためには、原則として、離職の日以前１年間に被保険者期間が通算して６ヵ月以上あること等の要件を満たす必要がある。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "雇用保険",
        "important": ""
    },
    {
        "id": 205,
        "shikenId": 5,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "国民年金に関する次の記述のうち、最も適切なものはどれか。(2023.05)",
        "choice1": "学生納付特例期間は、その期間に係る保険料の追納がない場合、老齢基礎年金の受給資格期間に算入されない。",
        "choice2": "生活保護法による生活扶助を受けることによる保険料免除期間は、その期間に係る保険料の追納がない場合、老齢基礎年金の受給資格期間には算入されるが、老齢基礎年金の年金額には反映されない。",
        "choice3": "保険料免除期間に係る保険料のうち、追納することができる保険料は、追納に係る厚生労働大臣の承認を受けた日の属する月前５年以内の期間に係るものに限られる。",
        "choice4": "産前産後期間の保険料免除制度により保険料の納付が免除された期間は、保険料納付済期間として老齢基礎年金の年金額に反映される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "国民年金",
        "important": ""
    },
    {
        "id": 206,
        "shikenId": 5,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "公的年金制度の障害給付に関する次の記述のうち、最も適切なものはどれか。(2021.01)",
        "choice1": "障害等級１級に該当する程度の障害の状態にある者に支給される障害基礎年金の額は、障害等級２級に該当する程度の障害の状態にある者に支給される障害基礎年金の額の１００分の１５０に相当する額である。",
        "choice2": "障害等級２級に該当する程度の障害の状態にある障害厚生年金の受給権者が、所定の要件を満たす配偶者を有する場合、その受給権者に支給される障害厚生年金には加給年金額が加算される。",
        "choice3": "障害等級３級に該当する程度の障害の状態にある者に支給される障害厚生年金の額については、障害等級２級に該当する程度の障害の状態にある者に支給される障害基礎年金の額の３分の２相当額が最低保障される。",
        "choice4": "国民年金の被保険者ではない２０歳未満の期間に初診日および障害認定日があり、２０歳に達した日において障害等級１級または２級に該当する程度の障害の状態にある者には、その者の所得にかかわらず、障害基礎年金が支給される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "障害年金",
        "important": ""
    },
    {
        "id": 207,
        "shikenId": 5,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "中小企業退職金共済、小規模企業共済および国民年金基金に関する次の記述のうち、最も適切なものはどれか。(2022.01)",
        "choice1": "中小企業退職金共済の掛金は、事業主が全額を負担し、掛金月額は、被共済者１人当たり３万円が上限となっている。",
        "choice2": "常時使用する従業員数が２０人以下の卸売業を営む個人事業主は、小規模企業共済に加入することができる。",
        "choice3": "国民年金基金の給付には、老齢年金、遺族一時金、障害一時金がある。",
        "choice4": "日本国籍を有するが、日本国内に住所を有しない２０歳以上６５歳未満の国民年金の任意加入被保険者は、国民年金基金に加入することができない。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "私的年金",
        "important": ""
    },
    {
        "id": 208,
        "shikenId": 5,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "住宅金融支援機構と金融機関が提携した住宅ローンであるフラット３５（買取型）に関する次の記述のうち、最も適切なものはどれか。(2022.09)",
        "choice1": "フラット３５の融資額は、住宅の建設費または購入価額以内で、最高１億円である。",
        "choice2": "フラット３５の返済方法は、元利均等返済に指定されている。",
        "choice3": "店舗付き住宅などの併用住宅を建築する場合、住宅部分・非住宅部分の床面積の割合に関係なく、フラット３５を利用することができる。",
        "choice4": "住宅金融支援機構は、融資を実行する金融機関から住宅ローン債権を買い取り、対象となる住宅の第１順位の抵当権者となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "フラット35",
        "important": ""
    },
    {
        "id": 209,
        "shikenId": 5,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "奨学金および教育ローンに関する次の記述のうち、最も不適切なものはどれか。(2021.05)",
        "choice1": "日本学生支援機構の給付奨学金を申し込む者は、一定の基準を満たせば、併せて貸与型の第一種奨学金および第二種奨学金を申し込むこともできる。",
        "choice2": "日本学生支援機構の貸与奨学金の返還が困難となった場合、毎月の返還額を減額して返還期間の延長を申請することができる。",
        "choice3": "日本政策金融公庫の教育一般貸付（国の教育ローン）の申込人は、学生等の保護者に限られる。",
        "choice4": "日本政策金融公庫の教育一般貸付（国の教育ローン）の資金使途には、入学金・授業料等の学校納付金や教材費だけではなく、自宅外から通学する学生等の住居費用等も含まれる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "奨学金と国の教育ローン",
        "important": ""
    },
    {
        "id": 210,
        "shikenId": 5,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "下記＜資料＞に基づき算出される中小企業のＡ社の財務分析に関する次の記述のうち、最も不適切なものはどれか。なお、変動費は売上原価に等しく、固定費は販売費及び一般管理費に等しいものとする。また、問題の性質上、明らかにできない部分は「□□□」で示してある。(2021.01)<br> <br><img src='/img/set1/1_10.png'/>",
        "choice1": "Ａ社の売上高営業利益率は、２５％である。",
        "choice2": "Ａ社の売上高経常利益率は、３０％である。",
        "choice3": "Ａ社の限界利益率は、５０％である。",
        "choice4": "Ａ社の損益分岐点売上高は、３００百万円である。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "経営分析指標",
        "important": ""
    },
    {
        "id": 211,
        "shikenId": 5,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "保険法に関する次の記述のうち、最も不適切なものはどれか。(2024.01)",
        "choice1": "保険金受取人の変更は、遺言によってもすることができる。",
        "choice2": "死亡保険契約の保険契約者または保険金受取人が、死亡保険金を受け取ることを目的として被保険者を故意に死亡させ、または死亡させようとした場合、保険会社は当該保険契約を解除することができる。",
        "choice3": "死亡保険契約において、保険契約者と被保険者が離婚し、被保険者が当該保険契約に係る同意をするに当たって基礎とした事情が著しく変更した場合、被保険者は保険契約者に対して当該保険契約を解除することを請求することができる。",
        "choice4": "生命保険契約の締結に際し、保険契約者または被保険者になる者は、保険会社から告知を求められた事項以外の保険事故の発生の可能性に関する重要な事項について、自発的に判断して事実の告知をしなければならない。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "保険法",
        "important": ""
    },
    {
        "id": 212,
        "shikenId": 5,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、特約については考慮しないものとする。(2024.01)",
        "choice1": "外貨建て終身保険では、死亡保険金を円貨で受け取る場合、受け取る金額は為替相場によって変動する。",
        "choice2": "変額保険（終身型）では、資産の運用実績に応じて死亡保険金額が変動するが、契約時に定めた保険金額（基本保険金額）は保証される。",
        "choice3": "こども保険（学資保険）では、契約者（＝保険料負担者）が死亡した場合であっても、保険契約は継続し、被保険者である子の成長に合わせて祝金（学資金）等を受け取ることができる。",
        "choice4": "低解約返戻金型終身保険では、他の契約条件が同一であれば、低解約返戻金型では終身保険と比較して、保険料払込期間満了後も解約返戻金が低く設定されている。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の商品と性質",
        "important": ""
    },
    {
        "id": 213,
        "shikenId": 5,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "個人年金保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。(2020.09)",
        "choice1": "確定年金では、年金受取開始日前に被保険者（＝年金受取人）が死亡した場合、死亡給付金受取人が契約時に定められた年金受取総額と同額の死亡給付金を受け取ることができる。",
        "choice2": "定額個人年金保険では、他の契約条件が同一の場合、保険料の払込満了から年金受取開始までの据置期間が長い方が、受け取る年金額は多くなる。",
        "choice3": "確定年金では、年金受取期間中に被保険者（＝年金受取人）が死亡した場合、相続人等が既払込保険料相当額の死亡給付金を受け取ることができる。",
        "choice4": "終身年金では、他の契約条件が同一の場合、保険料は被保険者が男性の方が女性よりも高くなる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "個人年金保険",
        "important": ""
    },
    {
        "id": 214,
        "shikenId": 5,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "生命保険の税金に関する次の記述のうち、最も不適切なものはどれか。なお、いずれも契約者（＝保険料負担者）および保険金・給付金等の受取人は個人であるものとする。(2021.09)",
        "choice1": "契約者および保険金受取人が夫、被保険者が妻である終身保険において、妻が死亡して夫が受け取る死亡保険金は、相続税の課税対象となる。",
        "choice2": "契約者が夫、被保険者および年金受取人が妻である個人年金保険において、妻が受け取る年金の年金受給権は、年金支払開始時に夫から妻への贈与とみなされ、贈与税の課税対象となる。",
        "choice3": "契約者、被保険者および年金受取人が同一人である個人年金保険（保証期間付終身年金）において、保証期間内に被保険者が死亡し、残りの保証期間について相続人が受け取る年金の年金受給権は、相続税の課税対象となる。",
        "choice4": "契約から５年を超えた一時払変額個人年金保険（１０年確定年金）を解約して契約者が受け取った解約返戻金は、一時所得として所得税（総合課税）の課税対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "個人の生命保険と税金",
        "important": ""
    },
    {
        "id": 215,
        "shikenId": 5,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "契約者（＝保険料負担者）を法人、被保険者を役員とする生命保険契約の経理処理に関する次の記述のうち、最も不適切なものはどれか。なお、いずれの保険契約も保険料は年払いかつ全期払いで、２０２１年１０月に締結したものとする。(2022.05改)",
        "choice1": "死亡保険金受取人が法人で、最高解約返戻率が６５％である定期保険（保険期間２０年、年払保険料１２０万円）の支払保険料は、保険期間の前半４割相当期間においては、その４０％相当額を資産に計上し、残額を損金の額に算入することができる。",
        "choice2": "死亡保険金受取人が法人である終身保険の支払保険料は、その全額を資産に計上する。",
        "choice3": "死亡保険金受取人および満期保険金受取人が法人である養老保険の支払保険料は、その２分の１相当額を資産に計上し、残額を損金の額に算入することができる。",
        "choice4": "給付金受取人が法人である解約返戻金のない医療保険の支払保険料は、その全額を損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "法人の生命保険の経理処理",
        "important": ""
    },
    {
        "id": 216,
        "shikenId": 5,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "損害保険による損害賠償等に関する次の記述のうち、最も不適切なものはどれか。(2021.05)",
        "choice1": "失火の責任に関する法律によれば、失火により他人に損害を与えた場合、その失火者に重大な過失がなかったときは、民法第７０９条（不法行為による損害賠償）の規定が適用される。",
        "choice2": "個人賠償責任保険では、被保険者が通学のため自転車を走行しているときに歩行者に衝突してケガを負わせたことについて、法律上の損害賠償責任を負った場合、補償の対象となる。",
        "choice3": "施設所有（管理）者賠償責任保険では、被保険者が営む飲食店の店舗の床が清掃時の水で濡れていたことにより滑って転倒した来店客がケガをしたことについて、法律上の損害賠償責任を負った場合、補償の対象となる。",
        "choice4": "生産物賠償責任保険（ＰＬ保険）では、被保険者が製造した商品の欠陥が原因で、商品を使用した者がケガをしたことについて、法律上の損害賠償責任を負った場合、補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "損害保険の補償",
        "important": ""
    },
    {
        "id": 217,
        "shikenId": 5,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "住宅用建物および家財を保険の対象とする火災保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、特約については考慮しないものとする。(2023.05)",
        "choice1": "消防活動により自宅建物に収容している家財に生じた水濡れによる損害は、補償の対象とならない。",
        "choice2": "落雷により自宅建物に収容している家財に生じた損害は、補償の対象となる。",
        "choice3": "経年劣化による腐食で自宅建物に生じた損害は、補償の対象とならない。",
        "choice4": "竜巻により自宅建物に生じた損害は、補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "火災保険",
        "important": ""
    },
    {
        "id": 218,
        "shikenId": 5,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "個人を契約者（＝保険料負担者）とする損害保険の税金に関する次の記述のうち、最も不適切なものはどれか。(2021.01改)",
        "choice1": "本年４月に加入した所得補償保険の保険料は、介護医療保険料控除の対象となる。",
        "choice2": "本年４月に住宅用建物および家財を保険の対象とする火災保険に地震保険を付帯して加入した場合、地震保険に係る保険料のみが地震保険料控除の対象となる。",
        "choice3": "契約者と被保険者が同一人である自動車保険の人身傷害（補償）保険において、被保険者が自動車事故で死亡した場合、その遺族が受け取った死亡保険金は、過失割合にかかわらず、その全額が非課税となる。",
        "choice4": "契約者の配偶者が不慮の事故で死亡したことにより、契約者が受け取った家族傷害保険の死亡保険金は、一時所得として課税の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "損害保険の保険金と税金",
        "important": ""
    },
    {
        "id": 219,
        "shikenId": 5,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "第三分野の保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。(2022.09)",
        "choice1": "就業不能保険では、入院や在宅療養が一定日数以上継続して所定の就業不能状態に該当した場合に、所定の保険金・給付金が支払われる。",
        "choice2": "先進医療特約で先進医療給付金の支払い対象とされている先進医療は、契約時点において厚生労働大臣によって定められたものである。",
        "choice3": "限定告知型の医療保険は、他の契約条件が同一で、限定告知型ではない一般の医療保険と比較した場合、保険料は割安となる。",
        "choice4": "がん保険では、被保険者ががんで入院したことにより受け取る入院給付金について、１回の入院での支払日数は９０日が限度となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "第三分野の保険",
        "important": ""
    },
    {
        "id": 220,
        "shikenId": 5,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "法人が所有する建物等を対象とした火災保険から受け取る保険金と圧縮記帳に関する次の記述のうち、最も適切なものはどれか。なお、契約している火災保険の契約者（＝保険料負担者）および保険金受取人は法人であるものとする。(2023.01)",
        "choice1": "工場建物および建物内に収容されている機械が全焼し、同一事業年度中に受け取った火災保険金で、焼失前と同様の工場建物および同一の機械を新たに取得した場合、当該工場建物・機械ともに圧縮記帳の対象となる。",
        "choice2": "工場建物が全焼し、同一事業年度中に受け取った火災保険金で、その滅失した工場建物と同一種類に区分される倉庫建物を新築した場合、当該倉庫建物は圧縮記帳の対象とならない。",
        "choice3": "工場建物が全焼し、同一事業年度中に受け取った火災保険金で、当該工場建物が滅失等をしたときにおいて現に建設中であった他の工場建物を完成させた場合、完成後の工場建物は圧縮記帳の対象となる。",
        "choice4": "保険金で取得した代替資産の圧縮限度額を算出する際、「所有固定資産の滅失または損壊により支出する経費」には、ケガ人に対する見舞金を含めることができる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "法人の損害保険と税金",
        "important": ""
    },
    {
        "id": 221,
        "shikenId": 5,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "為替相場や金利の変動要因等に関する次の記述のうち、最も不適切なものはどれか。(2023.05)",
        "choice1": "日本の物価が米国と比較して相対的に上昇することは、一般に円高米ドル安の要因となる。",
        "choice2": "米国が政策金利を引き上げ、日本と米国との金利差が拡大することは、一般に円安米ドル高の要因となる。",
        "choice3": "日本の対米貿易赤字が拡大することは、一般に円安米ドル高の要因となる。",
        "choice4": "日本銀行が、国債買入オペによって長期国債（利付国債）を買い入れ、金融市場に資金を供給することは、一般に市中金利の低下要因となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "為替の基礎と変動要因",
        "important": ""
    },
    {
        "id": 222,
        "shikenId": 5,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預金の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。(2020.09)",
        "choice1": "貯蓄預金は、クレジットカード利用代金などの自動振替口座や、給与や年金などの自動受取口座として利用することができる。",
        "choice2": "当座預金は、公共料金などの自動振替口座として利用することはできるが、株式の配当金の自動受取口座として利用することはできない。",
        "choice3": "為替先物予約を締結していない外貨定期預金の満期時の為替レートが預入時の為替レートに比べて円安になれば、当該外貨定期預金に係る円換算の運用利回りは高くなる。",
        "choice4": "期日指定定期預金は、預金者が預入時に据置期間経過後から最長預入期日までの間で満期日を指定しなければならない。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "貯蓄性金融商品",
        "important": ""
    },
    {
        "id": 223,
        "shikenId": 5,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "上場投資信託（ＥＴＦ）に関する次の記述のうち、最も適切なものはどれか。(2020.09)",
        "choice1": "ＥＴＦの売買には、上場株式と同様に売買委託手数料が発生するが、非上場の投資信託とは異なり、運用管理費用（信託報酬）は発生しない。",
        "choice2": "インバース型のＥＴＦは、日経平均株価や東証株価指数（ＴＯＰＩＸ）などの指標の日々の変動率に一定の正の倍数を乗じて算出される指数に連動した運用成果を目指して運用される。",
        "choice3": "証券取引所を通じて行うＥＴＦの売買取引では、現物取引のほか、信用取引も行うことができる。",
        "choice4": "ＥＴＦの分配金には、普通分配金と元本払戻金（特別分配金）があり、税法上、普通分配金は課税対象となり、元本払戻金（特別分配金）は非課税である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "上場投資信託（ETF）",
        "important": ""
    },
    {
        "id": 224,
        "shikenId": 5,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "債券のデュレーションに関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。(2022.01)<br><br>デュレーションは、債券への投資資金の平均回収期間を表すとともに、債券投資における金利変動リスクの度合い（金利変動に対する債券価格の感応度）を表す指標としても用いられる。他の条件が同じであれば、債券の表面利率が低いほど、また残存期間が長いほど、デュレーションは（　ア　）。なお、割引債券のデュレーションは、残存期間（　イ　）。",
        "choice1": "（ア）長くなる　（イ）と等しくなる",
        "choice2": "（ア）短くなる　（イ）よりも短くなる",
        "choice3": "（ア）長くなる　（イ）よりも短くなる",
        "choice4": "（ア）短くなる　（イ）と等しくなる",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券投資のデュレーション",
        "important": ""
    },
    {
        "id": 225,
        "shikenId": 5,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "下記＜Ｘ社のデータ＞に基づき算出されるＸ社株式の投資指標に関する次の記述のうち、最も適切なものはどれか。(2024.05)<br><br><img src='/img/set1/1_25.png'/>",
        "choice1": "１株当たり当期純利益は、５００円である。",
        "choice2": "株式益利回りは、０．６％である。",
        "choice3": "ＰＢＲは、５．０倍である。",
        "choice4": "配当性向は、３０．０％である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式投資の指標の計算",
        "important": ""
    },
    {
        "id": 226,
        "shikenId": 5,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "個人（居住者）が国内の金融機関等を通じて行う外貨建て金融商品の取引等に関する次の記述のうち、最も不適切なものはどれか。(2022.05)",
        "choice1": "外貨建て金融商品の取引に係る為替手数料の料率は、同一の外貨を対象にする場合であっても、取扱金融機関により異なることがある。",
        "choice2": "国外の証券取引所に上場している外国株式を、国内店頭取引により売買する場合、外国証券取引口座を開設する必要がある。",
        "choice3": "外国為替証拠金取引では、証拠金にあらかじめ決められた倍率を掛けた金額まで売買することができるが、倍率の上限は各取扱業者が決めており、法令による上限の定めはない。",
        "choice4": "米ドル建て債券を保有している場合、為替レートが円安・米ドル高に変動することは、当該債券に係る円換算の投資利回りの上昇要因となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨建金融商品",
        "important": ""
    },
    {
        "id": 227,
        "shikenId": 5,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "オプション取引の一般的な特徴に関する次の記述のうち、最も適切なものはどれか。(2025.01)",
        "choice1": "コール・オプションは「原資産を権利行使価格で売る権利」であり、プット・オプションは「原資産を権利行使価格で買う権利」である。",
        "choice2": "権利行使期間中であればいつでも権利行使が可能なものをヨーロピアン・オプションといい、満期日（権利行使日）においてのみ権利行使が可能なものをアメリカン・オプションという。",
        "choice3": "コール・オプションの買い手の最大利益とプット・オプションの買い手の最大利益は、いずれもプレミアム（オプション料）の額となる。",
        "choice4": "コール・オプションおよびプット・オプションは、他の条件が同一であれば、いずれもボラティリティが上昇するほど、プレミアム（オプション料）は高くなる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金融派生商品（デリバティブ）",
        "important": ""
    },
    {
        "id": 228,
        "shikenId": 5,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "下記＜資料＞に基づくファンドＡとファンドＢの過去５年間の運用パフォーマンスの比較評価に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。(2023.01)<br><br><img src='/img/set1/1_28.png'/><br><br>ファンドの運用パフォーマンスに係る評価指標の１つとして、シャープレシオがある。無リスク金利を全期間にわたり１．０％とし、＜資料＞の数値により、ファンドＡのシャープレシオの値を算出すると（　ア　）となる。同様にファンドＢのシャープレシオの値を算出したうえで、両ファンドの運用パフォーマンスを比較する場合、シャープレシオの比較においては、過去５年間は（　イ　）であったと判断される。",
        "choice1": "（ア）２．２ （イ）ファンドＡとファンドＢの運用効率は同等",
        "choice2": "（ア）２．２ （イ）ファンドＡの方が効率的な運用",
        "choice3": "（ア）３．２ （イ）ファンドＡとファンドＢの運用効率は同等",
        "choice4": "（ア）３．２ （イ）ファンドＡの方が効率的な運用",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "シャープレシオの計算",
        "important": ""
    },
    {
        "id": 229,
        "shikenId": 5,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "ＮＩＳＡ（少額投資非課税制度）に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、ＮＩＳＡにより投資収益が非課税となる口座をＮＩＳＡ口座という。(2023.05改)",
        "choice1": "ＮＩＳＡ口座で保有する上場株式の配当金を非課税扱いにするためには、配当金の受取方法として登録配当金受領口座方式を選択しなければならない。",
        "choice2": "ＮＩＳＡ口座で保有する金融商品を売却することで生じた譲渡損失の金額は、確定申告を行うことにより、同一年中に特定口座や一般口座で保有する金融商品を売却することで生じた譲渡益の金額と通算することができる。",
        "choice3": "ＮＩＳＡ口座を開設できるのは、国内に住所を有する者のうち、各年１月１日時点で２０歳以上の者に限られる。",
        "choice4": "ＮＩＳＡ口座の開設先を現在開設している金融機関から別の金融機関に変更する場合、変更したい年分の前年の１０月１日から変更したい年分の属する年の９月３０日までに変更手続きを行う必要がある。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "NISA制度",
        "important": ""
    },
    {
        "id": 230,
        "shikenId": 5,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "金融サービスの提供及び利用環境の整備等に関する法律（以下「金融サービス提供法」という）、消費者契約法および金融商品取引法に関する次の記述のうち、最も不適切なものはどれか。(2021.01改)",
        "choice1": "金融サービス提供法では、金融商品販売業者等は重要事項の説明義務違反によって生じた顧客の損害を賠償する責任を負うとされ、当該顧客は説明義務違反を立証すれば、その説明義務違反と損害発生との因果関係を立証する必要がない。",
        "choice2": "金融サービス提供法が規定する金融商品の販売において、金融サービス提供法と消費者契約法の両方の規定を適用することができる場合は、消費者契約法が優先して適用される。",
        "choice3": "消費者契約法では、事業者の一定の行為により、消費者が誤認または困惑した場合、消費者は、消費者契約の申込みまたは承諾の意思表示を取り消すことができるとされている。",
        "choice4": "金融商品取引法では、有価証券のデリバティブ取引のほか、通貨・金利スワップ取引も適用の対象とされている。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金融関連法規",
        "important": ""
    },
    {
        "id": 231,
        "shikenId": 5,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "わが国の税制に関する次の記述のうち、最も適切なものはどれか。(2021.09)",
        "choice1": "所得税は、国や地方公共団体の会計年度と同様、毎年４月１日から翌年３月３１日までの期間を単位として課される。",
        "choice2": "贈与税では、納税者が自らの納付すべき税額を確定させ、申告・納付する申告納税方式を採用している。",
        "choice3": "税金には、国税と地方税があるが、相続税は国税に該当し、登録免許税は地方税に該当する。",
        "choice4": "税金を負担する者と税金を納める者が異なる税金を間接税といい、固定資産税は間接税に該当する。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "税金の基礎",
        "important": ""
    },
    {
        "id": 232,
        "shikenId": 5,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税における各種所得に関する次の記述のうち、最も適切なものはどれか。(2022.01)",
        "choice1": "退職一時金を受け取った退職者が、「退職所得の受給に関する申告書」を提出している場合、所得税および復興特別所得税として、退職一時金の支給額の２０．４２％が源泉徴収される。",
        "choice2": "個人事業主が事業資金で購入した株式について、配当金を受け取ったことによる所得は、配当所得となる。",
        "choice3": "不動産の貸付けを事業的規模で行ったことにより生じた賃貸収入による所得は、事業所得となる。",
        "choice4": "会社員が勤務先から無利息で金銭を借りたことにより生じた経済的利益は、雑所得となる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "10種類の所得",
        "important": ""
    },
    {
        "id": 233,
        "shikenId": 5,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税の各種所得の金額の計算上生じた次の損失の金額のうち、他の所得の金額と損益通算できないものはどれか。(2023.01)",
        "choice1": "不動産所得の金額の計算上生じた損失の金額のうち、不動産所得を生ずべき建物の取得に要した負債の利子に相当する部分の金額",
        "choice2": "生活の用に供していた自家用車を売却したことによる譲渡所得の金額の計算上生じた損失の金額",
        "choice3": "コンサルティング業務を行ったことによる事業所得の金額の計算上生じた損失の金額",
        "choice4": "取得してから５年が経過した山林を伐採して譲渡したことによる山林所得の金額の計算上生じた損失の金額",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "損益通算のルール",
        "important": ""
    },
    {
        "id": 234,
        "shikenId": 5,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税における所得控除に関する次の記述のうち、最も不適切なものはどれか。なお、ほかに必要とされる要件等はすべて満たしているものとする。(2022.09)",
        "choice1": "所得税法上の障害者に該当する納税者は、その年分の合計所得金額の多寡にかかわらず、障害者控除の適用を受けることができる。",
        "choice2": "納税者は、その年分の合計所得金額の多寡にかかわらず、基礎控除の適用を受けることができる。",
        "choice3": "納税者は、その年分の合計所得金額が５００万円を超える場合、ひとり親控除の適用を受けることができない。",
        "choice4": "納税者は、その年分の合計所得金額が１，０００万円を超える場合、配偶者の合計所得金額の多寡にかかわらず、配偶者控除の適用を受けることができない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 235,
        "shikenId": 5,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "住宅を新築または取得した場合の所得税における住宅借入金等特別控除（以下「住宅ローン控除」という）に関する次の記述のうち、最も適切なものはどれか。(2021.05)",
        "choice1": "中古住宅を取得した者が住宅ローン控除の適用を受けるためには、その対象となる中古住宅を取得した日から１年以内に自己の居住の用に供さなければならない。",
        "choice2": "住宅ローン控除は、納税者が給与所得者である場合、所定の書類を勤務先に提出することにより、住宅を取得し、居住の用に供した年分から年末調整により適用を受けることができる。",
        "choice3": "住宅ローン控除の適用を受けていた者が、転勤等のやむを得ない事由により転居し、取得した住宅を居住の用に供しなくなった場合、翌年以降に再び当該住宅を居住の用に供すれば、原則として再入居した年以降の控除期間内については住宅ローン控除の適用を受けることができる。",
        "choice4": "住宅ローン控除の適用を受けていた者が、住宅ローンの一部繰上げ返済を行い、住宅ローンの償還期間が当初の借入れの日から１０年未満となった場合であっても、残りの控除期間について、住宅ローン控除の適用を受けることができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅ローン控除",
        "important": ""
    },
    {
        "id": 236,
        "shikenId": 5,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "次のうち、青色申告者のみが適用を受けることができる所得税の青色申告の特典として、最も不適切なものはどれか。(2024.01)",
        "choice1": "棚卸資産の評価における低価法の選択",
        "choice2": "純損失の繰戻還付",
        "choice3": "雑損失の繰越控除",
        "choice4": "中小事業者の少額減価償却資産の取得価額の必要経費算入",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "青色申告",
        "important": ""
    },
    {
        "id": 237,
        "shikenId": 5,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "法人税の損金に関する次の記述のうち、最も不適切なものはどれか。(2022.01)",
        "choice1": "役員退職給与を損金の額に算入するためには、所定の時期に確定額を支給する旨の定めの内容に関する届出書をあらかじめ税務署長に提出しなければならない。",
        "choice2": "２０１６年４月１日以後に取得した建物附属設備の減価償却方法は、定額法である。",
        "choice3": "参加者１人当たり１０，０００円以下の得意先との接待飲食費は、必要とされる書類を保存していれば、税法上の交際費等に該当せず、その全額を損金の額に算入することができる。",
        "choice4": "損金の額に算入される租税公課のうち、事業税については、原則として、その事業税に係る納税申告書を提出した日の属する事業年度の損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人税の損金算入",
        "important": ""
    },
    {
        "id": 238,
        "shikenId": 5,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "消費税に関する次の記述のうち、最も不適切なものはどれか。(2023.01)",
        "choice1": "基準期間における課税売上高が１，０００万円を超える法人は、消費税の免税事業者となることができない。",
        "choice2": "特定期間における給与等支払額の合計額および課税売上高がいずれも１，０００万円を超える法人は、消費税の免税事業者となることができない。",
        "choice3": "基準期間における課税売上高が５，０００万円を超える課税事業者は、簡易課税制度の適用を受けることができない。",
        "choice4": "消費税の免税事業者が「消費税課税事業者選択届出書」を提出して消費税の課税事業者となったときは、事業を廃止した場合を除き、原則として３年間は消費税の免税事業者に戻ることができない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "消費税の課税対象",
        "important": ""
    },
    {
        "id": 239,
        "shikenId": 5,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。(2024.09)",
        "choice1": "役員が会社の所有する土地を適正な時価よりも低い価額で譲り受けた場合、適正な時価と譲受価額との差額相当額が、その役員の雑所得の収入金額に算入される。",
        "choice2": "役員が会社の所有する社宅に無償で居住している場合、原則として、通常の賃貸料相当額が、その役員の給与所得の収入金額に算入される。",
        "choice3": "会社が役員の所有する土地を適正な時価よりも低い価額で譲り受けた場合、適正な時価と譲受価額との差額相当額が、その会社の所得金額の計算上、益金の額に算入される。",
        "choice4": "会社が役員からの借入金について債務免除を受けた場合、その債務免除を受けた金額が、その会社の所得金額の計算上、益金の額に算入される。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人と役員間の取引",
        "important": ""
    },
    {
        "id": 240,
        "shikenId": 5,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "決算書に関する次の記述のうち、最も不適切なものはどれか。(2022.01)",
        "choice1": "貸借対照表において、純資産の部の合計額がマイナスになることがある。",
        "choice2": "貸借対照表における資産の部の合計額は、負債の部および純資産の部の合計額と一致する。",
        "choice3": "損益計算書における売上総利益の額は、売上高の額から売上原価の額を差し引いた額である。",
        "choice4": "損益計算書における経常利益の額は、売上総利益の額から販売費及び一般管理費の額を差し引いた額である。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "損益計算書と貸借対照表",
        "important": ""
    },
    {
        "id": 241,
        "shikenId": 5,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "土地の価格に関する次の記述のうち、最も不適切なものはどれか。(2022.05)",
        "choice1": "地価公示法による公示価格は、毎年１月１日を標準地の価格判定の基準日としている。",
        "choice2": "都道府県地価調査の標準価格は、毎年７月１日を基準地の価格判定の基準日としている。",
        "choice3": "相続税路線価は、地価公示法による公示価格の７０％を価格水準の目安としている。",
        "choice4": "固定資産税評価額は、原則として、３年ごとの基準年度において評価替えが行われる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の価格",
        "important": ""
    },
    {
        "id": 242,
        "shikenId": 5,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "不動産の登記や調査に関する次の記述のうち、最も不適切なものはどれか。(2021.05)",
        "choice1": "不動産の登記記録において、土地の所有者とその土地上の建物の所有者が異なる場合は、その土地の登記記録に借地権設定の登記がなくても、借地権が設定されていることがある。",
        "choice2": "登記事項証明書の交付請求および受領は、インターネットを利用してオンラインで行うことができる。",
        "choice3": "抵当権の設定を目的とする登記では、不動産の登記記録の権利部乙区に、債権額や抵当権者の氏名または名称などが記載される。",
        "choice4": "公図（旧土地台帳附属地図）は、登記所に備え付けられており、対象とする土地の位置関係等を確認する資料として有用である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の登記",
        "important": ""
    },
    {
        "id": 243,
        "shikenId": 5,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "不動産の売買契約に係る民法の規定に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。(2021.09)",
        "choice1": "売主から代理権を付与された第三者が売主の所有不動産を売却する場合、その第三者が売買契約の締結時に売主の代理人である旨を買主に告げていなければ、買主がその旨を知ることができたとしても、当該契約は無効となる。",
        "choice2": "不動産が共有されている場合、各共有者は、自己が有している持分を第三者に譲渡するときには、他の共有者全員の同意を得なければならない。",
        "choice3": "売買の目的物である建物が、その売買契約の締結から当該建物の引渡しまでの間に、地震によって全壊した場合、買主は売主に対して建物代金の支払いを拒むことができる。",
        "choice4": "買主が売主に解約手付を交付した場合、相手方が売買契約の履行に着手した後でも、買主はその解約手付を放棄し、売主はその解約手付の倍額を現実に提供して、当該売買契約を解除することができる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の売買契約のルール",
        "important": ""
    },
    {
        "id": 244,
        "shikenId": 5,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、同法第２２条の借地権を一般定期借地権といい、第２２条から第２４条の定期借地権等以外の借地権を普通借地権という。また、記載のない特約については考慮しないものとする。(2025.01)",
        "choice1": "普通借地権の存続期間は３０年とされているが、契約でこれより長い期間を定めたときは、その期間とされる。",
        "choice2": "普通借地権の存続期間が満了した時点で借地上に建物が存在しない場合は、借地権者が契約の更新を請求しても、従前の契約と同一の条件で契約が更新されたものとはみなされない。",
        "choice3": "借地権者は、借地権の登記がない限り、その土地の上に借地権者の名義で登記されている建物を所有していても、当該借地権を第三者に対抗することはできない。",
        "choice4": "一般定期借地権において、契約の更新および建物の築造による存続期間の延長がなく、期間満了による建物の買取りの請求をしないこととする旨を定める特約は、公正証書等の書面（電磁的記録による場合を含む）によってしなければならない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "借地借家法",
        "important": ""
    },
    {
        "id": 245,
        "shikenId": 5,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。(2021.05)",
        "choice1": "都道府県は、すべての都市計画区域において、市街化区域と市街化調整区域との区分（区域区分）を定めなければならないとされている。",
        "choice2": "都市計画区域のうち、市街化調整区域は、おおむね１０年以内に優先的かつ計画的に市街化を図るべき区域とされている。",
        "choice3": "開発許可を受けた開発区域内の土地においては、開発行為に関する工事完了の公告があるまでの間は、原則として、建築物を建築することができない。",
        "choice4": "農業を営む者の居住の用に供する建築物の建築を目的として市街化調整区域内で行う開発行為は、開発許可を受ける必要がある。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "都市計画法",
        "important": ""
    },
    {
        "id": 246,
        "shikenId": 5,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も適切なものはどれか。(2024.09)",
        "choice1": "建築基準法第４２条第２項により道路境界線とみなされる線と道路との間の敷地の部分（セットバック部分）は、建築物を建築することができないが、建蔽率および容積率を算定する際の敷地面積に算入することができる。",
        "choice2": "準防火地域内に準耐火建築物を建築する場合、建築物の制限について緩和措置の適用を受けることができる。",
        "choice3": "建築物の敷地が２つの異なる用途地域にわたる場合、その建築物の全部について、敷地の過半の属する用途地域の建蔽率の制限が適用される。",
        "choice4": "敷地の前面道路の幅員が１２ｍ未満である建築物の建蔽率は、原則として、「都市計画で定められた建蔽率」と「前面道路の幅員に一定の数値を乗じて得たもの」とのいずれか低い方が上限となる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築基準法",
        "important": ""
    },
    {
        "id": 247,
        "shikenId": 5,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。(2022.09)",
        "choice1": "区分所有建物ならびにその敷地および附属施設の管理を行うための区分所有者の団体（管理組合）は、区分所有者全員で構成される。",
        "choice2": "区分所有建物のうち、構造上の独立性と利用上の独立性を備えた建物の部分は、区分所有権の目的となる専有部分であり、規約によって共用部分とすることはできない。",
        "choice3": "共用部分に対する区分所有者の共有持分は、規約に別段の定めがない限り、各共有者が有する専有部分の床面積の割合による。",
        "choice4": "規約を変更するためには、区分所有者および議決権の各４分の３以上の多数による集会の決議が必要となり、この変更が一部の区分所有者の権利に特別の影響を及ぼすべきときは、当該区分所有者の承諾を得なければならない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "区分所有法",
        "important": ""
    },
    {
        "id": 248,
        "shikenId": 5,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "不動産に係る固定資産税および都市計画税に関する次の記述のうち、最も適切なものはどれか。(2022.09)",
        "choice1": "年の中途に固定資産税の課税対象となる土地または家屋が譲渡された場合、その譲受人は、原則として、その年度内の所有期間に応じた当年度分の固定資産税を納付しなければならない。",
        "choice2": "住宅用地に係る固定資産税の課税標準については、住宅１戸当たり４００㎡以下の部分について課税標準となるべき価格の６分の１相当額とする特例がある。",
        "choice3": "都市計画税の税率は各地方自治体の条例で定められるが、１００分の０．３を超えることはできない。",
        "choice4": "都市計画税は、都市計画区域のうち、原則として、市街化調整区域および非線引きの区域内に所在する土地および家屋の所有者に対して課される。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の所有に係る税金",
        "important": ""
    },
    {
        "id": 249,
        "shikenId": 5,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "居住用財産を譲渡した場合の３，０００万円の特別控除（以下「３，０００万円特別控除」という）および居住用財産を譲渡した場合の長期譲渡所得の課税の特例（以下「軽減税率の特例」という）に関する次の記述のうち、最も不適切なものはどれか。(2021.09)",
        "choice1": "３，０００万円特別控除は、居住用財産を配偶者に譲渡した場合には適用を受けることができない。",
        "choice2": "３，０００万円特別控除は、譲渡した居住用財産の所有期間が、譲渡した日の属する年の１月１日において１０年を超えていなければ、適用を受けることができない。",
        "choice3": "軽減税率の特例では、課税長期譲渡所得の金額のうち６，０００万円以下の部分の金額について軽減税率が適用される。",
        "choice4": "３，０００万円特別控除と軽減税率の特例は、重複して適用を受けることができる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の譲渡に係る税金",
        "important": ""
    },
    {
        "id": 250,
        "shikenId": 5,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "不動産の投資判断の手法等に関する次の記述のうち、最も適切なものはどれか。(2023.09)",
        "choice1": "ＤＣＦ法は、対象不動産の一期間の純収益を還元利回りで還元して対象不動産の収益価格を求める手法である。",
        "choice2": "ＮＰＶ法（正味現在価値法）による投資判断においては、対象不動産から得られる収益の現在価値の合計額が投資額を上回っている場合、その投資は有利であると判定することができる。",
        "choice3": "ＮＯＩ利回り（純利回り）は、対象不動産から得られる年間の総収入額を総投資額で除して算出される利回りであり、不動産の収益性を測る指標である。",
        "choice4": "ＤＳＣＲ（借入金償還余裕率）は、対象不動産から得られる収益による借入金の返済余裕度を評価する指標であり、対象不動産に係る当該指標の数値が１. ０を下回っている場合は、対象不動産から得られる収益だけで借入金を返済することができる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の投資判断",
        "important": ""
    },
    {
        "id": 251,
        "shikenId": 5,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "民法上の贈与に関する次の記述のうち、最も適切なものはどれか。(2021.09)",
        "choice1": "書面によらない贈与においては、その履行がなされていない場合であっても、各当事者は契約の解除をすることができない。",
        "choice2": "定期贈与とは、贈与者が受贈者に対して定期的に財産を給付することを目的とする贈与をいい、贈与者が死亡しても受贈者が生存している限り、その効力を失うことはない。",
        "choice3": "負担付贈与では、受贈者がその負担である義務を履行しない場合において、贈与者が相当の期間を定めてその履行の催告をし、その期間内に履行がないときは、贈与者は、原則として、当該贈与の契約の解除をすることができる。",
        "choice4": "死因贈与とは、贈与者の死亡によって効力が生じる贈与をいい、民法の遺贈に関する規定が準用され、死因贈与契約書については家庭裁判所による検認が必要である。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与の基礎知識",
        "important": ""
    },
    {
        "id": 252,
        "shikenId": 5,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "贈与税の非課税財産等に関する次の記述のうち、最も不適切なものはどれか。(2021.01)",
        "choice1": "扶養義務者相互間において生活費または教育費に充てるためにした贈与により取得した財産のうち、通常必要と認められるものは、贈与税の課税対象とならない。",
        "choice2": "個人から受ける社交上必要と認められる香典や見舞金等の金品で、贈与者と受贈者との関係等に照らして社会通念上相当と認められるものは、贈与税の課税対象とならない。",
        "choice3": "父が所有する土地の名義を無償で子の名義に変更した場合、その土地は、原則として、贈与税の課税対象とならない。",
        "choice4": "相続または遺贈により財産を取得した者が、相続開始の年において被相続人から贈与により取得した財産は、原則として、相続税の課税価格に算入されるため、贈与税の課税対象とならない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の課税対象と申告",
        "important": ""
    },
    {
        "id": 253,
        "shikenId": 5,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "贈与税の計算に関する次の記述のうち、最も不適切なものはどれか。(2022.01)",
        "choice1": "暦年課税に係る贈与税額の計算上、適用される税率は、超過累進税率である。",
        "choice2": "子が同一年中に父と母のそれぞれから贈与を受けた場合、同年分の子の暦年課税に係る贈与税額の計算上、課税価格から控除する基礎控除額は、各贈与者につき最高１１０万円となる。",
        "choice3": "妻が夫から受けた贈与について贈与税の配偶者控除の適用を受けたことがある場合、その後、同一の夫から贈与を受けても、再び贈与税の配偶者控除の適用を受けることはできない。",
        "choice4": "相続時精算課税制度に係る贈与税額の計算上、適用される税率は、一律２０％である。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の計算",
        "important": ""
    },
    {
        "id": 254,
        "shikenId": 5,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "下記＜親族関係図＞において、Ａさんの相続が開始した場合の相続税額の計算における遺産に係る基礎控除額として、最も適切なものはどれか。なお、ＣさんはＡさんの相続開始前に死亡している。また、Ｅさんは、Ａさんの普通養子（特別養子縁組以外の縁組による養子）であり、相続の放棄をしている。(2024.01)<br><br><img src='/img/set1/1_54.png'/>",
        "choice1": "４，２００万円",
        "choice2": "４，８００万円",
        "choice3": "５，４００万円",
        "choice4": "６，０００万円",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "民法上の相続人",
        "important": ""
    },
    {
        "id": 255,
        "shikenId": 5,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "遺産分割協議に関する次の記述のうち、最も適切なものはどれか。(2022.05)",
        "choice1": "遺産分割協議書は、民法で定められた形式に従って作成し、かつ、共同相続人全員が署名・捺印していなければ無効となる。",
        "choice2": "遺産分割協議書は、相続人が相続の開始があったことを知った日の翌日から１０ヵ月以内に作成し、家庭裁判所に提出しなければならない。",
        "choice3": "遺産を現物分割する旨の遺産分割協議書を作成する際に、一定の場合を除き、遺産の一部についてのみ定めた遺産分割協議書を作成することができる。",
        "choice4": "適法に成立した遺産分割協議については、共同相続人全員の合意があったとしても、当該協議を解除し、再度、遺産分割協議を行うことはできない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺産分割協議",
        "important": ""
    },
    {
        "id": 256,
        "shikenId": 5,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "次の費用等のうち、相続税の課税価格の計算上、相続財産の価額から債務控除できないものはどれか。なお、当該費用等は、相続により財産を取得した相続人が負担したものとし、相続人は債務控除の適用要件を満たしているものとする。(2020.01)",
        "choice1": "被相続人に係る住民税で、相続開始時点で納税義務は生じているが、納期限が到来していない未払いのもの",
        "choice2": "遺言執行者である弁護士に支払った被相続人の相続に係る遺言執行費用",
        "choice3": "葬式に際して施与した金品で、被相続人の職業、財産その他の事情に照らして相当と認められるもの",
        "choice4": "通夜にかかった費用などで、通常葬式に伴うものと認められるもの",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の課税財産",
        "important": ""
    },
    {
        "id": 257,
        "shikenId": 5,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "相続税の計算に関する次の記述のうち、最も適切なものはどれか。なお、本問において、相続の放棄をした者はいないものとする。(2023.01)",
        "choice1": "遺産に係る基礎控除額の計算上、法定相続人の数に含めることができる養子（実子とみなされる者を除く）の数は、実子がいる場合、２人に制限される。",
        "choice2": "相続人となるべき被相続人の子がすでに死亡しているため、その死亡した子を代襲して相続人となった被相続人の孫は、相続税額の２割加算の対象者となる。",
        "choice3": "相続人が被相続人の配偶者のみである場合、「配偶者に対する相続税額の軽減」の適用を受けた配偶者については、相続により取得した遺産額の多寡にかかわらず、納付すべき相続税額が生じない。",
        "choice4": "「配偶者に対する相続税額の軽減」の適用を受けることができる配偶者は、被相続人と法律上の婚姻の届出をした者に限られず、いわゆる内縁の配偶者も含まれる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の計算",
        "important": ""
    },
    {
        "id": 258,
        "shikenId": 5,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "相続税における取引相場のない株式の評価に関する次の記述のうち、最も適切なものはどれか。なお、特定の評価会社の株式には該当しないものとする。(2023.05)",
        "choice1": "類似業種比準方式における比準要素は、１株当たりの配当金額、１株当たりの利益金額および１株当たりの純資産価額（帳簿価額によって計算した金額）である。",
        "choice2": "会社規模が大会社である会社において、中心的な同族株主が取得した株式の価額は、原則として、類似業種比準方式と純資産価額方式の併用方式によって評価する。",
        "choice3": "会社規模が小会社である会社において、中心的な同族株主が取得した株式の価額は、原則として、類似業種比準方式によって評価する。",
        "choice4": "同族株主のいる会社において、同族株主以外の株主が取得した株式の価額は、その会社規模にかかわらず、原則として、純資産価額方式によって評価する。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "取引相場のない株式の評価",
        "important": ""
    },
    {
        "id": 259,
        "shikenId": 5,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "宅地および宅地の上に存する権利に係る相続税における評価に関する次の記述のうち、最も不適切なものはどれか。なお、評価の対象となる宅地は、借地権の取引慣行のある地域にあるものとする。また、宅地の上に存する権利は、定期借地権および一時使用目的の借地権等を除くものとする。(2021.01)",
        "choice1": "Ａさんが、借地権の設定に際して通常の権利金を支払って賃借した宅地の上にＡさん名義の自宅を建築して居住していた場合において、Ａさんの相続が開始したときには、相続税額の計算上、その賃借している宅地の上に存するＡさんの権利の価額は、借地権として評価する。",
        "choice2": "Ｂさんが所有する従前宅地であった土地を、車庫などの施設がない青空駐車場として提供していた場合において、Ｂさんの相続が開始したときには、相続税額の計算上、その土地の価額は、貸宅地として評価する。",
        "choice3": "Ｃさんが所有する宅地の上にＣさん名義のアパートを建築して賃貸していた場合において、Ｃさんの相続が開始したときには、相続税額の計算上、そのアパートの敷地の用に供されている宅地の価額は、貸家建付地として評価する。",
        "choice4": "Ｄさんが、借地権の設定に際して通常の権利金を支払って賃借した宅地の上にＤさん名義のアパートを建築して賃貸していた場合において、Ｄさんの相続が開始したときには、相続税額の計算上、その賃借している宅地の上に存するＤさんの権利の価額は、貸家建付借地権として評価する。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "宅地の評価",
        "important": ""
    },
    {
        "id": 260,
        "shikenId": 5,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "小規模宅地等についての相続税の課税価格の計算の特例（以下「本特例」という）に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢において、相続人が相続により取得した宅地は、相続開始直前において被相続人等の事業の用に供されていなかったものとし、ほかに必要とされる要件等はすべて満たしているものとする。(2024.05)",
        "choice1": "相続開始直前において被相続人の居住の用に供されていた宅地を相続により取得した被相続人の配偶者は、相続の申告期限までに当該宅地を売却した場合であっても、本特例の適用を受けることができる。",
        "choice2": "相続開始直前において被相続人の居住の用に供されていた宅地を相続により取得した被相続人の子が当該宅地の上の被相続人の居住の用に供されていた一棟の建物に相続開始前から相続税の申告期限まで引き続き居住し、かつ、当該宅地を相続開始時から相続税の申告期限まで所有していた場合、本特例の適用を受けることができる。",
        "choice3": "相続開始直前において被相続人および被相続人の配偶者の居住の用に供されていた宅地を相続により取得した被相続人の子が、当該宅地を相続開始後に初めて自己の居住の用に供し、相続税の申告期限まで保有していた場合、本特例の適用を受けることができる。",
        "choice4": "相続開始直前において被相続人と生計を一にする被相続人の母の居住の用に供されていた宅地を相続により取得した被相続人の配偶者は、本特例の適用を受けることができる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "小規模宅地の特例",
        "important": ""
    },
    {
        "id": 261,
        "shikenId": 8,
        "no": 1,
        "answerType": 4,
        "groupId": 0,
        "answer": "777986,322536,20",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set1/s1_1.png'/>",
        "question2": "Mさんは、Aさんに対して、Aさんが受給することができる公的年金制度からの老齢給付について説明した。Mさんが説明した以下の文章の空欄①～③に入る最も適切な数値を、解答欄に入力しなさい。年金額の計算にあたっては、《設例》の＜Aさんとその家族に関する資料＞および下記の＜資料＞に基づくこと。なお、年金額は2025年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。<br><img src='/img/set1/s1_2.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "年",
        "choice4": "",
        "choice5": "2024.05(改）",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金と老齢厚生年金の年金額",
        "important": ""
    },
    {
        "id": 262,
        "shikenId": 8,
        "no": 2,
        "answerType": 6,
        "groupId": 0,
        "answer": "ロ,ホ,リ",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set1/s1_1.png'/>",
        "question2": "Mさんは、Aさんに対して、小規模企業共済制度について説明した。Mさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の＜語句群＞のなかから選び、その記号を解答欄に入力しなさい。<br><br>　「小規模企業共済制度は、Ａさんのような個人事業主が廃業等した場合に必要となる資金を準備しておくための共済制度です。毎月の掛金は、1,000 円から（　①　）円までの範囲内で、500 円単位で選択することができます。支払った掛金は、税法上、（　②　）の対象となります。<br>　共済金は、加入者に廃業等の事由が生じた場合に、掛金納付月数等に応じて支払われます。共済金の受取方法には、『一括受取り』『分割受取り』『一括受取りと分割受取りの併用』があります。『一括受取り』の共済金（死亡事由以外）は、税法上、（　③　）として課税対象となります。<br>　なお、掛金納付月数が 240 カ月未満で任意解約した場合は、解約手当金の額が掛金合計額を下回りますので、早期の解約はお勧めできません」<br><img src='/img/set1/s1_3.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.05(改）",
        "categoryName": "ライフ",
        "rontenName": "国民年金基金",
        "important": ""
    },
    {
        "id": 263,
        "shikenId": 8,
        "no": 3,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,1,2",
        "score": "1,1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set1/s1_1.png'/>",
        "question2": "Mさんは、Aさんに対して、老後の収入を増やすことができる各種制度について説明した。Mさんが説明した次の記述①～④について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「Ａさんは、国民年金の定額保険料に上乗せして、付加保険料を納付することができます。仮に、Ａさんが付加保険料を 200 月納付し、65 歳から老齢基礎年金を受給する場合、老齢基礎年金の額に付加年金として年額 80,000 円が上乗せされます」",
        "choice2": "「国民年金基金は、老齢基礎年金に上乗せする年金を支給する任意加入の年金制度です。加入は口数制となっており、１口目は２種類の終身年金（Ａ型・Ｂ型）のいずれかを選択します」",
        "choice3": "「国民年金基金の１口目の給付には、国民年金の付加年金相当が含まれているため、Ａさんが国民年金基金に加入した場合、国民年金の付加保険料を納付することはできません」",
        "choice4": "「国民年金の定額保険料や付加保険料を前納した場合、前納期間に応じて保険料の割引がありますが、国民年金基金の掛金については、前納による割引制度はありません」",
        "choice5": "2024.05(改）",
        "categoryName": "ライフ",
        "rontenName": "私的年金制度",
        "important": ""
    },
    {
        "id": 264,
        "shikenId": 8,
        "no": 4,
        "answerType": 4,
        "groupId": 0,
        "answer": "-280,2500,3000",
        "score": "2,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問4》～《問6》）に答えなさい。<br><img src='/img/set1/s2_1.png'/>",
        "question2": "はじめに、Mさんは、Aさんに対して、必要保障額と現在加入している定期保険特約付終身保険の保障金額について説明した。Mさんが説明した以下の文章の空欄①～③に入る最も適切な数値を解答欄に入力しなさい。なお、空欄①の金額がマイナスになる場合は、金額の前に「-」を記載し、マイナスであることを示すこと。<br><br>　「医療保障を充実させる前に、現時点での必要保障額を算出し、準備すべき死亡保障の額を把握しましょう。下記＜条件＞を参考にすれば、A さんが現時点で死亡した場合の必要保障額は（　①　）万円となります。<br>　A さんが現時点で死亡（不慮の事故や所定の感染症以外）した場合、定期保険特約付終身保険から妻 B さんに支払われる死亡保険金額は（　②　）万円となります。他方、A さんが不慮の事故で 180 日以内に死亡した場合の死亡保険金額は（　③　）万円となります。<br>　死亡整理資金等の一時的に必要となる金額を生命保険でどの程度確保するか、保険金額の減額や払済終身保険への変更等、解約以外の選択肢も含めて検討することをお勧めします」<br><br><img src='/img/set1/s2_2.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "2020.01(改）",
        "categoryName": "リスク（個人）",
        "rontenName": "必要保障額と保険金の計算",
        "important": ""
    },
    {
        "id": 265,
        "shikenId": 8,
        "no": 5,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問4》～《問6》）に答えなさい。<br><img src='/img/set1/s2_1.png'/>",
        "question2": "次に、Mさんは、Aさんに対して、公的医療保険制度について説明した。Mさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「A さんが病気などで医師の診察を受けた場合、医療費の一部負担金の割合は、原則３割となります。ただし、高額療養費制度により、一医療機関の窓口で支払う同一月内の一部負担金を、所定の自己負担限度額までとすることができます」",
        "choice2": "「高額療養費制度における自己負担限度額は、年齢および所得状況等に応じて決められています。同じ所得金額であっても、65 歳未満の者と 65 歳以上 70 歳未満の者とで自己負担限度額の計算の区分は異なります」",
        "choice3": "「A さんが定年退職により健康保険の被保険者資格を喪失した場合、一定期間、任意継続被保険者として加入することができます。任意継続被保険者となった場合は、原則として、在職中と同様の給付を受けられますが、高額療養費の支給は受けられません」",
        "choice4": "",
        "choice5": "2020.01(改）",
        "categoryName": "リスク（個人）",
        "rontenName": "公的医療保険",
        "important": ""
    },
    {
        "id": 266,
        "shikenId": 8,
        "no": 6,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,1",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問4》～《問6》）に答えなさい。<br><img src='/img/set1/s2_1.png'/>",
        "question2": "最後に、Mさんは、Aさんに対して、Aさんが現在加入している生命保険の見直しの方法やAさんが提案を受けた終身医療保険の特徴等についてアドバイスした。Mさんがアドバイスした次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「現在加入している定期保険特約付終身保険を払済終身保険に変更した場合、付加されている特定疾病保障定期保険特約は消滅します。そのため、特定疾病などの重度の疾病に備える保障をどのように確保するか、検討事項の１つとなります」",
        "choice2": "「先進医療特約は、療養を受けた時点ではなく、当該特約に加入した時点で先進医療と定められていれば支払対象となります。一部の先進医療については費用が高額となるケースもありますので、先進医療特約の付加をご検討ください」",
        "choice3": "「保険会社各社は、入院給付金や手術給付金が定額で受け取れるタイプの医療保険や通院保障が手厚いものなど、最近の医療事情に合わせて、さまざまなタイプの医療保険を取り扱っています。保障内容や保障範囲をしっかりと確認したうえで、加入を検討されることをお勧めします」",
        "choice4": "",
        "choice5": "2020.01(改）",
        "categoryName": "リスク（個人）",
        "rontenName": "生命保険・第三分野の保険の保障",
        "important": ""
    },
    {
        "id": 267,
        "shikenId": 8,
        "no": 7,
        "answerType": 4,
        "groupId": 0,
        "answer": "1920,1540",
        "score": "1,2",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問7》～《問9》）に答えなさい。<br><img src='/img/set1/s3_1.png'/>",
        "question2": "仮に、Ｘ社がＡさんに役員退職金5,000万円を支給した場合、Ａさんが受け取る役員退職金について、次の①、②を求め、解答欄に入力しなさい（計算過程の記載は不要）。〈答〉は万円単位とすること。なお、Ａさんの役員在任期間（勤続年数）を35年３カ月とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。<br><br>①　退職所得控除額<br>②　退職所得の金額",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "タックス",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 268,
        "shikenId": 8,
        "no": 8,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,2",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問7》～《問9》）に答えなさい。<br><img src='/img/set1/s3_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、＜資料１＞の終身保険について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「現時点で当該生命保険を解約した場合、配当金等を考慮しなければ、Ｘ社はそれまで資産計上していた保険料積立金 2,250 万円を取り崩して、解約返戻金 2,300万円との差額 50 万円を雑収入として経理処理します」",
        "choice2": "「勇退時に契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義を変更することで、当該生命保険を役員退職金の一部としてＡさんに支給することができます。保険料の払込みが既に終わっており、今後も解約返戻金額が増加することを考えると、個人の保険として保障を継続することも選択肢の１つです」",
        "choice3": "「契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義を変更し、当該生命保険を役員退職金の一部としてＡさんに支給した場合、名義変更時の既払込保険料総額がＡさんの退職所得に係る収入金額となり、他の退職手当等と合算して退職所得の金額を計算します」",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "リスク（法人）",
        "rontenName": "法人契約の終身保険",
        "important": ""
    },
    {
        "id": 269,
        "shikenId": 8,
        "no": 9,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,2,2",
        "score": "1,1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問7》～《問9》）に答えなさい。<br><img src='/img/set1/s3_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、＜資料２＞の定期保険について説明した。Ｍさんが説明した次の記述①～④について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「当該生命保険の単純返戻率（解約返戻金額÷払込保険料累計額）は、保険期間の途中でピークを迎え、その後は低下し、保険期間満了時には０（ゼロ）になります。当該生命保険の解約返戻金は、役員退職金の原資や設備投資等の事業資金として活用することができます」",
        "choice2": "「当該生命保険の場合、保険期間開始日から保険期間の４割に相当する期間を経過する日までは、当期分支払保険料の６割相当額を前払保険料として資産に計上し、残額は損金の額に算入します」",
        "choice3": "「当該生命保険を長男Ｂさんの勇退時に払済終身保険に変更した場合、契約は継続しているため、経理処理の必要はありません」",
        "choice4": "「保険期間中にＸ社に緊急の資金需要が発生し、契約者貸付制度を利用する場合、当該制度により借り入れることができる金額は、利用時点での既払込保険料相当額が限度となります」",
        "choice5": "2023.09",
        "categoryName": "リスク（法人）",
        "rontenName": "法人契約の定期保険と経理処理",
        "important": ""
    },
    {
        "id": 270,
        "shikenId": 8,
        "no": 10,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問10》～《問12》）に答えなさい。<br><img src='/img/set1/s4_1.png'/><img src='/img/set1/s4_2.png'/>",
        "question2": "Aさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「一時払養老保険は金融類似商品に該当するため、A さんが受け取った満期保険金に係る保険差益は源泉分離課税の対象となります」",
        "choice2": "「A さんの場合、総所得金額に算入される一時所得の金額が 20 万円を超えるため、所得税の確定申告をしなければなりません」",
        "choice3": "「A さんは、給与収入の金額が 850 万円を超え、かつ、扶養親族を有しているため、総所得金額の計算上、所得金額調整控除として、給与収入の金額から 850 万円を控除した金額の 10％相当額を給与所得の金額から控除します」",
        "choice4": "",
        "choice5": "2022.01(改）",
        "categoryName": "タックス",
        "rontenName": "所得税の課税対象と所得金額調整控除",
        "important": ""
    },
    {
        "id": 271,
        "shikenId": 8,
        "no": 11,
        "answerType": 6,
        "groupId": 0,
        "answer": "ヘ,ト,イ",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問10》～《問12》）に答えなさい。<br><img src='/img/set1/s4_1.png'/><img src='/img/set1/s4_2.png'/>",
        "question2": "Aさんの本年分の所得税における所得控除に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を解答用紙に記入しなさい。<br><br>Ⅰ． 「A さんの合計所得金額は（　①　）万円以下であるため、A さんは 38 万円の配偶者控除の適用を受けることができます。仮に、A さんの合計所得金額が（　①　）万円を超えると、配偶者控除の額は段階的に縮小し、合計所得金額が（　②　）万円を超えると、適用を受けることができなくなります」<br>Ⅱ． 「A さんが適用を受けることができる扶養控除の額は、（　③　）万円です」<br><br><img src='/img/set1/s4_3.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2022.01(改）",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 272,
        "shikenId": 8,
        "no": 12,
        "answerType": 4,
        "groupId": 0,
        "answer": "7500000,40000,512500",
        "score": "1,1,2",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問10》～《問12》）に答えなさい。<br><img src='/img/set1/s4_1.png'/><img src='/img/set1/s4_2.png'/>",
        "question2": "Aさんの本年分の所得税の算出税額を計算した下記の表の空欄①～④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src='/img/set1/s4_4.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "",
        "choice5": "2022.01(改）",
        "categoryName": "タックス",
        "rontenName": "所得税の計算",
        "important": ""
    },
    {
        "id": 273,
        "shikenId": 8,
        "no": 13,
        "answerType": 4,
        "groupId": 0,
        "answer": "4,10,500,3000",
        "score": "1,1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問13》～《問15》）に答えなさい。<br><img src='/img/set1/s5_1.png'/>",
        "question2": "父Dさんの相続等に関する以下の文章の空欄①～④に入る最も適切な数値を解答欄に入力しなさい。<br><br>Ⅰ． 「賃貸アパートを経営していた父 D さんが本年分の所得税について確定申告書を提出しなければならない場合に該当するとき、相続人は、原則として、相続の開始があったことを知った日の翌日から（　①　）カ月以内に準確定申告書を提出しなければなりません」<br><br>Ⅱ． 「相続税の申告書の提出期限は、原則として、相続の開始があったことを知った日の翌日から（　②　）カ月以内です。申告書の提出先は、父 D さんの死亡時の住所地を所轄する税務署長になります」<br><br>Ⅲ． 「弟 B さんが受け取る死亡保険金（2,000 万円）のうち、相続税の課税価格に算入される金額は、（　③　）万円となります」<br><br>Ⅳ． 「自宅（実家）の敷地および建物を A さんが取得し、『被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例』の適用を受けた場合、譲渡所得の金額の計算上、最高（　④　）万円の特別控除の適用を受けることができます」",
        "choice1": "ヵ月",
        "choice2": "ヵ月",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "2021.05(改）",
        "categoryName": "相続",
        "rontenName": "相続の手続きと課税価格のルール",
        "important": ""
    },
    {
        "id": 274,
        "shikenId": 8,
        "no": 14,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,2",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問13》～《問15》）に答えなさい。<br><img src='/img/set1/s5_1.png'/>",
        "question2": "「小規模宅地等についての相続税の課税価格の計算の特例」（以下、「本特例」という）に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「A さんが自宅（実家）の敷地を相続し、特定居住用宅地等として本特例の適用を受けた場合、その敷地の 400㎡までを限度面積として、評価額の 80％相当額を減額した金額を、相続税の課税価格に算入すべき価額とすることができます」",
        "choice2": "「A さんが自宅（実家）の敷地を相続し、当該敷地を相続税の申告期限前に売却した場合であっても、本特例の適用を受けることができます」",
        "choice3": "「自宅（実家）の敷地と賃貸アパートの敷地について、本特例の適用を受けようとする場合、適用対象面積の調整はせず、それぞれの宅地等の適用対象の限度面積まで適用を受けることができます」",
        "choice4": "",
        "choice5": "2021.05(改）",
        "categoryName": "相続",
        "rontenName": "小規模宅地等の特例",
        "important": ""
    },
    {
        "id": 275,
        "shikenId": 8,
        "no": 15,
        "answerType": 4,
        "groupId": 0,
        "answer": "4800,480,1440",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問13》～《問15》）に答えなさい。<br><img src='/img/set1/s5_1.png'/>",
        "question2": "父Dさんの相続における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は１億5,000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set1/s5_2.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "2021.05(改）",
        "categoryName": "相続",
        "rontenName": "相続税額の計算",
        "important": ""
    },
    {
        "id": 276,
        "shikenId": 7,
        "no": 1,
        "answerType": 4,
        "groupId": 0,
        "answer": "774521,276242,217,276459",
        "score": "1,1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問1》～《問3》）に答えなさい。<br><img src='/img/set1/k1_1.png'/>",
        "question2": "Aさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（2025年度価額）を計算した次の＜計算の手順＞の空欄①～④に入る最も適切な数値を解答欄に入力しなさい。なお、計算にあたっては、《設例》の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づくこと。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set1/k1_2.png'/><br><br><img src='/img/set1/k1_3.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "2024.01(改）",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金および老齢厚生年金の年金額",
        "important": ""
    },
    {
        "id": 277,
        "shikenId": 7,
        "no": 2,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問1》～《問3》）に答えなさい。<br><img src='/img/set1/k1_1.png'/>",
        "question2": "Mさんは、Aさんに対して、公的年金制度等の各種取扱いについて説明した。Mさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「Aさんは、国民年金の付加保険料を納付することができます。仮に、Aさんが月額 400 円の付加保険料を 180 月納付し、65 歳から老齢基礎年金を受け取る場合、老齢基礎年金の額に付加年金として年額 36,000 円が上乗せされます」",
        "choice2": " 「老齢基礎年金および老齢厚生年金は、繰下げ請求の申出により、繰下げ月数に応じて増額された年金を受給することができます。Aさんの場合、65 歳 1 カ月以降に年金の受給を開始することができ、その場合の増額率は、繰下げ月数に応じて増額し、1カ月で 0.7%、最大で 84.0% となります」",
        "choice3": "「小規模企業共済制度は、個人事業主が廃業した場合に必要となる資金を準備しておくための制度です。支払った掛金が所得控除の対象になることはメリットですが、契約者本人の都合で任意に解約ができないことに注意が必要です」",
        "choice4": "",
        "choice5": "2024.01(改）",
        "categoryName": "ライフ",
        "rontenName": "公的年金の諸制度",
        "important": ""
    },
    {
        "id": 278,
        "shikenId": 7,
        "no": 3,
        "answerType": 6,
        "groupId": 0,
        "answer": "チ,ホ,ル",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問1》～《問3》）に答えなさい。<br><img src='/img/set1/k1_1.png'/>",
        "question2": "Mさんは、Aさんに対して、国民年金基金について説明した。Mさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の＜語句群＞のなかから選び、その番号を解答欄に入力しなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>「国民年金基金は、老齢基礎年金に上乗せする年金を支給する任意加入の年金制度です。加入は口数制となっており、1 口目は、保証期間のある（　①　）年金 A 型と保証期間のない（　①　）年金 B 型のいずれかの給付の型を選択します。2 口目以降は、2 種類の（　①　）年金と 5 種類の□□□年金のなかから選択することができます。掛金の額は、加入者が選択した給付の型や口数、加入時の年齢等で決まり、掛金の拠出限度額の上限は、2025 年以降、（　②　）円です。なお、国民年金基金に加入している間は、国民年金の付加保険料を納付することができません。<br>国民年金基金の給付には、老齢年金のほかに遺族一時金があります。遺族一時金は、加入員が年金を受け取る前に死亡した場合などに、その遺族に対して支払われます。遺族が受け取れる遺族一時金は、（　③　）」<br><br><img src='/img/set1/k1_4.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2024.01(改）",
        "categoryName": "ライフ",
        "rontenName": "国民年金基金",
        "important": ""
    },
    {
        "id": 279,
        "shikenId": 7,
        "no": 4,
        "answerType": 4,
        "groupId": 0,
        "answer": "9.41,4.17",
        "score": "2,2,2",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set1/k2_1.png'/>",
        "question2": "《設例》の＜X社株式の関連情報＞および＜X社の財務データ＞に基づいて算出される次の①、②を求めなさい（計算過程の記載は不要）。〈答〉は、表示単位の小数点以下第３位を四捨五入し、小数点以下第２位までを解答すること。<br><br>①　 86 期における ROE（自己資本は 85 期と 86 期の平均を用いること）<br>②　 86 期における配当利回り",
        "choice1": "％",
        "choice2": "％",
        "choice3": "",
        "choice4": "",
        "choice5": "2022.01(改）",
        "categoryName": "金融",
        "rontenName": "株式投資の指標",
        "important": ""
    },
    {
        "id": 280,
        "shikenId": 7,
        "no": 5,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set1/k2_1.png'/>",
        "question2": "Mさんは、Aさんに対して、X社株式を購入する際の留意点等について説明した。Mさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「X 社株式の PBR は１倍を下回っていますが、PBR の１倍割れだけをもって割安と判断するのは注意する必要があります。PER などの他の投資指標についても比較検討するなど、多角的な視点が望まれます」",
        "choice2": "「上場株式の配当を受け取るためには、権利確定日に株主として株主名簿に記載される必要があります。X 社株式については、普通取引により、権利確定日の２営業日前である本年３月 27 日（水）までに買付けを行えば、次回の配当を受け取ることができます」",
        "choice3": "「X 社株式を購入する場合、成長投資枠またはつみたて投資枠のいずれかを利用することができます。本年中に成長投資枠に受け入れることができる金額は 240万円、同年中につみたて投資枠に受け入れることができる金額は 120 万円が上限です」",
        "choice4": "",
        "choice5": "2022.01(改）",
        "categoryName": "金融",
        "rontenName": "株式投資とNISAの制度理解",
        "important": ""
    },
    {
        "id": 281,
        "shikenId": 7,
        "no": 6,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,2",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set1/k2_1.png'/>",
        "question2": "Mさんは、Aさんに対して、昨今の投資事情等について説明した。Mさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「昨今、クレジットカード決済で『積立型』の投資信託や上場株式を購入し、ポイントが付与されるサービスや、付与されたポイント相当額で、証券会社に開設した口座を通じて投資信託等に投資することができるサービスが展開されています」",
        "choice2": "「法人の内部情報を知りうる特別な立場にある者が、決算予想値の大幅な修正等の未公表の重要事実に基づき、当該法人の上場株式、J-REIT、上場インフラファンドの売買を行うことについても、金融商品取引法上、インサイダー取引に該当し、禁止されています」",
        "choice3": "「仮に、A さんが特定口座（源泉徴収あり）において X 社株式を株価 4,800 円で200 株購入し、同年中に株価 5,300 円で全株売却した場合、その他の取引や手数料等を考慮しなければ、売却益 10 万円に対して 10.21％相当額が源泉徴収等されます」",
        "choice4": "",
        "choice5": "2022.01(改）",
        "categoryName": "金融",
        "rontenName": "株式投資の留意点",
        "important": ""
    },
    {
        "id": 282,
        "shikenId": 7,
        "no": 7,
        "answerType": 6,
        "groupId": 0,
        "answer": "ホ,イ,ヘ",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set1/k3_1.png'/>",
        "question2": "所得税における青色申告制度に関する以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を解答用紙に記入しなさい。<br><br>Ⅰ． 「事業所得の金額の計算上、青色申告特別控除として最高（　①　）万円を控除することができます。（　①　）万円の青色申告特別控除の適用を受けるためには、事業所得に係る取引を正規の簿記の原則に従い記帳し、その記帳に基づいて作成した貸借対照表、損益計算書その他の計算明細書を添付した確定申告書を法定申告期限内に提出することに加えて、e-Tax による申告（電子申告）または電子帳簿保存を行う必要があります。なお、確定申告書を法定申告期限後に提出した場合、青色申告特別控除額は最高（　②　）万円となります」<br><br>Ⅱ． 「青色申告者が受けられる税務上の特典として、青色申告特別控除のほかに、青色事業専従者給与の必要経費算入、純損失の３年間の繰越控除、（　③　）の所得に対する税額から還付を受けられる純損失の繰戻還付、棚卸資産の評価について低価法を選択できることなどが挙げられます」<br><br><img src='/img/set1/k3_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2021.05(改）",
        "categoryName": "タックス",
        "rontenName": "青色申告制度",
        "important": ""
    },
    {
        "id": 283,
        "shikenId": 7,
        "no": 8,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,1",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set1/k3_1.png'/>",
        "question2": "Aさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「A さんが受け取った一時払養老保険の満期保険金に係る差益は、源泉分離課税の対象となります」",
        "choice2": "「母 D さんの公的年金等に係る雑所得の金額は算出されません。A さんは母 Dさんに係る扶養控除の適用を受けることができます」",
        "choice3": "「A さんが、妻 B さんが負担すべき国民年金保険料を支払った場合、A さんに係る所得税の社会保険料控除の対象となります」",
        "choice4": "",
        "choice5": "2021.05(改）",
        "categoryName": "タックス",
        "rontenName": "所得税のルール",
        "important": ""
    },
    {
        "id": 284,
        "shikenId": 7,
        "no": 9,
        "answerType": 4,
        "groupId": 0,
        "answer": "5000000,580000,192500",
        "score": "2,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set1/k3_1.png'/>",
        "question2": "Aさんの本年分の所得税の算出税額を計算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set1/k3_3.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "",
        "choice5": "2021.05(改）",
        "categoryName": "タックス",
        "rontenName": "所属税額の計算",
        "important": ""
    },
    {
        "id": 285,
        "shikenId": 7,
        "no": 10,
        "answerType": 4,
        "groupId": 0,
        "answer": "500,1750",
        "score": "2,2",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問10》～《問12》）に答えなさい。<br><img src='/img/set1/k4_1.png'/>",
        "question2": "　甲土地と乙土地を一体とした土地上に耐火建築物を建築する場合における次の①、②を求めなさい（計算過程の記載は不要）。<br><br>①　建蔽率の上限となる建築面積<br>②　容積率の上限となる延べ面積",
        "choice1": "㎡",
        "choice2": "㎡",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "不動産",
        "rontenName": "建蔽率と容積率の計算",
        "important": ""
    },
    {
        "id": 286,
        "shikenId": 7,
        "no": 11,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問10》～《問12》）に答えなさい。<br><img src='/img/set1/k4_1.png'/>",
        "question2": "自宅（建物とその敷地である甲土地）の譲渡および月極駐車場（乙土地）の賃貸借契約に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「Ａさんがマンションに転居し、その後、居住していない現在の自宅を譲渡する場合、Ａさんが『居住用財産を譲渡した場合の 3,000 万円の特別控除の特例』の適用を受けるためには、現在の自宅にＡさんが居住しなくなった日から３年を経過する日の属する年の 12 月 31 日までに譲渡しなければなりません」",
        "choice2": "「『居住用財産を譲渡した場合の長期譲渡所得の課税の特例（軽減税率の特例）』の適用を受けるためには、譲渡した年の１月１日において居住用財産の所有期間が 10 年を超えていなければなりません。Ａさんが現在の自宅を譲渡する場合、譲渡所得の金額の計算上、相続により取得した現在の自宅の取得時期は相続開始日とされるため、当該特例の適用を受けることはできません」",
        "choice3": "「乙土地に係る月極駐車場の賃貸借契約には、借地借家法が適用されるため、当該契約に中途解約に関する条項がある場合であっても、正当な事由がない場合は、貸主であるＡさんから解約を申し入れることができません」",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "不動産",
        "rontenName": "不動産の賃貸借契約",
        "important": ""
    },
    {
        "id": 287,
        "shikenId": 7,
        "no": 12,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問10》～《問12》）に答えなさい。<br><img src='/img/set1/k4_1.png'/>",
        "question2": "建設協力金方式による甲土地と乙土地を一体とした土地の有効活用に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「建設協力金方式は、ＡさんがⅩ社から建設資金の一部または全部を借り受けて、Ⅹ社の要望に沿った店舗を建設し、その店舗をⅩ社に賃貸する手法です。借り受けた建設資金は、元本の返済に加え、利子の支払が必要となることがありますが、不動産所得の金額の計算上、返済した元利金は必要経費に算入することができます」",
        "choice2": "「建設協力金方式による土地の有効活用において、建設した店舗に係る固定資産税の納税義務は、Ａさんが負うことになります」",
        "choice3": "「Ａさんが建設した店舗をⅩ社に賃貸した後、その賃貸期間中にＡさんの相続が開始した場合、相続税額の計算上、店舗は貸家として評価され、甲土地と乙土地を一体とした土地は貸宅地として評価されます」",
        "choice4": "",
        "choice5": "2023.09",
        "categoryName": "不動産",
        "rontenName": "不動産の有効活用",
        "important": ""
    },
    {
        "id": 288,
        "shikenId": 7,
        "no": 13,
        "answerType": 6,
        "groupId": 0,
        "answer": "ロ,ホ,ヘ",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set1/k5_1.png'/>",
        "question2": "Aさんの相続等に関する以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を解答欄に入力しなさい。<br><br><img src='/img/set1/k5_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2022.05(改）",
        "categoryName": "相続",
        "rontenName": "相続の基礎知識と小規模宅地等の特例",
        "important": ""
    },
    {
        "id": 289,
        "shikenId": 7,
        "no": 14,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set1/k5_1.png'/>",
        "question2": "Aさんの相続等に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「孫 E さんは、相続税額の２割加算の対象になりますが、孫 F さんは、二男 Dさんの代襲相続人ですので、相続税額の２割加算の対象にはなりません」",
        "choice2": "「X 社株式の相続税評価額は、原則として、類似業種比準方式と純資産価額方式の併用方式により評価されます。そのうち類似業種比準方式は、類似業種の株価を基に、１株当たりの『配当金額』『取引金額』および『簿価純資産価額』の３つの要素から算出します」",
        "choice3": "「相続税の総額は、各相続人の実際の取得割合によって計算されますので、分割内容によって異なります」",
        "choice4": "",
        "choice5": "2022.05(改）",
        "categoryName": "相続",
        "rontenName": "相続税の計算におけるルール",
        "important": ""
    },
    {
        "id": 290,
        "shikenId": 7,
        "no": 15,
        "answerType": 4,
        "groupId": 0,
        "answer": "8000,4800,1415,6770",
        "score": "1,1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set1/k5_1.png'/>",
        "question2": "各相続人は《設例》の記載のとおり、相続財産を取得した。A さんの相続に係る相続税の総額を計算した下記の表の空欄①～④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set1/k5_3.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "2022.05(改）",
        "categoryName": "相続",
        "rontenName": "相続税額の計算",
        "important": ""
    },
    {
        "id": 291,
        "shikenId": 6,
        "no": 1,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,1,2,1",
        "score": "1,1,1,1",
        "question1": "ファイナンシャル・プランナー（以下「ＦＰ」という）が、ファイナンシャル・プランニング業務を行ううえでは関連業法等を順守することが重要である。ＦＰの行為に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を解答欄に記入しなさい。",
        "question2": "",
        "choice1": "弁護士資格を有していないＦＰ（遺言者や公証人と利害関係のない成年者）が、顧客から依頼されて公正証書遺言の証人となり、顧客から適正な報酬を受け取った。",
        "choice2": "税理士資格を有していないＦＰが、参加費有料の相続対策セミナーで、仮定の事例に基づく一般的な解説を行い、講師料を受け取った。",
        "choice3": "投資助言・代理業の登録を受けていないＦＰが、特定企業の公表されている決算報告書を用いて、有償で具体的な投資時期等の判断や助言を行った。",
        "choice4": "生命保険募集人・保険仲立人の登録を受けていないＦＰが、生命保険契約を検討している顧客のライフプランに基づき、必要保障額を具体的に試算した。",
        "choice5": "2022.01",
        "categoryName": "ライフ",
        "rontenName": "関連法規",
        "important": ""
    },
    {
        "id": 292,
        "shikenId": 6,
        "no": 2,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "「消費者契約法」に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "消費者契約法における「消費者」とは、個人（事業としてまたは事業のために契約の当事者となる場合におけるものを除く）のみである。",
        "choice2": "事業者が、消費者の利益となる旨を告げながら、重要事項について消費者に不利な事実をわざと告げずに消費者が誤認をして契約した場合、当該契約は取り消すことができる。",
        "choice3": "消費者が、商品を買わずに帰りたいと言っても帰らせてもらえずに困惑して契約した場合で、購入場所が事業者の店舗であるときは、当該契約は取り消すことができない。",
        "choice4": "「販売した商品は、いかなる理由があっても、後から返品・キャンセルはできません」とした契約条項は無効である。",
        "choice5": "2022.01",
        "categoryName": "ライフ",
        "rontenName": "消費者契約法",
        "important": ""
    },
    {
        "id": 293,
        "shikenId": 6,
        "no": 3,
        "answerType": 9,
        "groupId": 1,
        "answer": "1000,235",
        "score": "2,2",
        "question1": "下記＜資料＞は、本年１２月３１日時点の横川さん夫婦（翔馬さんと恵里さん）のＹＸ銀行（日本国内に本店のある普通銀行）における金融資産（時価）の一覧表である。この時点においてＹＸ銀行が破綻した場合に、預金保険制度によって保護される金融資産の金額に関する次の記述の空欄（ア）、（イ）にあてはまる数値を解答欄に記入しなさい。<br><br><img src='/img/set1/f3_1.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "2020.01(改）",
        "categoryName": "ライフ",
        "rontenName": "預金保険制度",
        "important": ""
    },
    {
        "id": 294,
        "shikenId": 6,
        "no": 4,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "下記＜資料＞に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、正しいものはどれか。<br><br><img src='/img/set1/f4_1.png'/>",
        "question2": "",
        "choice1": "（ア）ＹＬ （イ）ＹＬ",
        "choice2": "（ア）ＹＬ （イ）ＹＭ",
        "choice3": "（ア）ＹＭ （イ）ＹＬ",
        "choice4": "（ア）ＹＭ （イ）ＹＭ",
        "choice5": "2020.01",
        "categoryName": "金融",
        "rontenName": "株式投資の指標の計算",
        "important": ""
    },
    {
        "id": 295,
        "shikenId": 6,
        "no": 5,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "平尾さんはＫＡ投資信託を新規募集時に１００万口購入し、特定口座（源泉徴収口座）で保有して収益分配金を受け取っている。下記＜資料＞に基づき、平尾さんが保有するＫＡ投資信託に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、正しいものはどれか。<br><br><img src='/img/set1/f5_1.png'/>",
        "question2": "",
        "choice1": "（ア）３３，０００円　（イ）５００円",
        "choice2": "（ア）３３，０００円　（イ）２，０００円",
        "choice3": "（ア）２２，０００円　（イ）５００円",
        "choice4": "（ア）２２，０００円　（イ）２，０００円",
        "choice5": "2020.01",
        "categoryName": "金融",
        "rontenName": "投資信託のコストと分配金の計算",
        "important": ""
    },
    {
        "id": 296,
        "shikenId": 6,
        "no": 6,
        "answerType": 9,
        "groupId": 0,
        "answer": "1.728",
        "score": 2,
        "question1": "下記＜資料＞の債券を取得日から７年後に売却した場合における所有期間利回り（単利・年率）を計算しなさい。なお、手数料や税金等については考慮しないものとし、計算結果については小数点以下第４位を切り捨てること。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set1/f6_1.png'/>",
        "question2": "",
        "choice1": "％",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2020.01",
        "categoryName": "金融",
        "rontenName": "債券利回りの計算",
        "important": ""
    },
    {
        "id": 297,
        "shikenId": 6,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "下記＜資料＞は、外貨定期預金の契約締結前交付書面の一部である。この契約締結前交付書面に関する次の記述の空欄（ア）～（エ）にあてはまる語句として、最も適切なものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><br><img src='/img/set1/f7_1.png'/>",
        "question2": "",
        "choice1": "空欄（ア）にあてはまる語句は、「対象」である。",
        "choice2": "空欄（イ）にあてはまる語句は、「申告分離課税」である。",
        "choice3": "空欄（ウ）にあてはまる語句は、「１，５２０，０００円」である。",
        "choice4": "空欄（エ）にあてはまる語句は、「円安」である。",
        "choice5": "2025.01(改）",
        "categoryName": "不動産",
        "rontenName": "外貨建て金融商品",
        "important": ""
    },
    {
        "id": 298,
        "shikenId": 6,
        "no": 8,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "建築基準法に従い、下記＜資料＞の土地に耐火建築物を建てる場合、建築面積の最高限度（ア）と延べ面積（床面積の合計）の最高限度（イ）の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない条件は一切考慮しないこと。<br><br><img src='/img/set1/f8_1.png'/>",
        "question2": "",
        "choice1": "（ア）１６２㎡　（イ）１０８０㎡",
        "choice2": "（ア）１８９㎡　（イ）８６４㎡",
        "choice3": "（ア）１６２㎡　（イ）８６４㎡",
        "choice4": "（ア）１８９㎡　（イ）１０８０㎡",
        "choice5": "2022.09",
        "categoryName": "不動産",
        "rontenName": "建蔽率と容積率の計算",
        "important": ""
    },
    {
        "id": 299,
        "shikenId": 6,
        "no": 9,
        "answerType": 8,
        "groupId": 1,
        "answer": "1,2,4,5",
        "score": "1,1,1,1",
        "question1": "羽田さんは、所有しているアパートを貸すに当たり、ＦＰの近藤さんに借家契約の説明を受けた。借地借家法に基づく借家契約に関する下表の空欄（ア）～（エ）に入る最も適切な語句を語群の中から選び、その番号のみを解答欄に記入しなさい。なお、同じ語句を何度選んでもよいこととする。<br><br><img src='/img/set1/f9_1.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2022.09",
        "categoryName": "不動産",
        "rontenName": "借地借家法",
        "important": ""
    },
    {
        "id": 300,
        "shikenId": 6,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "公的な土地評価に関する下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><br><img src='/img/set1/f10_1.png'/>",
        "question2": "",
        "choice1": "（ア）国土交通省　（イ）70％ （ウ）贈与税",
        "choice2": "（ア）国土交通省　（イ）80％ （ウ）贈与税",
        "choice3": "（ア）内閣府　　　（イ）80％ （ウ）不動産取得税",
        "choice4": "（ア）内閣府　　　（イ）70％ （ウ）不動産取得税",
        "choice5": "2022.05",
        "categoryName": "不動産",
        "rontenName": "土地の価格",
        "important": ""
    },
    {
        "id": 301,
        "shikenId": 6,
        "no": 11,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "下記＜資料＞は、天野さんが購入を検討している投資用マンションの概要である。この物件の表面利回り（年利）と実質利回り（年利）の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない事項については一切考慮しないこととし、計算結果については小数点以下第３位を四捨五入すること。<br><br><img src='/img/set1/f11_1.png'/>",
        "question2": "",
        "choice1": "表面利回り（年利）：５．２０％　実質利回り（年利）：３．８８％",
        "choice2": "表面利回り（年利）：５．２０％　実質利回り（年利）：０．４０％",
        "choice3": "表面利回り（年利）：４．２０％　実質利回り（年利）：３．８８％",
        "choice4": "表面利回り（年利）：４．２０％　実質利回り（年利）：０．４０％",
        "choice5": "2022.09",
        "categoryName": "不動産",
        "rontenName": "不動産投資の利回りの計算",
        "important": ""
    },
    {
        "id": 302,
        "shikenId": 6,
        "no": 12,
        "answerType": 8,
        "groupId": 1,
        "answer": "3,5,7",
        "score": "1,1,1",
        "question1": "工藤達也さんは、住宅の取得を検討しており、固定資産税および不動産取得税について、ＦＰで税理士でもある宮本さんに質問をした。固定資産税および不動産取得税に関する次の記述の空欄（ア）～（ウ）にあてはまる適切な語句を語群の中から選び、その番号のみを解答欄に記入しなさい。<br><br><img src='/img/set1/f12_1.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2025.01(改）",
        "categoryName": "不動産",
        "rontenName": "不動産の取得と保有に係る税金",
        "important": ""
    },
    {
        "id": 303,
        "shikenId": 6,
        "no": 13,
        "answerType": 9,
        "groupId": 1,
        "answer": "110,9,172",
        "score": "2,2,2",
        "question1": "妹尾ゆかりさん（５８歳）が保険契約者（保険料負担者）および被保険者として加入している生命保険（下記＜資料＞参照）の保障内容等に関する次の記述の空欄（ア）～（ウ）にあてはまる数値を解答欄に記入しなさい。なお、保険契約は有効に継続しているものとし、ゆかりさんはこれまでに＜資料＞の保険から、保険金・給付金を一度も受け取っていないものとする。また、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><br><img src='/img/set1/f13_1.png'/><br><img src='/img/set1/f13_2.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "2021.01(改）",
        "categoryName": "リスク",
        "rontenName": "保険証書の読み取り",
        "important": ""
    },
    {
        "id": 304,
        "shikenId": 6,
        "no": 14,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "ＦＰの安西さんは相談者の井上さんが契約している生命保険の保険料支払いができなかった場合の流れについて説明を求められた。ＦＰの安西さんが説明した下記の記述の空欄（ア）～（エ）にあてはまる語句の組み合わせとして、適切なものはどれか。なお、記載のない事項については一切考慮しないこととする。<br><br><img src='/img/set1/f14_1.png'/>",
        "question2": "",
        "choice1": "（ア）払込猶予　（イ）自動振替貸付　（ウ）失効　（エ）復活",
        "choice2": "（ア）払込待機　（イ）契約者貸付　　（ウ）消滅　（エ）復活",
        "choice3": "（ア）払込猶予　（イ）契約者貸付　　（ウ）消滅　（エ）更新",
        "choice4": "（ア）払込待機　（イ）自動振替貸付　（ウ）失効　（エ）更新",
        "choice5": "2021.01",
        "categoryName": "リスク",
        "rontenName": "生命保険の猶予と失効",
        "important": ""
    },
    {
        "id": 305,
        "shikenId": 6,
        "no": 15,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,2,1",
        "score": "1,1,1,1",
        "question1": "平尾良治さんが契約している生命保険（下記＜資料＞参照）に関する次の（ア）～（エ）の記述について、適切なものには〇を、不適切なものには×を解答欄に記入しなさい。<br><br><img src='/img/set1/f15_1.png'/>",
        "question2": "",
        "choice1": "終身保険Ａから平尾咲子さんが受け取る死亡保険金は、相続税の課税対象となる。",
        "choice2": "特定疾病保障保険Ｂから平尾良治さんが受け取る死亡保険金は、相続税の課税対象となる。",
        "choice3": "定期保険Ｃから平尾太一さんが受け取る死亡保険金は、相続税の課税対象となる。",
        "choice4": "養老保険Ｄから平尾良治さんが一時金として受け取る満期保険金は、一時所得として所得税の課税対象となる。",
        "choice5": "2021.01",
        "categoryName": "リスク",
        "rontenName": "保険金・給付金の税金",
        "important": ""
    },
    {
        "id": 306,
        "shikenId": 6,
        "no": 16,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "加瀬卓也さんが契約している火災保険（下記＜資料＞参照）に関する次の記述のうち、最も不適切なものはどれか。なお、超過保険や一部保険には該当しないものとし、＜資料＞に記載のない特約については付帯がないものとする。また、保険契約は有効に継続しているものとする。<br><br><img src='/img/set1/f16_1.png'/>",
        "question2": "",
        "choice1": "火災による損害の補償に関する建物の保険金額は、１，４００万円で契約している。",
        "choice2": "竜巻が原因で建物と家財が全損となった場合、合計で２，１００万円の損害保険金が支払われる。",
        "choice3": "洪水が原因で建物と家財が全損となった場合、補償の対象にならない。",
        "choice4": "休日に卓也さんが自転車で走行中、誤って他人にケガを負わせた場合の法律上の損害賠償責任についても、補償の対象となる。",
        "choice5": "2021.01",
        "categoryName": "リスク",
        "rontenName": "損害保険の補償対象",
        "important": ""
    },
    {
        "id": 307,
        "shikenId": 6,
        "no": 17,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "工藤ももかさんは、高校卒業後に乗用車の運転免許を取得したいと考えており、自動車損害賠償責任保険（以下「自賠責保険」という）について、ＦＰの宮本さんに質問をした。自賠責保険の一般的な取扱いに関する次の記述のうち、最も不適切なものはどれか。なお、加害車両が複数の場合については考慮しないものとする。",
        "question2": "",
        "choice1": "死亡による損害に対する被害者１人当たりの保険金の支払限度額は、３，０００万円である。",
        "choice2": "傷害による損害に対する被害者１人当たりの保険金の支払限度額は、１２０万円である。",
        "choice3": "被保険者が被保険自動車を運転中に、ハンドル操作を誤って自宅の塀に衝突した場合、自動車の修理費用は自賠責保険の補償の対象となる。",
        "choice4": "被保険者が、被保険自動車を運転して駐車場から出庫する際に、誤って駐車場の壁面に衝突し、ケガをして通院した場合、自賠責保険の補償の対象とならない。",
        "choice5": "2025.01(改）",
        "categoryName": "リスク",
        "rontenName": "自賠責保険",
        "important": ""
    },
    {
        "id": 308,
        "shikenId": 6,
        "no": 18,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "会社員の榎田さんが本年中に支払った医療費等が下記＜資料＞のとおりである場合、榎田さんの本年分の所得税の確定申告における医療費控除の金額として、正しいものはどれか。なお、榎田さんの本年分の所得は、給与所得６１０万円のみであるものとし、榎田さんは妻および母と生計を一にしている。また、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）については考慮せず、保険金等により補てんされる金額はないものとする。<br><br><img src='/img/set1/f18_1.png'/>",
        "question2": "",
        "choice1": "４３, ０００円",
        "choice2": "４６３, ０００円",
        "choice3": "４９３, ０００円",
        "choice4": "５５０, ０００円",
        "choice5": "2023.09(改）",
        "categoryName": "タックス",
        "rontenName": "医療費控除",
        "important": ""
    },
    {
        "id": 309,
        "shikenId": 6,
        "no": 19,
        "answerType": 9,
        "groupId": 0,
        "answer": 45,
        "score": 2,
        "question1": "会社員の増田さんの本年分の所得等が下記＜資料＞のとおりである場合、増田さんが本年分の所得税の確定申告を行う際に、給与所得と損益通算できる損失はいくらになるか。なお、▲が付された所得金額は、その所得に損失が発生していることを意味するものとする。また、記載のない事項については一切考慮しないものとし、解答に当たっては、解答用紙に記載されている単位に従うこと。<br><br><img src='/img/set1/f19_1.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.09(改）",
        "categoryName": "タックス",
        "rontenName": "損益通算",
        "important": ""
    },
    {
        "id": 310,
        "shikenId": 6,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "広尾さん（６６歳）の本年分の収入等が下記＜資料＞のとおりである場合、広尾さんの本年分の所得税における総所得金額として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとし、総所得金額が最も少なくなるように計算すること。<br><br><img src='/img/set1/f20_1.png'/>",
        "question2": "",
        "choice1": "３３５万円",
        "choice2": "３４５万円",
        "choice3": "３５５万円",
        "choice4": "３９０万円",
        "choice5": "2023.09(改）",
        "categoryName": "タックス",
        "rontenName": "総所得金額",
        "important": ""
    },
    {
        "id": 311,
        "shikenId": 6,
        "no": 21,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "住吉さんは、加入していた下記＜資料＞の養老保険が本年８月に満期を迎えたため、満期保険金を一括で受け取った。住吉さんの本年分の所得税において、総所得金額に算入すべき一時所得の金額として、正しいものはどれか。なお、住吉さんには、この満期保険金以外に一時所得の対象となるものはないものとする。<br><br><img src='/img/set1/f21_1.png'/>",
        "question2": "",
        "choice1": "１０万円",
        "choice2": "２０万円",
        "choice3": "３５万円",
        "choice4": "７０万円",
        "choice5": "2023.09(改）",
        "categoryName": "タックス",
        "rontenName": "総所得金額に算入される一時所得",
        "important": ""
    },
    {
        "id": 312,
        "shikenId": 6,
        "no": 22,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "長岡さんは、住宅ローンの見直しについてＦＰの五十嵐さんに質問をした。一般的な住宅ローンの見直しに関する五十嵐さんの次の説明のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "「より有利な条件の住宅ローンを扱う金融機関に住宅ローンの『借換え』をする場合、抵当権の抹消や設定費用、事務手数料などの諸費用が必要になります。」",
        "choice2": "「通常の返済とは別にローンの元金部分の一部を返済する『繰上げ返済』をした場合、その元金に対応する利息部分の支払いがなくなり、総返済額を減らす効果があります。」",
        "choice3": "「現在の住宅ローンの借入先の金融機関において、返済期間を延長することで月々の返済額を減額したり、一定期間、月々の返済額を利息の支払いのみにする『条件変更』ができる場合もあります。」",
        "choice4": "「固定金利選択型１０年で借り入れている場合、現在の固定期間が終了した後は固定金利選択型１０年で自動更新され、他の固定金利選択型や変動金利型を選択することはできません。」",
        "choice5": "2023.09",
        "categoryName": "タックス",
        "rontenName": "住宅ローンの見直し",
        "important": ""
    },
    {
        "id": 313,
        "shikenId": 6,
        "no": 23,
        "answerType": 9,
        "groupId": 0,
        "answer": 3200,
        "score": 2,
        "question1": "下記の相続事例（本年４月１５日相続開始）における相続税の課税価格の合計額を計算しなさい。なお、記載のない条件については一切考慮しないこととする。また、解答に当たっては、解答用紙に記載されている単位に従うこと。<br><br><img src='/img/set1/f23_1.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2022.05(改）",
        "categoryName": "相続",
        "rontenName": "課税価格の計算",
        "important": ""
    },
    {
        "id": 314,
        "shikenId": 6,
        "no": 24,
        "answerType": 8,
        "groupId": 1,
        "answer": "4,1,7",
        "score": "1,1,1",
        "question1": "下記＜親族関係図＞の場合において、民法の規定に基づく法定相続分および遺留分に関する次の記述の空欄（ア）～（ウ）に入る適切な語句または数値を語群の中から選び、解答欄に記入しなさい。なお、同じ語句または数値を何度選んでもよいこととする。<br><br><img src='/img/set1/f24_1.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2022.05",
        "categoryName": "相続",
        "rontenName": "相続人と法定相続分",
        "important": ""
    },
    {
        "id": 315,
        "shikenId": 6,
        "no": 25,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "相続税における「小規模宅地等の評価減の特例」に関する下表の空欄（ア）～（ウ）にあてはまる数値の組み合わせとして、正しいものはどれか。<br><br><img src='/img/set1/f25_1.png'/>",
        "question2": "",
        "choice1": "（ア）３３０ （イ）２４０ （ウ）７０",
        "choice2": "（ア）３３０ （イ）２００ （ウ）８０",
        "choice3": "（ア）３００ （イ）２４０ （ウ）７０",
        "choice4": "（ア）３００ （イ）２００ （ウ）８０",
        "choice5": "2022.05",
        "categoryName": "相続",
        "rontenName": "小規模宅地の特例",
        "important": ""
    },
    {
        "id": 316,
        "shikenId": 6,
        "no": 26,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "下記＜資料＞の宅地（貸家建付地）に係る路線価方式による相続税評価額の計算式として、正しいものはどれか。<br><br><img src='/img/set1/f26_1.png'/>",
        "question2": "",
        "choice1": "２５０，０００円×１．００×４００㎡",
        "choice2": "２５０，０００円×１．００×４００㎡×６０％",
        "choice3": "２５０，０００円×１．００×４００㎡×（１－６０％）",
        "choice4": "２５０，０００円×１．００×４００㎡×（１－６０％×３０％×１００％）",
        "choice5": "2022.05",
        "categoryName": "相続",
        "rontenName": "宅地の評価",
        "important": ""
    },
    {
        "id": 317,
        "shikenId": 6,
        "no": 27,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "住吉さんは、ＦＰの宮本さんに配偶者居住権について質問をした。配偶者居住権に関する次の記述の空欄（ア）～（エ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、記載のない事項については、配偶者居住権の要件を満たしているものとする。<br><br><img src='/img/set1/f27_1.png'/>",
        "question2": "",
        "choice1": "（ア）ができる （イ）なる （ウ）相続開始時から６カ月後 （エ）はできない",
        "choice2": "（ア）ができる （イ）ならない （ウ）配偶者の死亡時 （エ）ができる",
        "choice3": "（ア）はできない （イ）なる （ウ）配偶者の死亡時 （エ）はできない",
        "choice4": "（ア）はできない （イ）ならない（ウ）相続開始時から 6 カ月後 （エ）ができる",
        "choice5": "2024.01",
        "categoryName": "相続",
        "rontenName": "配偶者居住権",
        "important": ""
    },
    {
        "id": 318,
        "shikenId": 6,
        "no": 28,
        "answerType": 9,
        "groupId": 0,
        "answer": 197,
        "score": 2,
        "question1": "山根家のキャッシュフロー表の空欄（ア）に入る数値を計算しなさい。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><br><img src='/img/set1/f28_1.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.01(改）",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 319,
        "shikenId": 6,
        "no": 29,
        "answerType": 9,
        "groupId": 0,
        "answer": 176,
        "score": 2,
        "question1": "山根家の両親が考えている進学プランは下記のとおりである。下記＜条件＞および＜資料＞のデータに基づいて、山根家のキャッシュフロー表の空欄（イ）に入る教育費の予測数値を計算しなさい。なお、計算過程においては端数処理をせずに計算し、計算結果については万円未満を四捨五入すること。<br><br><img src='/img/set1/f29_1.png'/><br><br><img src='/img/set1/f29_2.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.01(改）",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 320,
        "shikenId": 6,
        "no": 30,
        "answerType": 9,
        "groupId": 0,
        "answer": 729,
        "score": 2,
        "question1": "山根家のキャッシュフロー表の空欄（ウ）に入る数値を計算しなさい。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><br><img src='/img/set1/f30_1.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2023.01(改）",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 321,
        "shikenId": 6,
        "no": 31,
        "answerType": 9,
        "groupId": 0,
        "answer": 13865000,
        "score": 2,
        "question1": "広尾さんは、老後の旅行用資金として、毎年年末に１００万円を受け取りたいと考えている。受取期間を１５年間とし、年利１．０％で複利運用をした場合、受取り開始年の初めにいくらの資金があればよいか。下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないこととし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set1/f31_1.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2020.09",
        "categoryName": "ライフ",
        "rontenName": "係数の計算",
        "important": ""
    },
    {
        "id": 322,
        "shikenId": 6,
        "no": 32,
        "answerType": 9,
        "groupId": 0,
        "answer": 900000,
        "score": 2,
        "question1": "杉野さんは、現在、老後の生活資金として２，０００万円を保有している。これを２５年間、年利１．０％で複利運用しながら毎年１回、年末に均等に取り崩すこととした場合、毎年年末に取り崩すことができる最大金額はいくらになるか。下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないこととし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set1/f31_1.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2020.09",
        "categoryName": "ライフ",
        "rontenName": "係数の計算",
        "important": ""
    },
    {
        "id": 323,
        "shikenId": 6,
        "no": 33,
        "answerType": 9,
        "groupId": 0,
        "answer": 18100000,
        "score": 2,
        "question1": "工藤さんは、退職後は地方でゆっくり暮らすことを希望しており、そのための資金として、１０年後に２，０００万円を準備したいと考えている。１０年間、年利１．０％で複利運用する場合、現在いくらの資金があればよいか。下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないこととし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set1/f31_1.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2020.09",
        "categoryName": "ライフ",
        "rontenName": "係数の計算",
        "important": ""
    },
    {
        "id": 324,
        "shikenId": 6,
        "no": 34,
        "answerType": 9,
        "groupId": 0,
        "answer": 7865,
        "score": 2,
        "question1": "ＦＰの三上さんは、まず現時点（本年４月１日）における藤原家（隆行さんと妻の真理さん）のバランスシート分析を行うこととした。＜資料＞に基づく藤原家のバランスシートの空欄（ア）に入る数値を計算しなさい。なお、記載のない事項については一切考慮しないこととする。<br><br><img src='/img/set1/f34_1.png'/><br><br><img src='/img/set1/f34_2.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2021.05(改）",
        "categoryName": "ライフ",
        "rontenName": "バランスシート",
        "important": ""
    },
    {
        "id": 325,
        "shikenId": 6,
        "no": 35,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "工藤直樹さんは、娘のももかさんの大学進学を控えて奨学金に関心を持ち、ＦＰの宮本さんに質問をした。宮本さんが日本学生支援機構の奨学金（予約採用）の一般的な取扱いについて説明する際に使用した下表の空欄（ア）～（ウ）にあてはまる数値および語句の組み合わせとして、最も適切なものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><br><img src='/img/set1/f35_1.png'/>",
        "question2": "",
        "choice1": "（ア）３ （イ）学力基準および家計基準 （ウ）定額返還方式のみ",
        "choice2": "（ア）３ （イ）家計基準のみ （ウ） 所得連動返還方式か定額返還方式のどちらかを選択",
        "choice3": "（ア）５ （イ）学力基準および家計基準 （ウ） 所得連動返還方式か定額返還方式のどちらかを選択",
        "choice4": "（ア）５ （イ）家計基準のみ （ウ）定額返還方式のみ",
        "choice5": "2025.01(改）",
        "categoryName": "ライフ",
        "rontenName": "教育資金",
        "important": ""
    },
    {
        "id": 326,
        "shikenId": 6,
        "no": 36,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,2,2",
        "score": "1,1,1,1",
        "question1": "会社員の工藤直樹さん（４９歳）は、現在の勤務先を２０２５年９月に自己都合退職した場合に受給することができる雇用保険の基本手当についてＦＰの宮本さんに質問をした。下記＜資料＞に基づく基本手当に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を解答欄に記入しなさい。なお、個別延長給付等の記載のない事項については一切考慮しないものとする。<br><br><img src='/img/set1/f36_1.png'/><br><br><img src='/img/set1/f36_2.png'/>",
        "question2": "",
        "choice1": "空欄（ａ）にあてはまる語句は、「離職の日の翌日から１年間」である。",
        "choice2": "空欄（ｂ）にあてはまる語句は、「離職の日の翌日から２年間」である。",
        "choice3": "空欄（ｃ）にあてはまる語句は、「３３０日」である。",
        "choice4": "空欄（ｄ）にあてはまる語句は、「２ヵ月」である。",
        "choice5": "2025.01(改）",
        "categoryName": "ライフ",
        "rontenName": "雇用保険",
        "important": ""
    },
    {
        "id": 327,
        "shikenId": 6,
        "no": 37,
        "answerType": 8,
        "groupId": 1,
        "answer": "2,5,8",
        "score": "1,1,1",
        "question1": "会社員の工藤直樹さんは、２０ＸＸ年１月に病気（私傷病）の療養のため休業したことから、傷病手当金についてＦＰの宮本さんに質問をした。下記＜資料＞に基づき、直樹さんが受け取ることができる傷病手当金に関する次の記述の空欄（ア）～（ウ）にあてはまる適切な語句または数値を語群の中から選び、その番号のみを解答欄に記入しなさい。なお、直樹さんは、全国健康保険協会管掌健康保険（協会けんぽ）の被保険者である。また、記載のない事項については一切考慮しないものとする。<br><br><img src='/img/set1/f37_1.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "2025.01(改）",
        "categoryName": "ライフ",
        "rontenName": "傷病手当金",
        "important": ""
    },
    {
        "id": 328,
        "shikenId": 6,
        "no": 38,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "小山さん夫婦はマイホームの購入に当たり、夫婦での住宅ローンの借入れを検討しており、ＦＰで税理士でもある橋口さんに質問をした。橋口さんの説明の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、住宅ローン契約者は団体信用生命保険に加入するものとし、住宅借入金等特別控除（以下「住宅ローン控除」という）の適用を受けるための要件はすべて満たしているものとする。<br><br><img src='/img/set1/f38_1.png'/>",
        "question2": "",
        "choice1": "（ア）高く （イ）主たる債務者 （ウ）ペアローンすべて",
        "choice2": "（ア）高く （イ）夫と妻それぞれ （ウ）亡くなった人のみ",
        "choice3": "（ア）安く （イ）主たる債務者 （ウ）亡くなった人のみ",
        "choice4": "（ア）安く （イ）夫と妻それぞれ （ウ）ペアローンすべて",
        "choice5": "2024.05",
        "categoryName": "ライフ",
        "rontenName": "ペアローン",
        "important": ""
    },
    {
        "id": 329,
        "shikenId": 6,
        "no": 39,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,1,2,2",
        "score": "1,1,1,1",
        "question1": "工藤隆行さんは、自分の老齢年金の受取り方について考えており、ＦＰの三上さんに質問をした。老齢年金の繰上げおよび繰下げ受給に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を解答欄に記入しなさい。",
        "question2": "",
        "choice1": "老齢基礎年金と老齢厚生年金の繰上げ請求は、異なる時期に別々に行うことができる。",
        "choice2": "老齢基礎年金と老齢厚生年金の繰下げ申出は、異なる時期に別々に行うことができる。",
        "choice3": "老齢基礎年金または老齢厚生年金の支給の繰下げによる年金額の増額率は、最大で３０％となる。",
        "choice4": "老齢基礎年金と併せて付加年金が受給できる場合であっても、付加年金については繰上げ受給により減額されることはなく、繰下げ受給により増額されることもない。",
        "choice5": "2021.05",
        "categoryName": "ライフ",
        "rontenName": "繰上げ支給と繰下げ支給",
        "important": ""
    },
    {
        "id": 330,
        "shikenId": 6,
        "no": 40,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "藤原真理さんは、病気療養のため本年３月、ＫＡ病院に１０日間入院し、退院後の同月内に同病院に５日間通院した。真理さんの本年３月の１ヵ月間における保険診療分の医療費（窓口での自己負担額）が２４万円、入院時の食事代が２万円、差額ベッド代が１０万円であった場合、下記＜資料＞に基づく高額療養費として支給される額として、正しいものはどれか。なお、隆行さんは全国健康保険協会管掌健康保険（協会けんぽ）の被保険者であって標準報酬月額は４７万円であり、真理さんは隆行さんの被扶養者であるものとする。また、ＫＡ病院に「健康保険限度額適用認定証」の提示はしておらず、世帯合算および多数該当は考慮しないものとする。<br><br><img src='/img/set1/f40_1.png'/>",
        "question2": "",
        "choice1": "１５３，３７０円",
        "choice2": "１５４，５７０円",
        "choice3": "２７０，５７０円",
        "choice4": "２７４，５７０円",
        "choice5": "2021.05(改）",
        "categoryName": "ライフ",
        "rontenName": "高額療養費の計算",
        "important": ""
    },
    {
        "id": 331,
        "shikenId": 9,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナー（以下「ＦＰ」という）の顧客に対する行為に関する次の記述のうち、職業倫理や関連法規に照らし、最も不適切なものはどれか。",
        "choice1": "投資信託について顧客から相談を受けたＦＰのＡさんは、投資信託には元本保証および利回り保証のないことを説明した。",
        "choice2": "社会保険労務士の資格を有しないＦＰのＢさんは、顧客から公的年金の老齢給付の繰下げ支給について相談を受け、顧客の「ねんきん定期便」に記載されている年金見込額を基に、繰り下げた場合の年金額を試算した。",
        "choice3": "顧客からアパートの建設について相談を受けたＦＰのＣさんは、デベロッパーに事業計画策定のための資料として、顧客から預かっていた確定申告書（控）を顧客の同意を得ずにコピーして渡した。",
        "choice4": "税理士の資格を有しないＦＰのＤさんは、顧客から医療費控除やふるさと納税について相談を受け、制度の概要や確定申告の手続きについて説明した。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "関連法規とコンプライアンス",
        "important": ""
    },
    {
        "id": 332,
        "shikenId": 9,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "雇用保険に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "２つの事業所に雇用される６５歳以上の労働者で、１つの事業所における１週間の所定労働時間がそれぞれ５時間以上２０時間未満であり、かつ、２つの事業所における１週間の所定労働時間の合計が２０時間以上である者は、所定の要件を満たせば、申出により、雇用保険の高年齢被保険者となることができる。",
        "choice2": "雇用保険の適用事業所に雇用される労働者であって、所定の要件を満たす者は、日本国籍の有無にかかわらず、雇用保険の被保険者となる。",
        "choice3": "雇用保険の保険料は、失業等給付・育児休業給付に係る保険料、及び、雇用保険二事業に係る保険料のすべてを事業主と労働者が折半して負担する。",
        "choice4": "基本手当の受給期間中に、妊娠、出産、育児、病気等により、引き続き３０日以上職業に就くことができない場合、所定の期間内の申出により、最長４年まで受給期間を延長することができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "雇用保険に関する記述",
        "important": ""
    },
    {
        "id": 333,
        "shikenId": 9,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "雇用保険法に基づく育児休業給付および介護休業給付に関する次の記述のうち、最も適切なものはどれか。なお、一般被保険者と高年齢被保険者を本問では一般被保険者等と表記し、記載されたもの以外の要件はすべて満たしているものとする。",
        "choice1": "育児休業給付金に係る支給単位期間において、一般被保険者等に対して支払われた賃金額が、休業開始時賃金日額に支給日数を乗じて得た額の６７％相当額以上である場合、当該支給単位期間について育児休業給付金は支給されない。",
        "choice2": "一般被保険者等が、一定の状態の家族を介護するために休業する場合、同一の対象家族について、通算３回かつ９３日の介護休業を限度として、介護休業給付金が支給される。",
        "choice3": "一般被保険者等の父母は介護休業給付金の支給対象となるが、配偶者の父母は、介護休業給付金の支給対象とならない。",
        "choice4": "一般被保険者等が、３歳に満たない子を養育するために休業する場合、育児休業給付金が支給される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "雇用保険の給付",
        "important": ""
    },
    {
        "id": 334,
        "shikenId": 9,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "公的年金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "産前産後休業、育児休業を取得している厚生年金保険の被保険者の厚生年金保険料は、所定の手続きにより、被保険者負担分のみが免除される。",
        "choice2": "厚生年金保険の適用事業所に常時使用される者のうち、６５歳以上の者は、厚生年金保険の被保険者とならない。",
        "choice3": "国民年金の保険料免除期間に係る保険料のうち、追納することができる保険料は、追納に係る厚生労働大臣の承認を受けた日の属する月前５年以内の期間に係るものに限られる。",
        "choice4": "日本国籍を有するが日本国内に住所を有しない２０歳以上６５歳未満の者は、国民年金の第２号被保険者および第３号被保険者に該当しない場合、原則として、国民年金の任意加入被保険者となることができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的年金",
        "important": ""
    },
    {
        "id": 335,
        "shikenId": 9,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "老齢基礎年金の繰下げ支給に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "老齢基礎年金の受給権を有する６６歳０ヵ月以上の者は、当該老齢基礎年金の繰下げ支給の申出をすることができる。",
        "choice2": "付加年金を受給できる者が老齢基礎年金の繰下げ支給の申出をした場合、付加年金の額は繰下げによって増額されない。",
        "choice3": "２０２２年４月１日以降に７０歳に到達する者の老齢基礎年金の繰下げ支給による年金の増額率は、繰り下げた月数に０.７％を乗じて得た率で、最大４２％となる。",
        "choice4": "老齢厚生年金の受給権を有する者が老齢基礎年金の支給開始年齢を繰り下げる場合は、同時に老齢厚生年金の支給開始年齢も繰り下げなければならない。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金の繰下げ支給",
        "important": ""
    },
    {
        "id": 336,
        "shikenId": 9,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "公的年金の併給調整等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "老齢厚生年金と障害基礎年金の受給権を有している者は、６５歳以降、老齢厚生年金と障害基礎年金を同時に受給することができる。",
        "choice2": "遺族厚生年金と老齢厚生年金の受給権を有している者は、６５歳以降、その者の選択によりいずれか一方の年金が支給され、他方の年金は支給停止となる。",
        "choice3": "遺族厚生年金と障害基礎年金の受給権を有している者は、６５歳以降、遺族厚生年金と障害基礎年金を同時に受給することができる。",
        "choice4": "障害厚生年金と労働者災害補償保険法に基づく障害補償年金が、同一の事由により支給される場合、障害厚生年金は全額支給され、障害補償年金は所定の調整率により減額される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的年金の併給調整等",
        "important": ""
    },
    {
        "id": 337,
        "shikenId": 9,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "公的年金制度の障害給付に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "障害厚生年金の額を計算する際に、その計算の基礎となる被保険者期間の月数が３００月に満たない場合、３００月として計算する。",
        "choice2": "障害基礎年金の受給権者が、所定の要件を満たす配偶者を有する場合、その受給権者に支給される障害基礎年金には、配偶者に係る加算額が加算される。",
        "choice3": "国民年金の被保険者ではない２０歳未満の期間に初診日および障害認定日があり、２０歳に達した日において障害等級１級または２級に該当する程度の障害の状態にある者に対しては、その者の前年の所得の額にかかわらず、障害基礎年金が支給される。",
        "choice4": "障害手当金の支給を受けようとする者が、同一の傷病により労働者災害補償保険の障害補償給付の支給を受ける場合、障害手当金と障害補償給付の支給を同時に受けることができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的年金の障害給付",
        "important": ""
    },
    {
        "id": 338,
        "shikenId": 9,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "公的年金等に係る税金に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。",
        "choice1": "老齢基礎年金および老齢厚生年金は、その年中に受け取る当該年金の収入金額から公的年金等控除額を控除した金額が雑所得として所得税の課税対象となる。",
        "choice2": "老齢基礎年金および老齢厚生年金の受給者が死亡した場合、その者に支給されるべき年金のうち、支給されていなかった未支給年金は、その年金を受け取った遺族の一時所得として所得税の課税対象となる。",
        "choice3": "国民年金の保険料および国民年金基金の掛金は、いずれも社会保険料控除として所得税の所得控除の対象となる。",
        "choice4": "確定拠出年金の老齢給付金、小規模企業共済の加入者が事業を廃止した際に受け取る共済金のうち、年金形式で受給する場合は一時所得として所得税の課税対象となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的年金等の税金",
        "important": ""
    },
    {
        "id": 339,
        "shikenId": 9,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "日本学生支援機構の貸与型奨学金および日本政策金融公庫の教育一般貸付（以下「国の教育ローン」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "貸与型奨学金の一つである第一種奨学金の貸与を受けられるのは、国内の大学等に在学する特に優れた学生等であって、経済的理由により著しく修学に困難がある者とされている。",
        "choice2": "国の教育ローンの融資金利は固定金利であり、返済期間は、２０年以内とされている。",
        "choice3": "国の教育ローンを利用するためには、世帯年収（所得）が申込人の世帯で扶養している子の人数に応じて定められた額以下でなければならない。",
        "choice4": "国の教育ローンの資金使途は、受験にかかった費用（受験料、受験時の交通費・宿泊費など）と学校納付金（入学金、授業料、施設設備費など）に限定されている。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "奨学金と教育ローン",
        "important": ""
    },
    {
        "id": 340,
        "shikenId": 9,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "クレジットカード会社（貸金業者）が発行するクレジットカードの一般的な利用に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "クレジットカードは、約款上、クレジットカード会社が所有権を有しており、クレジットカード券面上に印字された会員本人以外が使用することはできない。",
        "choice2": "クレジットカードで無担保借入（キャッシング）をする行為は、貸金業法上、総量規制の対象となるが、クレジットカードで商品を購入（ショッピング）する行為は、総量規制の対象外である。",
        "choice3": "クレジットカードで商品を購入（ショッピング）した場合の支払方法の１つである定額リボルビング払い方式は、カード利用時に代金の支払回数を決め、利用代金をその回数で分割して支払う方法である。",
        "choice4": "ＩＣチップを埋め込んであるクレジットカードを専用の端末機のある加盟店で利用する場合、署名に代えて暗証番号を入力することで決済することができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "クレジットカード",
        "important": ""
    },
    {
        "id": 341,
        "shikenId": 9,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "少額短期保険に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "少額短期保険業者と締結した保険契約は保険法の適用対象となるが、少額短期保険業者は保険業法の適用対象とならない。",
        "choice2": "少額短期保険の保険期間は、損害保険では２年、生命保険および傷害疾病保険では１年が上限である。",
        "choice3": "少額短期保険は、低発生率保険を適用している少額短期保険業者が引き受ける保険契約を除き、今後、新規または更新後に、被保険者１人につき加入できる保険金額の合計額は１,５００万円が上限である。",
        "choice4": "破綻した少額短期保険業者と締結していた保険契約は、生命保険契約者保護機構または損害保険契約者保護機構による保護の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "少額短期保険",
        "important": ""
    },
    {
        "id": 342,
        "shikenId": 9,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "低解約返戻金型終身保険は、他の契約条件が同じで低解約返戻金型ではない終身保険と比較して、保険料払込期間中および保険料払込終了後の解約返戻金が低く抑えられており、割安な保険料が設定されている。",
        "choice2": "養老保険は、被保険者に高度障害保険金が支払われた場合、保険期間満了時に満期保険金から高度障害保険金相当額が控除された金額が支払われる。",
        "choice3": "収入保障保険の死亡保険金を一時金で受け取る場合、年金形式で受け取る場合の受取総額よりも多くなる。",
        "choice4": "定期保険特約付終身保険（更新型）では、定期保険特約を同額の保険金額で自動更新すると、更新後の保険料は、通常、更新前よりも高くなる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 343,
        "shikenId": 9,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "生命保険料控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "終身保険の保険料の払込みがないために自動振替貸付となった場合、それによって立て替えられた金額は、生命保険料控除の対象とならない。",
        "choice2": "２０１１年１２月３１日以前に締結した医療保険契約を２０１２年１月１日以後に更新した場合、更新後の保険料は介護医療保険料控除の対象となる。",
        "choice3": "２０１２年１月１日以後に締結した生命保険契約に付加された傷害特約および災害割増特約の保険料は、一般の生命保険料控除の対象となる。",
        "choice4": "変額個人年金保険および外貨建て個人年金保険の保険料は、個人年金保険料控除の対象とならず、一般の生命保険料控除の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険料控除",
        "important": ""
    },
    {
        "id": 344,
        "shikenId": 9,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "契約者（＝保険料負担者）を法人、被保険者を役員とする生命保険に係る保険料等の経理処理に関する次の記述のうち、最も適切なものはどれか。なお、いずれの保険契約も新たに締結し、他に加入している保険契約はなく、保険料は年払いであるものとする。",
        "choice1": "法人が受け取った医療保険の入院給付金は、２分の１を資産に計上し、残額を益金の額に算入する。",
        "choice2": "死亡保険金受取人が法人である終身保険の支払保険料は、その全額を給与として扱う。",
        "choice3": "給付金受取人が法人で、解約返戻金相当額のない短期払いの医療保険の支払保険料は、その事業年度に支払った保険料の額が被保険者１人当たり３０万円以下の場合、その支払った日の属する事業年度の損金の額に算入することができる。",
        "choice4": "死亡保険金受取人が法人で、最高解約返戻率が６５％である定期保険（保険期間２０年被保険者１人当たり年換算保険料相当額３０万円超）の支払保険料は、保険期間の前半４割相当期間においては、その６０％相当額を資産に計上し、残額を損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "法人契約の生命保険料等の経理処理",
        "important": ""
    },
    {
        "id": 345,
        "shikenId": 9,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "損害保険による損害賠償等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "失火の責任に関する法律によれば、失火により他人に損害を与えた場合、失火者に重大な過失がなかったときは、民法第７０９条（不法行為による損害賠償）の規定が適用される。",
        "choice2": "政府の自動車損害賠償保障事業および自動車損害賠償責任保険は、人身事故および物損事故による損害が対象となる。",
        "choice3": "施設所有（管理）者賠償責任保険では、被保険者が営む飲食店の店舗の床が清掃時の水で濡れていたことによって滑って転倒した来店客がケガをしたことについて、法律上の損害賠償責任を負った場合、補償の対象となる。",
        "choice4": "自動車保険の対人賠償保険では、被保険者が被保険自動車の運転中に起こした事故が原因で、兄弟姉妹にケガを負わせたことにより法律上の損害賠償責任を負った場合、補償の対象とならない。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "損害賠償等",
        "important": ""
    },
    {
        "id": 346,
        "shikenId": 9,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "地震保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "地震保険は、原則として火災保険に自動付帯となっているが、契約者が地震保険を付帯しないことの意思表示をした場合は、付帯しないことができる。",
        "choice2": "地震保険には、「建築年割引」「免震建築物割引」「耐震等級割引」「耐震診断割引」の4種類の保険料割引制度があり、重複して適用を受けることができる。",
        "choice3": "地震保険では、地震が発生した日の翌日から30日以上経過した後に生じた損害は、補償の対象とならない。",
        "choice4": "地震保険では、家財を対象とした契約をする場合、貴金属、宝石、骨とう等は、その価格にかかわらず補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "地震保険",
        "important": ""
    },
    {
        "id": 347,
        "shikenId": 9,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "自動車を被保険者の父の家の車庫に入れるとき、誤って内壁を損傷した場合、その損害は対物賠償保険の補償の対象となる。",
        "choice2": "自動車を運転中に交通事故で被保険者が重傷を負った場合、その損害のうち被保険者自身の過失割合に相当する部分を差し引いたものが人身傷害補償保険の補償の対象となる。",
        "choice3": "車両保険を契約した場合、他に特約を付帯していなくても地震・噴火およびそれらに起因する津波による車両の損害は補償の対象となる。",
        "choice4": "運転免許失効中の被保険者が自動車を運転中に交通事故で他人を死傷させてしまった場合、その損害は対人賠償保険の補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "自動車保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 348,
        "shikenId": 9,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "損害保険を利用した事業活動のリスク管理に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
        "choice1": "仕出し弁当を調理して提供する事業者が、食中毒を発生させて法律上の損害賠償責任を負うことによる損害に備えて、施設所有管理者賠償責任保険を契約した。",
        "choice2": "製造業を営む事業者が、業務中の災害によりパート従業員がケガを負う場合に備えて、労働者災害補償保険（政府労災保険）の上乗せ補償を目的として労働災害総合保険を契約した。",
        "choice3": "建設業を営む事業者が、請け負った建築工事中に誤って器具を落とし第三者にケガを負わせて法律上の損害賠償責任を負うことによる損害に備えて、建設工事保険を契約した。",
        "choice4": "貸しビル業を営む事業者が、火災により所有するビル内に設置した機械が損害を被る場合に備えて、機械保険を契約した。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "損害保険を利用した事業活動のリスク管理",
        "important": ""
    },
    {
        "id": 349,
        "shikenId": 9,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人が契約者（＝保険料負担者）となる損害保険の課税関係に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "自動車の運転中の交通事故により契約者が入院したことで家族傷害保険から受け取る保険金は、非課税となる。",
        "choice2": "契約者が年金払積立傷害保険から毎年受け取る給付金（年金）は、一時所得として課税対象となる。",
        "choice3": "配偶者が不慮の事故で死亡したことにより契約者が家族傷害保険から受け取る死亡保険金は、相続税の課税対象となる。",
        "choice4": "個人事業主が一部を事業の用に供している自宅を保険の対象として契約した火災保険の保険料は、事業所得の金額の計算上、事業の用に供している部分も必要経費に算入することができない。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "個人契約の損害保険の課税関係",
        "important": ""
    },
    {
        "id": 350,
        "shikenId": 9,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "第三分野の保険や特約の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "所得補償保険では、ケガや病気によって就業不能となった場合であっても、所定の医療機関に入院しなければ、補償の対象とならない。",
        "choice2": "ガン保険の入院給付金は、１回の入院での支払限度日数や保険期間を通じて累計した支払限度日数が定められている。",
        "choice3": "医療保険では、退院後に入院給付金を受け取り、その退院日の翌日から１８０日以内に前回と同一の疾病により再入院した場合、１回の入院での支払日数は前回の入院での支払日数と合算される。",
        "choice4": "先進医療特約では、契約時点において厚生労働大臣により定められていた先進医療が給付の対象となり、契約後に定められた先進医療は、給付の対象とならない。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "第三分野の保険や特約の一般的な商品性",
        "important": ""
    },
    {
        "id": 351,
        "shikenId": 9,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "経済指標のうち、国内総生産（ＧＤＰ）および日本銀行の全国企業短期経済観測調査（日銀短観）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "ＧＤＰは、国内で一定期間内に生産された財やサービスの付加価値の合計であり、海外で得た所得は含まれず、支出側の構成項目のうち、最も大きな構成比を占めるのは、民間最終消費支出である。",
        "choice2": "ＧＤＰには名目値と実質値があり、物価が持続的に低下する状態（デフレーション）にあるときは、一般に名目値が実質値を下回る。",
        "choice3": "日銀短観で公表される「業況判断ＤＩ」は、回答時点の業況とその３カ月後の業況予測について、「良い」と回答した企業の社数構成比から「悪い」と回答した企業の社数構成比を差し引いて算出される。",
        "choice4": "日銀短観の調査対象企業は、全国の資本金1,000万円以上の民間企業（金融機関等を除く）の中から抽出され、調査は年４回実施され、その結果は、３月、６月、９月、１２月に公表される。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "経済指標",
        "important": ""
    },
    {
        "id": 352,
        "shikenId": 9,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預金の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "期日指定定期預金は、据置期間経過後から最長預入期日までの間で、預金者が指定した日を満期日とすることができる。",
        "choice2": "貯蓄預金は、クレジットカード利用代金などの自動振替口座や、給与や年金などの自動受取口座として利用することができる。",
        "choice3": "スーパー定期預金は、預入期間が３年以上の場合、単利型と半年複利型があるが、半年複利型を利用することができるのは個人に限られる。",
        "choice4": "デリバティブを組み込んだ仕組預金には、金融機関の判断によって満期日が繰り上がったり、延長される商品がある。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "預金の一般的な商品性",
        "important": ""
    },
    {
        "id": 353,
        "shikenId": 9,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "上場投資信託（ＥＴＦ）および不動産投資信託（Ｊ－ＲＥＩＴ）に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "ＥＴＦは、株価指数のほか、ＲＥＩＴ指数や商品指数等のさまざまな指数に連動するものに限られ、アクティブ型のＥＴＦは国内の証券取引所に上場されていない。",
        "choice2": "ＥＴＦやＪ－ＲＥＩＴの売買には、上場株式と同様に売買委託手数料が発生するが、非上場の投資信託とは異なり、運用管理費用（信託報酬）は発生しない。",
        "choice3": "上場投資信託（ＥＴＦ）の分配金は、普通分配金のみであり、元本払戻金（特別分配金）はなく、税務上、普通分配金は課税対象となる。",
        "choice4": "他の要件を満たせば、ＥＴＦおよびＪ－ＲＥＩＴの分配金は、所得税の配当控除の対象となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "上場投資信託（ETF）、不動産投資信託（J-REIT）",
        "important": ""
    },
    {
        "id": 354,
        "shikenId": 9,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "固定利付債券（個人向け国債を除く）の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "債券を償還までの期間の長短で比較した場合、他の条件が同じであれば、償還までの期間が長い債券の方が、金利の変化に対する価格の変動幅は大きくなる。",
        "choice2": "債券を発行体の信用度で比較した場合、他の条件が同じであれば、発行体の信用度が高い債券の方が債券の価格は高い。",
        "choice3": "中央銀行が金融緩和策を縮小すると、一般に、市場金利は低下し、債券価格は上昇する。",
        "choice4": "市場金利が上昇すると、通常、債券の価格は下落し、債券の利回りは上昇する。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "固定利付債券の一般的な特徴",
        "important": ""
    },
    {
        "id": 355,
        "shikenId": 9,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "東京証券取引所の市場区分や株価指数に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "日経平均株価は、プライム市場に上場している銘柄のうち、時価総額上位２２５銘柄を対象として算出される株価指標である。",
        "choice2": "プライム市場の上場維持基準は、株主数や流通株式数等において、スタンダード市場およびグロース市場よりも高い数値が設定されており、スタンダード市場やグロース市場の上場銘柄も、プライム市場の新規上場基準等の要件を満たせば、所定の手続きにより、プライム市場に市場区分の変更できる。",
        "choice3": "東証株価指数（ＴＯＰＩＸ）は、プライム、スタンダード、グロース市場の全銘柄を対象として算出される。",
        "choice4": "ＪＰＸ日経インデックス４００は、プライム市場に上場する普通株式のうち、ＲＯＥや営業利益等の指標等により選定された４００銘柄を対象として算出される。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "東京証券取引所の市場区分や株価指数",
        "important": ""
    },
    {
        "id": 356,
        "shikenId": 9,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人（居住者）が国内の金融機関等を通じて行う外貨建て金融商品の取引等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "国外の証券取引所に上場している外国株式を国内店頭取引により売買するためには、あらかじめ外国証券取引口座を開設する必要がある。",
        "choice2": "外貨定期預金の預入時または預入後満期前に満期日の円貨での受取額を確定させるために為替先物予約を締結した場合、満期時に生じた為替差益は外貨預金の利息とともに源泉分離課税の対象となる。",
        "choice3": "国内の証券取引所に上場している外国株式を国内委託取引により売買した場合の受渡日は、国内株式と同様に、売買の約定日から起算して４営業日目となる。",
        "choice4": "ユーロ建て債券を保有している場合、ユーロに対する円の為替レートが円高に変動することは、当該債券に係る円換算の投資利回りの上昇要因となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨建て金融商品の取引",
        "important": ""
    },
    {
        "id": 357,
        "shikenId": 9,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "金融派生商品の取引の一般的な仕組みや特徴等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "オプション取引において、コール・オプションは「原資産を売る権利」、プット・オプションは「原資産を買う権利」であり、いずれも買い手は売り手に対してオプション料を支払う。",
        "choice2": "原資産を保有している投資家は、その先物取引で売りヘッジを行うことで、取引を行った時点以降の原資産価格の下落によって生じる評価損を先物取引の利益で相殺または軽減することができる。",
        "choice3": "先物価格が今後上昇すると予測される場合、先物取引で売建てし、後日、実際に相場が上昇したときに買い戻すことで利益を得ることができる。",
        "choice4": "異なる通貨間で一定期間、キャッシュフローを交換する取引を金利スワップという。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金融派生商品の取引の仕組みや特徴",
        "important": ""
    },
    {
        "id": 358,
        "shikenId": 9,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "ＮＩＳＡの成長投資枠およびつみたて投資枠に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "ＮＩＳＡのつみたて投資枠と成長投資枠は、同時に利用することはできない。",
        "choice2": "ＮＩＳＡの年間の非課税投資枠はつみたて投資枠は４０万円、成長投資枠は１２０万円である。",
        "choice3": "ＮＩＳＡを通じて購入した公募株式投資信託等に譲渡損失が生じた場合、その損失の金額は、特定口座や一般口座で生じた上場株式等に係る譲渡益の金額と損益の通算をすることができる。",
        "choice4": "ＮＩＳＡのつみたて投資枠を通じて購入することができる金融商品は、所定の要件を満たす公募株式投資信託やＥＴＦ（上場投資信託）であり、長期の積立・分散投資に適した一定の商品性を有するものに限られる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "NISA",
        "important": ""
    },
    {
        "id": 359,
        "shikenId": 9,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "下記 < 資料 > に基づくファンド A とファンド B の過去 5 年間の運用パフォーマンスの比較評価に関する次の記述の空欄（ア）、（イ）にあてはまる組み合わせとして、最も適切なものはどれか。<br><br><img src='/img/set2/9_29.png'/><br><br>ファンドの運用パフォーマンスに係る評価指標の一つとして、シャープレシオがある。無リスク金利を全期間にわたり1.0% とし、＜資料＞の数値により、ファンドＡのシャープレシオの値を算出すると、（　ア　）となる。同様にファンドＢのシャープレシオの値を算出したうえで、両ファンドの運用パフォーマンスを比較すると、過去 5 年間は（　イ　）の方が効率的な運用であったと判断される。",
        "choice1": "（ア）2.0 （イ）ファンド A",
        "choice2": "（ア）2.0 （イ）ファンド B",
        "choice3": "（ア）2.5 （イ）ファンド A",
        "choice4": "（ア）2.5 （イ）ファンド B",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "シャープレシオの計算",
        "important": ""
    },
    {
        "id": 360,
        "shikenId": 9,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "金融サービス提供法、消費者契約法および金融商品取引法に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "金融サービス提供法では、金融商品販売業者等は重要事項の説明義務違反によって生じた顧客の損害を賠償する責任を負うとされ、当該顧客は説明義務違反を立証すれば、その説明義務違反と損害発生との因果関係を立証する必要はない。",
        "choice2": "金融サービス提供法が規定する金融商品の販売において、金融サービス提供法と消費者契約法の両方の規定を適用することができる場合は、金融サービス提供法が優先して適用される。",
        "choice3": "消費者契約法では、事業者の一定の行為により、消費者が誤認または困惑した場合、消費者は、消費者契約の申込みまたは承諾の意思表示を取り消すことができるとされている。",
        "choice4": "金融商品取引法では、有価証券のデリバティブ取引のほか、通貨・金利スワップ取引も適用の対象とされるが、円建ての普通預金は適用の対象外である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金融商品の取引に係る各種法令",
        "important": ""
    },
    {
        "id": 361,
        "shikenId": 9,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "わが国の税制に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "所得税は、国や地方公共団体の会計年度と同様、毎年4月1日から翌年3月31日までの期間を単位として課される。",
        "choice2": "所得税、相続税、贈与税、法人税は、納税者が自らの納付すべき税額を確定させ、申告・納付する申告納税方式を採用している。",
        "choice3": "税金を負担する者と税金を納める者が異なる税金を間接税といい、固定資産税や消費税は間接税に該当する。",
        "choice4": "税金には、国税と地方税があるが、法人税や相続税は国税に該当し、登録免許税や事業税は地方税に該当する。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "わが国の税制",
        "important": ""
    },
    {
        "id": 362,
        "shikenId": 9,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "次のうち、所得税における非課税所得に該当しないものはどれか。",
        "choice1": "健康保険の傷病手当金",
        "choice2": "障害基礎年金",
        "choice3": "ふるさと納税の返礼品",
        "choice4": "雇用保険の基本手当や高年齢雇用継続基本給付金",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "非課税所得",
        "important": ""
    },
    {
        "id": 363,
        "shikenId": 9,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "不動産の貸付けに係る所得税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "不動産の貸付けをしたことに伴い敷金として収受する金額のうち、全部または一部について、収受する年中に、返還を要しないことが確定した金額は、その年分の不動産所得の金額の計算上、総収入金額に算入する。",
        "choice2": "借家人が賃貸借の目的とされている居宅の立退きに際し受ける立退き料（借家権の消滅の対価の額に相当する部分の金額を除く）は、原則として一時所得として扱う。",
        "choice3": "不動産所得の基因となる建物の賃借人の立退きに要した立退き料は、原則として、支出した日の属する年分の不動産所得の金額の計算上、必要経費に算入する。",
        "choice4": "賃貸用土地および建物の取得者が、当該土地および建物を取得した際に支払った仲介手数料は、支払った年分の不動産所得の金額の計算上、全額を必要経費に算入することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "不動産の貸付と所得",
        "important": ""
    },
    {
        "id": 364,
        "shikenId": 9,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税の損益通算に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "不動産所得の金額の計算上生じた損失の金額は、上場株式等に係る譲渡所得の金額と損益通算することができる。",
        "choice2": "公的年金等以外の雑所得の金額の計算上生じた損失の金額は、不動産所得の金額と損益通算することができる。",
        "choice3": "総合課税の対象となる事業所得の金額の計算上生じた損失の金額は、公的年金等に係る雑所得の金額と損益通算することができる。",
        "choice4": "一時所得の金額の計算上生じた損失の金額は、給与所得の金額と損益通算することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "損益通算",
        "important": ""
    },
    {
        "id": 365,
        "shikenId": 9,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税における医療費控除に関する次の記述のうち、最も不適切なものはどれか。なお、「特定一般用医薬品等購入費を支払った場合の医療費控除の特例」は考慮しないものとする。",
        "choice1": "納税者が支払った医療費は２００万円を限度として、その年中に支払った全額を医療費控除として控除することができる。",
        "choice2": "納税者本人の電車やバスによる通院費は医療費控除の対象となるが、マイカーのガソリン代や病院の駐車場代は医療費控除の対象とならない。",
        "choice3": "医療費控除の対象となる医療費の金額は、原則としてその年中に実際に支払った金額が対象となり、年末の時点で未払いの金額はその年分の医療費控除の対象とならない。",
        "choice4": "健康診断により重大な疾病が発見され、かつ、当該診断に引き続きその疾病の治療をした場合の健康診断の費用は、医療費控除の対象となる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "医療費控除",
        "important": ""
    },
    {
        "id": 366,
        "shikenId": 9,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "次のうち、所得税の確定申告を要する者はどれか。なお、いずれも適切に源泉徴収等がされ、年末調整すべきものは年末調整が済んでいるものとする。",
        "choice1": "給与として１ヵ所から年額１, ８００万円の支払いを受けた給与所得者",
        "choice2": "退職一時金として２, ０００万円の支払いを受け、その支払いを受ける時までに「退職所得の受給に関する申告書」を提出している者",
        "choice3": "同族会社である法人１ヵ所から給与として年額１, ０００万円の支払いを受け、かつ、その法人から不動産賃貸料として年額１２万円の支払いを受けたその法人の役員",
        "choice4": "老齢基礎年金および老齢厚生年金を合計で年額３００万円受給し、かつ、原稿料に係る雑所得が年額１８万円ある者",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の確定申告",
        "important": ""
    },
    {
        "id": 367,
        "shikenId": 9,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "法人税の仕組み等に関する次の記述のうち、最も適切なものはどれか。なお、法人はいずれも内国法人（普通法人）であるものとする。",
        "choice1": "期末資本金の額等が１億円以下の一定の中小法人に対する法人税の税率は、所得金額のうち年１，０００万円以下の部分については軽減税率が適用される。",
        "choice2": "新たに設立された法人が、その設立事業年度から青色申告の適用を受けるためには、設立の日以後２ヵ月経過した日と当該事業年度終了の日のいずれか早い日の前日までに、「青色申告承認申請書」を納税地の所轄税務署長に提出しなければならない。",
        "choice3": "法人は、その本店の所在地または当該代表者の住所地のいずれかから法人税の納税地を任意に選択することができる。",
        "choice4": "法人税における事業年度とは、法令または定款等により定められた１年以内の会計期間がある場合にはその期間をいう。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人税の仕組み",
        "important": ""
    },
    {
        "id": 368,
        "shikenId": 9,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "事業者が国内で行う取引に係る消費税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "金融商品取引法に規定する株式等の有価証券の譲渡は、消費税がかからない。",
        "choice2": "住宅（１カ月以上）の貸付は、消費税がかからない。",
        "choice3": "土地の譲渡や貸付（１カ月以上）は、消費税がかからない。",
        "choice4": "事業の用に供する家屋の譲渡や貸付は、消費税がかからない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "消費税の課税対象",
        "important": ""
    },
    {
        "id": 369,
        "shikenId": 9,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "役員が所有する土地を無償で会社に譲渡した場合、その適正な時価相当額が会社の受贈益として益金の額に算入される。",
        "choice2": "会社が所有する土地を適正な時価よりも低い価額で役員に譲渡した場合、その適正な時価と譲渡価額との差額が役員の給与所得の収入金額に算入される。",
        "choice3": "役員が会社の所有する社宅に無償で居住している場合、通常の賃貸料相当額が役員の給与所得の収入金額に算入される。",
        "choice4": "役員が会社に無利息で金銭の貸付けを行った場合、原則として、通常収受すべき利息に相当する金額が役員の雑所得の収入金額に算入される。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "会社と役員間の取引に係る税金",
        "important": ""
    },
    {
        "id": 370,
        "shikenId": 9,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "決算書の見方や一般的な特徴に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "貸借対照表の、純資産の部の合計額は、資産の部および負債の部の合計額と一致する。",
        "choice2": "貸借対照表の固定負債は、返済期限が決算日の翌日から起算して3 年以内に到来しない借入金等の負債の金額を表示している。",
        "choice3": "損益計算書の経常利益の額は、営業利益の額に営業外損益の額を加算・減算した額である。",
        "choice4": "損益計算書の営業利益の額は、売上高の額から売上原価の額を差し引いた額である。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "決算書",
        "important": ""
    },
    {
        "id": 371,
        "shikenId": 9,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "不動産の登記に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "不動産の登記記録は、当該不動産の所有者の住所地である市町村および特別区の役所や役場に備えられている。",
        "choice2": "不動産の登記事項証明書の交付を請求することができるのは、当該不動産に利害関係を有する者に限られる。",
        "choice3": "不動産の売買契約を締結した当事者は、当該契約締結後１ヵ月以内に、所有権移転の登記をすることが義務付けられている。",
        "choice4": "区分建物に係る登記記録において、床面積は、壁その他の区画の内側線で囲まれた部分の水平投影面積（内法面積）により算出される。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の登記",
        "important": ""
    },
    {
        "id": 372,
        "shikenId": 9,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "不動産鑑定評価基準における不動産の価格を求める鑑定評価の手法に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "原価法は、価格時点における対象不動産の再調達原価をもって評価する方法であるが、再調達原価について減価修正を考慮する必要はない。",
        "choice2": "収益還元法は、対象不動産が将来生み出すであろうと期待される総家賃収入の現在価値の総和を求めることにより、対象不動産の価格を求める手法である。",
        "choice3": "収益還元法は、文化財の指定を受けた建造物等の一般的に市場性を有しない不動産の価格を求める際にも適用できる。",
        "choice4": "最有効使用の原則は、不動産の価値を最大限に引き出す使用を前提として把握される価格を標準として、不動産の価格が形成されるとする原則である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の鑑定評価",
        "important": ""
    },
    {
        "id": 373,
        "shikenId": 9,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、同法第２２条から第２４条の定期借地権等以外の借地権を普通借地権という。",
        "choice1": "普通借地権の設定契約において、期間の定めがない場合には、存続期間は３０年となる。",
        "choice2": "普通借地権の存続期間が満了した場合、契約の更新がないときは、借地権者は、借地権設定者に対して、建物その他借地権者が権原により土地に附属させた物を時価で買い取るべきことを請求することができる。",
        "choice3": "事業用定期借地権等においては、建物の用途は事業用に限定されているため、法人が従業員向けの社宅として利用する建物の所有を目的として設定することができる。",
        "choice4": "建物の譲渡により建物譲渡特約付借地権が消滅した場合において、当該建物を使用する賃借人が借地権設定者に対して建物の継続使用を請求したときには、賃借人と借地権設定者との間で存続期間の定めのない建物の賃貸借がされたものとみなされる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "借地",
        "important": ""
    },
    {
        "id": 374,
        "shikenId": 9,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、同法第３８条による定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。また、記載のない事項については考慮しないものとする。",
        "choice1": "普通借家契約において存続期間を６ヵ月と定めた場合、その存続期間は１年とみなされる。",
        "choice2": "普通借家契約および定期借家契約において、賃借人は、原則として、その建物の賃借権の登記がなくても、引渡しを受けていれば、その後その建物について物権を取得した者に賃借権を対抗することができる。",
        "choice3": "普通借家契約および定期借家契約において、賃借人に造作買取請求権を放棄させる旨の特約は有効となる。",
        "choice4": "定期借家契約において、経済事情の変動があっても賃料を増減額しないこととする特約をした場合、その特約は有効である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "借家",
        "important": ""
    },
    {
        "id": 375,
        "shikenId": 9,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "市街化調整区域は、すでに市街地を形成している区域およびおおむね１０年以内に優先的かつ計画的に市街化を図るべき区域とされている。",
        "choice2": "市街化区域については用途地域を定め、市街化調整区域については原則として用途地域を定めないものとされている。",
        "choice3": "都市計画区域内において、用途地域が定められている区域については、防火地域または準防火地域のいずれかを定めなければならない。",
        "choice4": "市街化区域における開発行為は、その規模にかかわらず、都道府県知事等の許可が必要である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "都市計画法",
        "important": ""
    },
    {
        "id": 376,
        "shikenId": 9,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "建築物の敷地は、原則として、建築基準法に規定する道路に、２ｍ以上接していなければならない。",
        "choice2": "防火地域内に耐火建築物を建築する場合、建蔽率の制限について緩和措置を受けられる。",
        "choice3": "建築物の敷地が異なる２つの用途地域にわたる場合の建築物の用途は、その建築物の全部について、敷地の過半の属する用途地域の建築物の用途に関する規定が適用される。",
        "choice4": "建築基準法第４２条第２項の道路に面している敷地のうち、道路と道路境界線とみなされる線までの間の敷地部分（セットバック部分）は、建蔽率および容積率を算定する際の敷地面積に算入することができる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築基準法",
        "important": ""
    },
    {
        "id": 377,
        "shikenId": 9,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "不動産の取得に係る税金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "不動産取得税は、贈与により取得した場合には課税されるが、相続により不動産を取得した場合には課税されない。",
        "choice2": "所定の要件を満たす戸建て住宅（認定長期優良住宅を除く）を新築した場合、不動産取得税の課税標準の算定に当たっては、１戸につき最高１, ５００万円を価格から控除することができる。",
        "choice3": "不動産に抵当権設定登記をする際の登録免許税の課税標準は、当該不動産の固定資産税評価額である。",
        "choice4": "所有権移転登記に係る登録免許税の税率は、登記原因が贈与による場合の方が相続による場合よりも低い。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の取得に係る税金",
        "important": ""
    },
    {
        "id": 378,
        "shikenId": 9,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "個人が土地を譲渡した場合の譲渡所得に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "譲渡所得の金額の計算上、取得費が不明な場合には、譲渡収入金額の１０％相当額を取得費とすることができる。",
        "choice2": "譲渡所得のうち、土地を譲渡した日の属する年の１月１日における所有期間が１０年以下のものについては短期譲渡所得に区分される。",
        "choice3": "譲渡するために直接要した仲介手数料は、譲渡所得の金額の計算上、譲渡費用に含まれる。",
        "choice4": "土地の譲渡に係る譲渡所得の金額は、当該土地の所有期間の長短にかかわらず、他の所得の金額と合算して税額が計算される。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "譲渡所得",
        "important": ""
    },
    {
        "id": 379,
        "shikenId": 9,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "居住用財産を譲渡した場合の３, ０００万円の特別控除（以下、３, ０００万円特別控除）と居住用財産を譲渡した場合の長期譲渡所得の課税の特例（以下、軽減税率の特例）、特定居住用財産の買換えの場合の長期譲渡所得の課税の特例に関する次の記述のうち、最も適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。",
        "choice1": "３, ０００万円特別控除と軽減税率の特例は、居住の用に供さなくなった日の属する年の翌年１２月３１日までに譲渡することが要件とされる。",
        "choice2": "軽減税率の特例の適用を受けた場合、課税長期譲渡所得のうち、１億円以下の部分の税率が軽減される。",
        "choice3": "特定居住用財産の買換えの場合の長期譲渡所得の課税の特例の適用を受ける場合、３, ０００万円特別控除および軽減税率の特例は重複して適用することはできない。",
        "choice4": "軽減税率の特例は譲渡する年の１月１日時点の所有期間が２０年を超えていることが要件とされる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "居住用財産の譲渡の特例",
        "important": ""
    },
    {
        "id": 380,
        "shikenId": 9,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "不動産の有効活用の手法等の一般的な特徴に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "事業受託方式では、調査・企画、建物の設計・施工、建物の管理・運営、建築資金の調達をデベロッパーが行うため、土地所有者の業務や資金調達の負担が軽減される。",
        "choice2": "建設協力金方式は、土地所有者が利用予定のテナントから資金を借り入れて建物を建設し、テナントからの賃貸料で借入金を返済するため、自己資金が少なくても、賃貸事業を行うことができる。",
        "choice3": "等価交換方式における部分譲渡方式は、土地所有者がいったん土地の全部をデベロッパーに譲渡し、その対価をもって土地上にデベロッパーが建設した建物およびその土地の一部を譲り受ける譲渡方式である。",
        "choice4": "定期借地権方式では、土地を一定期間貸し付けることによる地代収入を得ることができ、借地期間中の当該土地上の建物の所有名義は土地所有者となる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の有効活用の手法",
        "important": ""
    },
    {
        "id": 381,
        "shikenId": 9,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "贈与税の計算および申告に関する次の記述のうち、最も不適切なものはどれか。なお、贈与財産は、住宅取得等資金や教育資金、結婚・子育てに係る資金の贈与ではなく、他の贈与はないものとする。",
        "choice1": "暦年課税による贈与に係る贈与税額の計算上、適用される税率は、超過累進税率である。",
        "choice2": "特定贈与者からの贈与について、相続時精算課税制度の適用を受けた場合、それ以後、特定贈与者からの贈与については、暦年課税に変更することはできない。",
        "choice3": "原則として、１８歳以上の者が、父母や祖父母等の直系尊属から贈与を受ける場合には一般贈与財産に係る贈与税率が適用され、夫婦間の贈与では特例贈与財産に係る贈与税率が適用される。",
        "choice4": "本年中に相続時精算課税制度を選択した受贈者は、受贈者ごと年間１１０万円以内であれば、贈与税の申告は不要となるが、特定贈与者から贈与により取得した財産の価額の合計額が１１０万円を超え、特別控除額以下である場合は、贈与税の申告書を提出する必要がある。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の計算と申告",
        "important": ""
    },
    {
        "id": 382,
        "shikenId": 9,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "贈与税の申告と納付に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "贈与税の配偶者控除の適用を受けることにより納付すべき贈与税額が算出されない場合であっても、当該控除の適用を受けるためには、贈与税の申告書を提出する必要がある。",
        "choice2": "贈与税の申告書の提出期間は、原則として、贈与を受けた年の翌年２月１日から３月１５日までである。",
        "choice3": "贈与税の納付は、金銭による一括納付が原則であるが、所定の要件を満たせば物納が認められる。",
        "choice4": "贈与税を延納するには、納付すべき贈与税額が１０万円を超えていなければならない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の申告と納付",
        "important": ""
    },
    {
        "id": 383,
        "shikenId": 9,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "親族等に係る民法の規定に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "親族の範囲は、３親等内の血族、配偶者、６親等内の姻族である。",
        "choice2": "特別養子縁組が成立した場合、原則として養子と実方の父母との親族関係は終了する。",
        "choice3": "相続開始時における胎児は、すでに生まれたものとみなされ、死産の場合を除き、相続権が認められる。",
        "choice4": "直系血族および兄弟姉妹は、互いに扶養をする義務があるが、家庭裁判所は、特別の事情があるときは、３親等内の親族間においても扶養の義務を負わせることができる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "親族等",
        "important": ""
    },
    {
        "id": 384,
        "shikenId": 9,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "成年後見制度に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "任意後見契約は、本人の判断能力が不十分であることが、医師の診断により認められた時からその効力が生じる。",
        "choice2": "任意後見契約は、公証人が作成する公正証書によってしなければならない。",
        "choice3": "法定後見制度において、成年後見人は、成年被後見人が行った法律行為について、原則として、取り消すことはできない。",
        "choice4": "法定後見制度において、後見開始の審判がされたときは、その内容が戸籍に記載される。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "成年後見制度",
        "important": ""
    },
    {
        "id": 385,
        "shikenId": 9,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "遺産分割に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "遺産の分割について、共同相続人間で協議が整わないときや協議をすることができないときは、各共同相続人は、家庭裁判所に調停または審判を申し立てることができる。",
        "choice2": "相続財産である不動産を、共同相続人間で分割するために売却して換価した場合、その所得は、所得税において非課税所得とされる。",
        "choice3": "代償分割により特定の財産（遺産）を取得した相続人から他の相続人に交付された代償財産が不動産や株式であっても、その不動産や株式を交付した相続人には、譲渡所得として所得税が課されることはない。",
        "choice4": "被相続人は、遺言によって、相続開始のときから１０年間を超えない期間を定めて、遺産の分割を禁ずることができる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺産分割",
        "important": ""
    },
    {
        "id": 386,
        "shikenId": 9,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "相続税の計算に関する次の記述のうち、最も不適切なものはどれか。なお、本問において、相続の放棄をした者はいないものとする。",
        "choice1": "遺産に係る基礎控除額の計算上、法定相続人の数に含めることができる養子（特別養子、代襲相続人である孫等の実子とみなされる者を除く）の数は、実子がいる場合、２人に制限される。",
        "choice2": "遺産に係る基礎控除額の計算上、法定相続人の数は、相続の放棄があっても、その放棄がなかったものとする。",
        "choice3": "相続税の２割加算の対象となるのは、兄弟姉妹や代襲相続人でない孫養子等であり、代襲相続人である孫は２割加算の対象とならない。",
        "choice4": "法定相続人が被相続人の配偶者のみである場合、「配偶者に対する相続税額の軽減」の適用を受けた配偶者については、相続により取得した遺産額の多寡にかかわらず、納付すべき相続税額が生じない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の計算",
        "important": ""
    },
    {
        "id": 387,
        "shikenId": 9,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "相続税における宅地の評価に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "二方面に路線がある角地を路線価方式によって評価する場合、それぞれの路線価に奥行価格補正率を乗じた価額を比較し、低い方が正面路線価となる。",
        "choice2": "登記上２筆の土地である宅地の価額は、これを一体として利用している場合であっても、原則として、２画地として別々に評価しなければならない。",
        "choice3": "宅地の評価方法には、路線価方式と倍率方式とがあり、いずれの方式を採用するかは、納税者が任意に選択することができる。",
        "choice4": "路線価図において、路線に「３００C 」と記載されている場合、３００はその路線に面する標準的な宅地１㎡当たりの価額が３００千円であることを示し、Ｃはその路線に面する宅地の借地権割合が７０％であることを示す。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "宅地の評価",
        "important": ""
    },
    {
        "id": 388,
        "shikenId": 9,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "不動産に係る相続対策等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "相続により土地を取得した者がその相続に係る相続税を延納する場合、担保として不適格なものでなければ、取得した土地を延納の担保として提供することができる。",
        "choice2": "配偶者が所有する居住用家屋およびその敷地に供されている土地のうち、土地のみについて贈与を受けた者は、贈与税の配偶者控除の適用を受けることができない。",
        "choice3": "「小規模宅地等についての相続税の課税価格の計算の特例」の適用を受けた宅地等を物納する場合の収納価額は、特例適用後の価額となる。",
        "choice4": "新築した家屋が店舗併用住宅で、その家屋の登記簿上の床面積の２分の１超に相当する部分が店舗の用に供される場合、その家屋の対価に充てるための金銭は、直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税の特例の適用を受けることができない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "不動産に係る相続対策等",
        "important": ""
    },
    {
        "id": 389,
        "shikenId": 9,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "相続税における取引相場のない株式の評価に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "類似業種比準方式における比準要素は、１株当たりの配当金額、利益金額、純資産価額（帳簿価額によって計算した金額）であり、ウェイトは「１：１：１」である。",
        "choice2": "純資産価額を計算する場合の「評価差額に対する法人税額等に相当する金額」の計算上、法人税等の割合は３７％である。",
        "choice3": "同族株主等のいる会社において、同族株主等以外の株主が取得した株式は、その会社規模にかかわらず、原則として、配当還元方式によって評価する。",
        "choice4": "配当還元価額は、その株式の１株当たりの年配当金額を５％で還元して評価する。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "取引相場のない株式の評価",
        "important": ""
    },
    {
        "id": 390,
        "shikenId": 9,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "民法における配偶者居住権に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "被相続人の配偶者は、取得した配偶者居住権を第三者に対して譲渡することができる。",
        "choice2": "配偶者居住権は、被相続人の遺言によるほか、相続人全員による遺産分割協議で取得することができる。",
        "choice3": "配偶者居住権とは、被相続人所有の居住用建物について、配偶者が無償で使用、収益できる権利をいい、特に定めがなければ、その存続期間は終身とされる。",
        "choice4": "居住建物を被相続人と被相続人の子が相続開始時において共有していた場合や、被相続人の配偶者が、相続開始時に被相続人所有の居住用建物に居住していなかった場合は、当該建物に係る配偶者居住権を取得することはできない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "配偶者居住権",
        "important": ""
    },
    {
        "id": 391,
        "shikenId": 10,
        "no": 1,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,1,2,1",
        "score": "1,1,1,1",
        "question1": "ファイナンシャル・プランナー（以下「ＦＰ」という）が、ファイナンシャル・プランニング業務を行う上では、関連法規等を順守することが重要である。ＦＰの行為に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択してください。",
        "question2": "",
        "choice1": "司法書士資格を有していないＦＰが、顧客から依頼され、顧客の任意後見人となる契約を締結した。",
        "choice2": "生命保険募集人・生命保険仲立人、金融サービス仲介業の登録をしていないＦＰが、生命保険契約を検討している顧客のライフプランに基づき、有償で必要保障額を具体的に試算した。",
        "choice3": "社会保険労務士資格を有していないＦＰが、顧客である個人事業主が受け取る雇用関係助成金申請の書類を作成して手続きの代行を行い、報酬を受け取った。",
        "choice4": "税理士資格を有していないＦＰが、節税対策を検討している顧客に対し、有料の相談業務において、仮定の事例に基づく一般的な解説を行った。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "FP業務と関連法規",
        "important": ""
    },
    {
        "id": 392,
        "shikenId": 10,
        "no": 2,
        "answerType": 8,
        "groupId": 1,
        "answer": "2",
        "score": "2",
        "question1": "ファイナンシャル・プランニングのプロセスに従い、次の１～６を６つのステップの順番に並べ替えたとき、その中で４番目（ステップ４）となるものはどれか。<br><br>１．\u0007面談やヒアリングシートにより顧客および家族の情報やファイナンス状態の情報等を収集し、顧客の財政的な目標を明確化する。<br>２．顧客の目標を達成するために必要なプランを作成し、顧客に提案書を提示して説明を行う。<br>３．顧客のキャッシュフロー表などを作成し、将来の財政状況の予測・分析等を行う。<br>４．\u0007顧客の家族構成などの環境の変化、税制や法律改正の内容を考慮し、定期的にプランの見直しを行う。<br>５．\u0007作成したプランに従い、顧客が行う金融商品の購入、不動産売却等の実行について助言や情報提供などの支援を行う。<br>６．\u0007顧客にファイナンシャル・プランニングで提供するサービス内容や報酬体系などを説明し、了解を得る。",
        "question2": "",
        "choice1": "1|2|3|4|5|6",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "ファイナンシャル・プランニングのプロセス",
        "important": ""
    },
    {
        "id": 393,
        "shikenId": 10,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "下記＜資料＞に関する次の記述の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、正しいものはどれか。<br><br><img src='/img/set2/s3_1.png'/>",
        "question2": "",
        "choice1": "（ア）１５万円　（イ）ない 　（ウ）投資適格債",
        "choice2": "（ア）１５０万円　（イ）ある　（ウ）投資適格債",
        "choice3": "（ア）１５万円　（イ）ある 　（ウ）投資不適格債",
        "choice4": "（ア）１５０万円　（イ）ない　（ウ）投資不適格債",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券の購入金額、手数料、格付け",
        "important": ""
    },
    {
        "id": 394,
        "shikenId": 10,
        "no": 4,
        "answerType": 9,
        "groupId": 0,
        "answer": "0.735",
        "score": 2,
        "question1": "下記＜資料＞の債券を満期まで保有した場合の最終利回り（単利・年率）を計算しなさい。なお、手数料や税金等については考慮しないものとし、計算結果については小数点以下第４位を切り捨てること。また、解答に当たっては記載されている単位（％）に従うこと。<br><br><img src='/img/set2/s4_1.png'/>",
        "question2": "",
        "choice1": "%",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券の利回り計算",
        "important": ""
    },
    {
        "id": 395,
        "shikenId": 10,
        "no": 5,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "国内の同業種であるＡ社、Ｂ社の株価および財務状況は以下の＜資料＞のとおりである。次の（ア）～（ウ）について、適切なものには○を、不適切なものには×を選択してください。<br><br><img src='/img/set2/s5_1.png'/>",
        "question2": "",
        "choice1": "ＰＥＲ（株価収益率）から判断して割安なのはＡ社である。",
        "choice2": "ＲＯＥ（自己資本利益率）で比較した場合、効率的に利益を上げているといえるのはＢ社である。",
        "choice3": "配当利回りがより高いのはＡ社である。",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の投資指標の計算",
        "important": ""
    },
    {
        "id": 396,
        "shikenId": 10,
        "no": 6,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,2,2",
        "score": "1,1,1,1",
        "question1": "下記＜資料＞は、外貨定期預金の契約締結前交付書面の一部である。この契約締結前交付書面に関する次の記述の空欄（ア）～（エ）にあてはまる語句として、適切なものには○を、不適切なものには×を選択してください。<br><br><img src='/img/set2/s6_1.png'/>",
        "question2": "",
        "choice1": "空欄（ア）にあてはまる語句は「源泉」である。",
        "choice2": "空欄（イ）に当てはまる語句は「譲渡」である。",
        "choice3": "空欄（ウ）に当てはまる語句は「１，４９０，０００円」である。",
        "choice4": "空欄（エ）に当てはまる語句は「対象」である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨預金",
        "important": ""
    },
    {
        "id": 397,
        "shikenId": 10,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "永田さんと今井さんは、下記＜資料＞のとおり、ST 株式会社の株式（以下「ST 株式」）を本年 4 月から8 月において毎月 15 日に購入した。次の記述のうち、最も不適切なものはどれか。なお、このほかに ST 株式の取引はないものとし、手数料および税金は考慮しないものとする。また、購入株数は正しいものとする。<br><br><img src='/img/set2/s7_1.png'/>",
        "question2": "",
        "choice1": "永田さんの平均購入単価は、今井さんの平均購入単価よりも低くなっている。",
        "choice2": "永田さんは、本年 6 月に保有株式を指値注文で売却することができるが、今井さんは、本年 6 月に保有株式を指値注文で売却することはできない。",
        "choice3": "永田さんおよび今井さんは、本年 6 月期の期末株主配当金を受け取ることができる。",
        "choice4": "永田さんおよび今井さんは、本年 6 月に開催される定時株主総会の議決権を持たない。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の購入",
        "important": ""
    },
    {
        "id": 398,
        "shikenId": 10,
        "no": 8,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,2,1,1",
        "score": "1,1,1,1",
        "question1": "下記＜資料＞は伊沢さんが購入を検討している物件の登記事項証明書の一部である。この登記事項証明書に関する次の（ア）～（エ）の記述について、正しいものには○、誤っているものには×を選択してください。<br><br><img src='/img/set2/s8_1.png'/>",
        "question2": "",
        "choice1": "市役所等で手数料を納付すれば、誰でも登記事項証明書の交付を請求することができる。",
        "choice2": "所有権保存など所有権に関する事項が記載されている欄（Ａ）は、権利部の乙区である。",
        "choice3": "平成〇年にＡＢ銀行の抵当権設定が行われ、ＡＢ銀行の抵当権設定当初の債権額は３,５００万円であることが分かる。",
        "choice4": "上記＜資料＞を確認する限り、本物件には現在、抵当権の設定はないことが分かる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "登記",
        "important": ""
    },
    {
        "id": 399,
        "shikenId": 10,
        "no": 9,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "建築基準法に従い、下記＜資料＞の土地に耐火建築物を建てる場合、建築面積の最高限度（ア）と延べ面積の最高限度（イ）の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない条件については一切考慮しないこと。<br><br><img src='/img/set2/s9_1.png'/>",
        "question2": "",
        "choice1": "（ア）１８０㎡ （イ）９００㎡",
        "choice2": "（ア）１８０㎡ （イ）８４０㎡",
        "choice3": "（ア）２１０㎡ （イ）８４０㎡",
        "choice4": "（ア）２１０㎡ （イ）９００㎡",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築面積と延べ面積の計算",
        "important": ""
    },
    {
        "id": 400,
        "shikenId": 10,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "芝沼さんは、保有しているマンションを賃貸している。下記＜資料＞に基づいて計算した本年の所得税に係る不動産所得の金額として、正しいものはどれか。なお、＜資料＞以外の収入および支出等はないものとし、青色申告特別控除は考慮しないこととする。<br><br><img src='/img/set2/s10_1.png'/>",
        "question2": "",
        "choice1": "３万円",
        "choice2": "７３万円",
        "choice3": "９３万円",
        "choice4": "１３３万円",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産所得の計算",
        "important": ""
    },
    {
        "id": 401,
        "shikenId": 10,
        "no": 11,
        "answerType": 8,
        "groupId": 1,
        "answer": "2,4,7",
        "score": "1,1,1",
        "question1": "鴇田さんは、所有しているアパートを賃貸するに当たり、ＦＰの岸さんから借家契約の説明を受けた。借地借家法に基づく借家契約に関する下表の空欄（ア）～（ウ）に入る最も適切な語句を語群の中から選び、その番号を選択してください。なお、同じ語句を何度選んでもよいこととする。<br><br><img src='/img/set2/s11_1.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "借家契約",
        "important": ""
    },
    {
        "id": 402,
        "shikenId": 10,
        "no": 12,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "太田さんは、自身の居住用財産である土地・建物の譲渡を予定しており、ＦＰで税理士でもある加藤さんに居住用財産を譲渡した場合の３，０００万円特別控除の特例（以下「本特例」という）について質問をした。＜資料＞に基づく次の記述のうち、最も不適切なものはどれか。<br><br><img src='/img/set2/s12_1.png'/>",
        "question2": "",
        "choice1": "「本年中に譲渡する場合、太田さんの本年の合計所得金額が２，０００万円を超えるときは、本特例の適用を受けることはできません。」",
        "choice2": "「譲渡先が太田さんの子であるときは、本特例の適用を受けることはできません。」",
        "choice3": "「２０２５年６月１０日に太田さんが家族とともに居住の用に供さなくなった場合、その日から２０２８年１２月３１日までに譲渡しなければ、本特例の適用を受けることはできません。」",
        "choice4": "「２０２５年中に譲渡する場合、太田さんが２０２３年に本特例の適用を受けていたときは、本特例の適用を受けることはできません。」",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "3,000万円特別控除の特例",
        "important": ""
    },
    {
        "id": 403,
        "shikenId": 10,
        "no": 13,
        "answerType": 9,
        "groupId": 1,
        "answer": "265,460,20",
        "score": "1,1,1",
        "question1": "阿部裕也さん（５0歳）が加入の提案を受けた生命保険の保障内容は下記＜資料＞のとおりである。この生命保険に加入した場合、次の記述の空欄（ア）～（ウ）にあてはまる数値を計算しなさい。なお、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><br><img src='/img/set2/s13_1.png'/><br><br><img src='/img/set2/s13_2.png'/><br><br><img src='/img/set2/s13_3.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の証券分析",
        "important": ""
    },
    {
        "id": 404,
        "shikenId": 10,
        "no": 14,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "下記の生命保険契約について、保険金・給付金の課税に関する次の記述のうち、最も適切なものはどれか。<br><br><img src='/img/set2/s14_1.png'/>",
        "question2": "",
        "choice1": "夫が死亡し、契約Ａについて妻が取得する死亡保険金に係る年金受給権は、相続税の課税対象となる。",
        "choice2": "夫が死亡し、契約Ａから妻が２年目以降に受け取る死亡給付金のうち課税部分は、所得税（一時所得）の課税対象となる。",
        "choice3": "妻がガンと診断されたために、契約Ｂから妻が受け取ったガン診断給付金は所得税（一時所得）の課税対象となる。",
        "choice4": "妻が死亡し、契約Ｂから夫が受け取る死亡給付金は贈与税の課税対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "保険金・給付金の税務",
        "important": ""
    },
    {
        "id": 405,
        "shikenId": 10,
        "no": 15,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,2,1",
        "score": "1,1,1,1",
        "question1": "長州力也さんが契約している火災保険および地震保険（下記＜資料＞参照）に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択してください。なお、保険契約の内容は適正（超過保険や一部保険に該当しない）であり、かつ有効に継続しているものとする。また、＜資料＞に記載のない特約等については考慮しないものとする。<br><br><img src='/img/set2/s15_1.png'/>",
        "question2": "",
        "choice1": "住宅の屋根が台風の強風により損壊し、１００万円の損害を被った場合、補償の対象になる。",
        "choice2": "住宅内に保管していた時価２０万円のダイヤモンドの指輪が盗難にあった場合、補償の対象とならない。",
        "choice3": "洪水が原因で建物と家財が全損となった場合、合計２, ６００万円の保険金が支払われる。",
        "choice4": "長州さんがベランダから誤って物を落とし、歩道を通行中の他人にケガを負わせた場合の損害賠償責任について補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "火災保険の証券分析",
        "important": ""
    },
    {
        "id": 406,
        "shikenId": 10,
        "no": 16,
        "answerType": 8,
        "groupId": 1,
        "answer": "3,7,8,13",
        "score": "1,1,1,1",
        "question1": "リビング・ニーズ特約に関する下記＜資料＞の空欄（ア）～（エ）に入る適切な語句を語群の中から選び、その番号を選択してください。<br><br><img src='/img/set2/s16_1.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9|10|11|12|13|14",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "リビング・ニーズ特約",
        "important": ""
    },
    {
        "id": 407,
        "shikenId": 10,
        "no": 17,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "宮井さんは、生命保険の解約返戻金について、ＦＰの清田さんに質問をした。清田さんが、生命保険の解約返戻金相当額について説明する際に使用した下記の＜イメージ図＞のうち、一般的な養老保険の解約返戻金相当額の推移に係る図として、最も適切なものはどれか。<br><br>＜イメージ図＞",
        "question2": "",
        "choice1": "<img src='/img/set2/s17_1.png'/ id=\"s-17-1-img\">",
        "choice2": "<img src='/img/set2/s17_2.png'/ id=\"s-17-1-img\">",
        "choice3": "<img src='/img/set2/s17_3.png'/ id=\"s-17-1-img\">",
        "choice4": "<img src='/img/set2/s17_4.png'/ id=\"s-17-1-img\">",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "解約返戻金のイメージ図",
        "important": ""
    },
    {
        "id": 408,
        "shikenId": 10,
        "no": 18,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "公的年金等に係る雑所得の取扱い等に関する次の（ア）～（ウ）の記述について、適切なものには〇、不適切なものには×を選択してください。",
        "question2": "",
        "choice1": "公的年金等の収入金額が400 万円以下（すべてが源泉徴収の対象）の場合、公的年金等に係る雑所得以外の所得金額の合計が20 万円以下であるときは、所得税の確定申告は不要である。",
        "choice2": "公的年金等控除額は、公的年金等に係る雑所得以外の合計所得金額の多寡にかかわらず、公的年金等の収入金額の合計額に応じて計算される。",
        "choice3": "公的年金等以外の雑所得としてＦＸ取引に係る雑所得等があり、当該雑所得の金額に赤字が生じた場合、その赤字の金額と公的年金等に係る雑所得の金額を通算し、雑所得の金額を計算することができる。",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "公的年金等に係る雑所得",
        "important": ""
    },
    {
        "id": 409,
        "shikenId": 10,
        "no": 19,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "個人事業主の新城さんは、本年２月に建物を購入したが、営業開始が遅延し、同年４月１０日から事業の用に供している。新城さんの本年分の所得税における事業所得の計算上、必要経費に算入すべき減価償却費の金額として、正しいものはどれか。なお、建物は、事業にのみ使用しており、その取得価額は９，０００万円、法定耐用年数は５０年である。<br><br><img src='/img/set2/s19_1.png'/>",
        "question2": "",
        "choice1": "１，２００，０００円",
        "choice2": "１，３５０，０００円",
        "choice3": "１，６５０，０００円",
        "choice4": "２，７００，０００円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "減価償却費の計算",
        "important": ""
    },
    {
        "id": 410,
        "shikenId": 10,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "会社員の小岩さんの本年分の所得等が下記＜資料＞のとおりである場合、小岩さんが本年分の所得税の確定申告をする際における総所得金額として、最も適切なものはどれか。なお、▲が付された所得の金額は、その所得に損失が発生していることを意味するものとする。<br><br><img src='/img/set2/s20_1.png'/>",
        "question2": "",
        "choice1": "４１０万円",
        "choice2": "４３０万円",
        "choice3": "４５０万円",
        "choice4": "４９０万円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "損益通算の計算",
        "important": ""
    },
    {
        "id": 411,
        "shikenId": 10,
        "no": 21,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "下記＜資料＞は、中田さんの本年分の「給与所得の源泉徴収票（一部省略）」である。空欄（ア）に入る中田さんの本年分の所得税額として、正しいものはどれか。なお、中田さんには、本年において給与所得以外に申告すべき所得はなく、年末調整の対象となった所得控除以外に適用を受けることのできる所得控除はない。また、本年の定額減税および復興特別所得税は考慮しないこと。<br><br><img src='/img/set2/s21_1.png'/>",
        "question2": "",
        "choice1": "１９０，５００円",
        "choice2": "２５０，５００円",
        "choice3": "７３２，５００円",
        "choice4": "７９２，５００円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "給与所得の源泉徴収票の計算",
        "important": ""
    },
    {
        "id": 412,
        "shikenId": 10,
        "no": 22,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "星野さんは、本年 12 月に勤務先を退職する予定である。星野さんが受け取る退職一時金（下記＜資料＞参照）から源泉徴収された所得税額として、正しいものはどれか。なお、星野さんは、退職に際して「退職所得の受給に関する申告書」を適正に提出している。また、復興特別所得税は考慮しないこと。<br><br><img src='/img/set2/s22_1.png'/>",
        "question2": "",
        "choice1": "８５，０００円",
        "choice2": "２５２，５００円",
        "choice3": "５１２，５００円",
        "choice4": "５８２，５００円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "退職所得の所得税計算",
        "important": ""
    },
    {
        "id": 413,
        "shikenId": 10,
        "no": 23,
        "answerType": 8,
        "groupId": 1,
        "answer": "3,5,9",
        "score": "1,1,1",
        "question1": "下記の＜親族関係図 > において、民法の規定に基づく法定相続分に関する次の記述の空欄（ア）～（ウ）に入る適切な語句または数値を語群の中から選び、その番号を選択してください。なお、同じ語句または数値を何度選んでもよいこととする。<br><br><img src='/img/set2/s23_1.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "民法上の法定相続分",
        "important": ""
    },
    {
        "id": 414,
        "shikenId": 10,
        "no": 24,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "本年中に発生した下記の相続事例における相続税の課税価格の合計額として、正しいものはどれか。<br><br><img src='/img/set2/s24_1.png'/>",
        "question2": "",
        "choice1": "３，７００万円",
        "choice2": "４，０００万円",
        "choice3": "４，２００万円",
        "choice4": "４，５００万円",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の課税価格の計算",
        "important": ""
    },
    {
        "id": 415,
        "shikenId": 10,
        "no": 25,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "江夏豊子さん（５８歳）は、本年１１月に夫から居住用不動産（財産評価額２，８００万円）の贈与を受けた。豊子さんが贈与税の配偶者控除の適用を受けた場合の本年分の贈与税額として、正しいものはどれか。<br>なお、本年においては、このほかに豊子さんが受けた贈与はないものとする。また、納付すべき贈与税額が最も少なくなるように計算すること。<br><br><img src='/img/set2/s25_1.png'/>",
        "question2": "",
        "choice1": "１９万円",
        "choice2": "１１７万円",
        "choice3": "１５１万円",
        "choice4": "１９５万円",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の計算",
        "important": ""
    },
    {
        "id": 416,
        "shikenId": 10,
        "no": 26,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,2,1",
        "score": "1,1,1,1",
        "question1": "福本さんは、自宅（敷地および建物）、店舗（敷地および建物）、貸駐車場（敷地）を所有している。＜下記＞資料をもとに福本さんに相続が発生した場合、相続税の計算における小規模宅地等についての相続税の課税価格の計算の特例に関する次の記述（ア）～（エ）について適切なものには○、不適切なものには×を選択してください。なお、資料に記述がない要件はすべて満たしているものとして、一切考慮しないこと。<br><br><img src='/img/set2/s26_1.png'/>",
        "question2": "",
        "choice1": "福本さんの自宅敷地は、最大で３００㎡まで８０％の減額の適用を受けられる。",
        "choice2": "福本さんの店舗敷地は、最大で５００㎡まで８０％の減額の適用を受けられる。",
        "choice3": "福本さんの貸駐車場は、最大で２００㎡まで５０％の減額の適用を受けられる。",
        "choice4": "福本さんの自宅敷地と店舗敷地については、面積調整をせずに、それぞれ限度面積まで適用を受けられる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "小規模宅地等の特例",
        "important": ""
    },
    {
        "id": 417,
        "shikenId": 10,
        "no": 27,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "下記＜資料＞の宅地（貸家建付地）に係る路線価方式による相続税評価額の計算式として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><br><img src='/img/set2/s27_1.png'/>",
        "question2": "",
        "choice1": "１８０，０００円×１．００×２８６㎡×（１－６０％）",
        "choice2": "１８０，０００円×１．００×２８６㎡×（１－６０％×３０％×１００％）",
        "choice3": "１８０，０００円×１．００×２８６㎡×（１－７０％）",
        "choice4": "１８０，０００円×１．００×２８６㎡×（１－７０％×３０％×１００％）",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "宅地の評価",
        "important": ""
    },
    {
        "id": 418,
        "shikenId": 10,
        "no": 28,
        "answerType": 9,
        "groupId": 0,
        "answer": 702,
        "score": 2,
        "question1": "松原さんの過去のある年の給与明細等が以下の＜資料＞のとおりである場合、松原さんの可処分所得の金額を計算しなさい。なお、ある年における松原さんの収入は給与収入のみである。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set2/s28_1.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 419,
        "shikenId": 10,
        "no": 29,
        "answerType": 9,
        "groupId": 0,
        "answer": 502,
        "score": 2,
        "question1": "松原家のキャッシュフロー表の空欄（ア）に入る数値を計算しなさい。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><br><img src='/img/set2/s29_1.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 420,
        "shikenId": 10,
        "no": 30,
        "answerType": 9,
        "groupId": 0,
        "answer": 190,
        "score": 2,
        "question1": "　松原家の両親が考えている進学プランは下記のとおりである。下記＜条件＞および＜資料＞のデータに基づいて、松原家のキャッシュフロー表の空欄（イ）に入る教育費の予測数値を計算しなさい。なお、計算過程においては端数処理をせずに計算し、計算結果については万円未満を四捨五入すること。<br><br><img src='/img/set2/s30_1.png'/><br><br><img src='/img/set2/s30_2.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 421,
        "shikenId": 10,
        "no": 31,
        "answerType": 9,
        "groupId": 0,
        "answer": 9060000,
        "score": 2,
        "question1": "大和田さんは、有料老人ホームへの入居を検討しており、そのための資金として、５年後に１，０００万円を準備したいと考えている。５年間、年利２．０％で複利運用する場合、現在いくらの資金があればよいか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set2/s31_1.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 422,
        "shikenId": 10,
        "no": 32,
        "answerType": 9,
        "groupId": 0,
        "answer": 455000,
        "score": 2,
        "question1": "鈴木さんは、独立開業の準備資金として、１０年後に５００万円を準備しようと考えている。年利２．０％で複利運用しながら毎年年末に一定額を積み立てる場合、毎年いくらずつ積み立てればよいか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set2/s32_1.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 423,
        "shikenId": 10,
        "no": 33,
        "answerType": 9,
        "groupId": 0,
        "answer": 6917200,
        "score": 2,
        "question1": "長門さんは、住宅の購入資金準備として新たに積立てを開始する予定である。毎年年末に４０万円を積み立てるものとし、１５年間、年利２．０％で複利運用しながら積み立てた場合、１５年後の合計額はいくらになるか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set2/s33_1.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 424,
        "shikenId": 10,
        "no": 34,
        "answerType": 9,
        "groupId": 0,
        "answer": 9660,
        "score": 2,
        "question1": "ＦＰの谷本さんは、現時点における星野家（和弘さんと康子さん）のバランスシート分析を行うこととした。下表の空欄（ア）に入る数値を計算しなさい。<br><br><img src='/img/set2/s34_1.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "バランスシート",
        "important": ""
    },
    {
        "id": 425,
        "shikenId": 10,
        "no": 35,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "宮井麻紀さんは、夫の誠司さんが死亡した場合の公的年金の遺族給付について、ＦＰの清田さんに相談をした。仮に誠司さんが、本年９月に４７歳で在職中に死亡した場合に、誠司さんの死亡時点において麻紀さんが受け取ることができる公的年金の遺族給付の額として、正しいものはどれか。なお、遺族給付の計算に当たっては、下記＜資料＞の金額を使用することとする。<br><br><img src='/img/set2/s35_1.png'/>",
        "question2": "",
        "choice1": "１，３７１，７００円",
        "choice2": "１，６１１，０００円",
        "choice3": "１，８５０，３００円",
        "choice4": "１，９３０，１００円",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的年金の遺族給付の計算",
        "important": ""
    },
    {
        "id": 426,
        "shikenId": 10,
        "no": 36,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "宮井さん（４７歳）の健康保険料等に関する次の記述のうち、最も適切なものはどれか。なお、宮井さんは全国健康保険協会管掌健康保険（協会けんぽ）の被保険者である。また、健康保険料の計算に当たり、下記＜資料＞に基づくこと。<br><br><img src='/img/set2/s36_1.png'/>",
        "question2": "",
        "choice1": "宮井さんが負担した健康保険料は、全額が社会保険料控除の対象となる。",
        "choice2": "協会けんぽの一般保険料率は、全国一律である。",
        "choice3": "毎月の給与に係る健康保険料のうち、宮井さんの負担分は２３，５７５円である。",
        "choice4": "賞与に係る健康保険料については、全額を会社が負担する。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "健康保険料",
        "important": ""
    },
    {
        "id": 427,
        "shikenId": 10,
        "no": 37,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "宮井誠司さんの弟の泰典さん（３０歳）は、よりよい職を求め、大学卒業後８年間勤務していたＴＦ社を本年５月に自己都合退職した。求職活動中は雇用保険から基本手当を受給する予定であり、基本手当の受給手続きについてＦＰの清田さんに質問をした。清田さんが雇用保険の基本手当について説明する際に使用した下表の空欄（ア）～（エ）に当てはまる適切な語句の組み合わせとして、正しいものはどれか。<br><br><img src='/img/set2/s37_1.png'/>",
        "question2": "",
        "choice1": "（ア）６カ月 （イ）３カ月 （ウ）２週間 （エ）１年間",
        "choice2": "（ア）１２カ月 （イ）３カ月 （ウ）２週間 （エ）２年間",
        "choice3": "（ア）６カ月 （イ）１カ月 （ウ）４週間 （エ）２年間",
        "choice4": "（ア）１２カ月 （イ）１カ月 （ウ）４週間 （エ）１年間",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "雇用保険の基本手当",
        "important": ""
    },
    {
        "id": 428,
        "shikenId": 10,
        "no": 38,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "星野さんは、老齢年金の受給方法などについて、ＦＰの谷本さんに質問をした。公的年金の受給に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "老齢年金の請求書は、老齢年金の受給権が発生する者に対し、受給権が発生する年齢に達する月の３カ月前に事前送付される。",
        "choice2": "年金の請求手続きが遅れた場合、手続き前５年間分の年金は遡って支給されるが、５年を超える分については、原則として、時効により権利が消滅したとして支給されない。",
        "choice3": "老齢年金は原則として、受給権が発生した月の当月分から、受給権が消滅した月の前月分まで支給される。",
        "choice4": "年金の支払いは、通常は偶数月の１５日（１５日が金融機関の休業日に当たる場合は、直前の営業日）にその月の前月分および前々月分の２カ月分ずつが支給される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢年金の受給方法",
        "important": ""
    },
    {
        "id": 429,
        "shikenId": 10,
        "no": 39,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,1,2,2",
        "score": "1,1,1,1",
        "question1": "星野さんは、自分の老齢年金の受け取り方法について考えており、ＦＰの谷本さんに質問をした。星野さんの老齢年金の繰上げ受給および繰下げ受給に関する次の（ア）～（エ）の記述のうち、適切なものには〇、不適切なものには×を選択してください。",
        "question2": "",
        "choice1": "老齢基礎年金と老齢厚生年金の繰上げ請求は、異なる時期に別々に行うことができない。",
        "choice2": "老齢基礎年金と老齢厚生年金の繰下げ申出は、異なる時期に別々に行うことができる。",
        "choice3": "老齢厚生年金の支給の繰下げによる年金額の増額率は、最大で３０％となる。",
        "choice4": "老齢基礎年金とあわせて付加年金が受給できる場合であっても、付加年金は繰上げ受給により減額されることはなく、繰下げ受給により増額されることもない。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢年金の繰上げ支給と繰下げ支給",
        "important": ""
    },
    {
        "id": 430,
        "shikenId": 10,
        "no": 40,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "星野康子さんは、パートタイマーとして働いている勤務先で健康保険の被保険者となっているが、辞めた場合や勤務時間を減らした場合に健康保険の被扶養者となることができるか気になったため、夫の和弘さんが加入する全国健康保険協会管掌健康保険（協会けんぽ）の被扶養者の原則的な扱いについて、ＦＰの谷本さんに質問をした。被扶養者に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢に記述されていること以外は考慮しないものとする。",
        "question2": "",
        "choice1": "「６０歳未満の者が被扶養者になるには年収１０３万円未満、６０歳以上の者および一定の障害者が被扶養者となるには、年収１３０万円未満であることが要件の１つとなっています。」",
        "choice2": "「同居する者が被扶養者となるには、被保険者の収入よりも少ないことが要件の１つとなっており、被保険者の収入の２分の１以上であっても、原則として、被扶養者となることができます。」",
        "choice3": "「健康保険の被扶養者となった場合、保険料の負担はありません。」",
        "choice4": "「和弘さんが任意継続被保険者となった場合、康子さんは被扶養者となることはできません。」",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "協会けんぽの被扶養者",
        "important": ""
    },
    {
        "id": 431,
        "shikenId": 11,
        "no": 1,
        "answerType": 6,
        "groupId": 0,
        "answer": "ロ,チ,ホ,ヌ",
        "score": "1,1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set2/k1_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、Ａさんが本年度現時点で死亡した場合に妻Ｂさんが受給することができる公的年金制度からの遺族給付および遺族年金生活者支援給付金について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>Ⅰ　「Ａさんが現時点において死亡した場合、妻Ｂさんに対して遺族基礎年金および遺族厚生年金が支給されます。遺族基礎年金を受けられる遺族の範囲は、死亡した被保険者によって生計を維持されていた『子のある配偶者』または『子』です。『子』とは、（ ① ）歳到達年度の末日までの間にあるか、□□□歳未満で障害等級１級または２級に該当する障害の状態にあり、かつ、現に婚姻していない子を指します。Ａさんの死亡直後に妻Ｂさんが受給することができる遺族基礎年金の額は（ ② ）円（本年度価額）です。また、妻Ｂさんが遺族基礎年金を受給し、前年の所得が一定額以下である場合、妻Ｂさんは、遺族年金生活者支援給付金を受給することができ、その年額は（ ③ ）円（本年度価額）となります」<br><br>Ⅱ　「遺族厚生年金の額は、Ａさんの厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の□分の□相当額になります。ただし、その計算の基礎となる被保険者期間の月数が（ ④ ）に満たない場合、（ ④ ）とみなして年金額が計算されます」<br><br><img src='/img/set2/k1_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "遺族基礎年金および遺族年金生活者支援給付金",
        "important": ""
    },
    {
        "id": 432,
        "shikenId": 11,
        "no": 2,
        "answerType": 4,
        "groupId": 0,
        "answer": 491772,
        "score": 3,
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set2/k1_1.png'/>",
        "question2": "Ａさんが本年度現時点で死亡した場合、《設例》の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づき、妻Ｂさんが受給することができる遺族厚生年金の額を求めなさい（計算過程の記載は不要）。なお、年金額は本年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。<br><br><img src='/img/set2/k1_3.png'/>",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "遺族厚生年金の計算",
        "important": ""
    },
    {
        "id": 433,
        "shikenId": 11,
        "no": 3,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,2",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set2/k1_1.png'/>",
        "question2": "ファイナンシャル・プランナーのＭさんは、Ａさんに対して、公的年金制度からの障害給付や公的介護保険について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択してください。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。",
        "choice1": "「Ａさんが現時点で介護保険の保険給付を受けた場合、 原則として、自己負担割合は実際にかかった費用（食費、居住費等を除く）の３割です」",
        "choice2": "「仮に、Ａさんの障害の程度が国民年金法に規定される障害等級１級と認定され、障害基礎年金を受給することになった場合、その障害基礎年金の額（本年度価額）は、『831,700円× 1.5＋子の加算』の算式により算出されます」",
        "choice3": "「Ａさんが介護保険の保険給付を受けるためには、都道府県から、要介護認定または要支援認定を受ける必要があります。ただし、40歳以上 60歳未満の者は介護保険の第２号被保険者に該当するため、要介護状態または要支援状態となった原因が、末期がんや脳血管疾患などの加齢に伴う特定疾病によって生じたものでなければ、保険給付は受けられません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "障害給付・介護保険",
        "important": ""
    },
    {
        "id": 434,
        "shikenId": 11,
        "no": 4,
        "answerType": 4,
        "groupId": 0,
        "answer": "5.5,4.29",
        "score": "2,2",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set2/k2_1.png'/>",
        "question2": "《設例》の＜Ｘ社株式の関連情報＞および＜Ｘ社の財務データ＞に基づいて算出される次の①、②を求めなさい（計算過程の記載は不要）。〈答〉は、％表示の小数点以下第３位を四捨五入し、小数点以下第２位までを解答すること。小数点以下第２位が0の場合は小数点以下第１位まで回答すること。<br><br>①　51期における ROE（自己資本は50期と51期の平均を用いる）<br>②　51期における配当利回り",
        "choice1": "％",
        "choice2": "％",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式投資指標の計算",
        "important": ""
    },
    {
        "id": 435,
        "shikenId": 11,
        "no": 5,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,1",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set2/k2_1.png'/>",
        "question2": "ファイナンシャル・プランナーのＭさんは、Ａさんに対して、Ｘ社株式を購入する際の留意点等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択してください。",
        "choice1": "「配当を受け取るためには、権利確定日に株主として株主名簿に記載される必要があります。次の決算期末の配当を受け取るためには、権利確定日の３営業日前である９月 25日（木）までに買付けを行ってください」",
        "choice2": "「51期におけるＸ社株式の PBR は1.0倍を下回っていますが、PBR の１倍割れだけをもって、割安と判断するのは注意が必要です。PER 等の他の投資指標も併せて比較・検討するなど、多角的な視点が望まれます」",
        "choice3": "「Ａさんが特定口座（源泉徴収あり）においてＸ社株式を株価 1,400円で200株購入し、同年中に株価 2,000円で全株売却した場合、その他の取引や手数料等を考慮しない場合、売買益 12万円に対して20.315％相当額が源泉徴収等されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の投資指標・税",
        "important": ""
    },
    {
        "id": 436,
        "shikenId": 11,
        "no": 6,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,2",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set2/k2_1.png'/>",
        "question2": "ファイナンシャル・プランナーのＭさんは、Ａさんに対して、NISA の成長投資枠およびつみたて投資枠について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「つみたて投資枠に受け入れることができる商品は、所定の要件を満たすインデックス型の公募株式投資信託に限られています。Ｘ社株式をつみたて投資枠に受け入れることはできません」",
        "choice2": "「成長投資枠とつみたて投資枠は同時に利用することはできません」",
        "choice3": "「NISA の年間投資上限額は、成長投資枠は120万円、つみたて投資枠は240万円です」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "NISA",
        "important": ""
    },
    {
        "id": 437,
        "shikenId": 11,
        "no": 7,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set2/k3_1.png'/>",
        "question2": "A さんの本年分の所得税の課税に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「 A さんが X 証券会社の口座内で生じた譲渡所得の金額は必ず確定申告をしなければなりません。その際『特定口座年間取引報告書』の添付が必要です」",
        "choice2": "「 A さんは、退職金受給時に『退職所得の受給に関する申告書』を提出しており、退職金の額の20.42% 相当額が源泉徴収されているため、他の所得とあわせて確定申告をすることで所得税の還付を受けられる可能性があります」",
        "choice3": "「A さんは白色申告者ですが、不動産所得の損失の額を損益通算できます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の課税",
        "important": ""
    },
    {
        "id": 438,
        "shikenId": 11,
        "no": 8,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set2/k3_1.png'/>",
        "question2": "A さんの本年分の所得税の算出における所得控除に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「医療費控除については、年末調整では適用を受けることができないため、所得税の確定申告が必要となります」",
        "choice2": "「妻 B さんの給与収入が58万円を超えているため、A さんは配偶者控除の適用を受けられません」",
        "choice3": "「長女 C さんは特定扶養親族に該当します。A さんが適用を受けることができる扶養控除の控除額は63万円です」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 439,
        "shikenId": 11,
        "no": 9,
        "answerType": 4,
        "groupId": 0,
        "answer": "220,15,465",
        "score": "1,1,2",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set2/k3_1.png'/>",
        "question2": "Ａさんの本年分の所得金額について、次の①、②、③を求めなさい（計算過程の記載は不要）。また、〈答〉は万円単位とすること。<br><br><img src='/img/set2/k3_2.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得金額の計算",
        "important": ""
    },
    {
        "id": 440,
        "shikenId": 11,
        "no": 10,
        "answerType": 4,
        "groupId": 0,
        "answer": "210,840",
        "score": "2,2",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set2/k4_1.png'/>",
        "question2": "甲土地上に耐火建築物を建築する場合における次の①、②を求めなさい（計算過程の記載は不要）。<br><br>①　建蔽率の上限となる建築面積<br>②　容積率の上限となる延べ面",
        "choice1": "㎡",
        "choice2": "㎡",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建蔽率と容積率の計算",
        "important": ""
    },
    {
        "id": 441,
        "shikenId": 11,
        "no": 11,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,2",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set2/k4_1.png'/>",
        "question2": "Ｘ社が提案する事業用定期借地権方式に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択してください。",
        "choice1": "「事業用定期借地権等は、存続期間が10年以上 30年未満の事業用借地権と30年以上 50年未満の事業用定期借地権に区別されます。事業用定期借地権等の設定契約は、公正証書等の書面（電磁的記録を含む）でしなければなりません」",
        "choice2": "「Ａさんが、所有する宅地をＸ社に事業用借地権方式により貸し付ける場合、宅地建物取引業の免許が必要となります」",
        "choice3": "「Ｘ社が甲土地に書店チェーンの店舗を建設した場合、相続税額の計算上、甲土地は貸家建付地として評価されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "事業用定期借地権方式",
        "important": ""
    },
    {
        "id": 442,
        "shikenId": 11,
        "no": 12,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set2/k4_1.png'/>",
        "question2": "被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例（以下、「本特例」という）に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択してください。",
        "choice1": "「本特例の適用を受けた場合の特別控除の額は最高 3,000万円です。本特例と相続財産を譲渡した場合の取得費の特例（相続税の取得費加算の特例）は併用できます」",
        "choice2": "「本特例の適用を受けるための要件の１つとして、1981（昭和 56）年５月 31日以前に建築された家屋であることが挙げられます。実家の建物を取り壊して、甲土地を更地にした場合、本特例の適用を受けることはできませんので、本特例の適用を検討しているのであれば、建物は現況の空き家のままにしておいてください」",
        "choice3": "「本特例の適用要件の１つとして譲渡対価の額が１億円以下であることがあげられます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "空き家に係る譲渡所得の特例",
        "important": ""
    },
    {
        "id": 443,
        "shikenId": 11,
        "no": 13,
        "answerType": 4,
        "groupId": 0,
        "answer": "41,2500,20,110",
        "score": "1,1,1,1",
        "question1": "【第５問】 次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set2/k5_1.png'/>",
        "question2": "生前贈与に関する以下の文章の空欄①～④に入る最も適切な数値を答えなさい。<br><br>Ⅰ　「Ａさんが生前贈与を実行するにあたり、長女Ｃさんが暦年課税（各種非課税制度の適用はない）により、本年中にＡさんから現金 450万円の贈与を受けた 場合、贈与税額は（ ① ）万円となります」<br><br>Ⅱ　「Ａさんからの贈与について、長女 C さんが暦年課税制度ではなく、相続時精算課税制度を選択した場合、累計で特別控除（ ② ）万円までの贈与について贈与税は課されず、その額を超える部分については、一律（ ③ ）％の税率により贈与税が課されます。なお、2024年以降の相続時精算課税制度において、特別控除前に、暦年課税制度とは別枠で年間（ ④ ）万円を差し引くことができます」<br><br><img src='/img/set2/k5_2.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "％",
        "choice4": "万円",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の暦年課税方式、相続時精算課税制度",
        "important": ""
    },
    {
        "id": 444,
        "shikenId": 11,
        "no": 14,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "【第５問】 次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set2/k5_1.png'/>",
        "question2": "「直系尊属から教育資金の一括贈与を受けた場合の贈与税の非課税の特例」（以下、「本特例」という）に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択してください。",
        "choice1": "「孫Ｅさんおよび孫Ｆさんが本特例の適用を受ける場合、受贈者１人につき1,000万円までは贈与税が非課税となります。ただし、学習塾などの学校等以外の者に対して直接支払われる金銭は300万円が限度となります」",
        "choice2": "「孫Ｅさんおよび孫Ｆさんが本特例の適用を受けるためには、孫Ｅさん、孫Ｆさんが教育資金の贈与を受けた年の前年分の長女Ｃさんの所得税に係る合計所得金額が1,000万円以下であることが要件とされます」",
        "choice3": "「制度としては、本特例は相続時精算課税制度と併用することができますが、孫 E さんおよび孫Ｆさんは本年の1月 1日時点で18歳未満であるため、相続時精算課税制度は併用できません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "教育資金の一括贈与を受けた場合の贈与税非課税",
        "important": ""
    },
    {
        "id": 445,
        "shikenId": 11,
        "no": 15,
        "answerType": 6,
        "groupId": 0,
        "answer": "リ,ロ,ヘ",
        "score": "1,1,1",
        "question1": "【第５問】 次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set2/k5_1.png'/>",
        "question2": "Ａさんの相続等に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　「Ａさんの相続が現時点で開始した場合、Ａさんの相続における遺産に係る基礎控除額は（ ① ）万円となります」<br><br>Ⅱ　「生命保険に加入していないのであれば、契約者（＝保険料負担者）および被保険者をＡさん、死亡保険金受取人を相続人とする終身保険に加入されることをお勧めします。終身保険に加入後、Ａさんの相続が開始した場合、相続人が受け取る死亡保険金は（ ② ）万円を限度として、死亡保険金の非課税金額の規定の適用を受けることができます」<br><br>Ⅲ　「妻Ｂさんが自宅の敷地および建物を相続した場合、小規模宅地等についての相続税の課税価格の計算の特例の適用を受けることができます。その場合、自宅の敷地（相続税評価額 5,000万円）について、課税価格に算入すべき価額を（ ③ ）万円とすることができます」<br><br><img src='/img/set2/k5_3.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の計算",
        "important": ""
    },
    {
        "id": 446,
        "shikenId": 12,
        "no": 1,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,1",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set2/h1_1.png'/>",
        "question2": "はじめに、Ｍさんは、Ａさん夫妻に対して、公的年金制度からの老齢給付について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「原則として、会社員歴を有する1961年４月２日以降生まれの男性、1966年４月２日以降生まれの女性には特別支給の老齢厚生年金は支給されず、65歳から老齢基礎年金および老齢厚生年金を受給することになります」",
        "choice2": "「Ａさんおよび妻Ｂさんが希望すれば、66歳以後、老齢基礎年金および老齢厚生年金の繰下げ支給の申出をすることができます。仮に、Ａさんが68歳０カ月で老齢基礎年金の繰下げ支給の申出をした場合、年金の増額率は18.0％となり、繰下げ支給の上限年齢は75歳です」",
        "choice3": "「Ａさんおよび妻Ｂさんが希望すれば、老齢基礎年金および老齢厚生年金の繰上げ支給の申出をすることができ、減額率は１カ月につき0.4％となります。老齢基礎年金および老齢厚生年金の繰上げ支給の申出は同時にしなければならず、一生涯減額された年金額を受け取ることになります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢給付の支給開始年齢、繰上げ支給、繰下げ支給",
        "important": ""
    },
    {
        "id": 447,
        "shikenId": 12,
        "no": 2,
        "answerType": 6,
        "groupId": 0,
        "answer": "チ,ロ,ホ",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set2/h1_1.png'/>",
        "question2": "次に、M さんは、A さんに対して、公的保険について説明した。M さんが説明した次の文章の空欄①～③に入る最も適切な数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ．「仮に、A さんが X 社に引き続き勤務し、業務外の事由による負傷または疾病の療養のために労務に服することができず、連続して□□日間休業し、かつ、（①）日目以降の休業した日について事業主から賃金の支払いがなかった場合、所定の手続きにより、（①）日目以降の休業した日について、傷病手当金が支給されます」<br><br>Ⅱ．「傷病手当金の支給額は、休業 1日につき、原則として、傷病手当金の支給を始める日の属する月以前の直近の継続した12カ月間の各月の標準報酬月額を平均した額の30分の1に相当する額の（②）となり、その支給を開始した日から通算（③）を限度として支給されます。<br><br><img src='/img/set2/h1_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的医療保険",
        "important": ""
    },
    {
        "id": 448,
        "shikenId": 12,
        "no": 3,
        "answerType": 4,
        "groupId": 0,
        "answer": "781451,1270113",
        "score": "2,2",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set2/h1_1.png'/>",
        "question2": "最後に、Ｍさんは、Ａさんに対して、Ａさんが65歳以後に受給することができる公的年金制度からの老齢給付について説明した。《設例》の＜Ａさん夫妻に関する資料＞および下記の＜資料＞に基づき、次の①、②を求めなさい（計算過程の記載は不要）。なお、年金額は本年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。<br><br>①　原則として、Ａさんが65歳から受給することができる老齢基礎年金の年金額<br>②　原則として、Ａさんが65歳から受給することができる老齢厚生年金の年金額<br><br><img src='/img/set2/h1_3.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金および老齢厚生年金の計算",
        "important": ""
    },
    {
        "id": 449,
        "shikenId": 12,
        "no": 4,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,1",
        "score": "1,1,1",
        "question1": "【第２問】 次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set2/h2_1.png'/>",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、ＡさんやＢさんの保障の見直し方法と障害年金について説明した。Ｍさんが説明した次の記述①～③について、適切なものには◯印を、不適切なものには×印を選択してください。",
        "choice1": "「妻Ｂさんに会社員としての給与収入があるため、Ｂさんが専業主婦である場合に比べて、Ａさんが死亡した場合の必要保障額が少なくなりますが、妻Ｂさんが病気やケガ等で就業不能となった場合や離職した場合などの生活への影響が大きくなります。夫婦で行ってきた家事や育児等を外部の代行業者等の利用を踏まえると、Ａさんの生命保険だけでなく、妻Ｂさんの保障内容も検討する必要があると考えられます」",
        "choice2": "「仮に A さんが厚生年金の被保険者期間中に初診日のある傷病によって重度の障害状態となり、障害認定日において、国民年金の障害等級 1級～3級のいずれかに該当し、保険料納付要件を満たしている場合、障害基礎年金を請求することができます」",
        "choice3": "「仮に A さんが業務上の理由により、障害厚生年金と労働者補償保険法に基づく障害補償年金が支給される場合、障害厚生年金は全額支給され、障害補償年金は所定の調整率により減額されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "保障の見直し方法と障害年金",
        "important": ""
    },
    {
        "id": 450,
        "shikenId": 12,
        "no": 5,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,2,2",
        "score": "1,1,1,1",
        "question1": "【第２問】 次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set2/h2_1.png'/>",
        "question2": "次に、Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の保障内容や税務、見直しの注意点等について説明した。Ｍさんが説明した次の記述①～④について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「現在加入している生命保険を契約転換することができます。転換後契約の保険料は転換前契約の加入時の年齢により算出されるため、新規に加入する場合と比較して、保険料負担を抑えられます」",
        "choice2": "「生命保険の契約の際、傷病歴や現在の健康状態など、事実を正しく告知しましょう。告知受領権は生命保険募集人が有しており、募集人に対して口頭で告知すれば、正しく告知したことになります」",
        "choice3": "「先進医療特約では、契約日時点において厚生労働大臣により先進医療と定められているものであれば、療養を受けた時点において先進医療としての承認を取り消されたものであっても給付の対象となります」",
        "choice4": "「Ａさんが所定の就業不能状態となり、就業不能給付金を請求できない特別な事情がある場合には、指定代理請求人である妻ＢさんがＡさんに代わって請求することができます。妻Ｂさんが代理請求した場合、就業不能給付金は一時所得として扱われます」",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険総合",
        "important": ""
    },
    {
        "id": 451,
        "shikenId": 12,
        "no": 6,
        "answerType": 6,
        "groupId": 0,
        "answer": "ロ,ニ,リ",
        "score": "1,1,1",
        "question1": "【第２問】 次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set2/h2_1.png'/>",
        "question2": "最後に、Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の課税関係について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　「支払保険料のうち、終身保険特約および定期保険特約に係る保険料は一般の生命保険料控除の対象となり、就業不能サポート特約、入院特約および先進医療特約に係る保険料は介護医療保険料控除の対象となります。それぞれの控除の適用限度額は、所得税で40,000円、住民税で（ ① ）円です。また、一般の生命保険料控除、介護医療保険料控除および個人年金保険料控除を合わせた合計適用限度額は、所得税で120,000円、住民税で（ ② ）円となります」<br><br>Ⅱ　「提案の生命保険にはリビング・ニーズ特約が付加されているため、Ａさんが余命６カ月以内と判断された場合、所定の範囲内で、死亡保険金の一部または全部を生前に受け取ることができます。Ａさんが受け取る特約保険金は、（ ③ ）となります」<br><br><img src='/img/set2/h2_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の課税関係",
        "important": ""
    },
    {
        "id": 452,
        "shikenId": 12,
        "no": 7,
        "answerType": 6,
        "groupId": 0,
        "answer": "リ,ロ,ホ",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set2/h3_1.png'/>",
        "question2": "《設例》の＜資料１＞の生命保険を現時点で解約した場合のＸ社の経理処理（仕訳）について、 下記の＜条件＞を基に、空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br><img src='/img/set2/h3_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の経理処理",
        "important": ""
    },
    {
        "id": 453,
        "shikenId": 12,
        "no": 8,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,1",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set2/h3_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、＜資料１＞の定期保険の活用法について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには ×印を選択してください。",
        "choice1": "「当該生命保険を現時点で解約した場合、Ｘ社が受け取る解約返戻金は、運転資金、設備投資、退職金等、自由に活用できます」",
        "choice2": "「当該生命保険の単純返戻率（解約返戻金額÷払込保険料累計額）は、現時点よりも65歳時点のほうが高くなり、その後も、保険期間の終了直前まで上昇しつづけ、保険期間終了直前に急減し、保険期間終了時時点でゼロとなります」",
        "choice3": "「当該生命保険を現時点で払済終身保険に変更することができます。変更した事業年度において、経理処理が必要となり、解約した場合と同額の雑収入が計上されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "定期保険の活用法",
        "important": ""
    },
    {
        "id": 454,
        "shikenId": 12,
        "no": 9,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,1,2",
        "score": "1,1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set2/h3_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、《設例》の＜資料２＞の終身保険について説明した。Ｍさんが説明した次の記述①～④について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「当該生命保険の支払保険料は、その全額を資産に計上します。仮に、保険料払込期間満了時にＡさんが死亡した場合、Ｘ社は、それまで資産計上していた保険料積立金 4,180万円を取り崩し、死亡保険金 5,000万円との差額 820万円を雑収入として経理処理します」",
        "choice2": "「当該生命保険は、低解約返戻金型ではない終身保険に比べて保険料払込期間中の解約返戻金の水準が低く設定されています。そのため、保険料払込期間の途中で解約とならないよう、継続的な支払が可能な保険料であるかをご確認ください」",
        "choice3": "「Ａさんが勇退する際に、契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義変更することで、当該保険契約を役員退職金の一部または全部として支給することができます。Ａさん個人の保険として継続することにより、納税資金の確保や死亡保険金の非課税金額の規定の適用など、相続対策として活用することができます」",
        "choice4": "「Ｘ社が保険期間中に資金を必要とした場合、契約者貸付制度を利用することにより、当該生命保険を解約することなく、資金を調達することができます。Ｘ社が契約者貸付金を受け取った場合、当該保険契約は継続しているため、経理処理は必要ありません」",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "終身保険の特徴等",
        "important": ""
    },
    {
        "id": 455,
        "shikenId": 12,
        "no": 10,
        "answerType": 6,
        "groupId": 0,
        "answer": "リ,ハ,ヘ",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set2/h4_1.png'/>",
        "question2": "所得税における青色申告制度に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　「事業所得に係る取引を正規の簿記の原則に従い記帳し、その記帳に基づいて作成した貸借対照表、損益計算書その他の計算明細書を添付した確定申告書を e-Tax を利用して法定申告期限内に提出することにより、事業所得の金額の計算上、青色申告特別控除として最高（ ① ）万円を控除することができます。なお、青色申告者が備え付けるべき決算関係書類などの帳簿書類は、原則として（ ② ）年間保存しなければなりません」<br><br>Ⅱ　「青色申告者が受けられる税務上の特典として、青色申告特別控除のほかに、青色事業専従者給与の必要経費算入、純損失の３年間の繰越控除、純損失の繰戻還付、棚卸資産の評価について（ ③ ）を選択できることなどが挙げられます」<br><br><img src='/img/set2/h4_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "青色申告制度",
        "important": ""
    },
    {
        "id": 456,
        "shikenId": 12,
        "no": 11,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set2/h4_1.png'/>",
        "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「母Ｃさんの合計所得金額は48万円以下となりますので、Ａさんは母Ｃさんに係る扶養控除の適用を受けることができます。母Ｃさんに係る扶養控除の額は48万円となります」",
        "choice2": "「一時払養老保険の満期保険金に係る保険差益は、源泉分離課税の対象となりますので、確定申告をする必要はありません」",
        "choice3": "「Ａさんの場合、公的年金等の収入金額の合計額が60万円以下であるため、公的年金等に係る雑所得の金額は算出されません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税総合",
        "important": ""
    },
    {
        "id": 457,
        "shikenId": 12,
        "no": 12,
        "answerType": 4,
        "groupId": 0,
        "answer": "400000,200000,380000,142500",
        "score": "1,1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set2/h4_1.png'/>",
        "question2": "Ａさんの本年分の所得税の算出税額を計算した下記の表の空欄①～④に入る最も適切な数値を求めなさい。なお、予定納税や源泉徴収税等は考慮しないものとし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set2/h4_3.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の計算",
        "important": ""
    },
    {
        "id": 458,
        "shikenId": 12,
        "no": 13,
        "answerType": 4,
        "groupId": 0,
        "answer": "4,1500,3000,10",
        "score": "1,1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set2/h5_1.png'/>",
        "question2": "父Ｄさんの相続等に関する以下の文章の空欄①～④に入る最も適切な数値を答えなさい。<br><br>Ⅰ　「賃貸アパートを経営していた父Ｄさんが本年分の所得税について確定申告書を提出しなければならない場合に該当するとき、相続人は、原則として、相続の開始があったことを知った日の翌日から（ ① ）カ月以内に準確定申告書を提出しなければなりません」<br><br>Ⅱ　「弟Ｂさんが受け取る死亡保険金（3,000万円）のうち、相続税の課税価格に算入される金額は、（ ② ）万円となります」<br><br>Ⅲ　「自宅（実家）の敷地および建物をＡさんおよび弟Ｂさんが取得し、『被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例』の適用を受けた場合、譲渡所得の金額の計算上、それぞれ最高（ ③ ）万円の特別控除の適用を受けることができます」<br><br>Ⅳ　「相続税の申告書の提出期限は、原則として、相続の開始があったことを知った日の翌日から（ ④ ）カ月以内です。申告書の提出先は、父Ｄさんの死亡時の住所地を所轄する税務署長になります」",
        "choice1": "ヵ月",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "ヵ月",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続総合",
        "important": ""
    },
    {
        "id": 459,
        "shikenId": 12,
        "no": 14,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,2",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set2/h5_1.png'/>",
        "question2": "「小規模宅地等についての相続税の課税価格の計算の特例」（以下、「小規模宅地等の特例」という）および「被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例」（以下、空き家の譲渡の特例という）に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「Ａさんが実家の建物を取り壊して敷地のみを譲渡した場合、空き家の譲渡の特例の適用を受けることができなくなります。空き家の譲渡の特例の適用を受けることを検討している場合、建物は現況の空き家のままにしておいてください」",
        "choice2": "「自宅（実家）の敷地と賃貸アパートの敷地について、小規模宅地等の特例の適用を受けようとする場合、適用対象面積の調整はせず、それぞれの宅地等の適用対象の限度面積まで適用を受けることができます」",
        "choice3": "「空き家の譲渡の特例と『相続財産に係る譲渡所得の課税の特例（相続税の取得費加算の特例）』 は、重複して適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "小規模宅地等の特例等",
        "important": ""
    },
    {
        "id": 460,
        "shikenId": 12,
        "no": 15,
        "answerType": 4,
        "groupId": 0,
        "answer": "4800,310,930",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set2/h5_1.png'/>",
        "question2": "父Ｄさんの相続における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は１億 2,000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set2/h5_2.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の計算",
        "important": ""
    },
    {
        "id": 461,
        "shikenId": 13,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "公的医療保険に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "健康保険の被保険者の甥や姪が被扶養者になるためには、被保険者と同一世帯に属していることが必要である。",
        "choice2": "健康保険の被保険者資格を喪失した者は、資格喪失日の前日までの被保険者期間が継続して１年以上あるなどの所定の要件を満たせば、最長で２年間、健康保険の任意継続被保険者となることができる。",
        "choice3": "後期高齢者医療制度の被保険者が保険医療機関等の窓口で支払う一部負担金（自己負担額）の割合は、原則として、当該被保険者が現役並み所得者である場合は３割、それ以外の者は１割とされる。",
        "choice4": "健康保険や国民健康保険の被保険者が７０歳に達したときは、その被保険者資格を喪失し、後期高齢者医療制度の被保険者となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的医療保険",
        "important": ""
    },
    {
        "id": 462,
        "shikenId": 13,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "労働者災害補償保険（以下「労災保険」という）に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "労災保険の適用を受ける労働者には、雇用形態がアルバイトやパートタイマーである者は含まれない。",
        "choice2": "業務上の負傷または疾病は治癒したものの、身体に一定の障害が残った場合、その障害の程度が労災保険法に規定する障害等級に該当する場合、障害補償給付が受けられる。",
        "choice3": "労災保険の保険料を計算する際に用いる保険料率は、適用事業所の事業の種類による差異はない。",
        "choice4": "労災保険の特別加入制度において、適用事業所の事業主は、その営む事業において使用する労働者数の多寡にかかわらず、労災保険の対象となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "労働者災害補償保険",
        "important": ""
    },
    {
        "id": 463,
        "shikenId": 13,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "雇用保険の失業等給付に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "自己都合による離退職などの一般の受給資格者に支給される基本手当の所定給付日数は、被保険者期間が２０年以上の場合、１８０日である。",
        "choice2": "雇用保険の一般被保険者が失業した場合、基本手当を受給するためには、原則として、離職の日以前２年間に被保険者期間が通算して１２ヵ月以上あること等の要件を満たす必要がある。",
        "choice3": "雇用保険に係る保険料のうち、失業等給付に係る保険料は、被保険者の賃金総額に事業の種類に応じた雇用保険率を乗じて得た額となり、事業主がその全額を負担する。",
        "choice4": "高年齢雇用継続基本給付金の支給を受けるためには、一定の一般被保険者に対して支給対象月に支払われた賃金の額が、原則として６０歳到達時の賃金月額の８５％未満になっていることが必要である。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "雇用保険の失業等給付",
        "important": ""
    },
    {
        "id": 464,
        "shikenId": 13,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "公的年金の老齢給付に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "国民年金の保険料納付済期間が１０年以上あり、厚生年金保険の被保険者期間を有する者は、原則として、６５歳から老齢基礎年金および老齢厚生年金を受給することができる。",
        "choice2": "１９６１年（昭和３６年）４月２日以降に生まれた男性、１９６６年（昭和４１年）４月２日以降に生まれた女性は、老齢基礎年金の受給資格期間を満たし、厚生年金保険の被保険者期間を１年以上有していても、報酬比例部分のみの特別支給の老齢厚生年金の支給を受けることができない。",
        "choice3": "老齢厚生年金の繰下げ支給を申し出る場合、老齢基礎年金の繰下げ支給と同時に申し出なければならない。",
        "choice4": "付加年金の受給権者が老齢基礎年金の繰下げ支給の申出をした場合、付加年金の額についても繰下げによって増額される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的年金の老齢給付",
        "important": ""
    },
    {
        "id": 465,
        "shikenId": 13,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "厚生年金保険における離婚時の年金分割制度に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、「離婚等をした場合における特例」による標準報酬の改定を合意分割といい、「被扶養配偶者である期間についての特例」による標準報酬の改定を３号分割という。",
        "choice1": "老齢厚生年金を受給している者で、老齢厚生年金を減額される者の年金額は、分割請求があった日の属する月の翌月から改定される。",
        "choice2": "離婚の相手方から分割を受けた厚生年金保険の保険料納付記録（標準報酬月額・標準賞与額）に係る期間は、老齢基礎年金の受給資格期間に算入される。",
        "choice3": "合意分割および３号分割の請求期限は、原則として離婚成立の日の翌日から起算して５年以内である。",
        "choice4": "合意分割の対象となるのは、離婚当事者の婚姻期間中の厚生年金保険の保険料納付記録（標準報酬月額・標準賞与額）、３号分割の対象となるのは、１９８６年４月１日以降の国民年金の第３号被保険者であった期間における第３号被保険者の配偶者の厚生年金保険の保険料納付記録（標準報酬月額・標準賞与額）である。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "離婚時の年金分割制度",
        "important": ""
    },
    {
        "id": 466,
        "shikenId": 13,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "キャッシュレス決済の一般的な特徴等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "交通系や流通系の電子マネーやプリペイドカードは、カードやスマートフォンに事前にチャージしておき、商品やサービスの購入時にチャージ額から支払う決済手段であるが、チャージ方法はクレジットカードによる電子決済に限られる。",
        "choice2": "デビットカードは、商品やサービスの購入時に使用すると代金が原則として翌月に銀行口座から引き落とされる決済手段であり、残高不足になってもあらかじめ設定された一定額までは後払いで使用することができる。",
        "choice3": "スマートフォン決済のうち、二次元コードやバーコードを利用するコード決済は、支払いアプリをスマートフォンにインストールして銀行口座やクレジットカード等の情報を登録したうえで、店舗または自身のスマートフォン上の二次元コードやバーコードを認証して支払う決済手段である。",
        "choice4": "クレジットカードで商品やサービスを購入した場合の返済方法の一つである分割払いは、利用代金の支払回数を決め、その回数で代金を分割して支払う方法であり、5 回以上の分割払いでは手数料が発生する。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュレス決済",
        "important": ""
    },
    {
        "id": 467,
        "shikenId": 13,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "中小企業退職金共済、小規模企業共済および国民年金基金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "小売業を主たる事業として営む個人事業主が、小規模企業共済に加入するためには、常時使用する従業員数が５人以下でなければならない。",
        "choice2": "中小企業退職金共済の掛金は、原則として、事業主と従業員が折半して負担する。",
        "choice3": "国民年金基金の掛金は、加入員が確定拠出年金の個人型年金に加入している場合、個人型年金加入者掛金と合わせて月額６８, ０００円が上限となる。",
        "choice4": "国内に住所を有する６０歳以上６５歳未満の国民年金の任意加入被保険者や、日本国籍を有する者で、日本国内に住所を有しない２０歳以上６５歳未満の国民年金の任意加入被保険者は、国民年金基金に加入することができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老後資金準備で利用できる制度",
        "important": ""
    },
    {
        "id": 468,
        "shikenId": 13,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "確定拠出年金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "企業型年金で加入者が掛金を拠出できることを規約で定める場合、企業型年金加入者掛金の額は、その加入者にかかる事業主掛金の額を超える額とすることができる。",
        "choice2": "企業型年金を実施していない企業の従業員である個人型年金の加入者は、原則として給与からの天引きにより、事業主を経由して掛金を納付することができる。",
        "choice3": "老齢給付金を年金で受け取った場合、当該給付金は雑所得として所得税の課税対象となり、雑所得の金額の計算上、公的年金等控除額を控除することができる。",
        "choice4": "国民年金の第１号被保険者は、現時点で国民年金の保険料を納付していれば、過去に国民年金の保険料未納期間があっても、個人型年金に加入することができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "確定拠出年金",
        "important": ""
    },
    {
        "id": 469,
        "shikenId": 13,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "リタイアメントプランニング等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "一般に、金融機関のリバースモーゲージには、利用者が死亡し、担保物件の売却代金による借入金返済後に残る債務について、利用者の相続人がその返済義務を負う「ノンリコース型」と、返済義務を負わない「リコース型」がある。",
        "choice2": "将来、本人の判断能力が不十分になった場合に備えて、あらかじめ自らが選任した者と任意後見契約を締結する場合、必ず公正証書によって締結しなければならない。",
        "choice3": "２０２５年４月以降、すべての企業に対して６５歳までの雇用確保が義務づけられ、それまでは定年年齢を６５歳未満に定めている事業主は、６５歳までの雇用確保のため「定年の引上げ」「継続雇用制度の導入」「定年の定めの廃止」のいずれかの措置を講じなければならない。",
        "choice4": "高齢者の居住の安定確保に関する法律に定める「サービス付き高齢者向け住宅」の入居者は、「状況把握サービス」や「生活相談サービス」を受けることができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "リタイアメントプランニング",
        "important": ""
    },
    {
        "id": 470,
        "shikenId": 13,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "決算書に基づく経営分析指標に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "当座比率は、「当座資産÷流動負債×１００（％）」の算式によって求めることができ、一般に、この数値が高い方が望ましいとされる。",
        "choice2": "損益分岐点売上高は、「固定費÷限界利益率」の算式によって求めることができる。",
        "choice3": "自己資本比率（株主資本比率）は、「自己資本÷総資産×１００（％）」の算式によって求めることができ、一般に、この数値が高い方が財務の健全性が高いと判断される。",
        "choice4": "固定比率は、固定負債に対する固定資産の割合を示したものであり、一般に、この数値が高い方が財務の健全性が高いと判断される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "決算書に基づく経営分析指標",
        "important": ""
    },
    {
        "id": 471,
        "shikenId": 13,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "生命保険の保険料等の仕組みに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "責任準備金は、保険会社が、将来の保険金や給付金の支払財源として保険数理に基づいて算定し、積み立てておく準備金である。",
        "choice2": "保険会社が実際に要した事業費が、保険料を算定する際に見込んでいた事業費よりも多かった場合、費差益が生じる。",
        "choice3": "収支相等の原則は、保険会社が受け取る保険料等の総額が、保険会社が支払う保険金等の総額と等しくなるように保険料を算定する原則のことをいう。",
        "choice4": "終身保険について、保険料の算定に用いられる予定利率が引き下げられた場合、新規契約の保険料は高くなる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の保険料等の仕組み",
        "important": ""
    },
    {
        "id": 472,
        "shikenId": 13,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "個人年金保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "終身年金では、基本年金額や保険料払込期間、年金受取開始年齢など契約内容が同一で被保険者が同年齢の場合、被保険者が男性の方が女性よりも保険料は安くなる。",
        "choice2": "変額個人年金保険では、保険会社の特別勘定による保険料の運用成果によって、将来受け取る年金額等が変動するが、死亡給付金については基本保険金額が最低保証されている。",
        "choice3": "保証期間のない有期年金では、年金受取期間中に被保険者（＝年金受取人）が死亡した場合、それ以降の年金は支払われない。",
        "choice4": "確定年金では、年金受取開始日前に被保険者（＝年金受取人）が死亡した場合、死亡給付金受取人が契約時に定められた年金受取総額と同額の死亡給付金を受け取ることができる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "個人年金保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 473,
        "shikenId": 13,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "総合福祉団体定期保険および団体定期保険（Ｂグループ保険）の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、いずれも契約者は企業であるものとする。",
        "choice1": "総合福祉団体定期保険のヒューマン・ヴァリュー特約は、従業員の死亡等による企業の経済的損失に備えるものであり、その特約死亡保険金の受取人は、従業員の遺族ではなく企業となる。",
        "choice2": "総合福祉団体定期保険の契約締結に際しては、加入予定者の被保険者になることについての同意および保険約款に基づく告知が必要である。",
        "choice3": "団体定期保険（Ｂグループ保険）の死亡保険金額は、企業の退職金規程等で定められた死亡退職金の金額の範囲内で設定しなければならない。",
        "choice4": "団体定期保険（Ｂグループ保険）は、従業員等が任意で加入し、その従業員等が保険料も負担する。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "総合福祉団体定期保険と団体定期保険",
        "important": ""
    },
    {
        "id": 474,
        "shikenId": 13,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "個人年金保険の税金に関する次の記述のうち、最も適切なものはどれか。なお、いずれも契約者（＝保険料負担者）は個人であるものとする。",
        "choice1": "契約者と年金受取人が同一である個人年金保険の場合、毎年受け取る年金は雑所得として、公的年金等控除の対象となる。",
        "choice2": "契約者と年金受取人が異なる場合、年金受取人は年金支払開始時に年金受給権を取得したものとみなされ、年金受給権が贈与税の課税対象となる。",
        "choice3": "契約者と被保険者が異なる個人年金保険において、年金支払開始前に被保険者が死亡して契約者が受け取った死亡給付金は、相続税の課税対象となる。",
        "choice4": "一時払終身年金保険を契約から５年以内に解約したことにより契約者が受け取る解約返戻金は、源泉分離課税の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "個人年金保険の課税",
        "important": ""
    },
    {
        "id": 475,
        "shikenId": 13,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "住宅用建物および住宅用建物に収容している家財を対象とする火災保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
        "choice1": "家財を保険の対象として契約した場合、同一敷地内の車庫に駐車している自動車が火災により受けた損害は補償の対象となる。",
        "choice2": "火災保険の保険料は、対象となる住宅用建物の構造により、Ｍ構造、Ｔ構造、Ｈ構造の３つに区分されて算定され、保険料は、Ｍ構造が最も安く、次いでＴ構造、Ｈ構造が最も高い。",
        "choice3": "家財を保険の対象として契約した場合、開放していた窓から雨が吹き込み、家財が濡れた損害は補償の対象となる。",
        "choice4": "住宅用建物を保険の対象として契約した場合、時間の経過により建物の壁に発生したカビによる損害は補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "火災保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 476,
        "shikenId": 13,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "傷害保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
        "choice1": "普通傷害保険では、細菌性食中毒は補償の対象となる。",
        "choice2": "家族傷害保険の被保険者は、被保険者本人および契約時の配偶者、本人または配偶者と生計を一にする同居の親族および別居の未婚の子となる。",
        "choice3": "交通事故傷害保険では、道路通行中または交通乗用具に搭乗中の交通事故および交通乗用具の火災によるケガを補償の対象としており、エレベーターやエスカレーターも交通乗用具に含まれる。",
        "choice4": "海外旅行保険、国内旅行傷害保険では、旅行中の地震によるケガは補償の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "傷害保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 477,
        "shikenId": 13,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "個人を契約者（＝保険料負担者）とする損害保険の税金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "新たに損害保険会社と契約した自らを被保険者とする所得補償保険や医療保険の保険料は、介護医療保険料控除の対象とならない。",
        "choice2": "新たに住宅用建物および家財を保険の対象とする火災保険に地震保険を付帯して加入した場合、火災保険および地震保険に係る保険料はともに地震保険料控除の対象となる。",
        "choice3": "契約者と被保険者が同一人である自動車保険の人身傷害（補償）保険において、被保険者が自動車事故で死亡した場合、その遺族が受け取った死亡保険金は、過失割合にかかわらず、その全額が非課税となる。",
        "choice4": "契約者の配偶者が不慮の事故で死亡したことにより、契約者が受け取った家族傷害保険の死亡保険金は、一時所得として課税の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "個人契約の損害保険の税金",
        "important": ""
    },
    {
        "id": 478,
        "shikenId": 13,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "法人を契約者（＝保険料負担者）とする損害保険の保険料や保険金の経理処理に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "法人が所有する自動車で従業員が業務中に起こした対人事故により、その相手方に保険会社から自動車保険の対人賠償保険金が直接支払われた場合、法人は当該保険金に関して経理処理する必要はない。",
        "choice2": "すべての役員・従業員を被保険者とする労働災害総合保険を契約した場合、支払った保険料の全額を損金の額に算入することができる。",
        "choice3": "すべての役員・従業員を被保険者とする積立普通傷害保険を契約した場合、支払った保険料の全額を損金の額に算入することができる。",
        "choice4": "法人が所有する倉庫建物が火災で焼失し、受け取った火災保険の保険金で同一事業年度内に代替の倉庫建物を取得した場合、所定の要件に基づき圧縮記帳が認められる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "法人契約の損害保険の経理処理",
        "important": ""
    },
    {
        "id": 479,
        "shikenId": 13,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "損害保険を活用した家庭のリスク管理に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "国内旅行中の飲食による細菌性食中毒で入院や通院をするリスクを考慮して、国内旅行傷害保険を契約した。",
        "choice2": "生計を一にする子の自転車運転中の事故により他人にケガをさせて法律上の損害賠償責任を負うリスクを考慮して、家族傷害保険に個人賠償責任補償特約を付帯して契約した。",
        "choice3": "勤めている会社が倒産することで失業してしまい、その結果、今の所得を失うリスクを考慮して、所得補償保険を契約した。",
        "choice4": "海岸近くに自宅を新築したので、地震による津波で自宅が損壊するリスクを考慮して、火災保険に地震保険を付帯して契約した。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "損害保険を活用した家庭のリスク管理",
        "important": ""
    },
    {
        "id": 480,
        "shikenId": 13,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "生命保険等を活用した法人の福利厚生に係るアドバイスに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「会社の休業補償規程に基づく従業員に支給する休業補償給付の原資を準備したい」という顧客に対して、団体就業不能保障保険の活用をアドバイスした。",
        "choice2": "「従業員の自助努力による財産形成を支援したい」という顧客に対して、財形貯蓄積立保険の活用をアドバイスした。",
        "choice3": "「従業員の死亡時に支給する死亡退職金の原資を準備したい」という顧客に対して、養老保険の活用をアドバイスした。",
        "choice4": "「従業員の定年退職時に支給する退職金の原資を準備したい」という顧客に対して、総合福祉団体定期保険の活用をアドバイスした。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険等を活用した法人の福利厚生",
        "important": ""
    },
    {
        "id": 481,
        "shikenId": 13,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "日本円・米ドル間の為替相場の変動要因等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "米国の物価が日本と比較して相対的に上昇することは、一般に、円安米ドル高要因となる。",
        "choice2": "購買力平価説によれば、米国と日本に同じ財があり、その財を米国では２米ドル、日本では２５０円で買える場合、為替レートは１米ドル＝１２５円が妥当と考える。",
        "choice3": "米国の景気が日本と比較して相対的に景気がよく、日本円が売られて、米ドルが買われる動きが多くなることは、一般に、円安ドル高の要因となる。",
        "choice4": "米国が政策金利を引き上げ、日本との金利差が拡大することは、一般に、円安米ドル高要因となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "為替相場の変動要因",
        "important": ""
    },
    {
        "id": 482,
        "shikenId": 13,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "投資信託の一般的な運用手法等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "マクロ的な環境要因等を基にまず国別組入比率や業種別組入比率などを決定し、その比率に応じて、個別銘柄を組み入れてポートフォリオを構築する手法をトップダウン・アプローチという。",
        "choice2": "リサーチによって銘柄を選定し、その積上げによってポートフォリオを構築する手法をボトムアップ・アプローチという。",
        "choice3": "企業の将来の売上高や利益の成長性が市場平均よりも高い銘柄を組み入れて運用するグロース運用は、ＰＥＲやＰＢＲが低く、配当利回りの高い銘柄中心のポートフォリオとなる傾向がある。",
        "choice4": "ベンチマークの動きにできる限り連動することで、同等の運用収益率を得ることを目指すパッシブ運用は、アクティブ運用に比べて運用コストが低くなる傾向がある。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "投資信託の一般的な運用手法",
        "important": ""
    },
    {
        "id": 483,
        "shikenId": 13,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "固定利付債券の利回り（単利・年率）と市場金利の変動との関係に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、手数料、経過利子、税金等については考慮しないものとする。<br><br>償還年限が１０年、表面利率が０. ５％の固定利付債券（以下「債券Ａ」という）が額面１００円当たり１００円で新規に発行された。発行から４年後に中央銀行の金融政策により市場金利が上昇した場合、この時点で債券Ａを購入した場合の最終利回りは０．５％よりも（ ア ）。<br>また、債券Ａを新規発行時に購入し、発行から４年後に売却する場合の所有期間利回りは０. ５％よりも（ イ ）。",
        "choice1": "（ア）高くなる　（イ）高くなる",
        "choice2": "（ア）高くなる　（イ）低くなる",
        "choice3": "（ア）低くなる　（イ）高くなる",
        "choice4": "（ア）低くなる　（イ）低くなる",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券の利回りと市場金利の変動との関係",
        "important": ""
    },
    {
        "id": 484,
        "shikenId": 13,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "株式の信用取引に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "制度信用取引の対象となる銘柄は、証券取引所の規則等に基づいて選定されたものに限られる。",
        "choice2": "一般信用取引の建株を制度信用取引の建株に変更することはできないが、制度信用取引の建株を一般信用取引の建株に変更することはできる。",
        "choice3": "一般信用取引では、投資家が証券会社から貸付けを受けた金銭や株式を3ヵ月以内に返済しなければならない。",
        "choice4": "信用取引で売建てした場合、反対売買により決済する差金決済の方法でしか決済できない。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の信用取引",
        "important": ""
    },
    {
        "id": 485,
        "shikenId": 13,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "下記＜Ａ社のデータ＞に基づき算出されるＡ社株式の投資指標に関する次の記述のうち、最も適切なものはどれか。<br><br><img src='/img/set3/1_25.png'/>",
        "choice1": "ＰＥＲ（株価収益率）は、２０. ０倍である。",
        "choice2": "ＰＢＲ（株価純資産倍率）は、５．０倍である。",
        "choice3": "ＲＯＥ（自己資本利益率）は、２５. ０％である。",
        "choice4": "配当利回りは、３. ０％である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の投資指標の計算",
        "important": ""
    },
    {
        "id": 486,
        "shikenId": 13,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "個人（居住者）が国内の金融機関等を通じて行う外貨建て金融商品の取引等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "円換算特約がついた生命保険契約では、為替変動リスクがないため、将来受け取る保険金等が支払った保険料よりも少なくなることはない。",
        "choice2": "外貨預金の払戻し時において、預金者が外貨を円貨に換える場合に適用される為替レートは、預入金融機関が提示する対顧客直物電信買相場（ＴＴＢ）である。",
        "choice3": "リバース・デュアル・カレンシー債は、購入代金の払込みおよび利払いが円貨で、償還金の支払いが外貨で行われる。",
        "choice4": "外国為替証拠金取引では、証拠金にあらかじめ決められた倍率を掛けた金額まで売買できるが、倍率の上限は各取扱業者が決めており、法令による上限の定めはない。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨建て金融商品の取引",
        "important": ""
    },
    {
        "id": 487,
        "shikenId": 13,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "オプション取引に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "コール・オプション、プット・オプションの売り手は、買い手に対してプレミアム（オプション料）を支払う。",
        "choice2": "満期までの残存期間が長い方が短い場合に比べて、プレミアム（オプション料）は低くなる。",
        "choice3": "原資産価格が上昇していく場合、コール・オプションのプレミアム（オプション料）は高くなり、プット・オプションのプレミアム（オプション料）は低くなる。",
        "choice4": "オプション取引において、買い手の損失は限定されないが、売り手の損失はオプション料に限定される。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "オプション取引",
        "important": ""
    },
    {
        "id": 488,
        "shikenId": 13,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "アセットアロケーションに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "アセットアロケーションとは、投資資金を複数の資産クラス（株式、債券および不動産等）に配分することである。",
        "choice2": "現代ポートフォリオ理論の一般的な考え方によれば、運用成果に与える影響は、資産クラスの配分よりも、個別銘柄の選択や売買のタイミング等の方が大きいとされる。",
        "choice3": "運用期間を通して、定められた各資産クラスの投資金額の配分比率を維持する方法の一つとして、値上がりした資産クラスを売却し、値下がりした資産クラスを購入するリバランスという方法がある。",
        "choice4": "各資産クラスの投資金額ではなくリスク量が同等になるように配分比率を調整するリスクパリティ運用（戦略）においては、特定の資産クラスのボラティリティが上昇した場合、当該資産を売却する。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "アセットアロケーション",
        "important": ""
    },
    {
        "id": 489,
        "shikenId": 13,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "ＮＩＳＡのつみたて投資枠に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "ＮＩＳＡのつみたて投資枠を利用できるのは１月１日現在２０歳以上である居住者等に限られる。",
        "choice2": "ＮＩＳＡのつみたて投資枠の対象商品は、所定の要件を満たす、長期の積立・分散投資に適した一定の公募株式投資信託、ＥＴＦ、Ｊ―ＲＥＩＴ等に限られる。",
        "choice3": "ＮＩＳＡのつみたて投資枠は非課税期間に制限がない。",
        "choice4": "ＮＩＳＡのつみたて投資枠の年間投資上限額は２４０万円である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "NISA",
        "important": ""
    },
    {
        "id": 490,
        "shikenId": 13,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "金融商品の取引に係る各種法令に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "外国為替証拠金取引は、金融サービス提供法における金融商品の販売に該当する取引であるが、ゴルフ会員権や金は金融サービス提供法の重要事項説明の対象外である。",
        "choice2": "金融商品取引法では、金融商品取引契約を締結しようとする金融商品取引業者等は、あらかじめ顧客（特定投資家を除く）に契約締結前交付書面を交付しなければならないとされているが、顧客から交付を要しない旨の意思表示があった場合には、金融商品取引業者等に対する書面交付義務は免除される。",
        "choice3": "犯罪収益移転防止法では、金融機関等の特定事業者が法人顧客と取引を行う場合、原則として、法人の実質的支配者および取引担当者双方の本人特定事項の確認が必要となる。",
        "choice4": "金融商品取引法では、金融商品取引業者等が行う金融商品取引業の内容に関する広告等をする場合、金融商品取引行為を行うことによる利益の見込みなどについて、著しく事実に相違する表現をし、または著しく人を誤認させるような表示をしてはならないとされている。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金融商品の取引に係る各種法令",
        "important": ""
    },
    {
        "id": 491,
        "shikenId": 13,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "所得税における各種所得に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "退職所得の金額（特定役員退職手当等､ 短期退職手当等に係るものを除く）は、「退職手当等の収入金額－退職所得控除額」の算式により計算される。",
        "choice2": "給与所得の金額は、原則として「給与等の収入金額－給与所得控除額」の算式により計算され、給与所得控除額は最低４８万円が保証され、収入金額が８５０万円を超える場合は１９５万円となる。",
        "choice3": "一時所得の金額は、「（一時所得に係る総収入金額－その収入を得るために支出した金額の合計額－特別控除額）×１／２」の算式により計算される。",
        "choice4": "不動産所得の金額は、原則として「不動産所得に係る総収入金額－必要経費」の算式により計算される。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税における各種所得",
        "important": ""
    },
    {
        "id": 492,
        "shikenId": 13,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "所得税における損益通算に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "金地金を譲渡したことによる譲渡所得の損失は、他の各種所得の金額と損益通算することができる。",
        "choice2": "賃貸アパート（国内）の土地および建物を譲渡したことによる譲渡所得の損失の金額は、給与所得の金額と損益通算することができる。",
        "choice3": "青色申告の承認を受けていない納税者の事業所得の金額の計算上生じた損失の金額は、他の各種所得の金額と損益通算することができない。",
        "choice4": "別荘を譲渡したことによる譲渡所得の金額の計算上生じた損失の金額は、他の各種所得の金額と損益通算することができない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "損益通算",
        "important": ""
    },
    {
        "id": 493,
        "shikenId": 13,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税における所得控除に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "控除対象扶養親族のうち、その年の１２月３１日時点の年齢が１９歳以上２３歳未満の者を特定扶養親族といい、その者に係る扶養控除の額は５８万円である。",
        "choice2": "納税者が加入している健康保険の被扶養者となっていて内縁関係にあると認められる者は、配偶者控除の対象とならない。",
        "choice3": "配偶者控除および配偶者特別控除の控除額は、控除を受ける納税者本人の合計所得金額に応じて異なる。",
        "choice4": "年の途中で死亡した者が、その死亡の時において控除対象扶養親族に該当している場合には、納税者は扶養控除の適用を受けることができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 494,
        "shikenId": 13,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。なお、選択肢記載以外の要件は満たしているものとする。",
        "choice1": "納税者が生命保険の保険料を支払った場合、支払った保険料の多寡にかかわらず、その年中に支払った全額を生命保険料控除として控除することができる。",
        "choice2": "納税者が医療費を支払った場合、支払った医療費の多寡にかかわらず、その年中に支払った全額を、医療費控除として控除することができる。",
        "choice3": "納税者が本人の確定拠出年金の個人型年金の掛金を支払った場合、支払った掛金の多寡にかかわらず、その年中に支払った全額を社会保険料控除として控除することができる。",
        "choice4": "納税者が自己、生計を一にする配偶者、親族に係る社会保険料を支払った場合、支払った社会保険料の多寡にかかわらず、その年中に支払った全額を、社会保険料控除として控除することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 495,
        "shikenId": 13,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税における住宅借入金等特別控除（以下「住宅ローン控除」という）に関する次の記述のうち、最も不適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。",
        "choice1": "中古住宅を取得した場合でも、一定の耐震基準に適合するものは、住宅ローン控除の適用を受けることができる。",
        "choice2": "給与所得者が住宅ローン控除の適用を受けようとする場合、最初の年分は確定申告が必要となるが、２年目以降は年末調整により適用できる。",
        "choice3": "住宅ローン控除の適用を受けていた者が、住宅ローンの一部繰上げ返済を行い、住宅ローンの償還期間が当初の償還の日から１０年未満となった場合であっても、残りの控除期間について、住宅ローン控除の適用を受けることができる。",
        "choice4": "住宅ローン控除の適用を受けていた者が、転勤等のやむを得ない事由により転居したため、取得した住宅を居住の用に供しなくなった場合、翌年以降に再び当該住宅を居住の用に供すれば、原則として再入居した年以降の控除期間内については住宅ローン控除の適用を受けることができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 496,
        "shikenId": 13,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税の青色申告に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "青色申告の適用を受けることができる者は、不動産所得、事業所得、雑所得を生ずべき業務を行う者で、納税地の所轄税務署長の承認を受けた者である。",
        "choice2": "青色申告者は、原則として７年間（一部５年間）、住所地もしくは居所地または事業所等に総勘定元帳その他の一定の帳簿を保存しなければならない。",
        "choice3": "前年からすでに業務を行っている者が、本年分から新たに青色申告の適用を受けようとする場合、その承認を受けようとする年の３月３１日までに「青色申告承認申請書」を納税地の所轄税務署長に提出しなければならない。",
        "choice4": "青色申告を取りやめようとする者は、その年の３月１５日までに「青色申告の取りやめ届出書」を納税地の所轄税務署長に提出しなければならない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "青色申告",
        "important": ""
    },
    {
        "id": 497,
        "shikenId": 13,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "法人税の損金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "役員退職給与を損金の額に算入するためには、事前に所定の時期に確定額を支給する旨の定めの内容を税務署長に届け出なければならない。",
        "choice2": "会社が役員に対して定期同額給与を支給した場合、不相当に高額な部分の金額など一定のものを除き、その会社の所得金額の計算上損金の額に算入される。",
        "choice3": "国または地方公共団体に対して支払った寄附金の額（確定申告書に明細を記載した書類を添付している）は、損金の額に算入することができる。",
        "choice4": "損金の額に算入される租税公課のうち、事業税については、原則としてその事業税に係る納税申告書を提出した日の属する事業年度の損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人税の損金",
        "important": ""
    },
    {
        "id": 498,
        "shikenId": 13,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "法人税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "過去に行った法人税の確定申告について、計算の誤りにより、納付した税額が過大であったことが判明した場合、原則として、法定申告期限から５年以内に限り、更正の請求をすることができる。",
        "choice2": "法人が従業員の業務遂行中の交通違反に係る反則金を負担した場合、その負担金は、損金の額に算入することができない。",
        "choice3": "１人当たり５，０００円以下の得意先等との飲食費であることを条件に、必要とされる書類等を保存していれば、税法上の交際費等に該当せず、その全額を損金の額に算入することができる。",
        "choice4": "期末資本金の額等が１億円以下の一定の中小法人が支出した交際費は、年８００万円までの金額または飲食費の５０％のいずれか多い金額までを損金に算入することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人税",
        "important": ""
    },
    {
        "id": 499,
        "shikenId": 13,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "消費税の適格請求書等保存方式（インボイス制度）に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "適格請求書には、適格請求書発行事業者の氏名または名称および税率ごとに区分した消費税額等の記載が必要とされるが、登録番号の記載は任意である。",
        "choice2": "適格請求書として必要とされる事項が記載された書類は、請求書として発行されたものだけが該当し、納品書や領収書等の名称で発行されたものは適格請求書に該当しない。",
        "choice3": "適格請求書発行事業者の登録を受けようとする事業者は、適格請求書発行事業者の登録申請書を、居住地の市区町村役場に提出しなければならない。",
        "choice4": "適格請求書発行事業者の登録に係る効力は、適格請求書発行事業者登録簿に登載された日から生じる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "消費税",
        "important": ""
    },
    {
        "id": 500,
        "shikenId": 13,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "決算書および法人税申告書に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "貸借対照表は、企業の一会計期間における経営成績を示す決算書であり、企業の経営成績について収益と費用とを対比して、その差額として利益を示す財務諸表の１つである。",
        "choice2": "損益計算書は、一時点における企業資本の運用形態である資産と、その調達源泉である負債、純資産の構成を示す計算書類である。",
        "choice3": "決算書における当期純利益と法人税申告書における事業年度の所得金額は、通常一致しない。",
        "choice4": "キャッシュフロー計算書は、キャッシュ（現金および現金同等物）を営業活動、投資活動、財務活動の３つに区分してその収支を計算し、キャッシュの増減を示す会社法上の計算書類の１つである。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "決算書および法人税申告書",
        "important": ""
    },
    {
        "id": 501,
        "shikenId": 13,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "不動産の登記や調査に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "不動産の登記記録において、土地の所有者とその土地上の建物の所有者が異なる場合は、その土地の登記記録に借地権設定の登記がなくても、借地権が設定されていることがある。",
        "choice2": "不動産登記には公信力がないため、登記記録を確認し、その登記記録の内容が真実であると信じて取引した場合、その登記記録の内容が真実と異なっていても法的な保護を受けることができない。",
        "choice3": "登記の目的が抵当権の設定である場合、不動産の登記記録の権利部甲区に、債権額や抵当権者の氏名または名称などが記載される。",
        "choice4": "公図は登記所に備え付けられており、対象とする土地の位置関係等を確認する資料として有用である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の登記や調査",
        "important": ""
    },
    {
        "id": 502,
        "shikenId": 13,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "不動産鑑定評価基準における不動産の価格を求める鑑定評価の手法に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "不動産の価格を求める鑑定評価の基本的な手法は、原価法、収益還元法および取引事例比較法に大別される。",
        "choice2": "不動産の鑑定評価の手法のうち、原価法は、既成市街地の土地の評価において適用できない。",
        "choice3": "収益還元法は、実際に賃貸の用に供されていない自用の不動産の価格を求める際には適用することができない。",
        "choice4": "取引事例比較法は、多数の取引事例を収集して、適切な事例を選択し、これらの取引価格に事情補正および時点修正ならびに地域要因の比較および個別的要因の比較を行って求められた価格を比較考量して、対象不動産の価格を求める手法である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の鑑定評価の手法",
        "important": ""
    },
    {
        "id": 503,
        "shikenId": 13,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "不動産の売買契約に係る民法の規定に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
        "choice1": "売買契約において、売主、買主の双方の責めに帰することができない事由により、売主が売買の目的物を引き渡すことができなくなった場合、買主は売買代金の支払を拒むことができる。",
        "choice2": "買主が売主に解約手付を交付した場合、買主が代金を支払った後であっても、売主は、自らが契約の履行に着手するまでは、受領した手付の倍額を買主に現実に提供して契約を解除することができる。",
        "choice3": "共有名義となっている建物について、自己が有している持分を第三者に譲渡するときは、他の共有者全員の同意を得なければならない。",
        "choice4": "不動産について二重に売買契約が締結された場合、当該複数の買主間においては、原則として、売買契約を先に締結した者が当該不動産の所有権を取得する。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の売買契約に係る民法の規定",
        "important": ""
    },
    {
        "id": 504,
        "shikenId": 13,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、同法第２２条の借地権を一般定期借地権といい、同法第２２条から第２４条の定期借地権等以外の借地権を普通借地権という。",
        "choice1": "普通借地権の存続期間は３０年とされているが、当事者が契約でこれより短い期間を定めたときは、その期間とする。",
        "choice2": "普通借地権の当初の存続期間が満了する場合、借地上に建物が存在しなくても、借地権者が借地権設定者に契約の更新を請求したときは、従前の契約と同一の条件（期間を除く）で契約を更新したものとみなされる。",
        "choice3": "一般定期借地権において、契約の更新および建物の築造による存続期間の延長がなく、建物等の買取りの請求をしないこととする旨を定める特約は、公正証書によってしなければならない。",
        "choice4": "一般定期借地権は、居住用および事業用の建物の所有を目的として、５０年以上の存続期間を定めて設定することができる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "借地",
        "important": ""
    },
    {
        "id": 505,
        "shikenId": 13,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "建築物の敷地が異なる建蔽率および容積率の地域にわたる場合、その敷地の全部について、敷地の過半の属する地域の建蔽率および容積率が適用される。",
        "choice2": "工業地域および工業専用地域内には、原則として、住宅を建てることはできない。",
        "choice3": "建築物の敷地が接する前面道路の幅員が１２ｍ未満である場合、容積率の上限は、指定容積率と前面道路の幅員に一定の数値を乗じて求めた容積率のいずれか高い方が適用される。",
        "choice4": "道路斜線制限は、すべての用途地域および用途地域の指定がない区域で適用される。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築基準法",
        "important": ""
    },
    {
        "id": 506,
        "shikenId": 13,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "集会において、区分所有者および議決権の各４分の３以上の多数により、建替えの決議をすることができる。",
        "choice2": "区分所有法が定める場合を除いて、専有部分と共用部分を分離処分することはできず、規約で定める場合を除き、専有部分と敷地利用権（数人で有する所有権その他の権利である場合）は分離処分できない。",
        "choice3": "区分所有者以外の専有部分の占有者は、建物またはその敷地もしくは附属施設の使用方法について、区分所有者が規約または集会の決議に基づいて負う義務と同一の義務を負う。",
        "choice4": "共用部分に対する区分所有者の共有持分は、規約に別段の定めがない限り、各共有者の専有部分の床面積の割合による。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "区分所有法",
        "important": ""
    },
    {
        "id": 507,
        "shikenId": 13,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "不動産の取得に係る税金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "贈与により取得した不動産について相続時精算課税制度の適用を受けた場合、相続により取得したものとみなされるため不動産取得税は課されない。",
        "choice2": "売買によって不動産を取得した場合の、不動産取得税の課税標準は、原則として、その取引価格とされる。",
        "choice3": "登録免許税は、贈与により建物を取得した場合には課税されるが、相続により建物を取得した場合には課税されない。",
        "choice4": "不動産取得税は、所有権移転登記の有無にかかわらず、契約内容等から総合的に判断して現実に所有権を取得したと認められる場合に、当該不動産の取得者に対して課される。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の取得の税金",
        "important": ""
    },
    {
        "id": 508,
        "shikenId": 13,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "不動産に係る固定資産税および都市計画税に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "所定の要件を満たす新築住宅に係る固定資産税は、１戸当たり１２０㎡以下の床面積に相当する部分の税額について、一定期間にわたり６分の１に軽減される特例がある。",
        "choice2": "住宅用地に係る固定資産税の課税標準については、住宅用地で住宅１戸当たり３００㎡以下の部分について課税標準となるべき価格の６分の１の額とする特例がある。",
        "choice3": "土地または家屋に係る固定資産税の課税標準となる価格は、原則として毎年度、評価替えが行われる。",
        "choice4": "都市計画税の税率は各地方自治体の条例で定められるが、１００分の０. ３を超えることはできない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "固定資産税および都市計画税",
        "important": ""
    },
    {
        "id": 509,
        "shikenId": 13,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "個人が土地を譲渡した場合の譲渡所得に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "土地の譲渡が長期譲渡所得に区分される場合、課税長期譲渡所得金額に対し、原則として、所得税（復興特別所得税を含む）１５. ３１５%、住民税５％の税率により課税される。",
        "choice2": "相続により土地を取得して相続税を課された者が、その土地を当該相続の開始があった日の翌日から相続税の申告期限の翌日以後３年を経過する日までに譲渡した場合、譲渡所得の金額の計算上、その者が負担した相続税額のうち、その土地に対応する部分の金額を取得費に加算することができる。",
        "choice3": "他者から購入した土地の取得の日は、原則としてその土地の引渡しを受けた日であるが、当該売買契約の効力が発生した日とすることもできる。",
        "choice4": "相続により取得した土地を譲渡した場合、その土地の所有期間を判定する際の取得の日は、相続人が当該相続を登記原因として所有権移転登記をした日である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "譲渡所得",
        "important": ""
    },
    {
        "id": 510,
        "shikenId": 13,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "土地の有効活用の手法の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "建設協力金方式は、入居予定のテナントから建設資金の全部または一部を借り受けて、テナントの仕様に合わせた建物を建設するため、用途の汎用性は低い。",
        "choice2": "等価交換方式は、土地所有者は建物の建築資金を負担する必要はないが、土地の所有権の一部を手放すことにより、当該土地上に建設された建物の全部を取得することができる。",
        "choice3": "定期借地権方式では、土地所有者は土地を一定期間貸し付けることにより地代収入を得ることができ、当該土地上に建設する建物の資金調達をする必要がない。",
        "choice4": "事業受託方式は、土地の有効活用の企画、建設会社の選定および当該土地上に建設された建物の管理・運営をデベロッパーに任せ、建設資金の調達や返済は土地所有者が行う。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "土地の有効活用手法",
        "important": ""
    },
    {
        "id": 511,
        "shikenId": 13,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "贈与に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "民法上、贈与は、当事者の一方がある財産を無償で相手方に与える意思表示をすることにより効力が生じ、相手方が受諾する必要はない。",
        "choice2": "定期贈与契約は、贈与者または受贈者の一方が死亡すると、その権利・義務が相続人に承継される。",
        "choice3": "負担付贈与については、贈与者は、その負担の限度において、売買契約の売主と同様の担保責任を負う。",
        "choice4": "死因贈与によって取得した財産は、贈与税の課税対象となる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与契約",
        "important": ""
    },
    {
        "id": 512,
        "shikenId": 13,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "贈与税の計算に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "祖父と父のそれぞれから同一の年において財産の贈与を受け、いずれの贈与についても暦年課税の適用を受けた場合の贈与税額の計算においては、贈与税の課税価格から基礎控除額として最高２２０万円を控除することができる。",
        "choice2": "贈与税額の計算において、贈与税の配偶者控除の適用を受ける場合は、贈与税の課税価格から基礎控除額を控除することができない。",
        "choice3": "相続時精算課税制度を選択した場合における贈与税額の計算において、贈与税の課税価格から控除する特別控除額は、特定贈与者ごとに累計で２, ５００万円である。",
        "choice4": "相続時精算課税制度を選択した場合、特定贈与者からの贈与により取得した財産に係る贈与税額の計算上、贈与税の税率は、贈与税の課税価格に応じた超過累進税率である。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の計算",
        "important": ""
    },
    {
        "id": 513,
        "shikenId": 13,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "贈与税の非課税財産に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "個人から受ける社交上必要と認められる香典・見舞金等の金品で、贈与者と受贈者との関係等に照らして社会通念上相当と認められるものは、贈与税の課税対象とならない。",
        "choice2": "個人が法人からの贈与により取得した財産は、贈与税の課税対象とならない。",
        "choice3": "相続により財産を取得した者が、その相続開始の年に被相続人から贈与により取得した財産は、原則として相続税の課税対象となり、贈与税の課税対象とならない。",
        "choice4": "扶養義務者から生活費として受け取った金銭を、投資目的の株式の運用に充てたとき、その金銭は、贈与税の課税対象とならない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の非課税財産",
        "important": ""
    },
    {
        "id": 514,
        "shikenId": 13,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "民法上の法定相続分に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "普通養子の法定相続分は、実子の法定相続分の２分の１である。",
        "choice2": "被相続人と父母の一方のみを同じくする兄弟姉妹の法定相続分は、父母の双方を同じくする兄弟姉妹の法定相続分の２分の１である。",
        "choice3": "相続人が被相続人の配偶者と母の合計２人である場合、配偶者および母の法定相続分は、それぞれ２分の１である。",
        "choice4": "代襲相続人が１人である場合、その代襲相続人の法定相続分は、被代襲者が受けるべきであった法定相続分の２分の１である。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "民法上の法定相続分",
        "important": ""
    },
    {
        "id": 515,
        "shikenId": 13,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "民法上の遺言および遺留分に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "相続人が自宅にある自筆証書遺言を発見し、家庭裁判所の検認を受ける前に開封した場合であっても、開封したことをもって、その遺言書が直ちに無効となるわけではない。",
        "choice2": "自筆証書遺言の内容を変更する場合、遺言者が変更箇所を指示し、これを変更した旨を付記したうえでこれに署名し、かつ、変更箇所に押印しなければならない。",
        "choice3": "被相続人の相続人が兄弟姉妹であった場合に、兄弟姉妹には遺留分は認められない。",
        "choice4": "遺留分権利者は、相続の開始があったことを知った時から３ヵ月以内に限り、家庭裁判所の許可を受けて遺留分の放棄をすることができる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺言および遺留分",
        "important": ""
    },
    {
        "id": 516,
        "shikenId": 13,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "相続人が負担した次の費用等のうち、相続税の課税価格の計算上、相続財産の価額から債務控除することができるものはどれか。なお、債務控除を受けるために必要とされる他の要件はすべて満たしているものとする。",
        "choice1": "被相続人が生前に購入した墓碑の購入代金で、相続開始時点で未払いのもの",
        "choice2": "被相続人に係る初七日および四十九日の法要に要した費用のうち、社会通念上相当と認められるもの",
        "choice3": "被相続人が所有していた不動産に係る固定資産税のうち、相続開始時点で納税義務は生じているが、納付期限が到来していない未払いの金額",
        "choice4": "被相続人が団体信用生命保険に加入して金融機関から借り入れていた住宅ローンで、相続開始直前にローン残高があるもの",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "債務控除",
        "important": ""
    },
    {
        "id": 517,
        "shikenId": 13,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続税における家屋等の評価に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "自用家屋の価額は、「その家屋の固定資産税評価額×１. ０」の算式により計算した金額により評価する。",
        "choice2": "貸家の価額は、「自用家屋としての評価額×（１－借家権割合×借地権割合×賃貸割合）」の算式により計算した金額により評価する。",
        "choice3": "借家権は、この権利が権利金等の名称をもって取引される慣行のない地域においては、評価しない。",
        "choice4": "家屋と一体となっている設備の価額は、その家屋の価額に含めて評価する。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "家屋等の評価",
        "important": ""
    },
    {
        "id": 518,
        "shikenId": 13,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続税額の計算における宅地の評価に関する次の記述のうち、最も適切なものはどれか。なお、評価の対象となる宅地は、借地権の取引慣行のある地域にあるものとする。また、宅地の上に存する権利は、定期借地権および一時使用目的の借地権等を除くものとする。",
        "choice1": "賃借している宅地の上に家屋を建てて、これを賃貸している場合、賃借している宅地の上に存する権利は、転貸借地権として評価する。",
        "choice2": "賃借している宅地の上に家屋を建てて、これを自宅として使用している場合、賃借している者の宅地の上に存する権利は、借地権として評価する。",
        "choice3": "自己が所有する土地を青空駐車場として第三者に賃貸する場合、土地所有者の権利は貸宅地として評価する。",
        "choice4": "親から子が土地を使用貸借により借り受けて、子がアパートを建築し、第三者に賃貸する場合、親の土地の権利は貸宅地として評価する。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "宅地の評価",
        "important": ""
    },
    {
        "id": 519,
        "shikenId": 13,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税の特例（以下「本特例」）に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢記載の条件以外はすべて満たしているものとする。",
        "choice1": "本特例は、受贈者の父母や祖父母からの贈与は対象となるが、受贈者の配偶者の父母や祖父母からの贈与は対象とならない。",
        "choice2": "本特例は、贈与年の１月１日時点で１８歳以上であり、贈与を受ける前年の合計所得金額が２，０００万円以下である者が適用を受けることができる。",
        "choice3": "新築した家屋が店舗併用住宅で、その家屋の登記簿上の床面積の２分の１以上が居住の用に供される場合、本特例の適用を受けることができる。",
        "choice4": "住宅取得等資金の贈与者が死亡した場合、その相続人が贈与を受けた住宅取得等資金のうち、本特例の適用を受けて贈与税が非課税とされた部分は、相続税の課税価格に加算されない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "住宅取得等資金の贈与税非課税",
        "important": ""
    },
    {
        "id": 520,
        "shikenId": 13,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "非上場企業の事業承継対策等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「非上場株式等についての贈与税の納税猶予及び免除の特例」の適用を受ける場合であっても、相続時精算課税制度の適用を受けることができる。",
        "choice2": "経営者が保有している自社株式を後継者（役員）に取得させる場合、あらかじめ後継者の役員報酬を増加させるなどの対策を講じることで、後継者の自社株式取得資金の負担を減らすことができる。",
        "choice3": "「遺留分に関する民法の特例」の適用を受けることにより、会社事業後継者が旧代表者から贈与により取得した自社株式について、その価額を、遺留分を算定するための財産の価額に算入しないことができる。",
        "choice4": "「遺留分に関する民法の特例」の適用を受けるための会社事業後継者は、旧代表者の親族に限られる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "事業承継対策",
        "important": ""
    },
    {
        "id": 521,
        "shikenId": 14,
        "no": 1,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,1,2,1",
        "score": "1,1,1,1",
        "question1": "フィデューシャリー・デューティー（受託者責任）を遂行するための軸として金融庁が公表する「顧客本位の業務運営に関する原則（以下「本原則」という）」に関する次の（ア）～（エ）の記述について、適切なものには〇、不適切なものには×を選択してください。",
        "question2": "",
        "choice1": "本原則は、金融事業者がとるべき行動について、金融庁が詳細に規定する「ルールベース・アプローチ」を採用する。",
        "choice2": "金融事業者が、本原則を採択したうえで、自らの状況等に照らして、本原則の一部を実施しない場合は、その理由や代替策を十分に説明することを求められる。",
        "choice3": "本原則を採択する場合、金融事業者が策定した業務運営に関する方針は、一貫して継続する必要があり、定期的な見直しは不要である。",
        "choice4": "本原則では、金融事業者は顧客の資産状況、取引経験、知識等を把握し、当該顧客にふさわしい金融商品の販売、推奨等を行うべきとしている。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "フィデュ―シャリー・デューティー",
        "important": ""
    },
    {
        "id": 522,
        "shikenId": 14,
        "no": 2,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "「消費者契約法」に関する次の（ア）～（ウ）の記述について、適切なものには○、不適切なものには×を選択してください。",
        "question2": "",
        "choice1": "消費者契約法は、個人および法人を保護の対象としている。",
        "choice2": "消費者契約の申込み等に係る取消権は、原則として消費者が追認をすることができるときから１年間行わないとき、または契約の締結のときから１０年を経過したときは、時効によって消滅すると定められている。",
        "choice3": "事業者が、将来の受取額が不確実な金融商品の販売において、「確実に儲かる」と断言し、消費者がそれを信じて結んだ契約は、取り消すことができる。",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "消費者契約法",
        "important": ""
    },
    {
        "id": 523,
        "shikenId": 14,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "下記＜資料＞は、瀬田さんが同一の特定口座内で本年中に行った東京証券取引所プライム市場上場会社であるＭＮ株式会社の株式（以下、「ＭＮ株式」という）の株式取引に係る明細である。瀬田さんのＭＮ株式の取引に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、正しいものはどれか。<br><br><img src='/img/set3/s1_1.png'/>",
        "question2": "",
        "choice1": "（ア）１２月２６日　（イ）１，２５０円",
        "choice2": "（ア）１２月２６日　（イ）１，３００円",
        "choice3": "（ア）１２月２７日　（イ）１，２５０円",
        "choice4": "（ア）１２月２７日　（イ）１，３００円",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の取引・取得価額の計算",
        "important": ""
    },
    {
        "id": 524,
        "shikenId": 14,
        "no": 4,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "北本さんは、保有しているＸＹ投資信託（追加型公募株式投資信託）の収益分配金を２０ＸＸ年１２月に受け取った。ＸＹ投資信託の運用状況が下記の＜資料＞のとおりである場合、次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、正しいものはどれか。<br><br><img src='/img/set3/s1_2.png'/>",
        "question2": "",
        "choice1": "（ア）利子所得　（イ）１１，０００円",
        "choice2": "（ア）利子所得　（イ）１０，６００円",
        "choice3": "（ア）配当所得　（イ）１０，６００円",
        "choice4": "（ア）配当所得　（イ）１１，０００円",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "投資信託の収益分配金",
        "important": ""
    },
    {
        "id": 525,
        "shikenId": 14,
        "no": 5,
        "answerType": 8,
        "groupId": 1,
        "answer": "2,6,7,11",
        "score": "1,1,1,1",
        "question1": "財形貯蓄制度に関する下表の空欄（ア）～（エ）にあてはまる語句を語群の中から選択してください。なお、復興特別所得税は考慮せず、同じ数値を何度選んでもよいこととする。また、問題の設定上、明らかにできない部分を（　※　）としている。<br><br><img src='/img/set3/s1_3.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9|10|11",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "財形貯蓄",
        "important": ""
    },
    {
        "id": 526,
        "shikenId": 14,
        "no": 6,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "金投資に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "個人が金地金を業者に売却する際には、売却代金の他に、売却代金の消費税相当額を受け取ることができる。",
        "choice2": "個人が金地金を売却した場合の所得は、総合課税の譲渡所得として課税され、譲渡日時点の保有期間が５年超の場合は長期譲渡所得、５年以下の場合は短期譲渡所得となる。",
        "choice3": "金地金を売却して損失が発生した場合には他の所得と損益通算できる。",
        "choice4": "金は、一般的に地政学的リスクに対して強いと考えられている代表的な資産である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金地金",
        "important": ""
    },
    {
        "id": 527,
        "shikenId": 14,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "経済統計等に関する下表の（ア）～（エ）にあてはまる語句に関する次の記述のうち、最も適切なものはどれか。<br><br><img src='/img/set3/s1_4.png'/>",
        "question2": "",
        "choice1": "空欄（ア）にあてはまる語句は、「財務省」である。",
        "choice2": "空欄（イ）にあてはまる語句は、「景気ウォッチャー調査」である。",
        "choice3": "空欄（ウ）にあてはまる語句は、「実質」である。",
        "choice4": "空欄（エ）にあてはまる語句は、「半期ごとに」である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "経済統計等関する語句",
        "important": ""
    },
    {
        "id": 528,
        "shikenId": 14,
        "no": 8,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "建築基準法に従い、下記＜資料＞の甲土地に準耐火建築物を建てる場合の（ア）建築面積の最高限度、（イ）延べ面積の最高限度の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない条件については一切考慮しないこととする。<br><br><img src='/img/set3/s1_5.png'/>",
        "question2": "",
        "choice1": "（ア）３０４㎡　（イ）７６０㎡",
        "choice2": "（ア）２６６㎡　（イ）１，１４０㎡",
        "choice3": "（ア）３０４㎡　（イ）１，１７０㎡",
        "choice4": "（ア）３２０㎡　（イ）１，２００㎡",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築面積と延べ面積の計算",
        "important": ""
    },
    {
        "id": 529,
        "shikenId": 14,
        "no": 9,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "公的な土地評価に関する次の一覧表の空欄（ア）～（ウ）に入る適切な語句の組み合わせとして、正しいものはどれか。<br><br><img src='/img/set3/s1_6.png'/>",
        "question2": "",
        "choice1": "（ア）国土交通省　（イ）１月１日　（ウ）７割",
        "choice2": "（ア）内閣府　（イ）７月１日　（ウ）７割",
        "choice3": "（ア）国土交通省　（イ）７月１日　（ウ）６割",
        "choice4": "（ア）内閣府　（イ）１月１日　（ウ）６割",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "公的な土地評価",
        "important": ""
    },
    {
        "id": 530,
        "shikenId": 14,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "固定資産税に関する次の記述の空欄（ア）～（エ）に入る語句の組み合わせとして、適切なものはどれか。<br><br>固定資産税は、（ ア ）が、毎年（ イ ）現在の土地や家屋等の所有者に対して課税します。固定資産税評価額が課税標準となりますが、一定の要件を満たす住宅が建つ住宅用地（小規模住宅用地）は、住戸１戸当たり（ ウ ）以下の部分について、課税標準が固定資産税評価額の（ エ ）になる特例があります。",
        "question2": "",
        "choice1": "（ア）市町村（東京２３区は東京都）（イ）４月１日 （ウ）１２０㎡ （エ）３分の１",
        "choice2": "（ア）都道府県 （イ）１月１日 （ウ）１２０㎡ （エ）６分の１",
        "choice3": "（ア）都道府県 （イ）４月１日 （ウ）２００㎡ （エ）３分の１",
        "choice4": "（ア）市町村（東京２３区は東京都）（イ）１月１日 （ウ）２００㎡ （エ）６分の１",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "固定資産税",
        "important": ""
    },
    {
        "id": 531,
        "shikenId": 14,
        "no": 11,
        "answerType": 8,
        "groupId": 1,
        "answer": "2,6,9,10",
        "score": "1,1,1,1",
        "question1": "不動産取得税に関する次の記述の空欄（ア）～（エ）にあてはまる適切な語句を語群の中から選択してください。なお、同じ語句を何度選んでもよいこととする。<br><br><img src='/img/set3/s1_7.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9|10|11|12",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産取得税",
        "important": ""
    },
    {
        "id": 532,
        "shikenId": 14,
        "no": 12,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "押田さんは、土地の有効活用をするに当たり、ＦＰの直井さんに、借地借家法に定める借地権について質問した。下記の記述の空欄（ア）～（ウ）に入る語句の組み合わせとして、適切なものはどれか。なお、「普通借地権」とは、借地借家法第２２条から第２４条の定期借地権等以外の借地権、「一般定期借地権」とは同法第２２条の借地権をいうものとする。<br><br><img src='/img/set3/s1_8.png'/>",
        "question2": "",
        "choice1": "（ア）１０年　（イ）３０年　（ウ）地方裁判所の許可を得て",
        "choice2": "（ア）１０年　（イ）５０年　（ウ）地方裁判所の許可を得て",
        "choice3": "（ア）３０年　（イ）３０年　（ウ）公正証書等の書面によって",
        "choice4": "（ア）３０年　（イ）５０年　（ウ）公正証書等の書面によって",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "借地権",
        "important": ""
    },
    {
        "id": 533,
        "shikenId": 14,
        "no": 13,
        "answerType": 9,
        "groupId": 1,
        "answer": "376,3205,8",
        "score": "1,1,1",
        "question1": "田中英俊さんが、保険契約者（保険料負担者）および被保険者として加入している生命保険（下記＜資料＞参照）の保障内容に関する次の空欄（ア）～（ウ）にあてはまる数値を計算しなさい。なお、保険契約は有効に継続し、かつ特約は自動更新しているものとし、英俊さんはこれまでに＜資料＞の保険から、保険金・給付金を一度も受け取っていないものとする。また、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><br><img src='/img/set3/s1_9.png'/><br><br><img src='/img/set3/s1_10.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の証券分析",
        "important": ""
    },
    {
        "id": 534,
        "shikenId": 14,
        "no": 14,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "高田泉さんが本年中に支払った生命保険の保険料は下記＜資料＞のとおりである。この場合の高田さんの本年分の所得税の計算における生命保険料控除の金額として、正しいものはどれか。なお、下記＜資料＞の保険について、これまでに契約内容の変更はないものとする。また、本年分の生命保険料控除額が最も多くなるように計算すること。<br><br><img src='/img/set3/s1_11.png'/>",
        "question2": "",
        "choice1": "７０，０００円",
        "choice2": "７５，０００円",
        "choice3": "８０，０００円",
        "choice4": "９０，０００円",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険料控除の計算",
        "important": ""
    },
    {
        "id": 535,
        "shikenId": 14,
        "no": 15,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,1,1",
        "score": "1,1,1,1",
        "question1": "栗林さん（５３歳）は、自身を記名被保険者として契約している自動車保険の契約更新案内（下記＜資料＞参照）について、ＦＰの広瀬さんにアドバイスを求めた。広瀬さんが述べた次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択してください。なお、＜資料＞に記載のない特約については考慮しないものとし、過去に自動車保険の対象となる事故はないものとする。<br><br><img src='/img/set3/s1_12.png'/>",
        "question2": "",
        "choice1": "「前年同内容プランおよびおすすめプランＡでは、大雨による洪水で被保険自動車が水没した場合や盗難による損害を受けた場合の自動車の損害を補償しますが、単独事故による損害は補償されません」",
        "choice2": "「栗林さんの友人（３３歳）が被保険自動車を運転中に対人事故を起こした場合、おすすめプランＡおよびおすすめプランＢでは補償対象となりません」",
        "choice3": "「栗林さんが運転中に他車との接触事故でケガをした場合、おすすめプランＢは、過失割合にかかわらず治療費用等は補償対象となります」",
        "choice4": "「おすすめプランＢでは、栗林さんが所有する原動機付自転車を運転中に対物事故を起こした場合、補償の対象となります」",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "自動車保険の証券分析",
        "important": ""
    },
    {
        "id": 536,
        "shikenId": 14,
        "no": 16,
        "answerType": 9,
        "groupId": 0,
        "answer": 5760,
        "score": 2,
        "question1": "株式会社ＴＳの専務取締役の度会さんが任期満了で退職した場合、同社の役員退職慰労金規程に基づき受け取ることができる役員退職慰労金の金額を計算しなさい。なお、解答は以下の＜前提条件＞および＜資料＞に基づくものとし、記載のない事項については一切考慮しないものとする。<br><br><img src='/img/set3/s1_13.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "役員退職金の計算",
        "important": ""
    },
    {
        "id": 537,
        "shikenId": 14,
        "no": 17,
        "answerType": 9,
        "groupId": 0,
        "answer": 14850,
        "score": 2,
        "question1": "山本さんは、相次ぐ地震報道を受けて地震保険に関心を持った。下記＜資料＞を基に計算した山本さんの自宅に係る年間の地震保険料を計算しなさい。なお、山本さんの自宅は、東京都にあるイ構造のマンションで、火災保険の保険金額は１，２００万円であり、地震保険は火災保険の保険金額の５０％相当額で、本年９月に契約し、建築年割引１０％が適用されるものとする。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set3/s1_14.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "地震保険料の計算",
        "important": ""
    },
    {
        "id": 538,
        "shikenId": 14,
        "no": 18,
        "answerType": 9,
        "groupId": 0,
        "answer": 89,
        "score": 2,
        "question1": "大柳さん（６５歳）の本年分の収入等が下記のとおりである場合、大柳さんの本年分の所得税における総所得金額を計算しなさい。なお、青色申告特別控除１０万円の適用を受けるものとする。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set3/s1_15.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 539,
        "shikenId": 14,
        "no": 19,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "会社員の保坂さんは、本年１２月に勤務先を退職する予定である。保坂さんの退職に係るデータが下記の＜資料＞のとおりである場合、保坂さんの退職一時金にかかる退職所得の金額として、正しいものはどれか。なお、保坂さんは、勤務先の役員であったことはなく、退職は障害者になったことに基因するものではない。<br><br><img src='/img/set3/s1_16.png'/>",
        "question2": "",
        "choice1": "２３０万円",
        "choice2": "４１５万円",
        "choice3": "４５０万円",
        "choice4": "８３０万円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 540,
        "shikenId": 14,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "香川さんの本年分の所得等に関して所得税の確定申告すべき金額として、最も適切なものは次のうちどれか。なお、給与所得については、年末調整により正しい所得税が源泉徴収されているものとし、他に申告すべき所得や、所得控除はないものとする。<br><br><img src='/img/set3/s1_17.png'/>",
        "question2": "",
        "choice1": "確定申告は不要です。",
        "choice2": "確定申告が必要です。確定申告すべき金額は３１０万円です",
        "choice3": "確定申告が必要です。確定申告すべき金額は３１５万円です。",
        "choice4": "確定申告が必要です。画定申告すべき金額は３３０万円です。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "確定申告の要・不要の判定",
        "important": ""
    },
    {
        "id": 541,
        "shikenId": 14,
        "no": 21,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "会社員の下田晃大さんが、本年中に支払った医療費等が下記＜資料＞のとおりである場合、下田さんの本年の所得税の確定申告における医療費控除の金額として、正しいものはどれか。なお、下田さんの本年中の所得は、給与所得５００万円のみであるものとし、下田さんは妻および小学生の長女と生計を一にしている。また、セルフメディケーション税制（医療費控除の特例）については考慮せず、保険金および自治体の助成金等により補てんされる金額はないものとする。<br><br><img src='/img/set3/s1_18.png'/>",
        "question2": "",
        "choice1": "４８０，０００円",
        "choice2": "５００，０００円",
        "choice3": "５８０，０００円",
        "choice4": "６８０，０００円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "医療費控除",
        "important": ""
    },
    {
        "id": 542,
        "shikenId": 14,
        "no": 22,
        "answerType": 9,
        "groupId": 0,
        "answer": 1265,
        "score": 3,
        "question1": "＜資料＞の空欄（ア）にあてはまる光男さんの本年分の事業所得の金額の数値を計算しなさい。なお、滝上さんは青色申告の承認を受けており、青色申告決算書（貸借対照表を含む）を添付し、国税電子申告・納税システム（ｅ－Ｔａｘ）を利用して電子申告を確定申告の期限内に行うものとし、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set3/s1_19.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "事業所得の計算",
        "important": ""
    },
    {
        "id": 543,
        "shikenId": 14,
        "no": 23,
        "answerType": 8,
        "groupId": 1,
        "answer": "8,4,6,1",
        "score": "1,1,1,1",
        "question1": "下記＜親族関係図＞の場合において、民法の規定に基づく法定相続分および遺留分に関する次の記述の空欄（ア）～（エ）に入る適切な語句または数値を語群の中から選択してください。なお、同じ語句または数値を何度選んでもよいこととする。<br><br><img src='/img/set3/s1_20.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "法定相続分と遺留分",
        "important": ""
    },
    {
        "id": 544,
        "shikenId": 14,
        "no": 24,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,2,2,1",
        "score": "1,1,1,1",
        "question1": "相続税において相続財産から控除できる債務等に関する次の記述の（ア）～（エ）の記述のうち、適切なものには○、不適切なものには×を選択してください。",
        "question2": "",
        "choice1": "被相続人が生前に購入した墓地の購入未払い金は、相続財産から控除することができる。",
        "choice2": "被相続人に課される未払いの所得税、住民税、固定資産税等は、支払時期が到来しているものに限り、相続財産から控除することができる。",
        "choice3": "香典返しのためにかかった費用については、葬式費用として相続財産から控除することができる。",
        "choice4": "被相続人に係る未払い医療費は、相続財産から控除することができる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "債務控除",
        "important": ""
    },
    {
        "id": 545,
        "shikenId": 14,
        "no": 25,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "羽田さん（４０歳）は、父（６８歳）と祖母（９２歳）から下記＜資料＞の贈与を受けた。羽田さんの本年分（２０２５年分）の贈与税額として、最も適切なものはどれか。なお、父からの贈与については、２年前から相続時精算課税制度の適用を受けている。<br><br><img src='/img/set3/s1_21.png'/>",
        "question2": "",
        "choice1": "６６．５万円",
        "choice2": "７１．０万円",
        "choice3": "８８．５万円",
        "choice4": "９３．０万円",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の計算",
        "important": ""
    },
    {
        "id": 546,
        "shikenId": 14,
        "no": 26,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "下記＜資料＞の土地に係る路線価方式による普通借地権の相続税評価額の計算式として、正しいものはどれか。<br><br><img src='/img/set3/s1_22.png'/>",
        "question2": "",
        "choice1": "２５０，０００円×０．９７×１０８㎡",
        "choice2": "２５０，０００円×０．９７×１０８㎡×（１－６０％）",
        "choice3": "２５０，０００円×０．９７×１０８㎡×６０％",
        "choice4": "２５０，０００円×０．９７×１０８㎡×（１－６０％×３０％×１００％）",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "宅地の評価",
        "important": ""
    },
    {
        "id": 547,
        "shikenId": 14,
        "no": 27,
        "answerType": 8,
        "groupId": 1,
        "answer": "1,3,6,7",
        "score": "1,1,1,1",
        "question1": "「直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税」についてまとめた下表の空欄（ア）～（エ）に入る適切な語句を語群の中から選択してください。<br><br><img src='/img/set3/s1_23.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "住宅取得等資金の非課税",
        "important": ""
    },
    {
        "id": 548,
        "shikenId": 14,
        "no": 28,
        "answerType": 9,
        "groupId": 0,
        "answer": 258,
        "score": 2,
        "question1": "成田家のキャッシュフロー表の空欄（ア）に入る数値を計算しなさい。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><br><img src='/img/set3/s1_24.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 549,
        "shikenId": 14,
        "no": 29,
        "answerType": 9,
        "groupId": 0,
        "answer": "1.5",
        "score": 2,
        "question1": "成田家のキャッシュフロー表の空欄（イ）に入る数値を計算しなさい。なお、計算過程においては端数処理をせず計算し、計算結果については％を単位として、小数点第１位まで解答すること。<br><br><img src='/img/set3/s1_25.png'/>",
        "question2": "",
        "choice1": "%",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 550,
        "shikenId": 14,
        "no": 30,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "キャッシュフロー表を作成する上では、収入や支出などの変動率や金融資産の運用利回りの予測が重要である。運用利回り等の変動に影響を与える要因についての次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "消費者物価指数の算出では、消費税率を含めて計算される。",
        "choice2": "為替が円高になると、輸入物価を押し上げる要因となる。",
        "choice3": "変動金利型住宅ローンの適用金利は、短期プライムレートを基準にする金融機関が主流である。",
        "choice4": "新発１０年国債利回りは、国内長期金利の代表的な指標である。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "運用利回り等の変動に影響を与える要因",
        "important": ""
    },
    {
        "id": 551,
        "shikenId": 14,
        "no": 31,
        "answerType": 9,
        "groupId": 0,
        "answer": 10462000,
        "score": 2,
        "question1": "小川さんは、老後資金に備えるために、新たに積立てを開始する予定である。毎年年末に１００万円を積み立てるものとし、１０年間、年利１．０％で複利運用しながら積み立てた場合、１０年後の合計額はいくらになるか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set3/s1_26.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 552,
        "shikenId": 14,
        "no": 32,
        "answerType": 9,
        "groupId": 0,
        "answer": 21020000,
        "score": 2,
        "question1": "磯貝さんは相続により受け取った２，０００万円を運用しようと考えている。これを５年間、年利１．０％で複利運用した場合、５年後の合計額はいくらになるか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set3/s1_27.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 553,
        "shikenId": 14,
        "no": 33,
        "answerType": 9,
        "groupId": 0,
        "answer": 1440000,
        "score": 2,
        "question1": "清水さんは、退職金として受け取った２，０００万円を老後の生活資金の一部として使用するつもりである。これを１５年間、年利１．０％で複利運用しながら毎年１回、年末に均等に取り崩すこととした場合、毎年年末に取り崩すことができる最大金額はいくらになるか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set3/s1_28.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 554,
        "shikenId": 14,
        "no": 34,
        "answerType": 9,
        "groupId": 0,
        "answer": 3790,
        "score": 2,
        "question1": "ＦＰの寺岡さんは、本年現時点における滝上家（光男さんと彰子さん）のバランスシート分析を行うこととした。下表の空欄（ア）に入る数値を計算しなさい。<br><br><img src='/img/set3/s1_29.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "バランスシート",
        "important": ""
    },
    {
        "id": 555,
        "shikenId": 14,
        "no": 35,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "山本修司さんは、長男である隆司さん（１７歳）の進学を控えて奨学金や教育ローンに関心をもち、ＦＰの向さんに質問をした。<br>向さんが日本学生支援機構の奨学金（第一種・第二種）および日本政策金融公庫の教育一般貸付（国の教育ローン）について説明する際に使用した下表の空欄（ア）～（エ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><br><img src='/img/set3/s1_30.png'/>",
        "question2": "",
        "choice1": "（ア）学生・生徒の保護者（イ）いつでも可能 （ウ）３００万円 （エ）年利２％",
        "choice2": "（ア）学生・生徒本人（イ）決められた募集期間内  （ウ）３５０万円 （エ）年利２％",
        "choice3": "（ア）学生・生徒本人（イ）決められた募集期間内  （ウ）３００万円 （エ）年利３％",
        "choice4": "（ア）学生・生徒の保護者（イ）いつでも可能 （ウ）３５０万円 （エ）年利３％",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "奨学金と教育ローン",
        "important": ""
    },
    {
        "id": 556,
        "shikenId": 14,
        "no": 36,
        "answerType": 8,
        "groupId": 1,
        "answer": "4,9,12,6",
        "score": "1,1,1,1",
        "question1": "山本さんは、ｉＤｅＣｏ（個人型確定拠出年金）とＮＩＳＡのつみたて投資枠についてＦＰの向さんに質問をした。向さんがＮＩＳＡのつみたて投資枠とｉＤｅＣｏの概要を説明する際に使用した下表の空欄（ア）～（エ）に入る適切な数値または語句を語群の中から選び、その番号のみを解答欄に入力しなさい。<br><br><img src='/img/set3/s1_31.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9|10|11|12",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "iDeCoとNISA",
        "important": ""
    },
    {
        "id": 557,
        "shikenId": 14,
        "no": 37,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,1,2",
        "score": "1,1,1",
        "question1": "山本さんは、現在居住している自宅の住宅ローンの見直しを検討しており、ＦＰの向さんに質問をした。住宅ローンの見直しに関する次の（ア）～（ウ）の記述について、適切なものには○、不適切なものには×を選択してください。",
        "question2": "",
        "choice1": "住宅ローンの繰上げ返済に充てられた金額は、全額が元本の返済に充当されるため、その元本に対応する部分の利息の支払いが軽減される。",
        "choice2": "借換えにおいては、抵当権の抹消や設定の費用、事務手数料等の諸費用が必要となるため、諸費用も含めて、借換え前後の支払額を比較することが重要である。",
        "choice3": "住宅ローンの条件変更では、返済期間を短くし、月々の返済額を増額すると、他の条件が同じであれば、変更前と比べて、住宅ローンの総返済額も増加する。",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "住宅ローンの見直し",
        "important": ""
    },
    {
        "id": 558,
        "shikenId": 14,
        "no": 38,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "滝上さんは、老後の生活の安定のために小規模企業共済に加入することを検討しており、ＦＰの寺岡さんに制度の概要について質問をした。小規模企業共済に関する次の記述のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "加入できるのは、常時使用する従業員の数が１００人以下（卸売業、小売業等は２０人以下）の個人事業主（共同経営者を含む）や会社等の役員である。",
        "choice2": "小規模企業共済とｉＤｅＣｏ（個人型確定拠出年金）は同時に加入することができる。",
        "choice3": "掛金の月額は、１，０００円から６８，０００円までの範囲内（５００円単位）で自由に設定することができる。",
        "choice4": "掛金は、所得税における小規模企業共済等掛金控除として、支払った全額を所得税額から控除することができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "小規模企業共済",
        "important": ""
    },
    {
        "id": 559,
        "shikenId": 14,
        "no": 39,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "滝上さんの公的年金の加入歴（見込みを含む）が下記＜資料＞のとおりである場合、滝上さんに６５歳から支給される老齢基礎年金（付加年金を含む）の額として、正しいものはどれか。なお、滝上さんは、60歳以降 65歳まで保険料の納付を続ける見込みである。計算に当たっては、下記＜資料＞に基づくものとし、計算過程および老齢基礎年金の額について、円未満の端数が生じた場合には、円未満を四捨五入するものとする。<br><br><img src='/img/set3/s1_32.png'/>",
        "question2": "",
        "choice1": "７４１，４８３円",
        "choice2": "７９７，０４６円",
        "choice3": "８４５，４４６円",
        "choice4": "８８０，１００円",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金の計算",
        "important": ""
    },
    {
        "id": 560,
        "shikenId": 14,
        "no": 40,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "滝上光男さんの弟である春男さん（５３歳）は、病気療養のため本年８月に１８日間入院した。退院する際に支払った保険診療分の医療費（窓口での自己負担分）が２４万円、その他、入院時の食事代が１万円、差額ベッド代が１８万円であった場合、下記＜資料＞に基づく高額療養費として春男さんに支給される額（多数該当は考慮しない）として、正しいものはどれか。なお、春男さんは全国健康保険協会管掌健康保険（協会けんぽ）の被保険者であり、春男さんの標準報酬月額は３６万円であるものとする。また、病院に「健康保険限度額適用認定証」の提示はしていないものとし、同月中に＜資料＞以外の医療費はないものとする。<br><br><img src='/img/set3/s1_33.png'/>",
        "question2": "",
        "choice1": "８０，１００円",
        "choice2": "８５，４３０円",
        "choice3": "１５４，５７０円",
        "choice4": "１５９，９００円",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "高額療養費",
        "important": ""
    },
    {
        "id": 561,
        "shikenId": 15,
        "no": 1,
        "answerType": 4,
        "groupId": 0,
        "answer": "779719,303867,256,304123",
        "score": "1,1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set3/k1_1.png'/>",
        "question2": "Ａさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（本年度価額）を計算した次の＜計算の手順＞の空欄①～④に入る最も適切な数値を求めなさい。計算にあたっては、《設例》の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づくこと。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set3/k1_2.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金および老齢厚生年金の計算",
        "important": ""
    },
    {
        "id": 562,
        "shikenId": 15,
        "no": 2,
        "answerType": 6,
        "groupId": 0,
        "answer": "イ,ニ,チ",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set3/k1_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、国民年金の付加保険料および国民年金基金について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　「Ａさんは、所定の手続により、国民年金の定額保険料に加えて、国民年金の付加保険料を納付することができます。仮に、Ａさんが付加保険料を180月納付し、65歳から老齢基礎年金を受け取る場合、老齢基礎年金の額に付加年金として（ ① ）円が上乗せされます」<br><br>Ⅱ　「国民年金基金は、老齢基礎年金に上乗せする年金を支給する任意加入の年金制度です。掛金の額は、加入者が選択した給付の型や口数、加入時の年齢等で決まり、掛金の拠出限度額は月額（ ② ）円となります。なお、国民年金基金に加入した場合は（ ③ ）を納付することはできません」<br><br><img src='/img/set3/k1_3.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "付加年金と国民年金基金",
        "important": ""
    },
    {
        "id": 563,
        "shikenId": 15,
        "no": 3,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,2",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set3/k1_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、公的年金制度等の各種取扱いについて説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「Ａさんは、老齢基礎年金および老齢厚生年金の繰下げ支給の申出をすることができます。仮に、Ａさんが72歳０カ月で老齢基礎年金および老齢厚生年金の繰下げ支給の申出をした場合の増額率は33.6％となります」",
        "choice2": "「Ａさんのような個人事業主や会社等の役員が所定の要件を満たしていれば小規模企業共済に加入することができます。毎月の掛金は1,000円から７万円までの範囲内（500円刻み）で選択でき、その全額が税額控除の対象となります」",
        "choice3": "「Ａさんは、老後の年金収入を増やすために、確定拠出年金の個人型年金に加入することができます。ただし、Ａさんが確定拠出年金の個人型年金に加入した場合、小規模企業共済制度には加入することができません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的年金制度等",
        "important": ""
    },
    {
        "id": 564,
        "shikenId": 15,
        "no": 4,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set3/k2_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、Ｕ社債および米ドル建定期預金に係る留意点について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「Ｕ社債の格付は、Ａ（シングルＡ）と評価されています。一般に、BBB（トリプルＢ）格相当以上の格付が付されていれば、投資適格債とされます」",
        "choice2": "「外貨預金の魅力は、円建ての預金と比べて相対的に金利が高いことにあります。《設例》の米ドル建定期預金の場合、Ａさんが満期時に受け取ることができる利息額（税引前）は、480米ドルになります」",
        "choice3": "「円建ての債券投資では、信用リスクや金利リスクに注意が必要です。一般に、市場金利が低下する局面では、債券価格は下落します」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券と外貨預金に係る留意点",
        "important": ""
    },
    {
        "id": 565,
        "shikenId": 15,
        "no": 5,
        "answerType": 4,
        "groupId": 0,
        "answer": "1.47,8.14",
        "score": "2,2",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set3/k2_1.png'/>",
        "question2": "次の①、②を求めなさい（計算過程の記載は不要）。なお、計算にあたっては税金等を考慮せず、〈答〉は、％表示の小数点以下第３位を四捨五入し、小数点以下第２位までを解答すること。<br><br>①　ＡさんがＵ社債を《設例》の条件で購入した場合の最終利回り（年率・単利）を求めなさい。<br>②　Ａさんが《設例》の条件で円貨を米ドルに換えて米ドル建定期預金に40,000米ドルを預け入れ、満期を迎えた場合の円ベースでの運用利回り（単利による年換算）を求めなさい。なお、預入期間６カ月は0.5年として計算すること。",
        "choice1": "％",
        "choice2": "％",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券と外貨預金の利回りの計算",
        "important": ""
    },
    {
        "id": 566,
        "shikenId": 15,
        "no": 6,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,2",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set3/k2_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、Ｕ社債および米ドル建定期預金に係る課税関係について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「Ｕ社債の利子は、利子の支払時において所得税および復興特別所得税と住民税の合計で20.315％相当額が源泉徴収等されます」",
        "choice2": "「為替予約のない米ドル建定期預金の満期による為替差益は、雑所得として総合課税の対象となります」",
        "choice3": "「Ｕ社債の譲渡益は、一時所得として総合課税の対象となりますので、上場株式の譲渡損失の金額と損益通算することはできません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券と外貨預金に係る課税",
        "important": ""
    },
    {
        "id": 567,
        "shikenId": 15,
        "no": 7,
        "answerType": 6,
        "groupId": 0,
        "answer": "ト,イ,ホ,ヌ",
        "score": "1,1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set3/k3_1.png'/>",
        "question2": "住宅借入金等特別控除（以下、「本控除」という）に関する以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>　「個人が、住宅ローンを利用して本年中に省エネ基準に適合する中古マンションを、自己の居住用として取得・入居した場合、合計所得金額等の要件を満たすと、床面積（ ① ）㎡以上であれば居住の用に供した年分以後、最長で（ ② ）年間、本控除の適用を受けることができます。Ａさんの場合、合計所得金額が（ ③ ）万円を超えた年は、本控除の適用を受けることができません。<br>　１年目から（ ② ）年目までの本控除の額は、原則として『住宅ローンの年末残高×（ ④ ）』の額になります」<br><br><img src='/img/set3/k3_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 568,
        "shikenId": 15,
        "no": 8,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set3/k3_1.png'/>",
        "question2": "Ａさんが中古分譲マンションを購入した場合の税金に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「Ａさんは、本年分の所得税について、年末調整で住宅借入金等特別控除の適用を受けることができます」",
        "choice2": "「Ａさんが、父親から受けた500万円の資金援助について『直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税の特例』の適用を受けた場合、その贈与を受けた金額の全額について贈与税が課されません。ただし、この場合、住宅借入金等特別控除の適用を受けることができなくなります」",
        "choice3": "「Ａさん本年中の所得税から住宅借入金等特別控除の額を控除しきれない場合、住民税の確定申告をしなくても、その残額を、Ａさんの所得税の課税総所得金額等の額の５％（最高９万7,500円）を限度に、翌年度の住民税額から控除されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除等",
        "important": ""
    },
    {
        "id": 569,
        "shikenId": 15,
        "no": 9,
        "answerType": 4,
        "groupId": 0,
        "answer": "8900000,630000,208600",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set3/k3_1.png'/>",
        "question2": "Ａさんの本年分の所得税額を計算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、総所得金額の計算上、住宅借入金等特別控除の適用を受けるものとし、Ａさんが所得金額調整控除の適用対象者に該当している場合、所得金額調整控除額を控除すること。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set3/k3_3.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の計算",
        "important": ""
    },
    {
        "id": 570,
        "shikenId": 15,
        "no": 10,
        "answerType": 4,
        "groupId": 0,
        "answer": "1200,4800",
        "score": "2,2",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set3/k4_1.png'/>",
        "question2": "甲土地と乙土地を一体とした土地上に耐火建築物を建築する場合における次の①、②を求めなさい（計算過程の記載は不要）。<br><br>①　建蔽率の上限となる建築面積<br>②　容積率の上限となる延べ面積",
        "choice1": "㎡",
        "choice2": "㎡",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建蔽率と容積率の計算",
        "important": ""
    },
    {
        "id": 571,
        "shikenId": 15,
        "no": 11,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set3/k4_1.png'/>",
        "question2": "自宅（建物とその敷地である甲土地）の譲渡に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「Ａさんが老朽化した自宅の建物を取り壊し、甲土地を更地にした場合、居住用財産を譲渡した場合の3,000万円の特別控除の適用を受けることはできません。本特例の適用を受けるためには、自宅の建物と甲土地を同時に譲渡する必要があります」",
        "choice2": "「仮に、Ａさんが高層マンションに転居し、その後、居住していない現在の自宅を譲渡した場合に、Ａさんが居住用財産を譲渡した場合の3,000万円の特別控除の適用を受けるためには、家屋に自己が居住しなくなった日から３年を経過する日までの譲渡であること等の要件を満たす必要があります」",
        "choice3": "「居住用財産を譲渡した場合の長期譲渡所得の課税の特例（軽減税率の特例）の適用を受けるためには、譲渡した年の１月１日において自宅の所有期間が10年を超えていなければなりません。相続により取得した不動産は取得時期を引き継ぐため、Ａさんは軽減税率の特例の適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "居住用財産の譲渡の特例",
        "important": ""
    },
    {
        "id": 572,
        "shikenId": 15,
        "no": 12,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,2",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set3/k4_1.png'/>",
        "question2": "土地の有効活用事業方式の一般的な特徴や固定資産税に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「等価交換方式とは、マンション開発業者が建設資金を負担して、マンションを建設し、完成した区分所有建物と土地の共有持分をＡさんとＫ社がそれぞれの出資割合に応じて取得する手法です」",
        "choice2": "「Ａさんが所有する甲土地、乙土地に等価交換方式や建設協力金方式により建物を建築し、Ａさんが取得した建物を賃貸した後、Ａさんに相続が開始した場合、相続税額の計算上、建物は貸家、敷地は貸家建付地として評価されます」",
        "choice3": "「Ａさんが所有する甲土地、乙土地に賃貸マンションを建築した場合、甲土地、乙土地に係る固定資産税の課税標準は、住宅１戸につき200㎡までの部分（小規模住宅用地）について課税標準となるべき価格の３分の１の額とする特例の適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "有効活用事業方式、固定資産税",
        "important": ""
    },
    {
        "id": 573,
        "shikenId": 15,
        "no": 13,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set3/k5_1.png'/>",
        "question2": "「直系尊属から住宅取得資金の贈与を受けた場合の贈与税の非課税」（以下、「本特例」という）に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「二男 C さんが、A さんから住宅取得等資金の贈与を受けて、省エネ等住宅に該当するマンションを購入し、本特例の適用を受ける場合、A さんから贈与を受けた資金は、1,500万円を限度として贈与税が非課税となります」",
        "choice2": "「二男 C さんが、A さんから贈与を受けた住宅取得等資金について、本特例の適用を受け、その3年後にAさんの相続が開始した場合、本特例の適用を受けたことにより贈与税が非課税となった金額は、相続税の課税価格に加算しなければなりません」",
        "choice3": "「本特例の適用を受けるためには、取得等した住宅用家屋の2分の1以上に相当する部分が、二男 C さんの居住の用に供されるものでなければなりません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "住宅取得資金の贈与の特例",
        "important": ""
    },
    {
        "id": 574,
        "shikenId": 15,
        "no": 14,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set3/k5_1.png'/>",
        "question2": "Ａさんの相続に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「公正証書遺言は、証人２人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人がこれを筆記して作成しますが、長男Ｂさん、その妻子および二男Ｃさんは証人になることができません」",
        "choice2": "「自筆証書遺言の紛失等を防ぐために、家庭裁判所で遺言書を保管する自筆証書遺言書保管制度があります。当制度を利用した場合、A さんの相続開始後の遺言書の検認が不要になります」",
        "choice3": "「二男Ｃさんが、Ａさんの生前に家庭裁判所に遺留分および相続の放棄をする旨を申し立てることは可能です」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺言等",
        "important": ""
    },
    {
        "id": 575,
        "shikenId": 15,
        "no": 15,
        "answerType": 6,
        "groupId": 0,
        "answer": "ヘ,イ,ハ,ニ",
        "score": "1,1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set3/k5_1.png'/>",
        "question2": "Ａさんの相続等に関する以下の文章の空欄①～④に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　「遺言により自宅および賃貸アパートを長男Ｂさんに相続させた場合、二男Ｃさんの遺留分を侵害する可能性があります。仮に、遺留分を算定するための財産の価額を２億 2,000万円とした場合、二男Ｃさんの遺留分の額は（ ① ）万円となります」<br><br>Ⅱ　「長男Ｂさんが自宅の敷地および建物を相続により取得し、自宅の敷地（相続税評価額：7,200万円）のすべてについて『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、相続税の課税価格に算入すべき価額を（ ② ）万円とすることができます」<br><br>Ⅲ　「現時点で A さんの相続が開始した場合、相続税の総額の計算において、遺産に係る基礎控除額は（ ③ ）万円となります。相続税の課税価格の合計額が（ ③ ）万円以下であれば、相続税はかかりません」<br><br>Ⅳ　「現時点で A さんの相続が開始し、課税遺産相続を2億円とした場合、相続税の総額は（ ④ ）万円となります」<br><br><img src='/img/set3/k5_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "小規模宅地等の特例の計算等",
        "important": ""
    },
    {
        "id": 576,
        "shikenId": 16,
        "no": 1,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set3/h1_1.png'/>",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、公的介護保険（以下、「介護保険」という）について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「介護保険の保険給付を受けるためには、市町村（特別区を含む）から要介護認定または要支援認定を受ける必要があります。また、40歳以上 60歳未満の医療保険加入者である介護保険の第２号被保険者は、特定疾病が原因で要介護状態または要支援状態となった場合に介護保険の保険給付を受けることができます」",
        "choice2": "「介護保険の第２号被保険者が保険給付を受けた場合の自己負担割合は、原則として実際にかかった費用（食費、居住費等を除く）の１割となりますが、一定金額以上の所得を有する第２号被保険者については、自己負担割合が２割または３割となります」",
        "choice3": "「介護保険の第２号被保険者に係る介護保険料は、国民健康保険の保険料と同時に徴収されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "介護保険",
        "important": ""
    },
    {
        "id": 577,
        "shikenId": 16,
        "no": 2,
        "answerType": 6,
        "groupId": 0,
        "answer": "イ,ホ,ト",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set3/h1_1.png'/>",
        "question2": "次に、Ｍさんは、Ａさんに対してＡさんが受給することができる公的年金からの老齢給付および付加年金について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句を、下記の語句群のなかから選び、その記号を選択してください。<br><br><img src='/img/set3/h1_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金、付加年金、任意加入",
        "important": ""
    },
    {
        "id": 578,
        "shikenId": 16,
        "no": 3,
        "answerType": 6,
        "groupId": 0,
        "answer": "ト,イ,ル,チ",
        "score": "1,1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set3/h1_1.png'/>",
        "question2": "さらに、Ｍさんは、Ａさんに対して、老後の収入を増やすための各種制度等について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br><img src='/img/set3/h1_3.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老後の収入を増やすための制度",
        "important": ""
    },
    {
        "id": 579,
        "shikenId": 16,
        "no": 4,
        "answerType": 4,
        "groupId": 0,
        "answer": "-1540,2000,2600",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set3/h2_1.png'/>",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、必要保障額と現在加入している定期保険特約付終身保険の保障金額について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な数値を求めなさい。なお、空欄①の金額がマイナスになる場合は、金額の前に「-」を記載し、マイナスであることを示すこと。<br><br>　「医療保障を充実させる前に、現時点での必要保障額を算出し、準備すべき死亡保障の額を把握しましょう。下記＜条件＞を参考にすれば、Ａさんが現時点で死亡した場合の必要保障額は（ ① ）万円となります。<br>　Ａさんが現時点で死亡（不慮の事故や所定の感染症以外）した場合、定期保険特約付終身保険から妻Ｂさんに支払われる死亡保険金額は（ ② ）万円となります。他方、Ａさんが不慮の事故で180日以内に死亡した場合の死亡保険金額は（ ③ ）万円となります」<br><br><img src='/img/set3/h2_2.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "必要保障額と生命保険の保障内容の計算",
        "important": ""
    },
    {
        "id": 580,
        "shikenId": 16,
        "no": 5,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2,2",
        "score": "1,1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set3/h2_1.png'/>",
        "question2": "次に、Ｍさんは、Ａさんに対して、公的医療保険制度について説明した。Ｍさんが説明した次の記述①～④について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「Ａさんが病気などで医師の診察を受けた場合、医療費の一部負担金の割合は、原則１割となります。ただし、高額療養費制度により、一医療機関の窓口で支払う同一月内の一部負担金を、所定の自己負担限度額までとすることができます」",
        "choice2": "「高額療養費制度における自己負担限度額は、年齢および所得状況等に応じて決められています。同じ所得金額であっても、70歳未満の者と70歳以上 75歳未満の者とで自己負担限度額の計算の区分は異なります」",
        "choice3": "「 A さんが任意継続被保険者となった場合、妻 B さんは被扶養者となることができないため、妻B さんは国民健康保険に加入する必要があります」",
        "choice4": "「任意継続被保険者となった場合は、原則として、在職中と同様の給付を受けられますが、高額療養費の支給は受けられません」",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "公的医療保険",
        "important": ""
    },
    {
        "id": 581,
        "shikenId": 16,
        "no": 6,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set3/h2_1.png'/>",
        "question2": "さらに、Ｍさんは、Ａさんに対して、Ａさんが現在加入している生命保険の見直しの方法やＡさんが提案を受けた終身医療保険の特徴等についてアドバイスした。Ｍさんがアドバイスした次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「現在加入している定期保険特約付終身保険を見直す方法として、契約転換制度の活用があります。契約転換時の告知や医師の診査は不要であるため、健康状態にかかわらず、保障内容を見直すことができます」",
        "choice2": "「要介護状態となった場合、自宅の改修費用など多額の出費が必要となることがあります。公的介護保険の保険給付は主に訪問介護等の介護サービスなので、一定額を介護一時金で準備しておくことは検討に値します」",
        "choice3": "「厚生労働省の患者調査等の各種データでは、入院日数が年々長くなっており、退院後の通院時の療養に係る費用負担も増えていますので、入院中や退院後の通院に対する保障の充実を検討しましょう」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の見直し等",
        "important": ""
    },
    {
        "id": 582,
        "shikenId": 16,
        "no": 7,
        "answerType": 4,
        "groupId": 0,
        "answer": "35,1850,2075",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set3/h3_1.png'/>",
        "question2": "仮に、Ａさんが役員在任期間（勤続年数）34年４カ月でＸ社を退任し、Ｘ社が役員退職金として6,000万円を支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額を計算した下記の計算式の空欄①～③に入る最も適切な数値を答えなさい。なお、Ａさんは、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set3/h3_2.png'/>",
        "choice1": "年",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 583,
        "shikenId": 16,
        "no": 8,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,1",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set3/h3_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、＜資料１＞の生命保険の特徴等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を解答欄に入力しなさい。",
        "choice1": "「福利厚生プランは、原則として、従業員全員を被保険者とする等の普遍的加入でなければなりませんので、制度導入後に入社した従業員について加入漏れがないように注意してください」",
        "choice2": "「養老保険の死亡保険金が被保険者の遺族に支払われた場合、死亡保険金に係る経理処理は不要であり、Ｘ社は当該契約に係る資産計上額を取り崩し、その金額を雑損失として損金の額に算入します」",
        "choice3": "「福利厚生プランの保険料は、720万円のうち360万円は資産計上し、360万円は福利厚生費として損金の額に算入します」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "福利厚生プラン",
        "important": ""
    },
    {
        "id": 584,
        "shikenId": 16,
        "no": 9,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,1,2,2",
        "score": "1,1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set3/h3_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、＜資料２＞の終身保険の特徴等について説明した。Ｍさんが説明した次の記述①～④について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「当該終身保険は、保険料払込期間における解約返戻金額が低解約返戻金型ではない通常の終身保険に比べて低く、その分保険料は通常の終身保険に比べて割安に設定されています」",
        "choice2": "「Ａさんが勇退する際に、契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義変更することで、当該保険契約を役員退職金の一部として支給することができます。個人の保険として継続することにより、納税資金の確保や死亡保険金の非課税金額の規定の適用など、相続対策として活用することができます」",
        "choice3": "「保険期間中にＸ社に緊急の資金需要が発生した場合、契約者貸付制度を利用することができます。当該制度により借り入れることができる金額は、その時点での既払込保険料相当額が限度となります」",
        "choice4": "「Ｘ社が高度障害保険金を受け取った場合、法人税法上、当該保険金については非課税所得となりますので、益金に計上する必要はありません」",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "終身保険の特徴等",
        "important": ""
    },
    {
        "id": 585,
        "shikenId": 16,
        "no": 10,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set3/h4_1.png'/>",
        "question2": "Ａさんの本年分の所得税の課税等に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「Ａさんが受け取った一時払変額個人年金保険の解約返戻金は、金融類似商品に該当し、源泉分離課税の対象となります」",
        "choice2": "「Ａさんが適用を受けることができる配偶者控除の控除額は、38万円です」",
        "choice3": "「 A さんが通常の医療費控除の適用を受けた場合、確定申告によって、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）の適用も併用して受けられます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税総合",
        "important": ""
    },
    {
        "id": 586,
        "shikenId": 16,
        "no": 11,
        "answerType": 6,
        "groupId": 0,
        "answer": "ロ,ト,ニ",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set3/h4_1.png'/>",
        "question2": "所得税における医療費控除に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選択してください。<br><br>　「通常の医療費控除は、その年分の総所得金額等の合計額が200万円以上である納税者の場合、その年中に支払った医療費の総額から保険金などで補てんされる金額を控除した金額が（ ① ）万円を超えるときは、その超える部分の金額（最高（ ② ）万円）をその納税者のその年分の総所得金額等から控除することができます。Ａさんが支払った医療費が医療費控除の対象であり、保険金がない場合、医療費控除の控除額は（ ③ ）万円です」<br><br><img src='/img/set3/h4_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "医療費控除の計算",
        "important": ""
    },
    {
        "id": 587,
        "shikenId": 16,
        "no": 12,
        "answerType": 4,
        "groupId": 0,
        "answer": "6100000,750000,760000,342500",
        "score": "1,1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set3/h4_1.png'/>",
        "question2": "Ａさんの本年分の所得税の算出税額を計算した下記の表の空欄①～④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set3/h4_3.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の計算",
        "important": ""
    },
    {
        "id": 588,
        "shikenId": 16,
        "no": 13,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1,1",
        "score": "1,1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set3/h5_1.png'/>",
        "question2": "Ａさんの相続に関する次の記述①～④について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「相続税の申告書の提出期限は、原則として、相続の開始があったことを知った日の翌日から４カ月以内です。申告書の提出先は、Ａさんの死亡時の住所地を所轄する税務署長になります」",
        "choice2": "「法務局（遺言書保管所）に保管されている自筆証書遺言は相続開始後、相続人が遅滞なく、家庭裁判所に提出して、その検認の請求をしなければなりません」",
        "choice3": "「相続人間で遺産分割に関する争いが起こり、相続税の申告期限までに遺産分割協議が成立しない場合の期限内の相続税の申告時において、未分割の財産に対しては『配偶者に対する相続税額の軽減』や『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けることができません」",
        "choice4": "「孫Ｆさん、孫Ｇさん、孫Ｈさんが相続または遺贈により財産を取得した場合、孫Ｇさんおよび孫ＨさんはＡさんの二女Ｅさんの代襲相続人ですので、相続税額の２割加算の対象となりませんが、孫Ｆさんは代襲相続人ではありませんので、2割加算の対象となります」",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続開始後の手続き、相続税総合",
        "important": ""
    },
    {
        "id": 589,
        "shikenId": 16,
        "no": 14,
        "answerType": 6,
        "groupId": 0,
        "answer": "チ,ホ,ハ",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set3/h5_1.png'/>",
        "question2": "Ａさんの相続に関する以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br><img src='/img/set3/h5_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税等の計算",
        "important": ""
    },
    {
        "id": 590,
        "shikenId": 16,
        "no": 15,
        "answerType": 4,
        "groupId": 0,
        "answer": "6000,190,1300",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set3/h5_1.png'/>",
        "question2": "Ａさんの相続における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は１億 5,600万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set3/h5_3.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の計算",
        "important": ""
    },
    {
        "id": 591,
        "shikenId": 17,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナー（以下「ＦＰ」という）の顧客に対する行為に関する次の記述のうち、職業倫理や関連法規に照らし、最も不適切なものはどれか。",
        "choice1": "顧客から公正証書遺言の作成時に証人になることを要請されたＦＰが、証人の欠格事由に該当しないことを確認した上で、適正な対価を受けて証人になった。",
        "choice2": "司法書士資格や弁護士資格を有しないＦＰが、顧客からの要請により、有償で当該顧客の任意後見受任者となった。",
        "choice3": "司法書士の資格を有しないＦＰが、住宅ローンを完済した顧客から、抵当権の抹消登記について相談を受け、申請書を作成して、登記手続きを代行した。",
        "choice4": "生命保険募集人や損害保険募集人でないＦＰが、生命保険の必要保障額を試算したり、生命保険や損害保険の商品の保障（補償）内容についてアドバイスをした。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "関連法規とコンプライアンス",
        "important": ""
    },
    {
        "id": 592,
        "shikenId": 17,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "ライフプランニングにおいて活用される各種係数に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "一定の利率で複利運用しながら一定期間後の元利合計額を試算する場合、現在保有する資金の額に乗じる係数は、終価係数である。",
        "choice2": "一定の利率で複利運用しながら一定期間後に目標とする額を得るために必要な毎年の積立額を試算する場合、目標とする額に乗じる係数は、減債基金係数である。",
        "choice3": "一定の利率で複利運用しながら一定期間、毎年一定金額を積み立てた場合の一定期間後の元利合計額を試算する場合、毎年の積立額に乗じる係数は、年金終価係数である。",
        "choice4": "一定の利率で複利運用しながら一定期間、毎年一定金額を受け取るために必要な元本を試算する場合、毎年受け取りたい金額に乗じる係数は、資本回収係数である。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "各種係数",
        "important": ""
    },
    {
        "id": 593,
        "shikenId": 17,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "公的医療保険に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "全国健康保険協会管掌健康保険（協会けんぽ）の一般保険料率は全国一律であるが、介護保険料率は都道府県ごと保険料率が異なる。",
        "choice2": "健康保険の適用事業所に常時使用される７５歳未満の者は、原則として、全国健康保険協会管掌健康保険（協会けんぽ）または組合管掌健康保険に加入することになる。",
        "choice3": "健康保険の任意継続被保険者となるためには、健康保険の被保険者資格を喪失した日の前日まで継続して２年以上の被保険者期間が必要である。",
        "choice4": "個人事業主などが被保険者となる国民健康保険は、国が保険者として運営している。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的医療保険",
        "important": ""
    },
    {
        "id": 594,
        "shikenId": 17,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "国民年金の保険料に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "第１号被保険者で障害基礎年金を受給している者は、原則として、所定の届出により、保険料の納付が免除される。",
        "choice2": "学生を除く５０歳未満の第１号被保険者は、本人および配偶者の前年の所得（１月から６月までの月分の保険料については前々年の所得）がそれぞれ一定金額以下の場合、所定の申請により、保険料納付猶予制度の適用を受けることができる。",
        "choice3": "第１号被保険者である大学生は、本人の所得金額の多寡にかかわらず、所定の申請により、学生納付特例制度の適用を受けることができる。",
        "choice4": "第１号被保険者が出産する場合、所定の届出により、出産予定月の前月から４ヵ月間（多胎妊娠の場合は出産予定月の３ヵ月前から６ヵ月間）、保険料の納付が免除される。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "国民年金の保険料",
        "important": ""
    },
    {
        "id": 595,
        "shikenId": 17,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "老齢厚生年金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "６５歳以上の厚生年金保険の被保険者に支給される老齢厚生年金は、在職老齢年金の仕組みにより、その受給権者の総報酬月額相当額と基本月額との合計額が５１万円（本年度価額）を超えた場合、超える部分の２分の１が支給停止となる。",
        "choice2": "厚生年金保険適用事業所に勤めていても、７０歳以降は厚生年金保険の被保険者とはならないため、７０歳以降は在職老齢年金の仕組みは適用されない。",
        "choice3": "老齢厚生年金の加給年金は、その受給権者に、所定の要件を満たす配偶者または子があり、原則として、厚生年金保険の被保険者期間が２５年以上あることが支給要件とされる。",
        "choice4": "２０２２年４月１日以降に６０歳に到達する者の老齢厚生年金の繰上げ支給による減額率は、繰り上げた月数に０．５％を乗じて得た率で最大３０％となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢厚生年金",
        "important": ""
    },
    {
        "id": 596,
        "shikenId": 17,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "公的年金の遺族給付に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "遺族基礎年金を受給することができる遺族は、国民年金の被保険者等の死亡当時その者によって生計を維持し、かつ、所定の要件を満たす「子のある妻」または「子」である。",
        "choice2": "国民年金の第１号被保険者としての保険料納付済期間が３６月以上ある者が、老齢基礎年金または障害基礎年金の支給を受けないまま死亡し、遺族基礎年金の支給を受けられる遺族がいない場合、死亡した者と生計を同じくしていた一定の遺族に死亡一時金が支給される。",
        "choice3": "厚生年金保険の被保険者である夫が死亡し、子のない３０歳未満の妻が遺族厚生年金の受給権を取得した場合、その妻に対する遺族厚生年金の支給期間は、最長で１０年間である。",
        "choice4": "遺族厚生年金の年金額は、原則として、死亡した者の厚生年金保険の被保険者記録を基に計算された老齢厚生年金の報酬比例部分の３分の２相当額である。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "公的年金の遺族給付",
        "important": ""
    },
    {
        "id": 597,
        "shikenId": 17,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "確定拠出年金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "個人型年金の加入者が国民年金の第１号被保険者である場合、掛金の拠出限度額は年額８４０, ０００円である。",
        "choice2": "個人型年金の加入者が国民年金の第３号被保険者である場合、掛金の拠出限度額は年額２７６, ０００円である。",
        "choice3": "確定拠出年金の通算加入者等期間が１０年以上である場合、老齢給付金は最も早くて６５歳から受給することができる。",
        "choice4": "一時金で受け取る老齢給付金は、一時所得として所得税の課税対象となる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "確定拠出年金",
        "important": ""
    },
    {
        "id": 598,
        "shikenId": 17,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "奨学金および教育ローンに関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "日本学生支援機構の貸与型奨学金は、原則として、連帯保証人および保証人による人的保証と日本国際教育支援協会による機関保証の両方の保証が必要となる。",
        "choice2": "日本学生支援機構の給付型奨学金は、海外留学資金として利用することはできない。",
        "choice3": "日本学生支援機構の奨学金と日本政策金融公庫の教育一般貸付（国の教育ローン）は、重複して利用することができる。",
        "choice4": "日本政策金融公庫の教育一般貸付（国の教育ローン）の融資限度額は、外国の教育施設に３ヵ月以上在籍する資金として利用する場合は学生・生徒１人につき３５０万円である。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "奨学金および教育ローン",
        "important": ""
    },
    {
        "id": 599,
        "shikenId": 17,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "変動金利型の住宅ローンを返済しているAさんの返済方法の見直し等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "Aさんが別の金融機関の住宅ローンに借り換える場合、元利均等返済を選択するほうが、他の条件が同じ元金均等返済と比べて、総返済額は少なくなる。",
        "choice2": "Aさんが住宅ローンの借換えに際して、現在借入れをしている金融機関の抵当権を抹消し、借換先の金融機関の抵当権を新たに設定する場合には、登録免許税等の諸費用が必要ない。",
        "choice3": "住宅金融支援機構と民間金融機関が提携して提供する「フラット35 」は、すべての商品が住宅取得時における利用に限定されているため、Aさんは住宅ローンの借換先として選択することができない。",
        "choice4": "Aさんが全期間固定金利型の住宅ローンに借り換えた場合、仮に返済期間中に市中金利が上昇しても、金利の上昇分に相当する額の返済負担が増加するリスクは避けられる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "住宅ローンの返済方法の見直し",
        "important": ""
    },
    {
        "id": 600,
        "shikenId": 17,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "中小企業による金融機関からの資金調達に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "手形貸付は、借入れについての内容や条件等を記載した金銭消費貸借契約証書によって資金を調達する方法である。",
        "choice2": "信用保証協会保証付融資（マル保融資）の対象となる企業には、業種に応じた資本金または常時使用する従業員数の要件はない。",
        "choice3": "ＡＢＬ（動産・債権担保融資）は、企業が保有する売掛債権等の債権や在庫・機械設備等の動産を担保として資金を調達する方法である。",
        "choice4": "インパクトローンは、米ドル等の外貨によって資金を調達する方法であり、その資金使途は限定されている。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "中小企業の資金調達",
        "important": ""
    },
    {
        "id": 601,
        "shikenId": 17,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "保険法に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "保険法では、保険契約者と被保険者が異なる死亡保険契約は、その加入に当たって、被保険者の同意が必要とされる。",
        "choice2": "保険法では、告知義務に関して、同法の規定よりも保険契約者、被保険者にとって不利な内容である約款の定めは、適用除外となる一部の保険契約を除き、無効となる旨が定められている。",
        "choice3": "保険法は、保険契約と同等の内容を有する共済契約についても適用対象となる。",
        "choice4": "保険法では、保険金等の支払時期に関する規定が設けられており、同法の施行日後に締結された保険契約に限って適用される。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "保険法",
        "important": ""
    },
    {
        "id": 602,
        "shikenId": 17,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "死亡保障を目的とする生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
        "choice1": "逓減定期保険は、保険期間の経過に伴い所定の割合で保険金額および保険料が逓減する。",
        "choice2": "終身保険の保険料は、被保険者の年齢、死亡保険金額、保険料払込期間など契約内容が同一の場合、一般に、被保険者が女性である方が男性であるよりも高い。",
        "choice3": "特定疾病保障定期保険は、被保険者がガン、急性心筋梗塞、脳卒中以外で死亡した場合には、死亡保険金は支払われない。",
        "choice4": "変額保険（終身型）は、一般に、契約時に定めた死亡保険金額（基本保険金額）が保証されている。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "死亡保障目的の生命保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 603,
        "shikenId": 17,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "所得税の生命保険料控除に関する次の記述のうち、最も適切なものはどれか。なお、他の要件は満たしているものとする。",
        "choice1": "本年中に契約した一時払定額個人年金保険の保険料は、支払った年のみ、個人年金保険料控除の対象となる。",
        "choice2": "本年に契約した特定（三大）疾病保障定期保険の保険料は、介護医療保険料控除の対象となる。",
        "choice3": "外貨建て終身保険は、円貨建ての終身保険と異なり、支払った保険料は生命保険料控除の対象とならない。",
        "choice4": "２０１１年１２月３１日までに締結した医療保険（更新型）の保険料は、更新月の前月までは一般の生命保険料控除の対象となり、今後、更新した月以後は、介護医療保険料控除の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険料控除",
        "important": ""
    },
    {
        "id": 604,
        "shikenId": 17,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "生命保険の税金に関する次の記述のうち、最も適切なものはどれか。なお、いずれも契約者（＝保険料負担者）および保険金・給付金等の受取人は個人であるものとする。",
        "choice1": "一時払終身保険を保険期間の初日から３年８ヵ月で解約して契約者が受け取った解約返戻金は、一時所得として総合課税の対象となる。",
        "choice2": "契約者と被保険者が同一人である終身保険において、被保険者がリビング・ニーズ特約に基づいて受け取った特約保険金は、一時所得として課税の対象となる。",
        "choice3": "契約者と被保険者が同一人である医療保険において、被保険者が疾病の治療により入院したことで受け取った入院給付金は、一時所得として課税の対象となる。",
        "choice4": "契約者と被保険者が同一人である養老保険において、被保険者の相続人ではない者が受け取った死亡保険金は、贈与税の課税対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "個人の生命保険の税金",
        "important": ""
    },
    {
        "id": 605,
        "shikenId": 17,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "法人を契約者（＝保険料負担者）とする生命保険に係る保険料の経理処理に関する次の記述のうち、最も適切なものはどれか。なお、いずれも保険料は年払いで、いずれの保険契約も新たに締結したものとする。",
        "choice1": "被保険者が役員のみ、死亡保険金受取人が被保険者の遺族、満期保険金受取人が法人である養老保険の支払保険料は、その２分の１相当額を資産に計上し、残額を福利厚生費として損金の額に算入することができる。",
        "choice2": "被保険者が役員、死亡保険金受取人が法人で、最高解約返戻率が８０％である定期保険（保険期間１０年）の支払保険料は、保険期間の前半４割相当期間においては、その４０％相当額を資産に計上し、残額を損金の額に算入することができる。",
        "choice3": "被保険者が役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を資産に計上する。",
        "choice4": "被保険者が役員、給付金受取人が法人である解約返戻金のない医療保険の支払保険料は、資産に計上する。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "法人契約の生命保険の経理処理",
        "important": ""
    },
    {
        "id": 606,
        "shikenId": 17,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "傷害保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "家族傷害保険の被保険者は、被保険者本人、配偶者、被保険者本人または配偶者と生計を共にする同居の親族および別居の未婚の子であり、その続柄は事故発生時におけるものによる。",
        "choice2": "普通傷害保険では、日本国外における業務中の事故によるケガは補償の対象とならない。",
        "choice3": "国内旅行傷害保険では、国内旅行中にかかった細菌性食中毒は補償の対象とならない。",
        "choice4": "海外旅行傷害保険では、日本を出国してから帰国するまでの間の事故によって被った損害を補償の対象としており、国内移動中の事故によるケガは補償の対象とならない。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "傷害保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 607,
        "shikenId": 17,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "豪雨による洪水で被保険自動車が水没して損害が生じた場合、一般条件の車両保険の補償の対象となる。",
        "choice2": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って通行人が連れていたペットの犬に接触してケガをさせたことにより、法律上の損害賠償責任を負った場合、対物賠償保険の補償の対象となる。",
        "choice3": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って飲食店の店舗に衝突した場合、店舗の復旧期間中の休業損害は、対物賠償保険の補償の対象となる。",
        "choice4": "自動車保険のノンフリート等級別料率制度では、人身傷害保険の保険金が支払われる場合、1 等級ダウン事故となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "自動車保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 608,
        "shikenId": 17,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "地震保険料控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "地震保険料控除の控除限度額は、所得税では４０，０００円、住民税では２８，０００円である。",
        "choice2": "地震保険の保険期間が１年を超える長期契約で、地震保険料を一括で支払った場合、その全額が支払った年分の地震保険料控除の対象となる。",
        "choice3": "店舗併用住宅の所有者が、当該家屋を保険の対象とする火災保険に地震保険を付帯して契約した場合、当該家屋全体の９０％以上を居住の用に供しているときは、支払った地震保険料の全額を居住用として地震保険料控除を計算できる。",
        "choice4": "居住用家屋を保険の対象とする地震保険の保険料は、その家屋の所有者と契約者（＝保険料負担者）が同一人である場合に限り、地震保険料控除の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "地震保険料控除",
        "important": ""
    },
    {
        "id": 609,
        "shikenId": 17,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "契約者（＝保険料負担者）を法人とする損害保険に係る経理処理に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "法人が所有する建物について長期の火災保険に加入し、保険料を一括で支払った場合、支払った保険料のうち当該事業年度に係る部分については損金の額に算入することができる。",
        "choice2": "業務中の事故で従業員が死亡し、普通傷害保険の死亡保険金が保険会社から従業員の遺族へ直接支払われた場合、法人は死亡保険金の一部を死亡退職金として損金の額に算入することができる。",
        "choice3": "法人が所有する業務用自動車が交通事故で全損となり、受け取った自動車保険の車両保険の保険金で同一事業年度内に代替となる車両を取得した場合、所定の要件に基づき圧縮記帳が認められる。",
        "choice4": "積立普通傷害保険の満期返戻金と契約者配当金を法人が受け取った場合、いずれも全額を益金の額に算入し、それまで資産計上していた積立保険料の累計額を取り崩して損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "法人契約の損害保険の経理処理",
        "important": ""
    },
    {
        "id": 610,
        "shikenId": 17,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "第三分野の保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "特定疾病保障保険は、ガンに罹患して特定疾病保険金が支払われた後も契約が存続し、ガンが再発した場合には、１度目の再発に限り特定疾病保険金が支払われる。",
        "choice2": "所得補償保険は、被保険者が保険会社所定の病気により就業不能になった場合には補償の対象となるが、ケガにより就業不能になった場合には補償の対象とならない。",
        "choice3": "ガン保険は、契約日から２カ月経過以降に被保険者がガンと診断された場合、診断給付金が支払われる。",
        "choice4": "医療保険（更新型）は、所定の年齢の範囲内であれば、保険期間中に入院給付金を受け取ったとしても、契約を更新することができる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "第三分野の保険の一般的な商品性",
        "important": ""
    },
    {
        "id": 611,
        "shikenId": 17,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "内閣府が公表する景気動向指数に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "景気動向指数の遅行系列に採用されているものには、消費者物価指数、新規求人数等がある。",
        "choice2": "景気動向指数に採用されている指数は、先行指数が１１系列、一致指数が１０系列、遅行指数が９系列の合計３０系列となっている。",
        "choice3": "景気動向指数の先行系列に採用されているものには、新設住宅着工床面積、完全失業率等がある。",
        "choice4": "景気動向指数の一致系列に採用されているものには、有効求人倍率（除学卒）、法人税収入等がある。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "景気動向指数",
        "important": ""
    },
    {
        "id": 612,
        "shikenId": 17,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預金等の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "貯蓄預金は、クレジットカード利用代金などの自動振替口座や、給与や年金などの自動受取口座として利用することができる。",
        "choice2": "当座預金は、公共料金などの自動振替口座として利用することはできるが、株式の配当金の自動受取口座として利用することはできない。",
        "choice3": "スーパー定期は、市場金利の動向等に応じて、各金融機関が預金金利を設定する。",
        "choice4": "ゆうちょ銀行の預入限度額は、通常貯金と定期性貯金（財形貯金各種を除く）を合わせて１,３００万円である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "預金等の一般的な商品性",
        "important": ""
    },
    {
        "id": 613,
        "shikenId": 17,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "投資信託の一般的な運用手法や費用に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "割高な銘柄の買建てと割安な銘柄の売建てをそれぞれ同程度の金額で行い、市場全体の変動の影響を最小限に抑えて収益の確保を目指す手法を、マーケット・ニュートラル運用という。",
        "choice2": "会計監査に必要な費用や組入有価証券に係る売買委託手数料は、委託者（運用会社）が負担する費用である。",
        "choice3": "「ブル型」「ベア型」と呼ばれる特殊型の投資信託のうち、「ベア型」は、ベンチマークが下落すると基準価額が上昇するように運用されている。",
        "choice4": "信託財産留保額は、投資信託を保有する投資家の公平性を確保するための費用であり、すべての投資信託に設定され、中途換金時に解約代金から徴収される。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "投資信託",
        "important": ""
    },
    {
        "id": 614,
        "shikenId": 17,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "上場投資信託（ＥＴＦ）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "上場投資信託（ＥＴＦ）の分配金を受け取るためには、ＥＴＦの決算日（権利確定日）において所有者になっている必要がある。",
        "choice2": "ＥＴＦを市場で売買する際に支払う委託手数料は、証券会社により異なる。",
        "choice3": "証券取引所を通じて行うＥＴＦの売買取引では、現物取引のほか、信用取引も行うことができる。",
        "choice4": "ＥＴＦを証券取引所の立会時間中に売買する場合、成行注文はできるが、指値注文はできない。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "上場投資信託（ETF）",
        "important": ""
    },
    {
        "id": 615,
        "shikenId": 17,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "債券のイールドカーブ（利回り曲線）およびデュレーションの一般的な特徴等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "イールドカーブは、景気がよいときに中央銀行が金融引締めを行うとスティープ化し、景気が悪いときに中央銀行が金融緩和を行うとフラット化する傾向がある。",
        "choice2": "イールドカーブの形状は、通常、右上がりの順イールドであるが、急激な金融引締め時に右下がりの逆イールドとなる傾向がある。",
        "choice3": "デュレーション（債券への投資資金の平均回収期間、債券投資における金利変動に対する債券価格の感応度）について、他の条件が同じであれば、債券の表面利率が低いほど、また残存期間が長いほど、デュレーションは長くなる。",
        "choice4": "割引債券のデュレーションは、利息収入がないため残存期間と等しくなり、利付債券のデュレーションは、一定期間ごとに利息を受け取ることができる分、残存期間よりも短くなる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "イールドカーブ、デュレーション",
        "important": ""
    },
    {
        "id": 616,
        "shikenId": 17,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "株式指標の一般的な特徴に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "ＰＥＲ（倍）は、「株価÷１株当たり経常利益」の算式により計算され、業種および事業内容が同一である場合、数値が高いほど割高と考えられる。",
        "choice2": "ＰＢＲ（倍）は、「株価÷１株当たり総資産」の算式により計算され、これが１倍を下回ると、理論上、株価は解散価値を下回っていることを示す。",
        "choice3": "ＲＯＥ（％）は、「当期純利益÷自己資本×１００」により求められ、数値が高いほど、会社が自己資本を効率的に活用して利益を上げていると評価できる。",
        "choice4": "配当利回り（％）は、「配当金総額÷純資産×１００」の算式により計算され、この値が高いほど投資価値が高いと考えられる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式指標",
        "important": ""
    },
    {
        "id": 617,
        "shikenId": 17,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "金融派生商品に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "先物取引には、証拠金を預けることによって、それよりも多額の取引ができるという現物取引にはない特徴があり、これをレバレッジ効果という。",
        "choice2": "ヘッジ取引には、将来の価格上昇リスク等を回避または軽減する売りヘッジと将来の価格下落リスク等を回避または軽減する買いヘッジがある。",
        "choice3": "現物と反対のポジションの先物を保有することなどにより、価格変動リスク等を回避または軽減することを狙う取引を、ヘッジ取引という。",
        "choice4": "先物の将来の価格を予想してポジションを取り、予想どおりの方向に変動したときに、反対売買を行って利益を確定する取引を、スペキュレーション取引という。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金融派生商品",
        "important": ""
    },
    {
        "id": 618,
        "shikenId": 17,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "上場株式の譲渡および配当（一定の大口株主等が受けるものを除く）および特定公社債の譲渡および利子に係る税金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "上場株式等の配当金について、申告分離課税を選択して確定申告をした場合、配当控除の適用を受けることができる。",
        "choice2": "上場株式等の譲渡損失を翌年以降に繰り越すには、特定口座の源泉徴収選択口座を選択している場合でも、確定申告が必要となる。",
        "choice3": "上場株式等の譲渡損失は、特定公社債の利子等に係る利子所得と損益通算することができる。",
        "choice4": "特定公社債の譲渡所得等および利子所得は、申告分離課税の対象となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "上場株式等の税金",
        "important": ""
    },
    {
        "id": 619,
        "shikenId": 17,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "ポートフォリオ理論に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "ポートフォリオの期待収益率は、組み入れた各資産の期待収益率を組入比率で加重平均した値となる。",
        "choice2": "株式のポートフォリオにおいて、組入銘柄数を増やすことにより、システマティック・リスクを低減することができる。",
        "choice3": "ポートフォリオのリスクは、組み入れた各資産のリスクを組入比率で加重平均した値よりも大きくなる。",
        "choice4": "異なる２資産からなるポートフォリオにおいて、２資産間の相関係数が１である場合、ポートフォリオを組成することによる分散投資の効果（リスクの低減効果）は最大となる。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "ポートフォリオ理論",
        "important": ""
    },
    {
        "id": 620,
        "shikenId": 17,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "わが国における個人による金融商品取引に係るセーフティネットに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "国内銀行に預け入れられている円預金のうち、財形貯蓄や確定拠出年金制度で運用されている預金も、預金保険制度による保護の対象となる。",
        "choice2": "国内銀行に預け入れた外貨預金は預金保険制度による保護の対象となるが、外国銀行の在日支店に預け入れた外貨預金は預金保険制度による保護の対象とならない。",
        "choice3": "国内銀行に預け入れた決済用預金は、その金額の多寡にかかわらず、全額が預金保険制度による保護の対象となる。",
        "choice4": "証券会社が破綻し、分別管理が適切に行われていなかったために、一般顧客の資産の一部または全部が返還されない事態が生じた場合、日本投資者保護基金により、補償対象債権に係る顧客資産について一般顧客１人当たり１, ０００万円を上限として補償される。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "セーフティネット",
        "important": ""
    },
    {
        "id": 621,
        "shikenId": 17,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税の原則的な仕組みに関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "所得税では、課税対象となる所得を８種類に区分して、それぞれの所得の種類ごとに定められた計算方法により所得の金額を計算する。",
        "choice2": "非居住者は国内源泉所得についてのみ所得税の納税義務がある。",
        "choice3": "所得税は、納税者が申告をした後に、税務署長が所得や納付すべき税額を決定する賦課課税方式を採用している。",
        "choice4": "課税総所得金額に対する所得税額は、課税総所得金額の多寡にかかわらず、一律の税率により計算する。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の原則的な仕組み",
        "important": ""
    },
    {
        "id": 622,
        "shikenId": 17,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税の申告と納付に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "確定申告書を提出した納税者が、法定申告期限後に計算の誤りにより所得税を過大に申告し納付したことに気づいた場合、原則として、法定申告期限から３年以内に限り、更正の請求をすることができる。",
        "choice2": "納税者が、確定申告に係る所得税について延納の適用を受けようとする場合、納期限までに納付すべき所得税額の2分の1相当額以上を納付する必要がある。",
        "choice3": "年間の給与収入の金額が800万円で年末調整が済んでいる給与所得者は、生命保険の満期保険金に係る一時所得の金額が50万円ある場合、確定申告は不要である。",
        "choice4": "年間の給与収入の金額が800万円で年末調整が済んでいる給与所得者は、アルバイトとして兼業しているZ社からの給与の収入金額が30万円ある場合、確定申告は不要である。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の申告と納付",
        "important": ""
    },
    {
        "id": 623,
        "shikenId": 17,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "所得税における各種所得に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "会社員が勤務先から無利息で金銭を借り入れたことによる経済的利益は、利子所得に該当する。",
        "choice2": "貸付けが事業的規模で行われているアパート経営の賃貸収入に係る所得は、事業所得に該当する。",
        "choice3": "賃貸していた土地および建物を売却したことによる所得は、不動産所得に該当する。",
        "choice4": "専業主婦が金地金を売却したことによる所得は、譲渡所得に該当する。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "各種所得",
        "important": ""
    },
    {
        "id": 624,
        "shikenId": 17,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "Ａさんの本年分の所得の金額が下記のとおりであった場合の所得税における総所得金額として、最も適切なものはどれか。なお、▲が付された所得の金額は、その所得に損失が発生していることを意味するものとする。<br><br><img src='/img/set4/1_34.png'/>",
        "choice1": "４３０万円",
        "choice2": "５０５万円",
        "choice3": "５３０万円",
        "choice4": "５５０万円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "損益通算と総所得金額の計算",
        "important": ""
    },
    {
        "id": 625,
        "shikenId": 17,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "基礎控除は、納税者本人の合計所得金額を問わず、誰でも４８万円を控除することができる。",
        "choice2": "配偶者控除および配偶者特別控除は、納税者本人の合計所得金額が１，０００万円を超える場合、控除することができない。",
        "choice3": "扶養控除の対象となる控除対象扶養親族のうち、同居老親等とは納税者またはその配偶者の直系尊属で同居している６５歳以上の老人扶養親族をいう。",
        "choice4": "控除対象扶養親族のうち、特定扶養親族とは、その年の１２月３１日現在の年齢が１９歳以上２３歳未満の者をいい、控除額は５８万円である。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 626,
        "shikenId": 17,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "新たに本年中に新築住宅（省エネ基準適合住宅、ＺＥＨ水準省エネ住宅、認定住宅）を取得・入居した場合の所得税における住宅借入金等特別控除（以下、「住宅ローン控除」という）に関する次の記述のうち、最も適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。",
        "choice1": "住宅ローン控除を受けようとする年の合計所得金額は３，０００万円以下でなければならない。",
        "choice2": "住宅ローン控除の控除額は、住宅ローン等の年末残高の合計額（限度額あり）に控除率１％を乗じて求められる。",
        "choice3": "住宅ローン控除の適用を受ける場合、居住の用に供した年分以後１０年間、各年分の所得税額から控除することができる。",
        "choice4": "住宅ローン控除の適用を受けるためには、その対象となる家屋を取得等した日から６カ月以内に自己の居住の用に供さなければならない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 627,
        "shikenId": 17,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税の青色申告の特典に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "青色申告者が確定申告の期限後に確定申告書を提出した場合、受けられる青色申告特別控除額は最大１０万円となる。",
        "choice2": "青色申告者に損益通算してもなお控除しきれない損失の金額（純損失の金額）が生じた場合、翌年以後最長で７年にわたり繰り越して、各年分の所得金額から控除することができる。",
        "choice3": "事業所得を生ずる業務を営む納税者が配偶者に青色事業専従者給与を支払った場合、その支払った額が一定額以下であり、納税者の合計所得金額が一定額以下であれば、支払った給与を必要経費に算入することに加えて、配偶者控除の適用を受けることができる。",
        "choice4": "事業的規模でない不動産所得を生ずべき業務を行っている青色申告者と生計を一にする配偶者がその業務に専従している場合、所定の届出により、その配偶者に支払った給与を青色事業専従者給与として必要経費に算入することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "青色申告",
        "important": ""
    },
    {
        "id": 628,
        "shikenId": 17,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "法人税の仕組みに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "法人税額は、各事業年度の確定した決算に基づく当期純利益の額に税率を乗じて算出される。",
        "choice2": "法人税法上の法人には、普通法人、公益法人等、人格のない社団等などの種類があり、それぞれの種類について納税義務の有無や課税所得等の範囲が定められている。",
        "choice3": "法人税の確定申告による納付は、原則として、各事業年度終了の日の翌日から２ヵ月以内にしなければならない。",
        "choice4": "法人税の納税地は、法人の本店または主たる事務所の所在地である。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人税の仕組み",
        "important": ""
    },
    {
        "id": 629,
        "shikenId": 17,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "法人税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "法人が納付した法人税の本税および法人住民税の本税は、その全額を損金の額に算入することができない。",
        "choice2": "会社が役員に支給した退職金は、不相当に高額な部分を除き、支給する金額が確定した事業年度に損金に算入することができる。",
        "choice3": "法人が支払う固定資産税、都市計画税、印紙税、事業所税は、損金に算入することができる。",
        "choice4": "法人が減価償却費として損金経理した金額のうち、償却限度額を超える部分の金額は、その事業年度の損金の額に算入することができる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "法人税",
        "important": ""
    },
    {
        "id": 630,
        "shikenId": 17,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "消費税に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "簡易課税制度の適用を受けた事業者は、課税売上高に従業員数に応じて定められたみなし仕入率を乗じて仕入に係る消費税額を計算する。",
        "choice2": "課税事業者は、免税事業者に対して支払った消費税全額を仕入税額として控除することができる。",
        "choice3": "「消費税課税事業者選択届出書」を提出して消費税の課税事業者となった法人は、事業を廃止した場合を除き、原則として２年間は消費税の免税事業者となることができない。",
        "choice4": "消費税の課税事業者である個人事業者は、原則として、消費税の確定申告書をその年の翌年３月１５日までに納税地の所轄税務署長に提出しなければならない。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "消費税",
        "important": ""
    },
    {
        "id": 631,
        "shikenId": 17,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "土地の価格に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "都道府県地価調査の基準地の標準価格は、毎年７月１日を価格判定の基準としている。",
        "choice2": "相続税路線価は、地価公示の公示価格の８０％を価格水準の目安として設定されている。",
        "choice3": "評価替えの基準年度における固定資産税評価額は、前年の公示価格の６０％を価格水準の基準として決定されている。",
        "choice4": "固定資産課税台帳に登録する土地の価格は、市町村長が決定する。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "土地の価格",
        "important": ""
    },
    {
        "id": 632,
        "shikenId": 17,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "宅地建物取引業法に関する次の記述のうち、最も不適切なものはどれか。なお、買主は宅地建物取引業者ではないものとする。",
        "choice1": "宅地建物取引業者は、自ら売主となる宅地・建物の売買契約を締結したときは、当該買主に、遅滞なく、宅地建物取引士をして、宅地建物取引業法第３５条に規定する重要事項を記載した書面を交付して説明をさせなければならない。",
        "choice2": "宅地建物取引業者は、自ら売主となる宅地・建物の売買契約の締結に際して、売買代金の２割を超える額の手付を受領することができない。",
        "choice3": "宅地建物取引業者が、宅地・建物の貸借の媒介を行う場合に、貸主・借主の双方から受け取ることのできる報酬の合計額の上限は、賃料の１ヵ月分に消費税を加えた金額に相当する額である。",
        "choice4": "専任媒介契約の有効期間は、３ヵ月を超えることができず、これより長い期間を定めたときは、３カ月とされ、３カ月を超える部分が無効とされる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "宅地建物取引業法",
        "important": ""
    },
    {
        "id": 633,
        "shikenId": 17,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "不動産の売買契約における民法上の留意点に関する次の記述のうち、最も適切なものはどれか。 なお、記載のない特約については考慮しないものとする。",
        "choice1": "買主に債務の履行不能が生じた場合、売主が契約を解除するためには、相当の期間を定めて履行の催告をしなければならない。",
        "choice2": "買主が売主に解約手付を交付した場合、買主が契約の履行に着手するまでは、売主は、受領した手付金を買主に現実に提供することにより、契約を解除することができる。",
        "choice3": "土地の売買契約において、その土地の登記記録の面積と実測面積とが相違していても、その面積の差に基づく売買代金の増減精算は行わないという旨の特約は有効である。",
        "choice4": "民法上、売主が種類または品質に関して契約内容に適合しない目的物を買主に引き渡した場合、買主は不適合を知ったときから２年以内に売主に対してその旨を通知しなければ、不適合を理由とする追完請求、代金減額請求、損害賠償請求、契約の解除はできない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の売買契約における民法上の留意点",
        "important": ""
    },
    {
        "id": 634,
        "shikenId": 17,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "民法および借地借家法に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、同法における定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。",
        "choice1": "賃借人は、建物の引渡しを受けた後にこれに生じた損傷であっても、通常の使用および収益によって生じた建物の損耗および経年変化については、賃貸借終了時、原状に復する義務を負わない。",
        "choice2": "期間の定めがある普通借家契約において、賃借人は、正当の事由があると認められるときでなければ、賃貸人に対して更新しない旨の通知をすることができない。",
        "choice3": "定期借家契約は、公正証書以外の書面（電磁的記録を含む）によって、締結することができる。",
        "choice4": "定期借家契約では、賃貸借期間が１年以上の場合、賃貸人は、原則として、期間満了の１年前から６ヵ月前までの間に賃借人に対して期間満了により契約が終了する旨の通知をしなければ、その終了を賃借人に対抗することができない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "借家",
        "important": ""
    },
    {
        "id": 635,
        "shikenId": 17,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "市街化調整区域内において、農業を営む者の居住の用に供する建築物の建築を目的として行う開発行為は、都道府県知事の許可が必要である。",
        "choice2": "開発許可を受けた開発区域内の土地においては、開発行為に関する工事完了の公告があるまでの間は、原則として、建築物を建築することができない。",
        "choice3": "土地の区画形質の変更は、建築物の建築や特定工作物の建設の用に供することを目的としていない場合であっても、開発行為に該当する。",
        "choice4": "土地区画整理事業、市街地再開発事業の施行として行う開発行為は、都道府県知事等の許可が必要である。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "都市計画法",
        "important": ""
    },
    {
        "id": 636,
        "shikenId": 17,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "第一種低層住居専用地域、第二種低層住居専用地域、田園住居地域の建築物の高さは、原則として１０ｍまたは１２ｍを超えてはならない。",
        "choice2": "全ての用途地域で適用される斜線制限は、隣地斜線制限である。",
        "choice3": "北側斜線制限は、第一種低層住居専用地域内の建築物は適用されるが、商業地域内の建築物には適用されない。",
        "choice4": "日影規制（日影による中高層の建築物の高さの制限）は、原則として、工業専用地域、工業地域、商業地域では適用されない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築基準法",
        "important": ""
    },
    {
        "id": 637,
        "shikenId": 17,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "区分所有者であっても希望すれば管理組合を任意に脱退できる。",
        "choice2": "区分所有建物のうち、構造上の独立性と利用上の独立性を備えた建物の部分は、区分所有権の目的となる専有部分であり、規約によって共用部分とすることはできない。",
        "choice3": "建替え決議を除く集会の招集の通知は、規約で別段の定めをしない限り、開催日の少なくとも１週間前までに会議の目的たる事項を示して各区分所有者に発しなければならない。",
        "choice4": "規約を変更するためには、区分所有者および議決権の各５分の４以上の多数による集会の決議が必要となる。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "区分所有法",
        "important": ""
    },
    {
        "id": 638,
        "shikenId": 17,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "不動産に係る固定資産税および都市計画税に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "土地および家屋に係る固定資産税の税率は１. ４％と定められており、各市町村は条例によってこれと異なる税率を定めることができない。",
        "choice2": "都市計画税は、都市計画区域のうち、原則として市街化調整区域内に所在する土地または家屋の所有者に対して課される。",
        "choice3": "地方税法において、固定資産税における小規模住宅用地（住宅用地で住宅１戸当たり２００㎡以下の部分）の課税標準については、課税標準となるべき価格の３分の１の額とする特例がある。",
        "choice4": "固定資産税および都市計画税は、毎年１月１日における所有者に課税されるため、年の途中に売買等により所有者が変わっても、納税義務者は変わらない。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "固定資産税および都市計画税",
        "important": ""
    },
    {
        "id": 639,
        "shikenId": 17,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "居住用財産を譲渡した場合の３,０００万円の特別控除（以下「３,０００万円特別控除」という）お よび居住用財産を譲渡した場合の長期譲渡所得の課税の特例（以下「軽減税率の特例」という）に関 する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "３, ０００万円特別控除と軽減税率の特例は、要件を満たせば、重複して適用を受けることができる。",
        "choice2": "３, ０００万円特別控除および軽減税率の特例は、いずれも譲渡した居住用財産の所有期間が、譲渡した日の属する年の１月１日において１０年を超えていなければ、適用を受けることはできない。",
        "choice3": "３, ０００万円特別控除と軽減税率の特例は、配偶者や子に譲渡した場合には適用を受けることができない。",
        "choice4": "軽減税率の特例では、課税長期譲渡所得金額のうち６, ０００万円以下の部分の金額について軽減税率が適用される。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "居住用財産の譲渡の特例",
        "important": ""
    },
    {
        "id": 640,
        "shikenId": 17,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "不動産の投資判断手法等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "NPV 法（正味現在価値法）による投資判断においては、投資額よりも対象不動産から得られる収益の現在価値の合計額のほうが下回っている場合、その投資は有利であると判定することができる。",
        "choice2": "レバレッジ効果とは、投資の収益率が借入金の金利を下回っている場合に、借入金を利用することにより自己資金に対する利回りが上昇する効果をいう。",
        "choice3": "NOI 利回り（純利回り）は、対象となる不動産から得られる年間の総収益を総投資額で除して算出される利回りである。",
        "choice4": "IRR（内部収益率）とは、投資によって得られる将来のキャッシュフローの現在価値が、現時点での投資額と等しくなる割引率をいう。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の投資判断手法",
        "important": ""
    },
    {
        "id": 641,
        "shikenId": 17,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "贈与に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "負担付贈与の受贈者が、その負担である義務を履行しない場合、贈与者は、相当の期間を定めてその履行を催告し、その期間内に履行がないときは、贈与契約を解除することができる。",
        "choice2": "書面によらない贈与において、いまだその履行がなされていない場合でも、各当事者は一方的に解除することはできない。",
        "choice3": "定期贈与により取得した財産は、毎年受け取る金額が贈与税の基礎控除額以下であっても、定期金給付契約に基づくものとして、贈与税の課税対象となる場合がある。",
        "choice4": "死因贈与契約は、贈与者が死亡するとその効力を生じるが、受贈者が先に死亡すると無効となる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与契約",
        "important": ""
    },
    {
        "id": 642,
        "shikenId": 17,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "贈与税の課税財産に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "契約者（＝保険料負担者）が母、被保険者が父、保険金受取人が子である生命保険契約において、父の死亡により子が受け取った死亡保険金は、子が母から贈与されたものとして贈与税の課税対象となる。",
        "choice2": "離婚による財産分与として取得した財産は、その価額が婚姻中の夫婦の協力によって得た財産の額等を考慮しても、なお過大であると認められる部分は、贈与税の課税対象となる。",
        "choice3": "父が、その所有する土地の名義を無償で子の名義に変更した場合には、原則として、子が父からその土地を贈与により取得したものとして、贈与税の課税対象となる。",
        "choice4": "子が、父の所有する土地を使用貸借によって借り受け、その土地に自己資金で建物を建築して自己の居住の用に供する場合には、子が父から借地権相当額を贈与により取得したものとして、贈与税の課税対象となる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の課税財産",
        "important": ""
    },
    {
        "id": 643,
        "shikenId": 17,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "民法に規定する相続に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "被相続人と婚姻の届出をしていないが、被相続人と生計を一にしており内縁関係にあった者は、被相続人の配偶者とみなされて相続人となる。",
        "choice2": "被相続人の兄と妹が相続人である場合において、当該兄が被相続人の相続開始以前に死亡していたときは、その死亡した兄の子が代襲して相続人となる。",
        "choice3": "相続の放棄をする場合は、相続の開始があったことを知った時から原則として3ヵ月以内に、共同相続人全員で家庭裁判所に申述しなければならない。",
        "choice4": "相続の単純承認をした相続人は、被相続人の財産のうち、預金や不動産などの積極財産のみを相続する。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "民法に規定する相続",
        "important": ""
    },
    {
        "id": 644,
        "shikenId": 17,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "民法上の遺言に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "遺言は、未成年者であっても、満１５歳以上の者で、かつ、遺言をする時にその能力があれば、法定代理人の同意を得ることなく単独ですることができる。",
        "choice2": "自筆証書によって遺言をするには、遺言者が全文、日付および氏名を自書し、これに押印することが必要となるが、財産目録については自筆でなくてもよい。",
        "choice3": "公正証書遺言を作成した遺言者が、自筆証書遺言も作成し、それぞれの内容が異なる場合、その異なる部分について作成日付の新しい遺言の内容が効力を有する。",
        "choice4": "公正証書によって遺言をするには証人２人以上の立会いが必要であり、推定相続人はその証人になることができる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺言",
        "important": ""
    },
    {
        "id": 645,
        "shikenId": 17,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "相続税の非課税財産に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "被相続人の死亡によって相続人に支給される弔慰金は、被相続人の死亡が業務外の死亡である場合、被相続人の死亡当時における普通給与の３年分に相当する金額まで相続税の課税対象とならない。",
        "choice2": "被相続人の死亡によって被相続人に支給されるべきであった死亡退職金で、被相続人の死亡後３年以内に支給が確定したものを相続人が取得した場合は、死亡退職金の非課税金額の規定の適用を受けることができる。",
        "choice3": "死亡保険金の非課税限度額は「５００万円×法定相続人の数」であり、相続を放棄した者がいた場合でも、相続の放棄がなかったものとして計算する。",
        "choice4": "死亡保険金および死亡退職金の非課税金額の規定は、相続人が受け取る場合にのみ適用され、相続を放棄した者が受け取る場合には適用されない。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の非課税財産",
        "important": ""
    },
    {
        "id": 646,
        "shikenId": 17,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続税の申告と納付に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "配偶者の税額軽減や小規模宅地等についての相続税の課税価格の計算の特例の適用を受けた結果、相続税額がゼロとなる場合、相続税の申告は不要となる。",
        "choice2": "相続税の金銭一括納付、延納が困難である場合、物納することができ、国債、不動産、上場株式等は物納順位の第１位である。",
        "choice3": "期限内申告書に係る相続税の納付は、原則として、相続人がその相続の開始があったことを知った日の翌日から４ヵ月以内にしなければならない。",
        "choice4": "相続税は金銭により一時に納付することが原則であるが、それが困難な場合には、納税義務者は、任意に延納または物納を選択することができる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の申告と納付",
        "important": ""
    },
    {
        "id": 647,
        "shikenId": 17,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "宅地の財産評価に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "普通借地権が設定されている宅地（貸宅地）の価額は、「自用地評価額×（1 －借地権割合）」により評価する。",
        "choice2": "貸家建付地は、「自用地評価額×（１－借家権割合×賃貸割合）」により評価する。",
        "choice3": "普通借地契約により借り受けた宅地に、建物を建築して、第三者に適正な賃料で貸し付けている場合の貸家建付借地権の評価額は、「自用地評価額×借地権割合×（1 －借地権割合×借家権割合×賃貸割合）」により評価する。",
        "choice4": "倍率方式とは、宅地の固定資産税評価額に奥行価格補正率等の補正率を乗じて算出した金額によって、宅地の評価額を評価する方式である。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "宅地の評価",
        "important": ""
    },
    {
        "id": 648,
        "shikenId": 17,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "小規模宅地等についての相続税の課税価格の計算の特例（以下「本特例」）に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢に記載されている内容以外の要件はすべて満たしているものとする。",
        "choice1": "被相続人が居住の用に供していた宅地等を、配偶者が取得し、その後、相続税の申告期限までに売却した場合、本特例を適用できない。",
        "choice2": "被相続人が事業の用に供していた宅地等を、事業を引き継いだ親族が、相続税の申告期限まで宅地等を所有し続け、事業を継続している場合、３３０㎡まで８０％の減額の対象となる。",
        "choice3": "被相続人が貸付事業の用に供していた宅地等を、貸付事業を引き継いだ親族が、相続税の申告期限まで宅地等を所有し続け、貸付事業を継続している場合、２００㎡まで５０％の減額の対象となる。",
        "choice4": "特定居住用宅地等と貸付事業用宅地等について本特例を適用する場合、それぞれの適用対象面積の限度まで適用できる。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "小規模宅地等の特例",
        "important": ""
    },
    {
        "id": 649,
        "shikenId": 17,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "各種金融資産の相続税評価に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "外貨預金の邦貨換算については、原則として、取引金融機関が公表する課税時期における最終の対顧客直物電信買相場（ＴＴＢ）またはこれに準ずる相場による。",
        "choice2": "相続開始時において、保険事故がまだ発生していない生命保険契約に関する権利の価額は、課税時期における既払込保険料相当額により評価する。",
        "choice3": "金融商品取引所に上場されている不動産投資信託の価額は、上場株式に関する評価の定めに準じて評価する。",
        "choice4": "既経過利子の額が少額である普通預金の価額は、課税時期現在の預入高により評価する。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "金融資産の相続税評価",
        "important": ""
    },
    {
        "id": 650,
        "shikenId": 17,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 4,
        "score": 1,
        "question1": "",
        "question2": "同族株主等が取得する取引相場のない株式の評価に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "会社規模が大会社である会社の株式を同族株主等が取得する場合、原則として、類似業種比準方式と純資産価額方式の併用方式によって評価する。",
        "choice2": "会社規模が小会社である会社の株式を同族株主等が取得する場合、純資産価額方式によって評価し、類似業種比準方式と純資産価額方式の併用方式によって評価することはできない。",
        "choice3": "会社規模が中会社である会社の株式を同族株主等が取得する場合、類似業種比準方式または純資産価額方式のいずれかによって評価する。",
        "choice4": "土地保有特定会社、株式等保有特定会社に該当する株式を同族株主等が取得する場合、会社規模にかかわらず純資産価額方式によって評価する。",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "取引相場のない株式の評価",
        "important": ""
    },
    {
        "id": 651,
        "shikenId": 18,
        "no": 1,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,1,2",
        "score": "1,1,1",
        "question1": "ファイナンシャル・プランナーは、執筆や講演などの依頼を受ける場合があり、著作権についての理解が必要である。著作権法に基づく著作権の保護に関する次の（ア）～（ウ）の記述について、適切なものには○、不適切なものには×を選択してください。",
        "question2": "",
        "choice1": "新聞記事をコピーし、投資希望者向け講演会の資料として配布する場合は、当該新聞社の許諾が必要である。",
        "choice2": "著作内容に、政府が集計、公表した統計資料を転載する場合、原則として担当省庁の許諾は不要である。",
        "choice3": "公表されている他人の著作物を自分の著作物に引用する場合、内容的に引用部分が「主」、自ら作成する部分が「従」であるような主従関係がなければならない。",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "著作権法",
        "important": ""
    },
    {
        "id": 652,
        "shikenId": 18,
        "no": 2,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "個人情報の保護に関する法律（以下、「個人情報保護法」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "個人番号（マイナンバー）、基礎年金番号、健康保険の被保険者証の記号番号のいずれも、個人情報として取り扱う必要がある。",
        "choice2": "個人事業主であるファイナンシャル・プランナーが、事業の用に供する目的で５名分の顧客名簿を作成している場合、個人情報保護法の適用対象とならない。",
        "choice3": "個人情報取扱事業者が、本人との契約書を通じて、契約者本人の個人情報を取得する場合、原則として、契約締結前に本人に対し、その利用目的を明示する必要がある。",
        "choice4": "個人情報取扱事業者が、税務署の職員による税務調査に応じ、個人情報を提出する場合は、第三者提供に関する本人の同意は不要である。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "個人情報保護法",
        "important": ""
    },
    {
        "id": 653,
        "shikenId": 18,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "根本さんは、本年 7月に購入し、特定口座（源泉徴収選択口座）で保有している国内公募追加型株式投資信託 WS ファンドの売却を検討している。下記＜資料＞に基づき、WS ファンドを一部解約した場合の譲渡所得の金額として、正しいものはどれか。なお、計算過程に当たっては、円未満の端数が生じた場合には、円未満の端数を切り捨てること。<br><br><img src='/img/set4/s1_1.png'/>",
        "question2": "",
        "choice1": "９４，７７７円",
        "choice2": "９５，９１１円",
        "choice3": "９６，１６９円",
        "choice4": "１０３，０００円",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "投資信託の譲渡所得の計算",
        "important": ""
    },
    {
        "id": 654,
        "shikenId": 18,
        "no": 4,
        "answerType": 8,
        "groupId": 1,
        "answer": "2,8,6,13",
        "score": "1,1,1,1",
        "question1": "下記は、ＮＩＳＡ（少額投資非課税制度）の成長投資枠およびつみたて投資枠について概要の一部をまとめた表である。下表の空欄（ア）～（エ）に入る適切な数値を語群の中から選択してください。<br><br><img src='/img/set4/s1_2.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9|10|11|12|13|14",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "NISA",
        "important": ""
    },
    {
        "id": 655,
        "shikenId": 18,
        "no": 5,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "個人向け国債に関する下表の空欄（ア）～（エ）にあてはまる語句または数値に関する次の記述のうち、最も適切なものはどれか。<br><br><img src='/img/set4/s1_3.png'/>",
        "question2": "",
        "choice1": "空欄（ア）にあてはまる語句は、「変動」である。",
        "choice2": "空欄（イ）にあてはまる語句は、「１年」である。",
        "choice3": "空欄（ウ）にあてはまる語句は、「０. ０５」である。",
        "choice4": "空欄（エ）にあてはまる語句は、「３カ月」である。",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "個人向け国債",
        "important": ""
    },
    {
        "id": 656,
        "shikenId": 18,
        "no": 6,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "下記＜資料＞の外貨定期預金を満期まで保有した場合における外貨ベースの元利合計額を円転した金額として正しいものはどれか。なお、計算結果（円転した金額）について円未満の端数が生じる場合は切り捨てること。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set4/s1_4.png'/>",
        "question2": "",
        "choice1": "１，５８６，３２０円",
        "choice2": "１，５８７，９００円",
        "choice3": "１，５９５，８００円",
        "choice4": "１，６０６，４００円",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨預金の計算",
        "important": ""
    },
    {
        "id": 657,
        "shikenId": 18,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "安藤さんは、投資信託への投資を検討するに当たり、ＦＰの細川さんから候補である３ファンドの過去３年間の運用パフォーマンスについて説明を受けた。ＦＰの細川さんが下記＜資料＞に基づいて説明した内容の空欄（ア）～（ウ）にあてはまる語句および数値の組み合わせとして、最も適切なものはどれか。<br><br><img src='/img/set4/s1_5.png'/>",
        "question2": "",
        "choice1": "（ア）０．９６　（イ）ＲＺファンド　（ウ）ＲＹファンド",
        "choice2": "（ア）１．６０　（イ）ＲＺファンド　（ウ）ＲＸファンド",
        "choice3": "（ア）０．９６　（イ）ＲＸファンド　（ウ）ＲＺファンド",
        "choice4": "（ア）１．６０　（イ）ＲＹファンド　（ウ）ＲＺファンド",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "シャープレシオ",
        "important": ""
    },
    {
        "id": 658,
        "shikenId": 18,
        "no": 8,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "谷村さんは、自らが居住している自宅の土地および建物の売却を検討している。売却に係る状況が下記＜資料＞のとおりである場合、所得税における課税長期譲渡所得金額として、正しいものはどれか。<br><br><img src='/img/set4/s1_6.png'/>",
        "question2": "",
        "choice1": "１，５００万円",
        "choice2": "２，１００万円",
        "choice3": "２，４００万円",
        "choice4": "２，７００万円",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の譲渡所得の計算",
        "important": ""
    },
    {
        "id": 659,
        "shikenId": 18,
        "no": 9,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "下記＜資料＞は末松太郎さんが所有する土地の登記事項証明書の一部である。この登記事項証明書に関する次の記述のうち、最も適切なものはどれか。<br><br><img src='/img/set4/s1_7.png'/>",
        "question2": "",
        "choice1": "上記＜資料＞から、抵当権の設定当時、末松太郎さんがこの土地を単独で所有していたことが分かる。",
        "choice2": "末松太郎さんが債務の弁済を怠った場合、株式会社ＥＦ銀行は、債権を回収するためにこの土地の競売を裁判所に申し立てることができる。",
        "choice3": "この土地は、株式会社ＥＦ銀行の抵当権が設定されているため、別途、ほかの金融機関が抵当権を設定することはできない。",
        "choice4": "末松太郎さんが株式会社ＥＦ銀行への債務を完済した場合、当該抵当権の登記は自動的に抹消される。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "登記事項証明書",
        "important": ""
    },
    {
        "id": 660,
        "shikenId": 18,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "下記＜資料＞は、三浦さんが購入を検討している中古タワーマンションのインターネット上の広告（抜粋）である。この広告の内容等に関する次の記述のうち、最も不適切なものはどれか。<br><br><img src='/img/set4/s1_8.png'/>",
        "question2": "",
        "choice1": "この広告の物件を購入した場合、購入前になされた集会の決議について、三浦さんにその効力は及ばない。",
        "choice2": "この広告の物件の専有面積は壁芯面積で記載されているが、これは登記簿上の内法面積より大きい。",
        "choice3": "この広告の物件を購入する場合、現在の区分所有者が管理費を滞納していれば、新たに区分所有者となる者にも滞納分の管理費の支払義務が生じる。",
        "choice4": "この物件を購入する場合、通常、宅地建物取引業者に媒介業務に係る報酬（仲介手数料）を支払う。",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産広告の見方",
        "important": ""
    },
    {
        "id": 661,
        "shikenId": 18,
        "no": 11,
        "answerType": 9,
        "groupId": 1,
        "answer": "4.56,3.72",
        "score": "2,2",
        "question1": "下記＜資料＞は、大浜さんが購入を検討している投資用マンションの概要である。この物件の表面利回り（年利）と実質利回り（年利）を計算しなさい。なお、＜資料＞に記載のない事項については一切考慮しないこととし、計算結果については小数点以下第３位を四捨五入すること。<br><br><img src='/img/set4/s1_9.png'/>",
        "question2": "",
        "choice1": "%",
        "choice2": "%",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "投資利回りの計算",
        "important": ""
    },
    {
        "id": 662,
        "shikenId": 18,
        "no": 12,
        "answerType": 9,
        "groupId": 0,
        "answer": 208,
        "score": 2,
        "question1": "建築基準法に従い、下記＜資料＞の土地に建物を建てる場合の建築面積の最高限度を計算しなさい。なお、記載のない事項については一切考慮しないものとする。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set4/s1_10.png'/>",
        "question2": "",
        "choice1": "㎡",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築面積の計算",
        "important": ""
    },
    {
        "id": 663,
        "shikenId": 18,
        "no": 13,
        "answerType": 9,
        "groupId": 1,
        "answer": "370,2330,2",
        "score": "1,1,1",
        "question1": "羽鳥秀一さん（４５歳）が加入の提案を受けた生命保険の保障内容は下記＜資料＞のとおりである。この生命保険に加入した場合、次の記述の空欄（ア）～（ウ）にあてはまる数値を計算しなさい。なお、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><br><img src='/img/set4/s1_11.png'/><br><br><img src='/img/set4/s1_12.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の証券分析",
        "important": ""
    },
    {
        "id": 664,
        "shikenId": 18,
        "no": 14,
        "answerType": 9,
        "groupId": 0,
        "answer": 140,
        "score": 2,
        "question1": "広瀬さんは、心疾患および事故により合計３回入院をした。下記＜資料＞に基づき、広瀬さんが契約している医療保険の入院給付金の日数に関する次の記述の空欄（ア）に入る数値を計算しなさい。なお、広瀬さんは、入院Ａについてはこの医療保険から所定の入院給付金を受け取っているが、それ以外にこの医療保険から一度も給付金を受け取っていないものとする。<br><br><img src='/img/set4/s1_13.png'/>",
        "question2": "",
        "choice1": "日分",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "医療保険の入院給付金",
        "important": ""
    },
    {
        "id": 665,
        "shikenId": 18,
        "no": 15,
        "answerType": 7,
        "groupId": 1,
        "answer": "1,2,1,2",
        "score": "1,1,1,1",
        "question1": "真鍋国春さんが契約している保険（下記＜資料＞参照）の契約に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択してください。なお、保険契約は、有効に成立しており、記載のない事項については一切考慮しないこととする。<br><br><img src='/img/set4/s1_14.png'/><br><br><img src='/img/set4/s1_15.png'/>",
        "question2": "",
        "choice1": "特定疾病保障保険Ａおよび介護保障定期保険Ｂにリビング・ニーズ特約を中途付加する場合、特約保険料はかからない。",
        "choice2": "国春さんが、初めてがん（悪性新生物）と診断確定され、その後に死亡した場合、特定疾病保障保険Ａから特定疾病保険金と死亡保険金の両方を受け取ることができる。",
        "choice3": "国春さんが、常時寝たきり状態で、ベッド周辺の歩行、入浴および大小便の排泄後の拭き取り始末が自分ではできず、他人の介護を要する状態が１８０日以上継続した場合、介護保障定期保険Ｂから介護保険金を受け取ることができる。",
        "choice4": "国春さんが、公的介護保険制度の要介護１に認定された場合、介護保障定期保険Ｂから介護保険金を受け取ることができる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の証券分析",
        "important": ""
    },
    {
        "id": 666,
        "shikenId": 18,
        "no": 16,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,1,2,1",
        "score": "1,1,1,1",
        "question1": "持田孝夫さんが契約している個人年金保険（下記＜資料＞参照）に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択してください。<br><br><img src='/img/set4/s1_16.png'/>",
        "question2": "",
        "choice1": "孝夫さんが毎年受け取る年金は、一時所得として所得税の課税対象となる。",
        "choice2": "孝夫さんが死亡し、幸恵さんが受け取る死亡給付金は、相続税の課税対象となる。",
        "choice3": "孝夫さんが契約日から５年経過後に解約して受け取った解約返戻金は、雑所得として所得税の課税対象となる。",
        "choice4": "孝夫さんが毎年支払う保険料は、所得税における個人年金保険料控除の対象となる。",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "個人年金保険",
        "important": ""
    },
    {
        "id": 667,
        "shikenId": 18,
        "no": 17,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "井上貴弘さんは、契約中の収入保障保険Ａの保障額について、ＦＰの小椋さんに質問をした。小椋さんが説明の際に使用した下記＜イメージ図＞を基に、本年１０月１日に貴弘さんが死亡した場合に支払われる年金総額として正しいものはどれか。なお、年金は毎月受け取るものとする。<br><br><img src='/img/set4/s1_17.png'/>",
        "question2": "",
        "choice1": "４，８００万円",
        "choice2": "３，８４０万円",
        "choice3": "３，３６０万円",
        "choice4": "４８０万円",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "収入保障保険の計算",
        "important": ""
    },
    {
        "id": 668,
        "shikenId": 18,
        "no": 18,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "野村さん（７０歳）の本年分の収入等は下記のとおりである。野村さんの本年分の所得税における総所得金額として、正しいものはどれか。<br><br><img src='/img/set4/s1_18.png'/>",
        "question2": "",
        "choice1": "１６０万円",
        "choice2": "１９０万円",
        "choice3": "２１０万円",
        "choice4": "２１５万円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 669,
        "shikenId": 18,
        "no": 19,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "個人でデザイン事務所を営む落合さんの本年分の所得等は下記＜資料＞のとおりである。落合さんの本年分の所得税において、事業所得と損益通算できる損失に関する次の記述のうち、最も適切なものはどれか。なお、▲が付された所得の金額は、その所得に損失が発生していることを意味するものとする。<br><br><img src='/img/set4/s1_19.png'/>",
        "question2": "",
        "choice1": "不動産所得の損失（▲５０万円）、譲渡所得の損失（▲８０万円）と損益通算できる。",
        "choice2": "不動産所得の損失（▲２０万円）、一時所得の損失（▲６０万円）と損益通算できる。",
        "choice3": "不動産所得の損失（▲５０万円）とのみ損益通算できる。",
        "choice4": "不動産所得の損失（▲２０万円）とのみ損益通算できる。",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "損益通算の判定",
        "important": ""
    },
    {
        "id": 670,
        "shikenId": 18,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "会社員の半沢さんは、妻と子ども２人の４人家族である。本年中における半沢さんの合計所得金額が１，１００万円、妻の合計所得金額が３０万円である場合、半沢さんの本年分の所得税における配偶者控除（ア）と扶養控除（イ）の金額の組み合わせとして、正しいものはどれか。なお、本年中において、半沢家は全員同居し、生計を一にしている。また、障害者・特別障害者に該当する者はいない。<br><br><img src='/img/set4/s1_20.png'/>",
        "question2": "",
        "choice1": "（ア）０円　（イ） ６３万円",
        "choice2": "（ア）０円　（イ）１０１万円",
        "choice3": "（ア）３８万円　（イ） ６３万円",
        "choice4": "（ア）３８万円　（イ）１０１万円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "配偶者控除と扶養控除",
        "important": ""
    },
    {
        "id": 671,
        "shikenId": 18,
        "no": 21,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "会社員の高橋昌彦さん（給与収入：年額６００万円）は、会社員の妻の珠恵さん（給与収入：年額５００万円）と小学生の長女と３人暮らしである。高橋さん夫婦が本年中に昌彦さんと珠恵さんの共有名義で新築住宅を購入し、同年中に居住を開始した場合の住宅借入金等特別控除（以下、「住宅ローン控除」という）に関する次の（ア）～（ウ）の記述について、適切なものには○、不適切なものには×を選択してください。なお、高橋さん夫婦は、住宅ローン控除の適用を受けるための要件をすべて満たしているものとし、給与収入以外の収入はないものとする。",
        "question2": "",
        "choice1": "所得税の住宅ローン控除の適用を受ける場合は、毎年確定申告をする必要がある。",
        "choice2": "高橋昌彦さんが転勤により単身赴任をする場合、珠恵さんと長女が住み続ける等、所定の要件を満たせば、単身赴任中も住宅ローン控除の適用を受け続けることができる。",
        "choice3": "本年分の住宅ローン控除可能額が所得税から控除しきれない場合は、翌年度の住民税から控除することができるが、その場合、市区町村への住民税の申告が必要となる。",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 672,
        "shikenId": 18,
        "no": 22,
        "answerType": 9,
        "groupId": 0,
        "answer": 2050,
        "score": 2,
        "question1": "井上さん夫婦は、本年１０月にマンションを購入する予定である。井上さん夫婦が＜資料＞のマンションを購入する場合の販売価格のうち、土地（敷地の共有持分）の価格を計算しなさい。なお、消費税の税率は１０％とし、計算結果について万円未満の端数が生じる場合は四捨五入すること。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set4/s1_21.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "不動産取引の消費税の計算",
        "important": ""
    },
    {
        "id": 673,
        "shikenId": 18,
        "no": 23,
        "answerType": 8,
        "groupId": 1,
        "answer": "3,7,4,5",
        "score": "1,1,1,1",
        "question1": "下記＜資料＞の相続開始後の手続きに関する次の記述の空欄（ア）～（エ）に入る適切な語句を語群の中から選択してください。なお、同じ語句を何度選んでも良いこととする。<br><br><img src='/img/set4/s1_22.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続開始後の手続き",
        "important": ""
    },
    {
        "id": 674,
        "shikenId": 18,
        "no": 24,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 2,
        "question1": "贈与税の配偶者控除（以下「本特例」という）に関する次の記述の空欄（ア）～（エ）に入る語句の組み合わせとして、正しいものはどれか。<br><br><img src='/img/set4/s1_23.png'/>",
        "question2": "",
        "choice1": "（ア）２０年　（イ）とは別に　（ウ）翌年３月１５日　（エ）加算されない",
        "choice2": "（ア）２５年　（イ）とは別に　（ウ）翌年３月１５日　（エ）加算される",
        "choice3": "（ア）２０年　（イ）を含めて　（ウ）１２月３１日　（エ）加算される",
        "choice4": "（ア）２５年　（イ）を含めて　（ウ）１２月３１日　（エ）加算されない",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の配偶者控除",
        "important": ""
    },
    {
        "id": 675,
        "shikenId": 18,
        "no": 25,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "「小規模宅地等についての相続税の課税価格の計算の特例」に関する下表の空欄（ア）～（ウ）に当てはまる数値の組み合わせとして、正しいものはどれか。<br><br><img src='/img/set4/s1_24.png'/>",
        "question2": "",
        "choice1": "（ア）８０　（イ）５０　（ウ）１",
        "choice2": "（ア）８０　（イ）５０　（ウ）３",
        "choice3": "（ア）５０　（イ）８０　（ウ）３",
        "choice4": "（ア）５０　（イ）８０　（ウ）１",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "小規模宅地等の特例",
        "important": ""
    },
    {
        "id": 676,
        "shikenId": 18,
        "no": 26,
        "answerType": 7,
        "groupId": 1,
        "answer": "2,2,2,1",
        "score": "1,1,1,1",
        "question1": "服部さんは、FP の鈴木さんに遺言書の作成について相談をした。鈴木さんが行った次の（ア）～（エ）の説明について、適切なものには〇、不適切なものには×を選択してください。",
        "question2": "",
        "choice1": "「パソコンで自筆証書遺言書に添付する財産目録を作成する場合、当該目録の最初のページのみ署名および押印が必要です。」",
        "choice2": "「自筆証書遺言書保管制度では、自筆証書遺言の保管を申請する場合、疾病等で遺言者本人が遺言書保管所（法務局）へ出向くことが難しいときには、代理人による申請も認められています」",
        "choice3": "「自筆証書遺言書保管制度により遺言書保管所に保管されている自筆証書遺言書は、相続開始後に家庭裁判所の検認を受ける必要があります」",
        "choice4": "「公正証書による遺言をした人は、その遺言を自筆証書による遺言によって撤回することができます」",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺言",
        "important": ""
    },
    {
        "id": 677,
        "shikenId": 18,
        "no": 27,
        "answerType": 9,
        "groupId": 1,
        "answer": "3920,550",
        "score": "2,2",
        "question1": "下記の相続事例（本年６月１２日相続開始）における配偶者と長男の相続税の課税価格を求めなさい。なお、記載のない事項については一切考慮しないものとする。<br><br><img src='/img/set4/s1_25.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "各人の相続税課税価格",
        "important": ""
    },
    {
        "id": 678,
        "shikenId": 18,
        "no": 28,
        "answerType": 9,
        "groupId": 0,
        "answer": 624,
        "score": 2,
        "question1": "長尾家のキャッシュフロー表の空欄（ア）に入る数値を計算しなさい。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><br><img src='/img/set4/s1_26.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 679,
        "shikenId": 18,
        "no": 29,
        "answerType": 9,
        "groupId": 0,
        "answer": 817,
        "score": 2,
        "question1": "長尾家のキャッシュフロー表の空欄（イ）に入る数値を計算しなさい。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><br><img src='/img/set4/s1_27.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 680,
        "shikenId": 18,
        "no": 30,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "長尾さんは、教育費の負担が心配になり、奨学金について調べることにした。日本学生支援機構の奨学金に関する次の記述のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "日本学生支援機構の貸与型奨学金には、利子が付く「第一種」と利子が付かない「第二種」がある。",
        "choice2": "日本学生支援機構の奨学金（貸与型）は、進学前に申し込む「予約採用」、進学後に申し込む「在学採用」、家計の急変等に対応する「緊急・応急採用」等がある。",
        "choice3": "日本学生支援機構の奨学金は、学生本人または保護者の名義の口座に振り込まれる。",
        "choice4": "日本学生支援機構の奨学金は、希望すれば進学前から受け取ることができる。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "日本学生支援機構の奨学金",
        "important": ""
    },
    {
        "id": 681,
        "shikenId": 18,
        "no": 31,
        "answerType": 9,
        "groupId": 0,
        "answer": 9230000,
        "score": 2,
        "question1": "市岡さんは、独立開業の資金として、８年後に１，０００万円を準備したいと考えている。８年間、年利１．０％で複利運用する場合、現在いくらの資金があればよいか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set4/s1_28.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 682,
        "shikenId": 18,
        "no": 32,
        "answerType": 9,
        "groupId": 0,
        "answer": 824000,
        "score": 2,
        "question1": "伊勢さんは、自宅のリフォーム費用４００万円を、リフォームローンを利用して返済しようと考えている。今後５年間、年利１．０％で毎年借入応当日に元利均等返済をする場合、毎年の返済額はいくらになるか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set4/s1_29.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 683,
        "shikenId": 18,
        "no": 33,
        "answerType": 9,
        "groupId": 0,
        "answer": 33034500,
        "score": 2,
        "question1": "村田さんは、老後の生活資金の一部として、毎年年末に１５０万円を受け取りたいと考えている。受取期間を２５年間とし、年利１．０％で複利運用をする場合、受取り開始時にいくらの資金があればよいか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img src='/img/set4/s1_30.png'/>",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 684,
        "shikenId": 18,
        "no": 34,
        "answerType": 9,
        "groupId": 0,
        "answer": 6540,
        "score": 2,
        "question1": "ＦＰの玉田さんは、現時点における羽鳥家（孝治さんと千種さん）のバランスシート分析を行うこととした。下表の空欄（ア）に入る数値を計算しなさい。<br><br><img src='/img/set4/s1_31.png'/>",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "バランスシートの計算",
        "important": ""
    },
    {
        "id": 685,
        "shikenId": 18,
        "no": 35,
        "answerType": 3,
        "groupId": 0,
        "answer": 4,
        "score": 2,
        "question1": "井上貴弘さんと妻の恵里菜さんはマンションの購入に当たり、夫婦での住宅ローンの借入れを検討しており、ＦＰの小椋さんに質問をした。小椋さんが行った次の説明のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "「連帯保証方式である収入合算を利用すると、夫婦の収入を合算して１つの住宅ローンを契約するため、貴弘さんが単独で住宅ローンを契約する場合に比べて、借入金額を増やすことができます」",
        "choice2": "「ペアローンは、夫婦それぞれが住宅ローンを契約するため、一定の要件を満たせば、貴弘さんと恵里菜さんは２人とも住宅借入金等特別控除の適用を受けることができます」",
        "choice3": "「現時点で、貴弘さんや恵里菜さんに自動車ローンや奨学金の負債（借入れ）がある場合、負債（借入れ）がない場合に比べて、借入可能額が少なくなる可能性があります」",
        "choice4": "「連帯保証方式である収入合算で住宅ローンを契約した場合、貴弘さんと恵里菜さんは２人とも団体信用生命保険を付保することができます」",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "住宅ローン",
        "important": ""
    },
    {
        "id": 686,
        "shikenId": 18,
        "no": 36,
        "answerType": 8,
        "groupId": 1,
        "answer": "1,4,6,8",
        "score": "1,1,1,1",
        "question1": "井上恵里菜さんは、仮に夫の貴弘さんが本年９月に４０歳で死亡した場合の公的年金の遺族給付について、ＦＰの小椋さんに質問をした。恵里菜さんが６５歳になるまで受給できる公的年金の遺族給付についての説明の空欄（ア）～（エ）に入る適切な語句を語群の中から選び、その番号のみを解答欄に記入しなさい。なお、貴弘さんは、２０歳から大学卒業まで国民年金に加入し、大学卒業後の２２歳から死亡時まで継続して厚生年金保険に２２１月加入しているものとする。また、家族に障害者に該当する者はなく、記載以外の遺族給付の受給要件はすべて満たしているものとし、記載のない条件については一切考慮しないこと。<br><br><img src='/img/set4/s1_32.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7|8|9|10",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "遺族給付",
        "important": ""
    },
    {
        "id": 687,
        "shikenId": 18,
        "no": 37,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "会社員として勤務している羽鳥さんは、現在加入している雇用保険について、ＦＰの玉田さんに質問をした。玉田さんが行った雇用保険の加入や給付に関する次の説明の空欄（ア）～（エ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><br><img src='/img/set4/s1_33.png'/>",
        "question2": "",
        "choice1": "（ア）６５歳　（イ）２カ月　（ウ）再就職　（エ）生涯１回に限り",
        "choice2": "（ア）６０歳　（イ）２カ月　（ウ）求職者　（エ）生涯１回に限り",
        "choice3": "（ア）６５歳　（イ）１カ月　（ウ）求職者　（エ）支給要件を満たすごとに",
        "choice4": "（ア）６０歳　（イ）１カ月　（ウ）再就職　（エ）支給要件を満たすごとに",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "雇用保険の失業等給付",
        "important": ""
    },
    {
        "id": 688,
        "shikenId": 18,
        "no": 38,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "羽鳥さんは、今後自分に介護が必要になった場合を考え、公的介護保険の介護サービスについて、ＦＰの玉田さんに質問をした。介護保険の給付に関する下表の空欄（ア）～（エ）に入る語句として適切なものはどれか。なお、問題の設定上、明らかにできない部分を（　＊　）としている。<br><br><img src='/img/set4/s1_34.png'/>",
        "question2": "",
        "choice1": "（ア）には「都道府県」が入る。",
        "choice2": "（イ）には「６５歳」が入る。",
        "choice3": "（ウ）には「原因を問わず」が入る。",
        "choice4": "（エ）には「２割」が入る。",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "介護保険",
        "important": ""
    },
    {
        "id": 689,
        "shikenId": 18,
        "no": 39,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 2,
        "question1": "羽鳥さん（全国健康保険協会管掌健康保険に加入中）が、将来、会社を退職し、すぐに再就職しない場合に選択できる健康保険の任意継続被保険者について、ＦＰの玉田さんが説明を行った。任意継続被保険者に関する下表の空欄（ア）～（ウ）に入る適切な語句の組み合わせとして最も適切なものはどれか。<br><br><img src='/img/set4/s1_35.png'/>",
        "question2": "",
        "choice1": "（ア）２年　（イ）２年　（ウ）１４日",
        "choice2": "（ア）２年　（イ）５年　（ウ）２０日",
        "choice3": "（ア）２カ月 （イ）２年　（ウ）２０日",
        "choice4": "（ア）２カ月 （イ）５年　（ウ）１４日",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "任意継続被保険者",
        "important": ""
    },
    {
        "id": 690,
        "shikenId": 18,
        "no": 40,
        "answerType": 8,
        "groupId": 1,
        "answer": "2,4,5",
        "score": "1,1,1",
        "question1": "羽鳥さんは、将来を見据え後期高齢者医療制度について理解を深めたいと思い、ＦＰの玉田さんに質問をした。後期高齢者医療制度に関する下表の空欄（ア）～（ウ）に入る適切な語句を語群の中から選択してください。<br><br><img src='/img/set4/s1_36.png'/>",
        "question2": "",
        "choice1": "1|2|3|4|5|6|7",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "後期高齢者医療制度",
        "important": ""
    },
    {
        "id": 691,
        "shikenId": 19,
        "no": 1,
        "answerType": 6,
        "groupId": 0,
        "answer": "ニ,イ,ヘ",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set4/k1_1.png'/>",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、公的年金制度からの老齢給付について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>　「報酬比例部分のみの特別支給の老齢厚生年金の支給開始年齢は、順次引き上げられており、（ ① ）年４月２日以後生まれの男性からは支給がありません。Ａさんは、原則として、65歳から老齢基礎年金および老齢厚生年金を受給することになります。なお、Ａさんが希望すれば、60歳以上 65歳未満の間に老齢基礎年金の繰上げ支給を請求することができます。仮に、Ａさんが63歳０カ月で老齢基礎年金の繰上げ支給を請求した場合の減額率は（ ② ）％となります。Ａさんが老齢基礎年金の繰上げ支給の請求をする場合、同時に老齢厚生年金の繰上げ支給の請求を（ ③ ）」<br><br><img src='/img/set4/k1_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢給付",
        "important": ""
    },
    {
        "id": 692,
        "shikenId": 19,
        "no": 2,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,1",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set4/k1_1.png'/>",
        "question2": "次に、Ｍさんは、Ａさんに対して、社会保険の取扱い等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「Ａさんが65歳でＸ社を退職し、厚生年金保険の被保険者でなくなった場合、妻Ｂさんは、国民年金の第３号被保険者から第１号被保険者への種別変更の届出を行い、65歳になるまでの間、国民年金の保険料を納付することになります」",
        "choice2": "「Ａさんが60歳でＸ社を定年退職し、雇用保険から基本手当を受給する場合、基本手当の所定給付日数は150日となります。基本手当の受給期間は、原則として、離職した日の翌日から１年間ですが、定年退職の場合は最長１年間の受給期間延長を申し出ることができます」",
        "choice3": "「Ａさんは、所定の手続を行うことにより、退職日の翌日から最長で２年間、全国健康保険協会管掌健康保険に任意継続被保険者として加入することができます。任意継続被保険者の保険料は、在職時とは異なり全額自己負担となります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "社会保険の取扱い等",
        "important": ""
    },
    {
        "id": 693,
        "shikenId": 19,
        "no": 3,
        "answerType": 4,
        "groupId": 0,
        "answer": "831700,1244473,620,1660993",
        "score": "1,1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set4/k1_1.png'/>",
        "question2": "Ａさんが、65歳でＸ社を退職した場合、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（本年度価額）を計算した次の＜計算の手順＞の空欄①～④に入る最も適切な数値を求めなさい。計算にあたっては、《設例》の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づくこと。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set4/k1_3.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金および老齢厚生年金の計算",
        "important": ""
    },
    {
        "id": 694,
        "shikenId": 19,
        "no": 4,
        "answerType": 4,
        "groupId": 0,
        "answer": "20.00,1.52",
        "score": "2,2",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set4/k2_1.png'/>",
        "question2": "《設例》のデータに基づき算出される次の①、②を求めなさい（計算過程の記載は不要）。〈答〉は表示単位の小数点以下第3位を四捨五入し、小数点以下第2位までを解答すること。<br><br>①　W社のＰＥＲ<br>②　W社のＰＢＲ",
        "choice1": "倍",
        "choice2": "倍",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式投資指標の計算",
        "important": ""
    },
    {
        "id": 695,
        "shikenId": 19,
        "no": 5,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set4/k2_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、《設例》のデータに基づいて、株式の投資指標等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「ROE は、W社株式のほうが X 社株式よりも高くなっています。一般に、ROE の数値が高いほうが経営の効率性が高いと判断されます」",
        "choice2": "「株主に対する利益還元の大きさに着目した指標として、配当性向があります。配当性向は、Ｘ社のほうがＷ社よりも高くなっています」",
        "choice3": "「一般に、自己資本比率が低いほど、経営の安全性が高いと考えられます。自己資本比率は、Ｗ社のほうがＸ社よりも高くなっています」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式投資指標の計算",
        "important": ""
    },
    {
        "id": 696,
        "shikenId": 19,
        "no": 6,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,2",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set4/k2_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、インデックスファンド等を購入する際の留意点等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「運用管理費用（信託報酬）は、投資信託を保有する投資家が負担する費用です。一般に、インデックスファンド（パッシブ型の投資信託）は、アクティブ型投資信託よりも運用管理費用（信託報酬）が高い傾向があります」",
        "choice2": "「ドルコスト平均法は、価格が変動する商品を定期的に一定口数ずつ購入する方法で、定期的に一定額ずつ購入するよりも平均購入単価を引き下げる効果が期待できます」",
        "choice3": "「 NISA の非課税保有限度額（総枠）は、1,800万円です。そのうち成長投資枠は1,200万円、つみたて投資枠は600万円とされており、これを超える金額の投資信託を購入し、保有することはできません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "運用管理費用、ドルコスト平均法、ＮＩＳＡ",
        "important": ""
    },
    {
        "id": 697,
        "shikenId": 19,
        "no": 7,
        "answerType": 6,
        "groupId": 0,
        "answer": "ホ,イ,ヘ",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set4/k3_1.png'/>",
        "question2": "所得税における青色申告制度に関する以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　「事業所得の金額の計算上、青色申告特別控除として最高（ ① ）万円を控除することができます。（ ① ）万円の青色申告特別控除の適用を受けるためには、事業所得に係る取引を正規の簿記の原則に従い記帳し、その記帳に基づいて作成した貸借対照表、損益計算書その他の計算明細書を添付した確定申告書を法定申告期限内に提出することに加えて、e-Tax による申告（電子申告）または一定の要件を満たす電子帳簿保存を行う必要があります。なお、確定申告書を法定申告期限後に提出した場合、青色申告特別控除額は最高（ ② ）万円となります」<br><br>Ⅱ　「青色申告者が受けられる税務上の特典として、青色申告特別控除のほかに、青色事業専従者給与の必要経費算入、純損失の（ ③ ）間の繰越控除、前年分の所得に対する税額から還付を受けられる純損失の繰戻還付、棚卸資産の評価について低価法を選択できることなどが挙げられます」<br><br><img src='/img/set4/k3_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "青色申告",
        "important": ""
    },
    {
        "id": 698,
        "shikenId": 19,
        "no": 8,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,2",
        "score": "1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set4/k3_1.png'/>",
        "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。<br><br><img src='/img/set4/k3_3.png'/>",
        "choice1": "「母Ｄさんの公的年金等に係る雑所得の金額は算出されません。Ａさんの所得控除において、母Ｄさんは同居老親等にあたります」",
        "choice2": "「Ａさんが受け取った一時払養老保険の満期保険金に係る差益は、源泉分離課税の対象となります」",
        "choice3": "「Ａさんが適用を受けることができる基礎控除の額は、48万円です」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税総合",
        "important": ""
    },
    {
        "id": 699,
        "shikenId": 19,
        "no": 9,
        "answerType": 4,
        "groupId": 0,
        "answer": "4250000,0,580000,107500",
        "score": "1,1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set4/k3_1.png'/>",
        "question2": "Ａさんの本年分の所得税の算出税額を計算した下記の表の空欄①～④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set4/k3_4.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の計算",
        "important": ""
    },
    {
        "id": 700,
        "shikenId": 19,
        "no": 10,
        "answerType": 4,
        "groupId": 0,
        "answer": "320,960",
        "score": "2,2",
        "question1": "【第４問】 次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set4/k4_1.png'/>",
        "question2": "甲土地上に準耐火建築物を建築する場合における次の①、②を求めなさい（計算過程の記載は不要）。<br><br>①　建蔽率の上限となる建築面積<br>②　容積率の上限となる延べ面積",
        "choice1": "㎡",
        "choice2": "㎡",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建蔽率と容積率の計算",
        "important": ""
    },
    {
        "id": 701,
        "shikenId": 19,
        "no": 11,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,1",
        "score": "1,1,1",
        "question1": "【第４問】 次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set4/k4_1.png'/>",
        "question2": "Ｘ社が提案する事業方式による効果に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「Ａさんが金融機関から融資を受けて賃貸アパートを建築する場合、借入金による事業リスクを考慮する必要があります。ＤＳＣＲ（借入金償還余裕率）の値が1.0未満の場合、年間の賃料収入から必要経費を差し引いた金額の範囲内では年間の元利金の返済はできないことを示しています」",
        "choice2": "「Ｘ社と一括賃貸借契約（普通借家契約・マスターリース契約（特定賃貸借契約））を締結することで、賃料収入が保証されることは大きなメリットです。普通借家契約の場合、借地借家法の規定により、Ｘ社から賃料の減額請求をされることはありません」",
        "choice3": "「近年、サブリース業者に対する規制が強化されており、賃貸住宅の管理業務等の適正化に関する法律において、サブリース業者がマスターリース契約を締結しようとする際に誇大広告や不当な勧誘を行うことを禁止しており、Ａさんが賃貸マンションを建築し、Ｘ社がＡさんから建物を一括賃借する場合も当該規制の適用を受けます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "ＤＳＣＲ、賃貸借契約",
        "important": ""
    },
    {
        "id": 702,
        "shikenId": 19,
        "no": 12,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "【第４問】 次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set4/k4_1.png'/>",
        "question2": "Ａさんが甲土地に賃貸アパートを建築した場合における賃貸開始後の甲土地の相続税評価額に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「甲土地は、地積規模の大きな宅地の評価の規定の適用を受けることができます」",
        "choice2": "「甲土地は、相続税額の計算上、貸家建付地として評価されます。甲土地の貸家建付地としての価額は、当該マンションの賃貸割合が高いほど、高く評価されます」",
        "choice3": "「対象地の面する道路に付された『300Ｄ』『200Ｄ』の数値は、１㎡当たりの価額を千円単位で表示した相続税路線価です。数値の後に表示されている『Ｄ』の記号（アルファベット）は、借地権割合が60％であることを示しています」",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "相続税評価額",
        "important": ""
    },
    {
        "id": 703,
        "shikenId": 19,
        "no": 13,
        "answerType": 6,
        "groupId": 0,
        "answer": "ヘ,ロ,リ",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set4/k5_1.png'/>",
        "question2": "Ａさんの相続等に関する以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　「Ａさんの相続が開始し、相続人が自宅に保管されていたＡさんの自筆証書遺言を発見した場合、相続人は、遅滞なく、自筆証書遺言を（ ① ）に提出して、その検認を請求しなければなりません」<br><br>Ⅱ　「Ａさんが本年分の所得税および復興特別所得税について確定申告書を提出しなければならない場合に該当するとき、相続人は、原則として、相続の開始があったことを知った日の翌日から（ ② ）カ月以内に準確定申告書を提出しなければなりません」<br><br>Ⅲ　「Ａさんに係る相続税の申告書の提出期限は、原則として、翌年（ ③ ）（休業日の場合は翌営業日）になります。申告書の提出先は、Ａさんの（死亡時の）住所地を所轄する税務署長です」<br><br><img src='/img/set4/k5_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続発生後の手続き",
        "important": ""
    },
    {
        "id": 704,
        "shikenId": 19,
        "no": 14,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,1",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set4/k5_1.png'/>",
        "question2": "Ａさんの相続等に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
        "choice1": "「妻Ｂさんが受け取った死亡保険金は、みなし相続財産として相続税の課税対象となります。妻Ｂさんが受け取った死亡保険金 3,000万円のうち、相続税の課税価格に算入される金額は1,500万円となります」",
        "choice2": "「妻Ｂさんが相続により取得した財産の金額が、配偶者の法定相続分相当額と１億 6,000万円とのいずれか多い金額を超えない場合、配偶者に対する相続税額の軽減の適用により、妻Ｂさんが納付すべき相続税額は算出されません。この場合、相続税の申告も不要です」",
        "choice3": "「孫Ｅさんは、相続税額の２割加算の対象になります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税総合",
        "important": ""
    },
    {
        "id": 705,
        "shikenId": 19,
        "no": 15,
        "answerType": 4,
        "groupId": 0,
        "answer": "8500,4800,1640,7820",
        "score": "1,1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set4/k5_1.png'/>",
        "question2": "相続人等は《設例》の記載のとおり、Ａさんの財産を取得した。Ａさんの相続に係る相続税の総額を計算した下記の表の空欄①～④に入る最も適切な数値を選択してください。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set4/k5_3.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の計算",
        "important": ""
    },
    {
        "id": 706,
        "shikenId": 20,
        "no": 1,
        "answerType": 6,
        "groupId": 0,
        "answer": "ロ,チ,ニ",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set4/h1_1.png'/>",
        "question2": "まず、Ｍさんは、Ａさんに対して、退職後の社会保険の各種取扱い等について説明した。Ｍさんが説明した以下の文章の空欄の①～③に入る適切な語句または数値を、下記の＜語句群＞のなかから選び、その記号を選択してください。<br><br>Ⅰ　「Ａさんは、国民健康保険に加入する以外に、所定の手続により、退職日の翌日から最長で（ ① ）、全国健康保険協会管掌健康保険に任意継続被保険者として加入することができます。そのためには資格喪失日から20日以内に手続きを行うことが必要です。なお、都道府県と市町村が保険者である国民健康保険は、健康保険とは異なり、（ ② ）は任意給付となっています」<br><br>Ⅱ　「Ａさんが厚生年金保険の被保険者でなくなった場合、妻Ｂさんは、国民年金の第３号被保険者から第（ ③ ）被保険者への種別変更の届出を行い、国民年金の保険料を納付することになります」<br><br><img src='/img/set4/h1_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "退職後の社会保険",
        "important": ""
    },
    {
        "id": 707,
        "shikenId": 20,
        "no": 2,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,2",
        "score": "1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set4/h1_1.png'/>",
        "question2": "次に、Ｍさんは、Ａさんに対して、確定拠出年金の個人型年金（以下、「個人型年金」という）について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択してください。",
        "choice1": "「国民年金の第１号被保険者で国民年金の定額保険料を納付している者は、原則として、個人型年金に加入することができます。個人型年金は、通算加入者等期間が10年以上あれば、老齢給付金を最も早くて65歳から受給することができます」",
        "choice2": "「個人型年金では、銀行・証券会社等の運営管理機関が定める手数料を負担する必要がありますが、当該手数料の額は金融機関の別なく、一律です」",
        "choice3": "「個人型年金の掛金は、その全額が社会保険料控除の対象となり、総所得金額等から控除することができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "個人型確定拠出年金",
        "important": ""
    },
    {
        "id": 708,
        "shikenId": 20,
        "no": 3,
        "answerType": 6,
        "groupId": 0,
        "answer": "ロ,ニ,ト,ル",
        "score": "1,1,1,1",
        "question1": "【第１問】　次の設例に基づいて、下記の各問（《問１》～《問３》）に答えなさい。<br><img src='/img/set4/h1_1.png'/>",
        "question2": "最後に、Ｍさんは、Ａさんに対して、老後の収入を増やすための各種制度について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な数値または語句を下記の＜語句群＞の中から選び、その記号を選択してください。<br><br><img src='/img/set4/h1_3.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老後の収入を増やすための制度",
        "important": ""
    },
    {
        "id": 709,
        "shikenId": 20,
        "no": 4,
        "answerType": 6,
        "groupId": 0,
        "answer": "ホ,リ,ロ",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set4/h2_1.png'/>",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、下記の＜前提＞においてＡさんが死亡した場合、妻Ｂさんが受給することができる公的年金制度からの遺族給付について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br><img src='/img/set4/h2_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "遺族給付",
        "important": ""
    },
    {
        "id": 710,
        "shikenId": 20,
        "no": 5,
        "answerType": 4,
        "groupId": 0,
        "answer": "7488,6000,7000",
        "score": "1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set4/h2_1.png'/>",
        "question2": "次に、Ｍさんは、Ａさんに対して、必要保障額およびＡさんが提案を受けた生命保険の死亡保障の額について説明した。Ｍさんが説明した以下の文章の空欄①〜③に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set4/h2_3.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "必要保障額と生命保険の保障内容の計算",
        "important": ""
    },
    {
        "id": 711,
        "shikenId": 20,
        "no": 6,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,1,2,1",
        "score": "1,1,1,1",
        "question1": "【第２問】　次の設例に基づいて、下記の各問（《問４》～《問６》）に答えなさい。<br><img src='/img/set4/h2_1.png'/>",
        "question2": "さらに、Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の保障内容および課税関係について説明した。Ｍさんが説明した次の記述①～④について、適切なものには○印を、不適切なものには×印を選択してください。",
        "choice1": "「先進医療の治療を受けた場合、その技術料に係る費用だけでなく診察料や投薬料等に係る費用も全てが自己負担となりますので、先進医療特約の付加をお勧めします」",
        "choice2": "「必要保障額は、通常、末子が生まれた時に最大となり、その後、子どもの成長とともに逓減していきます。Ａさんの今後のライフステージの変化に合わせて、保障内容を定期的に見直すことをお勧めします」",
        "choice3": "「当該生命保険の支払保険料のうち、終身保険特約、定期保険特約、逓減定期保険特約および傷害特約に係る保険料は一般の生命保険料控除の対象となり、入院特約および先進医療特約に係る保険料は介護医療保険料控除の対象となります」",
        "choice4": "「Ａさんが重い病気等で余命６カ月以内と判断された場合、リビング・ニーズ特約により所定の範囲内で死亡保険金の全部または一部を生前にＡさんが受け取ることができます」",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "保障内容および課税関係",
        "important": ""
    },
    {
        "id": 712,
        "shikenId": 20,
        "no": 7,
        "answerType": 4,
        "groupId": 0,
        "answer": "1920,2540",
        "score": "1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set4/h3_1.png'/>",
        "question2": "仮に、将来Ｘ社がＡさんに役員退職金 7,000万円を支給した場合、Ａさんが受け取る役員退職金について、次の①、②を求めなさい（計算過程の記載は不要）。〈答〉は万円単位とすること。なお、Ａさんの役員在任期間（勤続年数）を35年３カ月とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。<br><br>①　退職所得控除額<br>②　退職所得の金額",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 713,
        "shikenId": 20,
        "no": 8,
        "answerType": 6,
        "groupId": 0,
        "answer": "ホ,ト,イ,ヘ",
        "score": "1,1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set4/h3_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、＜資料＞の定期保険の支払保険料の経理処理について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選択してください。<br><br>「法人を契約者（＝保険料負担者）および死亡保険金受取人とし、役員等を被保険者とする保険期間が３年以上の定期保険で、最高解約返戻率が（ ① ）％を超えるものの支払保険料の経理処理については、最高解約返戻率が『（ ① ）％超（ ② ）％以下』『（ ② ）％超 85％以下』『85％超』の３つの区分に応じて取り扱います。＜資料＞の定期保険の最高解約返戻率は『（ ② ）％超 85％以下』であるため、保険期間開始日から保険期間の（ ③ ）割相当期間を経過する日までは、当期分支払保険料の（ ④ ）％相当額を前払保険料として資産に計上し、残額は損金の額に算入します。（ ③ ）割に相当する期間経過後は、当期分支払保険料の全額を損金の額に算入するとともに、資産に計上した金額は、保険期間の7.5割相当期間経過後から保険期間終了日までにおいて均等に取り崩し、損金の額に算入します」<br><br><img src='/img/set4/h3_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の経理処理",
        "important": ""
    },
    {
        "id": 714,
        "shikenId": 20,
        "no": 9,
        "answerType": 6,
        "groupId": 0,
        "answer": "イ,ト,ニ,ヌ",
        "score": "1,1,1,1",
        "question1": "【第３問】　次の設例に基づいて、下記の各問（《問７》～《問９》）に答えなさい。<br><img src='/img/set4/h3_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、中小企業退職金共済制度（以下、「中退共」という）について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>　「中退共は、中小企業の事業主が独立行政法人勤労者退職金共済機構と雇用者（従業員）を被共済者とする退職金共済契約を締結して、退職金を社外に積み立てる共済制度です。　掛金は、被共済者（従業員）１人につき、月額 5,000円から（ ① ）までの範囲から選択し、事業主が全額を負担します。なお、短時間労働者（パートタイマー等）は、特例として、月額 2,000円から加入することができます。<br>　中退共に新たに加入する事業主に対して、原則として、掛金月額の（ ② ）（被共済者１人ごとに5,000円が上限）を加入後（ ③ ）から１年間、国が助成する制度があります。また、掛金月額が18,000円以下の被共済者（従業員）の掛金を増額した事業主に対して、増額分の３分の１を増額月から１年間、国が助成する制度もあります。<br>　被共済者（従業員）が退職した場合、独立行政法人勤労者退職金共済機構から退職金が（ ④ ）支給されます。退職金は、退職時に一括して受け取る一時払いのほか、退職金が所定の金額以上であることなどの要件を満たした場合は、退職金の全部または一部を分割払いにすることもできます」<br><br><img src='/img/set4/h3_3.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "中小企業退職金共済",
        "important": ""
    },
    {
        "id": 715,
        "shikenId": 20,
        "no": 10,
        "answerType": 6,
        "groupId": 0,
        "answer": "ヘ,ニ,ト",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set4/h4_1.png'/>",
        "question2": "住宅借入金等特別控除（以下、「本控除」という）に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選択してください。<br><br>「Ａさんが、住宅ローンを利用して、宅地建物取引業者から新築分譲マンションを取得等し、本年中に居住した場合、所定の要件を満たせば、居住の用に供した年分以後、最大で（ ① ）年間、本控除の適用を受けられます。控除額の計算上、住宅ローンの年末残高には限度額が設けられており、Aさんが省エネ基準適合住宅に本年中に居住した場合の年末残高の限度額は（ ② ）万円です。なお、本控除の適用を受けるための要件には、『住宅ローンの償還期間が（ ③ ）年以上であること』などもあります」<br><br><img src='/img/set4/h4_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 716,
        "shikenId": 20,
        "no": 11,
        "answerType": 5,
        "groupId": 0,
        "answer": "1,2,1,1",
        "score": "1,1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set4/h4_1.png'/>",
        "question2": "Ａさんの所得税および住宅取得資金に係る贈与税に関する次の記述①～④について、適切なものには○印を、不適切なものには×印を選択してください。",
        "choice1": "「Ａさんは白色申告者ですが、不動産所得の損失は損益通算することができます」",
        "choice2": "「Ａさんの株式の譲渡所得の損失は、給与所得と損益通算することができます」",
        "choice3": "「父親からの資金援助について、『直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税』の適用を受けた場合、贈与税は課されません」",
        "choice4": "「転勤等のやむを得ない事由によりＡさんが単身赴任で転居した場合、妻Ｂさん、長女Ｃさん、長男Ｄさんが引き続きマンションに居住する場合、単身赴任後も引き続き住宅借入金等特別控除の適用を受けることができます」",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "損益通算、住宅取得等資金の贈与税の非課税、住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 717,
        "shikenId": 20,
        "no": 12,
        "answerType": 4,
        "groupId": 0,
        "answer": "6700000,630000,207900",
        "score": "1,1,1",
        "question1": "【第４問】　次の設例に基づいて、下記の各問（《問 10》～《問 12》）に答えなさい。<br><img src='/img/set4/h4_1.png'/>",
        "question2": "Ａさんの本年分の所得税額を計算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。①の計算上、Ａさんが所得金額調整控除の適用対象者に該当している場合、所得金額調整控除額を控除すること。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set4/h4_3.png'/>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の計算",
        "important": ""
    },
    {
        "id": 718,
        "shikenId": 20,
        "no": 13,
        "answerType": 6,
        "groupId": 0,
        "answer": "イ,ヘ,チ,ホ",
        "score": "1,1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set4/h5_1.png'/>",
        "question2": "Ａさんの相続等に関する以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　「A さんが長女 C さんに、X 社株式等の事業に関わる財産のすべてを相続させる旨の遺言を作成した場合、二女 D さんおよび三女 E さんが遺留分の請求をする可能性があります。仮に、A さんの相続に係る遺留分を算定するための財産の価額を4億 5,000万円とした場合、二女 D さんの遺留分は（ ① ）となります」<br><br>Ⅱ　「Ｘ社株式の相続税評価額は、原則として類似業種比準方式により評価されます。類似業種比準価額は、類似業種の株価ならびに１株当たりの配当金額、１株当たりの利益金額、１株当たりの（ ② ）価額の３つの比準要素を基に計算されます」<br><br>Ⅲ　「Ａさんが生前贈与を実行するにあたっては、暦年課税による贈与を活用することもできます。仮に、長女Ｃさんが暦年課税（各種非課税制度の適用はない）により、本年中にＡさんから現金700万円の贈与を受けた場合、贈与税額は（ ③ ）万円となります」<br><br>Ⅳ　「妻 B さんが『配偶者に対する相続税額の軽減』の適用を受けた場合、相続により取得した財産の金額が、配偶者の法定相続分相当額と1億 6,000万円とのいずれか（ ④ ）金額までであれば、原則として、妻 B さんが納付すべき相続税額は算出されません」<br><br><img src='/img/set4/h5_2.png'/>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税・財産評価等",
        "important": ""
    },
    {
        "id": 719,
        "shikenId": 20,
        "no": 14,
        "answerType": 5,
        "groupId": 0,
        "answer": "2,2,1",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set4/h5_1.png'/>",
        "question2": "A さんの相続税等に関する以下の文章の①～③について適切なものには○印を、不適切なものには×印を選択してください。",
        "choice1": "「二女Dさんと三女Eさんに対する代償交付金を準備する方法として、契約者（＝保険料負担者）および被保険者を A さん、死亡保険金受取人を長女 C さんとする終身保険に加入する方法があります。ただし、死亡保険金は、原則として遺留分を算定するための財産に含まれるため、保険金額について十分に検討する必要があります」",
        "choice2": "「長女 C さんに X 社株式を移転する方法として、相続時精算課税制度の活用が考えられます。相続時精算課税制度は、特定贈与者からの贈与のうち毎年 110万円を除いた金額を累計して2,500万円までは贈与税が非課税になる制度です。2,500万円を超えた金額には暦年贈与の贈与税率により贈与税が課税されます」",
        "choice3": "「妻 B さんが相続により自宅建物および敷地を取得した場合、当該敷地は特定居住用宅地等として『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けることができます。仮に妻 B さんが相続税の申告期限までに当該敷地を売却しても、適用を受けることが可能です」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続等に関する記述",
        "important": ""
    },
    {
        "id": 720,
        "shikenId": 20,
        "no": 15,
        "answerType": 4,
        "groupId": 0,
        "answer": "5400,620,5080",
        "score": "1,1,1",
        "question1": "【第５問】　次の設例に基づいて、下記の各問（《問 13》～《問 15》）に答えなさい。<br><img src='/img/set4/h5_1.png'/>",
        "question2": "現時点において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は３億円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img src='/img/set4/h5_3.png'/>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の計算",
        "important": ""
    }
]